//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiClientBase } from './ApiClientBase';

export class ApiClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    lookup(iban: string): Promise<GetBankByIbanResponseApiResult> {
        let url_ = this.baseUrl + "/bank/lookup?";
        if (iban === undefined || iban === null)
            throw new Error("The parameter 'iban' must be defined and cannot be null.");
        else
            url_ += "iban=" + encodeURIComponent("" + iban) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: Response): Promise<GetBankByIbanResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBankByIbanResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetBankByIbanResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getDefaultFundigProduct(body: GetDefaultFundingProductRequest | undefined): Promise<GetCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/GetDefaultFundigProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultFundigProduct(_response);
        });
    }

    protected processGetDefaultFundigProduct(response: Response): Promise<GetCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReconsideratedFundigProduct(body: GetReconsideratedFundingProductRequest | undefined): Promise<GetCalculationResponseForReconsideredProductApiResult> {
        let url_ = this.baseUrl + "/calculation/getReconsideratedFundigProduct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReconsideratedFundigProduct(_response);
        });
    }

    protected processGetReconsideratedFundigProduct(response: Response): Promise<GetCalculationResponseForReconsideredProductApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseForReconsideredProductApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseForReconsideredProductApiResult>(null as any);
    }

    /**
     * @param calculationId (optional) 
     * @param overtakeCustomer (optional) 
     * @return Success
     */
    getReconsideredFundingProductForExistingDeal(dealId: number, calculationId: number | undefined, referencesDealId: number, overtakeCustomer: boolean | undefined): Promise<GetCalculationResponseForReconsideredProductApiResult> {
        let url_ = this.baseUrl + "/calculation/getReconsideredFundigProductForExistingDeal?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (calculationId === null)
            throw new Error("The parameter 'calculationId' cannot be null.");
        else if (calculationId !== undefined)
            url_ += "CalculationId=" + encodeURIComponent("" + calculationId) + "&";
        if (referencesDealId === undefined || referencesDealId === null)
            throw new Error("The parameter 'referencesDealId' must be defined and cannot be null.");
        else
            url_ += "ReferencesDealId=" + encodeURIComponent("" + referencesDealId) + "&";
        if (overtakeCustomer === null)
            throw new Error("The parameter 'overtakeCustomer' cannot be null.");
        else if (overtakeCustomer !== undefined)
            url_ += "OvertakeCustomer=" + encodeURIComponent("" + overtakeCustomer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReconsideredFundingProductForExistingDeal(_response);
        });
    }

    protected processGetReconsideredFundingProductForExistingDeal(response: Response): Promise<GetCalculationResponseForReconsideredProductApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseForReconsideredProductApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseForReconsideredProductApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculate(body: GetCalculatedProductRequest | undefined): Promise<GetCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<GetCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateExistingDeal(body: GetCalculatedProductForExistingDealRequest | undefined): Promise<GetCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/calculateWithDealId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateExistingDeal(_response);
        });
    }

    protected processCalculateExistingDeal(response: Response): Promise<GetCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCalculationById(dealId: number, id: number): Promise<GetCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/{dealId}/{id}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCalculationById(_response);
        });
    }

    protected processGetCalculationById(response: Response): Promise<GetCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultCalculationByDealId(dealId: number): Promise<GetCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/{dealId}/default";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultCalculationByDealId(_response);
        });
    }

    protected processGetDefaultCalculationByDealId(response: Response): Promise<GetCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCalculationResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveCalculation(body: SaveCalculationRequest | undefined): Promise<SaveCalculationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveCalculation(_response);
        });
    }

    protected processSaveCalculation(response: Response): Promise<SaveCalculationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveCalculationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveCalculationResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCreditCheck(id: number): Promise<GetCreditCheckResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCreditCheck(_response);
        });
    }

    protected processGetCreditCheck(response: Response): Promise<GetCreditCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCreditCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetCreditCheckResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendToCreditCheck(body: SendToCreditCheckRequest | undefined): Promise<SendToCreditCheckResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendToCreditCheck(_response);
        });
    }

    protected processSendToCreditCheck(response: Response): Promise<SendToCreditCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendToCreditCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendToCreditCheckResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    voteOnSalesAidLimitViolation(body: VoteOnSalesAidLimitViolationRequest | undefined): Promise<VoteOnSalesAidLimitViolationResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck/salesAidLimitViolation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVoteOnSalesAidLimitViolation(_response);
        });
    }

    protected processVoteOnSalesAidLimitViolation(response: Response): Promise<VoteOnSalesAidLimitViolationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoteOnSalesAidLimitViolationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoteOnSalesAidLimitViolationResponseApiResult>(null as any);
    }

    /**
     * @param providerId (optional) 
     * @return Success
     */
    getProviders(dealId: number, providerId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck/providers?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (providerId === null)
            throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined)
            url_ += "ProviderId=" + encodeURIComponent("" + providerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProviders(_response);
        });
    }

    protected processGetProviders(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getEuriborDates(selectedEuriborDateId: number): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck/euriborDates?";
        if (selectedEuriborDateId === undefined || selectedEuriborDateId === null)
            throw new Error("The parameter 'selectedEuriborDateId' must be defined and cannot be null.");
        else
            url_ += "SelectedEuriborDateId=" + encodeURIComponent("" + selectedEuriborDateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEuriborDates(_response);
        });
    }

    protected processGetEuriborDates(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getHandoverDealers(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/creditCheck/handoverDealers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHandoverDealers(_response);
        });
    }

    protected processGetHandoverDealers(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSubsidyGiver(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/salesAid/subsidy/giver";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubsidyGiver(_response);
        });
    }

    protected processGetSubsidyGiver(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSubsidyRecipient(): Promise<SubsidyRecipientViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/salesAid/subsidy/recipient";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubsidyRecipient(_response);
        });
    }

    protected processGetSubsidyRecipient(response: Response): Promise<SubsidyRecipientViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubsidyRecipientViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubsidyRecipientViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSalesAid(id: number): Promise<SalesAidViewApiResult> {
        let url_ = this.baseUrl + "/calculation/salesAid/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesAid(_response);
        });
    }

    protected processGetSalesAid(response: Response): Promise<SalesAidViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesAidViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesAidViewApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPreselectedDealerId(): Promise<GetPreselectedDealerResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/agentOptions/preselectedDealerId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreselectedDealerId(_response);
        });
    }

    protected processGetPreselectedDealerId(response: Response): Promise<GetPreselectedDealerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPreselectedDealerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPreselectedDealerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSuppliers(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSuppliers(_response);
        });
    }

    protected processGetSuppliers(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getEuriborRate(financingCalculationId: number, euriborId: number): Promise<DoubleApiResult> {
        let url_ = this.baseUrl + "/calculation/euriborRate?";
        if (financingCalculationId === undefined || financingCalculationId === null)
            throw new Error("The parameter 'financingCalculationId' must be defined and cannot be null.");
        else
            url_ += "FinancingCalculationId=" + encodeURIComponent("" + financingCalculationId) + "&";
        if (euriborId === undefined || euriborId === null)
            throw new Error("The parameter 'euriborId' must be defined and cannot be null.");
        else
            url_ += "EuriborId=" + encodeURIComponent("" + euriborId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEuriborRate(_response);
        });
    }

    protected processGetEuriborRate(response: Response): Promise<DoubleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoubleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DoubleApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPrintFinancialCalculationDocuments(financingCalculationId: number): Promise<GetPrintFinancialCalculationDocumentsResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/printFinancialCalculationDocuments?";
        if (financingCalculationId === undefined || financingCalculationId === null)
            throw new Error("The parameter 'financingCalculationId' must be defined and cannot be null.");
        else
            url_ += "FinancingCalculationId=" + encodeURIComponent("" + financingCalculationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintFinancialCalculationDocuments(_response);
        });
    }

    protected processGetPrintFinancialCalculationDocuments(response: Response): Promise<GetPrintFinancialCalculationDocumentsResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPrintFinancialCalculationDocumentsResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPrintFinancialCalculationDocumentsResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printFinancingCalculationDocuments(body: PrintFinancingCalculationDocumentsRequest | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/calculation/printFinancingCalculationDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintFinancingCalculationDocuments(_response);
        });
    }

    protected processPrintFinancingCalculationDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendFinancingCalculationDocuments(body: SendFinancingCalculationDocumentsRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/calculation/sendFinancingCalculationDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendFinancingCalculationDocuments(_response);
        });
    }

    protected processSendFinancingCalculationDocuments(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signFinancingCalculationDocuments(body: SignFinancingCalculationDocumentsRequest | undefined): Promise<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/calculation/signFinancingCalculationDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignFinancingCalculationDocuments(_response);
        });
    }

    protected processSignFinancingCalculationDocuments(response: Response): Promise<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult>(null as any);
    }

    /**
     * @param cacheGuid (optional) 
     * @param calculationId (optional) 
     * @param serviceVariantId (optional) 
     * @param variantNumber (optional) 
     * @param serviceChargeNet (optional) 
     * @param productOptionIds (optional) 
     * @param technicalOptionIds (optional) 
     * @param priceNet (optional) 
     * @param totalPrice (optional) 
     * @return Success
     */
    getServices(modelId: number, vat: number, distributionChannel: number, cacheGuid: string | undefined, dealId: number, calculationId: number | undefined, serviceVariantId: number | undefined, variantNumber: number | undefined, serviceProductId: string, mileageId: number, duration: number, isServiceVariantsResetRequest: boolean, serviceChargeNet: number | undefined, configurationID: string, productOptionIds: string[] | undefined, productIndustryId: string, productUsageId: string, technicalOptionIds: string[] | undefined, campaignId: string, priceNet: number | undefined, baumuster: string, nstCode: string, fundingProductId: number, totalPrice: number | undefined, priceFormState: ApiconSpecialCasePriceFormState, specialCaseRequestBundle_Comment: string, specialCaseRequestBundle_Phone: string, specialCaseRequestBundle_EMail: string, specialCaseRequestBundle_OfferID: string, specialCaseRequestBundle_SpecialCaseID: string, preCheckServiceProductSelectionsFromRequest: boolean, preCheckServiceProductSelectionsFromApicon: boolean, isPriceFormSpecialCaseMandatory: boolean, isServiceVariantSaveRequest: boolean, isBundle: boolean): Promise<ApiconServiceBundleApiResult> {
        let url_ = this.baseUrl + "/calculation/services?";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined and cannot be null.");
        else
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (vat === undefined || vat === null)
            throw new Error("The parameter 'vat' must be defined and cannot be null.");
        else
            url_ += "Vat=" + encodeURIComponent("" + vat) + "&";
        if (distributionChannel === undefined || distributionChannel === null)
            throw new Error("The parameter 'distributionChannel' must be defined and cannot be null.");
        else
            url_ += "DistributionChannel=" + encodeURIComponent("" + distributionChannel) + "&";
        if (cacheGuid === null)
            throw new Error("The parameter 'cacheGuid' cannot be null.");
        else if (cacheGuid !== undefined)
            url_ += "CacheGuid=" + encodeURIComponent("" + cacheGuid) + "&";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (calculationId === null)
            throw new Error("The parameter 'calculationId' cannot be null.");
        else if (calculationId !== undefined)
            url_ += "CalculationId=" + encodeURIComponent("" + calculationId) + "&";
        if (serviceVariantId === null)
            throw new Error("The parameter 'serviceVariantId' cannot be null.");
        else if (serviceVariantId !== undefined)
            url_ += "ServiceVariantId=" + encodeURIComponent("" + serviceVariantId) + "&";
        if (variantNumber === null)
            throw new Error("The parameter 'variantNumber' cannot be null.");
        else if (variantNumber !== undefined)
            url_ += "VariantNumber=" + encodeURIComponent("" + variantNumber) + "&";
        if (serviceProductId === undefined || serviceProductId === null)
            throw new Error("The parameter 'serviceProductId' must be defined and cannot be null.");
        else
            url_ += "ServiceProductId=" + encodeURIComponent("" + serviceProductId) + "&";
        if (mileageId === undefined || mileageId === null)
            throw new Error("The parameter 'mileageId' must be defined and cannot be null.");
        else
            url_ += "MileageId=" + encodeURIComponent("" + mileageId) + "&";
        if (duration === undefined || duration === null)
            throw new Error("The parameter 'duration' must be defined and cannot be null.");
        else
            url_ += "Duration=" + encodeURIComponent("" + duration) + "&";
        if (isServiceVariantsResetRequest === undefined || isServiceVariantsResetRequest === null)
            throw new Error("The parameter 'isServiceVariantsResetRequest' must be defined and cannot be null.");
        else
            url_ += "IsServiceVariantsResetRequest=" + encodeURIComponent("" + isServiceVariantsResetRequest) + "&";
        if (serviceChargeNet === null)
            throw new Error("The parameter 'serviceChargeNet' cannot be null.");
        else if (serviceChargeNet !== undefined)
            url_ += "ServiceChargeNet=" + encodeURIComponent("" + serviceChargeNet) + "&";
        if (configurationID === undefined || configurationID === null)
            throw new Error("The parameter 'configurationID' must be defined and cannot be null.");
        else
            url_ += "ConfigurationID=" + encodeURIComponent("" + configurationID) + "&";
        if (productOptionIds === null)
            throw new Error("The parameter 'productOptionIds' cannot be null.");
        else if (productOptionIds !== undefined)
            productOptionIds && productOptionIds.forEach(item => { url_ += "ProductOptionIds=" + encodeURIComponent("" + item) + "&"; });
        if (productIndustryId === undefined || productIndustryId === null)
            throw new Error("The parameter 'productIndustryId' must be defined and cannot be null.");
        else
            url_ += "ProductIndustryId=" + encodeURIComponent("" + productIndustryId) + "&";
        if (productUsageId === undefined || productUsageId === null)
            throw new Error("The parameter 'productUsageId' must be defined and cannot be null.");
        else
            url_ += "ProductUsageId=" + encodeURIComponent("" + productUsageId) + "&";
        if (technicalOptionIds === null)
            throw new Error("The parameter 'technicalOptionIds' cannot be null.");
        else if (technicalOptionIds !== undefined)
            technicalOptionIds && technicalOptionIds.forEach(item => { url_ += "TechnicalOptionIds=" + encodeURIComponent("" + item) + "&"; });
        if (campaignId === undefined || campaignId === null)
            throw new Error("The parameter 'campaignId' must be defined and cannot be null.");
        else
            url_ += "CampaignId=" + encodeURIComponent("" + campaignId) + "&";
        if (priceNet === null)
            throw new Error("The parameter 'priceNet' cannot be null.");
        else if (priceNet !== undefined)
            url_ += "PriceNet=" + encodeURIComponent("" + priceNet) + "&";
        if (baumuster === undefined || baumuster === null)
            throw new Error("The parameter 'baumuster' must be defined and cannot be null.");
        else
            url_ += "Baumuster=" + encodeURIComponent("" + baumuster) + "&";
        if (nstCode === undefined || nstCode === null)
            throw new Error("The parameter 'nstCode' must be defined and cannot be null.");
        else
            url_ += "NstCode=" + encodeURIComponent("" + nstCode) + "&";
        if (fundingProductId === undefined || fundingProductId === null)
            throw new Error("The parameter 'fundingProductId' must be defined and cannot be null.");
        else
            url_ += "FundingProductId=" + encodeURIComponent("" + fundingProductId) + "&";
        if (totalPrice === null)
            throw new Error("The parameter 'totalPrice' cannot be null.");
        else if (totalPrice !== undefined)
            url_ += "TotalPrice=" + encodeURIComponent("" + totalPrice) + "&";
        if (priceFormState === undefined || priceFormState === null)
            throw new Error("The parameter 'priceFormState' must be defined and cannot be null.");
        else
            url_ += "PriceFormState=" + encodeURIComponent("" + priceFormState) + "&";
        if (specialCaseRequestBundle_Comment === undefined || specialCaseRequestBundle_Comment === null)
            throw new Error("The parameter 'specialCaseRequestBundle_Comment' must be defined and cannot be null.");
        else
            url_ += "SpecialCaseRequestBundle.Comment=" + encodeURIComponent("" + specialCaseRequestBundle_Comment) + "&";
        if (specialCaseRequestBundle_Phone === undefined || specialCaseRequestBundle_Phone === null)
            throw new Error("The parameter 'specialCaseRequestBundle_Phone' must be defined and cannot be null.");
        else
            url_ += "SpecialCaseRequestBundle.Phone=" + encodeURIComponent("" + specialCaseRequestBundle_Phone) + "&";
        if (specialCaseRequestBundle_EMail === undefined || specialCaseRequestBundle_EMail === null)
            throw new Error("The parameter 'specialCaseRequestBundle_EMail' must be defined and cannot be null.");
        else
            url_ += "SpecialCaseRequestBundle.EMail=" + encodeURIComponent("" + specialCaseRequestBundle_EMail) + "&";
        if (specialCaseRequestBundle_OfferID === undefined || specialCaseRequestBundle_OfferID === null)
            throw new Error("The parameter 'specialCaseRequestBundle_OfferID' must be defined and cannot be null.");
        else
            url_ += "SpecialCaseRequestBundle.OfferID=" + encodeURIComponent("" + specialCaseRequestBundle_OfferID) + "&";
        if (specialCaseRequestBundle_SpecialCaseID === undefined || specialCaseRequestBundle_SpecialCaseID === null)
            throw new Error("The parameter 'specialCaseRequestBundle_SpecialCaseID' must be defined and cannot be null.");
        else
            url_ += "SpecialCaseRequestBundle.SpecialCaseID=" + encodeURIComponent("" + specialCaseRequestBundle_SpecialCaseID) + "&";
        if (preCheckServiceProductSelectionsFromRequest === undefined || preCheckServiceProductSelectionsFromRequest === null)
            throw new Error("The parameter 'preCheckServiceProductSelectionsFromRequest' must be defined and cannot be null.");
        else
            url_ += "PreCheckServiceProductSelectionsFromRequest=" + encodeURIComponent("" + preCheckServiceProductSelectionsFromRequest) + "&";
        if (preCheckServiceProductSelectionsFromApicon === undefined || preCheckServiceProductSelectionsFromApicon === null)
            throw new Error("The parameter 'preCheckServiceProductSelectionsFromApicon' must be defined and cannot be null.");
        else
            url_ += "PreCheckServiceProductSelectionsFromApicon=" + encodeURIComponent("" + preCheckServiceProductSelectionsFromApicon) + "&";
        if (isPriceFormSpecialCaseMandatory === undefined || isPriceFormSpecialCaseMandatory === null)
            throw new Error("The parameter 'isPriceFormSpecialCaseMandatory' must be defined and cannot be null.");
        else
            url_ += "IsPriceFormSpecialCaseMandatory=" + encodeURIComponent("" + isPriceFormSpecialCaseMandatory) + "&";
        if (isServiceVariantSaveRequest === undefined || isServiceVariantSaveRequest === null)
            throw new Error("The parameter 'isServiceVariantSaveRequest' must be defined and cannot be null.");
        else
            url_ += "IsServiceVariantSaveRequest=" + encodeURIComponent("" + isServiceVariantSaveRequest) + "&";
        if (isBundle === undefined || isBundle === null)
            throw new Error("The parameter 'isBundle' must be defined and cannot be null.");
        else
            url_ += "IsBundle=" + encodeURIComponent("" + isBundle) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServices(_response);
        });
    }

    protected processGetServices(response: Response): Promise<ApiconServiceBundleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiconServiceBundleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiconServiceBundleApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getMileages(mileageId: number): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/calculation/mileages/{mileageId}";
        if (mileageId === undefined || mileageId === null)
            throw new Error("The parameter 'mileageId' must be defined.");
        url_ = url_.replace("{mileageId}", encodeURIComponent("" + mileageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMileages(_response);
        });
    }

    protected processGetMileages(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param serviceVariantId (optional) 
     * @param serviceProductId (optional) 
     * @param isServiceVariantsResetRequest (optional) 
     * @return Success
     */
    getServiceVariants(financingCalculationId: number, serviceVariantId: number | undefined, serviceProductId: string | undefined, isServiceVariantsResetRequest: boolean | undefined): Promise<GetServiceVariantsResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/serviceVariants?";
        if (financingCalculationId === undefined || financingCalculationId === null)
            throw new Error("The parameter 'financingCalculationId' must be defined and cannot be null.");
        else
            url_ += "FinancingCalculationId=" + encodeURIComponent("" + financingCalculationId) + "&";
        if (serviceVariantId === null)
            throw new Error("The parameter 'serviceVariantId' cannot be null.");
        else if (serviceVariantId !== undefined)
            url_ += "ServiceVariantId=" + encodeURIComponent("" + serviceVariantId) + "&";
        if (serviceProductId === null)
            throw new Error("The parameter 'serviceProductId' cannot be null.");
        else if (serviceProductId !== undefined)
            url_ += "ServiceProductId=" + encodeURIComponent("" + serviceProductId) + "&";
        if (isServiceVariantsResetRequest === null)
            throw new Error("The parameter 'isServiceVariantsResetRequest' cannot be null.");
        else if (isServiceVariantsResetRequest !== undefined)
            url_ += "IsServiceVariantsResetRequest=" + encodeURIComponent("" + isServiceVariantsResetRequest) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceVariants(_response);
        });
    }

    protected processGetServiceVariants(response: Response): Promise<GetServiceVariantsResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetServiceVariantsResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetServiceVariantsResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateServicePrice(body: CalculateServicePriceRequest | undefined): Promise<ApiconServiceBundleApiResult> {
        let url_ = this.baseUrl + "/calculation/calculateServicePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateServicePrice(_response);
        });
    }

    protected processCalculateServicePrice(response: Response): Promise<ApiconServiceBundleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiconServiceBundleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiconServiceBundleApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSpecialCasePrice(body: CreateSpecialCasePriceRequest | undefined): Promise<ApiconServiceBundleApiResult> {
        let url_ = this.baseUrl + "/calculation/createSpecialCasePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSpecialCasePrice(_response);
        });
    }

    protected processCreateSpecialCasePrice(response: Response): Promise<ApiconServiceBundleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiconServiceBundleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiconServiceBundleApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeSpecialCasePrice(body: CompleteSpecialCasePriceRequest | undefined): Promise<ApiconServiceBundleApiResult> {
        let url_ = this.baseUrl + "/calculation/completeSpecialCasePrice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteSpecialCasePrice(_response);
        });
    }

    protected processCompleteSpecialCasePrice(response: Response): Promise<ApiconServiceBundleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiconServiceBundleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiconServiceBundleApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveServiceVariant(body: SaveServiceVariantRequest | undefined): Promise<SaveServiceVariantResponseApiResult> {
        let url_ = this.baseUrl + "/calculation/saveServiceVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveServiceVariant(_response);
        });
    }

    protected processSaveServiceVariant(response: Response): Promise<SaveServiceVariantResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveServiceVariantResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveServiceVariantResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveProposal(body: SaveProposalRequest | undefined): Promise<ApiconServiceBundleApiResult> {
        let url_ = this.baseUrl + "/calculation/saveProposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveProposal(_response);
        });
    }

    protected processSaveProposal(response: Response): Promise<ApiconServiceBundleApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiconServiceBundleApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiconServiceBundleApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClassificationGroup(body: CreateClasssificationGroupRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClassificationGroup(_response);
        });
    }

    protected processCreateClassificationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getClassificationGroups(): Promise<ClassificationGroupViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClassificationGroups(_response);
        });
    }

    protected processGetClassificationGroups(response: Response): Promise<ClassificationGroupViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassificationGroupViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassificationGroupViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateClassificationGroup(id: string, body: UpdateClassificationGroupRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateClassificationGroup(_response);
        });
    }

    protected processUpdateClassificationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteClassificationGroup(id: string): Promise<void> {
        let url_ = this.baseUrl + "/classification/groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteClassificationGroup(_response);
        });
    }

    protected processDeleteClassificationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createClassifiedObject(body: CreateClassifiedObjectRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/groups/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateClassifiedObject(_response);
        });
    }

    protected processCreateClassifiedObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeClassificationGroup(body: RemoveClassificationGroupRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/groups/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveClassificationGroup(_response);
        });
    }

    protected processRemoveClassificationGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getFeatureDefinitions(): Promise<FeatureDefinitionViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/feature-definitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeatureDefinitions(_response);
        });
    }

    protected processGetFeatureDefinitions(response: Response): Promise<FeatureDefinitionViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureDefinitionViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureDefinitionViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFeatureDefinition(body: CreateFeatureDefinitionRequest | undefined): Promise<GuidApiResult> {
        let url_ = this.baseUrl + "/classification/feature-definitions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFeatureDefinition(_response);
        });
    }

    protected processCreateFeatureDefinition(response: Response): Promise<GuidApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFeatureDefinition(id: string, body: UpdateFeatureDefinitionRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-definitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFeatureDefinition(_response);
        });
    }

    protected processUpdateFeatureDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteFeatureDefinition(id: string): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-definitions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFeatureDefinition(_response);
        });
    }

    protected processDeleteFeatureDefinition(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getFeatureClassifications(groupId: string): Promise<FeatureClassificationViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/feature-classifications/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeatureClassifications(_response);
        });
    }

    protected processGetFeatureClassifications(response: Response): Promise<FeatureClassificationViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureClassificationViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureClassificationViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFeatureClassification(body: CreateFeatureClassificationsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-classifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFeatureClassification(_response);
        });
    }

    protected processCreateFeatureClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFeatureClassification(body: UpdateFeatureClassificationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-classifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFeatureClassification(_response);
        });
    }

    protected processUpdateFeatureClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteFeatureClassification(body: DeleteFeatureClassificationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-classifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFeatureClassification(_response);
        });
    }

    protected processDeleteFeatureClassification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getFeatureValues(domainId: number, objectType: ClassificationType): Promise<FeatureValueViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/feature-values?";
        if (domainId === undefined || domainId === null)
            throw new Error("The parameter 'domainId' must be defined and cannot be null.");
        else
            url_ += "domainId=" + encodeURIComponent("" + domainId) + "&";
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined and cannot be null.");
        else
            url_ += "objectType=" + encodeURIComponent("" + objectType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeatureValues(_response);
        });
    }

    protected processGetFeatureValues(response: Response): Promise<FeatureValueViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureValueViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureValueViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateFeatureValue(body: UpdateFeatureValueRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/classification/feature-values";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFeatureValue(_response);
        });
    }

    protected processUpdateFeatureValue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    getClassificationGroupObjects(groupId: string | undefined): Promise<ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/objects?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClassificationGroupObjects(_response);
        });
    }

    protected processGetClassificationGroupObjects(response: Response): Promise<ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getMatchingRuleSets(dealId: number, includeSimulation: boolean): Promise<GetMatchingCampaignResponseApiResult> {
        let url_ = this.baseUrl + "/classification/objects/ruleset?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (includeSimulation === undefined || includeSimulation === null)
            throw new Error("The parameter 'includeSimulation' must be defined and cannot be null.");
        else
            url_ += "IncludeSimulation=" + encodeURIComponent("" + includeSimulation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMatchingRuleSets(_response);
        });
    }

    protected processGetMatchingRuleSets(response: Response): Promise<GetMatchingCampaignResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMatchingCampaignResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMatchingCampaignResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDealFeatureValues(dealId: number): Promise<FeatureValueViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/classification/deal/{dealId}/features";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealFeatureValues(_response);
        });
    }

    protected processGetDealFeatureValues(response: Response): Promise<FeatureValueViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureValueViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureValueViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadSupplierInvoice(dealId: number, calculationId: number, conversionOptionId: number, file: FileParameter | undefined): Promise<UploadSupplierInvoiceResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{calculationId}/conversionOption/{conversionOptionId}/uploadInvoice";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (calculationId === undefined || calculationId === null)
            throw new Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        if (conversionOptionId === undefined || conversionOptionId === null)
            throw new Error("The parameter 'conversionOptionId' must be defined.");
        url_ = url_.replace("{conversionOptionId}", encodeURIComponent("" + conversionOptionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadSupplierInvoice(_response);
        });
    }

    protected processUploadSupplierInvoice(response: Response): Promise<UploadSupplierInvoiceResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadSupplierInvoiceResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadSupplierInvoiceResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    removeSupplierInvoice(dealId: number, calculationId: number, conversionOptionId: number): Promise<void> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{calculationId}/conversionOption/{conversionOptionId}/removeInvoice";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (calculationId === undefined || calculationId === null)
            throw new Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        if (conversionOptionId === undefined || conversionOptionId === null)
            throw new Error("The parameter 'conversionOptionId' must be defined.");
        url_ = url_.replace("{conversionOptionId}", encodeURIComponent("" + conversionOptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveSupplierInvoice(_response);
        });
    }

    protected processRemoveSupplierInvoice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    downloadSupplierInvoice(dealId: number, calculationId: number, conversionOptionId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{calculationId}/conversionOption/{conversionOptionId}/supplierInvoice";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (calculationId === undefined || calculationId === null)
            throw new Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        if (conversionOptionId === undefined || conversionOptionId === null)
            throw new Error("The parameter 'conversionOptionId' must be defined.");
        url_ = url_.replace("{conversionOptionId}", encodeURIComponent("" + conversionOptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadSupplierInvoice(_response);
        });
    }

    protected processDownloadSupplierInvoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createCommercialCustomer(body: CreateCommercialCustomerRequest | undefined): Promise<CreateCommercialCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/customer/commercial";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateCommercialCustomer(_response);
        });
    }

    protected processCreateCommercialCustomer(response: Response): Promise<CreateCommercialCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateCommercialCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateCommercialCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCommercialCustomer(id: number): Promise<CommercialCustomerViewApiResult> {
        let url_ = this.baseUrl + "/customer/commercial/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommercialCustomer(_response);
        });
    }

    protected processGetCommercialCustomer(response: Response): Promise<CommercialCustomerViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommercialCustomerViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommercialCustomerViewApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCommercialCustomer(body: EditCommercialCustomerRequest | undefined): Promise<EditCommercialCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/customer/commercial/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditCommercialCustomer(_response);
        });
    }

    protected processEditCommercialCustomer(response: Response): Promise<EditCommercialCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCommercialCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCommercialCustomerResponseApiResult>(null as any);
    }

    /**
     * @param vatId (optional) 
     * @param commercialRegisterNumber (optional) 
     * @param street (optional) 
     * @param zip (optional) 
     * @param city (optional) 
     * @param ksvId (optional) 
     * @return Success
     */
    searchCommercialCustomerKSV(companyName: string, vatId: string | undefined, commercialRegisterNumber: string | undefined, street: string | undefined, zip: string | undefined, city: string | undefined, ksvId: string | undefined): Promise<CommercialCustomerKsvResponseIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/commercial/ksv?";
        if (companyName === undefined || companyName === null)
            throw new Error("The parameter 'companyName' must be defined and cannot be null.");
        else
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (vatId === null)
            throw new Error("The parameter 'vatId' cannot be null.");
        else if (vatId !== undefined)
            url_ += "VatId=" + encodeURIComponent("" + vatId) + "&";
        if (commercialRegisterNumber === null)
            throw new Error("The parameter 'commercialRegisterNumber' cannot be null.");
        else if (commercialRegisterNumber !== undefined)
            url_ += "CommercialRegisterNumber=" + encodeURIComponent("" + commercialRegisterNumber) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (zip === null)
            throw new Error("The parameter 'zip' cannot be null.");
        else if (zip !== undefined)
            url_ += "Zip=" + encodeURIComponent("" + zip) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (ksvId === null)
            throw new Error("The parameter 'ksvId' cannot be null.");
        else if (ksvId !== undefined)
            url_ += "KsvId=" + encodeURIComponent("" + ksvId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCommercialCustomerKSV(_response);
        });
    }

    protected processSearchCommercialCustomerKSV(response: Response): Promise<CommercialCustomerKsvResponseIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommercialCustomerKsvResponseIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommercialCustomerKsvResponseIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param companyName (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param street (optional) 
     * @param postalCode (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    searchSimilarCommercial(customerId: number, companyName: string | undefined, country: string | undefined, city: string | undefined, street: string | undefined, postalCode: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<MergeCustomerViewIPagedListApiResult> {
        let url_ = this.baseUrl + "/customer/commercial/similar?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (companyName === null)
            throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSimilarCommercial(_response);
        });
    }

    protected processSearchSimilarCommercial(response: Response): Promise<MergeCustomerViewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MergeCustomerViewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeCustomerViewIPagedListApiResult>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param customerTypeId (optional) 
     * @param onlyValid (optional) 
     * @param excludeCustomerIds (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    getCustomerOverview(searchTerm: string | undefined, customerTypeId: number | undefined, onlyValid: boolean | undefined, excludeCustomerIds: number[] | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<CustomerOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/customer?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (customerTypeId === null)
            throw new Error("The parameter 'customerTypeId' cannot be null.");
        else if (customerTypeId !== undefined)
            url_ += "CustomerTypeId=" + encodeURIComponent("" + customerTypeId) + "&";
        if (onlyValid === null)
            throw new Error("The parameter 'onlyValid' cannot be null.");
        else if (onlyValid !== undefined)
            url_ += "OnlyValid=" + encodeURIComponent("" + onlyValid) + "&";
        if (excludeCustomerIds === null)
            throw new Error("The parameter 'excludeCustomerIds' cannot be null.");
        else if (excludeCustomerIds !== undefined)
            excludeCustomerIds && excludeCustomerIds.forEach(item => { url_ += "ExcludeCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerOverview(_response);
        });
    }

    protected processGetCustomerOverview(response: Response): Promise<CustomerOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @param name1 (optional) 
     * @param name2 (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param street (optional) 
     * @param postalCode (optional) 
     * @param customerTypeId (optional) 
     * @param onlyValid (optional) 
     * @param excludeCustomerIds (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    searchCustomers(name1: string | undefined, name2: string | undefined, country: string | undefined, city: string | undefined, street: string | undefined, postalCode: string | undefined, customerTypeId: number | undefined, onlyValid: boolean | undefined, excludeCustomerIds: number[] | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<CustomerOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/customer/search?";
        if (name1 === null)
            throw new Error("The parameter 'name1' cannot be null.");
        else if (name1 !== undefined)
            url_ += "Name1=" + encodeURIComponent("" + name1) + "&";
        if (name2 === null)
            throw new Error("The parameter 'name2' cannot be null.");
        else if (name2 !== undefined)
            url_ += "Name2=" + encodeURIComponent("" + name2) + "&";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (customerTypeId === null)
            throw new Error("The parameter 'customerTypeId' cannot be null.");
        else if (customerTypeId !== undefined)
            url_ += "CustomerTypeId=" + encodeURIComponent("" + customerTypeId) + "&";
        if (onlyValid === null)
            throw new Error("The parameter 'onlyValid' cannot be null.");
        else if (onlyValid !== undefined)
            url_ += "OnlyValid=" + encodeURIComponent("" + onlyValid) + "&";
        if (excludeCustomerIds === null)
            throw new Error("The parameter 'excludeCustomerIds' cannot be null.");
        else if (excludeCustomerIds !== undefined)
            excludeCustomerIds && excludeCustomerIds.forEach(item => { url_ += "ExcludeCustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCustomers(_response);
        });
    }

    protected processSearchCustomers(response: Response): Promise<CustomerOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerType(id: number): Promise<CustomerTypeApiResult> {
        let url_ = this.baseUrl + "/customer/type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCustomerType(_response);
        });
    }

    protected processGetCustomerType(response: Response): Promise<CustomerTypeApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerTypeApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerTypeApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSalutations(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/salutation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalutations(_response);
        });
    }

    protected processGetSalutations(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getTitles(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/title";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTitles(_response);
        });
    }

    protected processGetTitles(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getTitlesInternational(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/title/international";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTitlesInternational(_response);
        });
    }

    protected processGetTitlesInternational(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCountries(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/country";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountries(_response);
        });
    }

    protected processGetCountries(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getMaritalStatus(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/maritalStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMaritalStatus(_response);
        });
    }

    protected processGetMaritalStatus(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPepSpecifications(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/pepspecification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPepSpecifications(_response);
        });
    }

    protected processGetPepSpecifications(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getJobTitles(): Promise<JobTitleViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/jobtitle";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetJobTitles(_response);
        });
    }

    protected processGetJobTitles(response: Response): Promise<JobTitleViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobTitleViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JobTitleViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getResidenceTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/residencetype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResidenceTypes(_response);
        });
    }

    protected processGetResidenceTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getAssetTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/assettype";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAssetTypes(_response);
        });
    }

    protected processGetAssetTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getOtherAssetTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/assettype/other";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOtherAssetTypes(_response);
        });
    }

    protected processGetOtherAssetTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getLegalForms(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/legalform";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLegalForms(_response);
        });
    }

    protected processGetLegalForms(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getBranches(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/branch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBranches(_response);
        });
    }

    protected processGetBranches(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    replaceMainCustomer(body: ReplaceMainCustomerRequest | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/replace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReplaceMainCustomer(_response);
        });
    }

    protected processReplaceMainCustomer(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param orderSelectors (optional) 
     * @return Success
     */
    getSimilarCustomer(customerId: number, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<MergeCustomerViewIPagedListApiResult> {
        let url_ = this.baseUrl + "/customer/similar?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSimilarCustomer(_response);
        });
    }

    protected processGetSimilarCustomer(response: Response): Promise<MergeCustomerViewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MergeCustomerViewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeCustomerViewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getMergeCustomer(customerId: number): Promise<MergeCustomerViewApiResult> {
        let url_ = this.baseUrl + "/customer/merge?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMergeCustomer(_response);
        });
    }

    protected processGetMergeCustomer(response: Response): Promise<MergeCustomerViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MergeCustomerViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeCustomerViewApiResult>(null as any);
    }

    /**
     * @return Success
     */
    setKsvSearchDone(customerId: number, searchDoneFlag: boolean): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/customer/ksvSearchDone?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (searchDoneFlag === undefined || searchDoneFlag === null)
            throw new Error("The parameter 'searchDoneFlag' must be defined and cannot be null.");
        else
            url_ += "SearchDoneFlag=" + encodeURIComponent("" + searchDoneFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetKsvSearchDone(_response);
        });
    }

    protected processSetKsvSearchDone(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getIdentityCheckByCustomerId(id: number): Promise<IdentityCheckResponseApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/byCustomerId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityCheckByCustomerId(_response);
        });
    }

    protected processGetIdentityCheckByCustomerId(response: Response): Promise<IdentityCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("No Content", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityCheckResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getIdentityCheckByBusinessPartnerId(id: string): Promise<IdentityCheckResponseApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/byBusinessPartnerId/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityCheckByBusinessPartnerId(_response);
        });
    }

    protected processGetIdentityCheckByBusinessPartnerId(response: Response): Promise<IdentityCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityCheckResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getIdentityCheckByContractId(contractId: string): Promise<IdentityCheckResponseApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/byContractId/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityCheckByContractId(_response);
        });
    }

    protected processGetIdentityCheckByContractId(response: Response): Promise<IdentityCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityCheckResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getIdentityCheck(identityCheckId: string): Promise<IdentityCheckResponseApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/{identityCheckId}";
        if (identityCheckId === undefined || identityCheckId === null)
            throw new Error("The parameter 'identityCheckId' must be defined.");
        url_ = url_.replace("{identityCheckId}", encodeURIComponent("" + identityCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityCheck(_response);
        });
    }

    protected processGetIdentityCheck(response: Response): Promise<IdentityCheckResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentityCheckResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityCheckResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getIdentityCheckReport(identityCheckId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/customer/identityCheck/{identityCheckId}/report";
        if (identityCheckId === undefined || identityCheckId === null)
            throw new Error("The parameter 'identityCheckId' must be defined.");
        url_ = url_.replace("{identityCheckId}", encodeURIComponent("" + identityCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityCheckReport(_response);
        });
    }

    protected processGetIdentityCheckReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @param dealId (optional) 
     * @return Success
     */
    startIdentityCheck(customerId: number | undefined, dealId: number | undefined): Promise<GuidApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/start?";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (dealId === null)
            throw new Error("The parameter 'dealId' cannot be null.");
        else if (dealId !== undefined)
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartIdentityCheck(_response);
        });
    }

    protected processStartIdentityCheck(response: Response): Promise<GuidApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuidApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuidApiResult>(null as any);
    }

    /**
     * @param dealId (optional) 
     * @return Success
     */
    completeIdentityCheck(identityCheckId: string, customerId: number, dealId: number | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/{identityCheckId}/customers/{customerId}/complete?";
        if (identityCheckId === undefined || identityCheckId === null)
            throw new Error("The parameter 'identityCheckId' must be defined.");
        url_ = url_.replace("{identityCheckId}", encodeURIComponent("" + identityCheckId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (dealId === null)
            throw new Error("The parameter 'dealId' cannot be null.");
        else if (dealId !== undefined)
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteIdentityCheck(_response);
        });
    }

    protected processCompleteIdentityCheck(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param customerId (optional) 
     * @return Success
     */
    cancelIdentityCheck(identityCheckId: string, customerId: number | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/customer/identityCheck/{identityCheckId}/cancel?";
        if (identityCheckId === undefined || identityCheckId === null)
            throw new Error("The parameter 'identityCheckId' must be defined.");
        url_ = url_.replace("{identityCheckId}", encodeURIComponent("" + identityCheckId));
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelIdentityCheck(_response);
        });
    }

    protected processCancelIdentityCheck(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveIdentityCheckFields(customerId: number, body: SaveIdentityCheckFieldsBody | undefined): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/customer/{customerId}/identity-fields";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveIdentityCheckFields(_response);
        });
    }

    protected processSaveIdentityCheckFields(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @param dealId (optional) 
     * @return Success
     */
    resetKsvSearch(customerId: number, dealId: number | undefined): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/customer/{customerId}/ksv-search?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (dealId === null)
            throw new Error("The parameter 'dealId' cannot be null.");
        else if (dealId !== undefined)
            url_ += "dealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResetKsvSearch(_response);
        });
    }

    protected processResetKsvSearch(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPrivateCustomer(id: number): Promise<PrivateCustomerViewApiResult> {
        let url_ = this.baseUrl + "/customer/private/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivateCustomer(_response);
        });
    }

    protected processGetPrivateCustomer(response: Response): Promise<PrivateCustomerViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivateCustomerViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivateCustomerViewApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPrivateCustomer(body: CreatePrivateCustomerRequest | undefined): Promise<CreatePrivateCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/customer/private";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreatePrivateCustomer(_response);
        });
    }

    protected processCreatePrivateCustomer(response: Response): Promise<CreatePrivateCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePrivateCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatePrivateCustomerResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editPrivateCustomer(body: EditPrivateCustomerRequest | undefined): Promise<EditPrivateCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/customer/private/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditPrivateCustomer(_response);
        });
    }

    protected processEditPrivateCustomer(response: Response): Promise<EditPrivateCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditPrivateCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditPrivateCustomerResponseApiResult>(null as any);
    }

    /**
     * @param street (optional) 
     * @param house (optional) 
     * @param zipCode (optional) 
     * @param city (optional) 
     * @param ksvId (optional) 
     * @return Success
     */
    searchPrivateCustomerKSV(firstName: string, lastName: string, birthDate: Date, street: string | undefined, house: string | undefined, zipCode: string | undefined, city: string | undefined, ksvId: string | undefined): Promise<PrivateCustomerKsvResponseIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/customer/private/ksv?";
        if (firstName === undefined || firstName === null)
            throw new Error("The parameter 'firstName' must be defined and cannot be null.");
        else
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === undefined || lastName === null)
            throw new Error("The parameter 'lastName' must be defined and cannot be null.");
        else
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (birthDate === undefined || birthDate === null)
            throw new Error("The parameter 'birthDate' must be defined and cannot be null.");
        else
            url_ += "BirthDate=" + encodeURIComponent(birthDate ? "" + birthDate.toISOString() : "") + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (house === null)
            throw new Error("The parameter 'house' cannot be null.");
        else if (house !== undefined)
            url_ += "House=" + encodeURIComponent("" + house) + "&";
        if (zipCode === null)
            throw new Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (ksvId === null)
            throw new Error("The parameter 'ksvId' cannot be null.");
        else if (ksvId !== undefined)
            url_ += "KsvId=" + encodeURIComponent("" + ksvId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchPrivateCustomerKSV(_response);
        });
    }

    protected processSearchPrivateCustomerKSV(response: Response): Promise<PrivateCustomerKsvResponseIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivateCustomerKsvResponseIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivateCustomerKsvResponseIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param birthDate (optional) 
     * @param country (optional) 
     * @param city (optional) 
     * @param street (optional) 
     * @param postalCode (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    searchSimilarPrivate(customerId: number, firstName: string | undefined, lastName: string | undefined, birthDate: Date | undefined, country: string | undefined, city: string | undefined, street: string | undefined, postalCode: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<MergeCustomerViewIPagedListApiResult> {
        let url_ = this.baseUrl + "/customer/private/similar?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (firstName === null)
            throw new Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (birthDate === null)
            throw new Error("The parameter 'birthDate' cannot be null.");
        else if (birthDate !== undefined)
            url_ += "BirthDate=" + encodeURIComponent(birthDate ? "" + birthDate.toISOString() : "") + "&";
        if (country === null)
            throw new Error("The parameter 'country' cannot be null.");
        else if (country !== undefined)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchSimilarPrivate(_response);
        });
    }

    protected processSearchSimilarPrivate(response: Response): Promise<MergeCustomerViewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MergeCustomerViewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeCustomerViewIPagedListApiResult>(null as any);
    }

    /**
     * @param group (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    getDocuments(category: DocumentCategory, group: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<DocumentOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/dashboard/documents?";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        if (group === null)
            throw new Error("The parameter 'group' cannot be null.");
        else if (group !== undefined)
            url_ += "Group=" + encodeURIComponent("" + group) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: Response): Promise<DocumentOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getAllowedDocumentGroups(category: DocumentCategory): Promise<StringIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/documentGroups?";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined and cannot be null.");
        else
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedDocumentGroups(_response);
        });
    }

    protected processGetAllowedDocumentGroups(response: Response): Promise<StringIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    downloadDocument(attachmentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dashboard/documents/{attachmentId}";
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getDetail(contract: string): Promise<GetDetailResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/{contract}";
        if (contract === undefined || contract === null)
            throw new Error("The parameter 'contract' must be defined.");
        url_ = url_.replace("{contract}", encodeURIComponent("" + contract));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetail(_response);
        });
    }

    protected processGetDetail(response: Response): Promise<GetDetailResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDetailResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDetailResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getReport(contract: string): Promise<ReportEntryApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/{contract}/report";
        if (contract === undefined || contract === null)
            throw new Error("The parameter 'contract' must be defined.");
        url_ = url_.replace("{contract}", encodeURIComponent("" + contract));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReport(_response);
        });
    }

    protected processGetReport(response: Response): Promise<ReportEntryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportEntryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportEntryApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInquire(contract: string, body: NotificationModel | undefined): Promise<GetDetailResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/{contract}/inquire";
        if (contract === undefined || contract === null)
            throw new Error("The parameter 'contract' must be defined.");
        url_ = url_.replace("{contract}", encodeURIComponent("" + contract));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInquire(_response);
        });
    }

    protected processSendInquire(response: Response): Promise<GetDetailResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDetailResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDetailResponseApiResult>(null as any);
    }

    /**
     * @param applicationState (optional) 
     * @return Success
     */
    getApplications(showAll: boolean, applicationState: number | undefined): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/application?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (applicationState === null)
            throw new Error("The parameter 'applicationState' cannot be null.");
        else if (applicationState !== undefined)
            url_ += "ApplicationState=" + encodeURIComponent("" + applicationState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplications(_response);
        });
    }

    protected processGetApplications(response: Response): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationModelIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationModelIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param applicationState (optional) 
     * @return Success
     */
    getPriliminaryContracts(showAll: boolean, applicationState: number | undefined): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/preliminary?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (applicationState === null)
            throw new Error("The parameter 'applicationState' cannot be null.");
        else if (applicationState !== undefined)
            url_ += "ApplicationState=" + encodeURIComponent("" + applicationState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPriliminaryContracts(_response);
        });
    }

    protected processGetPriliminaryContracts(response: Response): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationModelIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationModelIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getActiveContracts(showAll: boolean, filter: ActiveContractFilter): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/active?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (filter === undefined || filter === null)
            throw new Error("The parameter 'filter' must be defined and cannot be null.");
        else
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveContracts(_response);
        });
    }

    protected processGetActiveContracts(response: Response): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationModelIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationModelIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getExpiredDeals(state: ExpiredDealState, showAll: boolean): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/expired?";
        if (state === undefined || state === null)
            throw new Error("The parameter 'state' must be defined and cannot be null.");
        else
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExpiredDeals(_response);
        });
    }

    protected processGetExpiredDeals(response: Response): Promise<ApplicationModelIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationModelIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationModelIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSalesContest(): Promise<GetSalesContestResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/incentive";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesContest(_response);
        });
    }

    protected processGetSalesContest(response: Response): Promise<GetSalesContestResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesContestResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSalesContestResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setApproval(body: SetApprovalRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/dashboard/incentive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetApproval(_response);
        });
    }

    protected processSetApproval(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param searchText (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    searchContracts(showAll: boolean, searchText: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<ApplicationModelIPagedListApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/search?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (searchText === null)
            throw new Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchContracts(_response);
        });
    }

    protected processSearchContracts(response: Response): Promise<ApplicationModelIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationModelIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationModelIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getRkvConfiguration(rkv: string): Promise<RkvConfigurationEntryApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/rkvConfiguration?";
        if (rkv === undefined || rkv === null)
            throw new Error("The parameter 'rkv' must be defined and cannot be null.");
        else
            url_ += "rkv=" + encodeURIComponent("" + rkv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRkvConfiguration(_response);
        });
    }

    protected processGetRkvConfiguration(response: Response): Promise<RkvConfigurationEntryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RkvConfigurationEntryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RkvConfigurationEntryApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDashboardConfiguration(body: SaveDashboardConfigurationRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/dashboard/contracts/dealPriceDisplay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDashboardConfiguration(_response);
        });
    }

    protected processSaveDashboardConfiguration(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getApplicationWidget(showAll: boolean): Promise<StringInt32DictionaryApiResult> {
        let url_ = this.baseUrl + "/dashboard/widgets/application?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationWidget(_response);
        });
    }

    protected processGetApplicationWidget(response: Response): Promise<StringInt32DictionaryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringInt32DictionaryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringInt32DictionaryApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPreliminaryWidget(showAll: boolean): Promise<StringInt32DictionaryApiResult> {
        let url_ = this.baseUrl + "/dashboard/widgets/preliminary?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreliminaryWidget(_response);
        });
    }

    protected processGetPreliminaryWidget(response: Response): Promise<StringInt32DictionaryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringInt32DictionaryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringInt32DictionaryApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getActiveWidget(showAll: boolean): Promise<StringInt32DictionaryApiResult> {
        let url_ = this.baseUrl + "/dashboard/widgets/active?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActiveWidget(_response);
        });
    }

    protected processGetActiveWidget(response: Response): Promise<StringInt32DictionaryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringInt32DictionaryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringInt32DictionaryApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDocumentWidget(showAll: boolean): Promise<StringInt32DictionaryApiResult> {
        let url_ = this.baseUrl + "/dashboard/widgets/document?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDocumentWidget(_response);
        });
    }

    protected processGetDocumentWidget(response: Response): Promise<StringInt32DictionaryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringInt32DictionaryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringInt32DictionaryApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSpecialOfferWidget(showAll: boolean): Promise<StringInt32DictionaryApiResult> {
        let url_ = this.baseUrl + "/dashboard/widgets/specialoffer?";
        if (showAll === undefined || showAll === null)
            throw new Error("The parameter 'showAll' must be defined and cannot be null.");
        else
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpecialOfferWidget(_response);
        });
    }

    protected processGetSpecialOfferWidget(response: Response): Promise<StringInt32DictionaryApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringInt32DictionaryApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringInt32DictionaryApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDissolveValuesReport(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dashboard/reports/dissolveValues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDissolveValuesReport(_response);
        });
    }

    protected processGetDissolveValuesReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getContractsReport(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/dashboard/reports/contracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream; charset=utf-8"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContractsReport(_response);
        });
    }

    protected processGetContractsReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getConfigurationValues(configurationEnumeration: AllowedSettingsReading): Promise<GetConfigurationValuesResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/configuration/getConfiguration?";
        if (configurationEnumeration === undefined || configurationEnumeration === null)
            throw new Error("The parameter 'configurationEnumeration' must be defined and cannot be null.");
        else
            url_ += "configurationEnumeration=" + encodeURIComponent("" + configurationEnumeration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationValues(_response);
        });
    }

    protected processGetConfigurationValues(response: Response): Promise<GetConfigurationValuesResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetConfigurationValuesResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConfigurationValuesResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getTypeCertificate(dealId: number): Promise<GetTypeCertificateInfoResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/typeCertificate/info?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTypeCertificate(_response);
        });
    }

    protected processGetTypeCertificate(response: Response): Promise<GetTypeCertificateInfoResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTypeCertificateInfoResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTypeCertificateInfoResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTypeCertificate(body: SendTypeCertificateRequest | undefined): Promise<SendTypeCertificateResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/typeCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendTypeCertificate(_response);
        });
    }

    protected processSendTypeCertificate(response: Response): Promise<SendTypeCertificateResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendTypeCertificateResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendTypeCertificateResponseApiResult>(null as any);
    }

    /**
     * @param dissolveDates (optional) 
     * @return Success
     */
    getDissolveValues(cmsId: number, dissolveDates: Date[] | undefined): Promise<LeasmanDissolveValueIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/dashboard/dissolve?";
        if (cmsId === undefined || cmsId === null)
            throw new Error("The parameter 'cmsId' must be defined and cannot be null.");
        else
            url_ += "CmsId=" + encodeURIComponent("" + cmsId) + "&";
        if (dissolveDates === null)
            throw new Error("The parameter 'dissolveDates' cannot be null.");
        else if (dissolveDates !== undefined)
            dissolveDates && dissolveDates.forEach(item_ => { url_ += "DissolveDates=" + encodeURIComponent(item_ ? "" + item_.toISOString() : "null") + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDissolveValues(_response);
        });
    }

    protected processGetDissolveValues(response: Response): Promise<LeasmanDissolveValueIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeasmanDissolveValueIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LeasmanDissolveValueIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDissolveValues(body: SaveDissolveValuesRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/dashboard/dissolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDissolveValues(_response);
        });
    }

    protected processSaveDissolveValues(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPurchaseApplication(body: SendPurchaseApplicationRequest | undefined): Promise<SendPurchaseApplicationResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/purchaseApplication/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendPurchaseApplication(_response);
        });
    }

    protected processSendPurchaseApplication(response: Response): Promise<SendPurchaseApplicationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendPurchaseApplicationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SendPurchaseApplicationResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signPurchaseApplication(body: SignPurchaseApplicationRequest | undefined): Promise<SignFinancingCalculationDocumentsResponseApiResult> {
        let url_ = this.baseUrl + "/dashboard/purchaseApplication/sign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignPurchaseApplication(_response);
        });
    }

    protected processSignPurchaseApplication(response: Response): Promise<SignFinancingCalculationDocumentsResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignFinancingCalculationDocumentsResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignFinancingCalculationDocumentsResponseApiResult>(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    getDealOverview(searchTerm: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<DealOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/deal?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealOverview(_response);
        });
    }

    protected processGetDealOverview(response: Response): Promise<DealOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDeal(body: SaveDealRequest | undefined): Promise<SaveDealResponseApiResult> {
        let url_ = this.baseUrl + "/deal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDeal(_response);
        });
    }

    protected processSaveDeal(response: Response): Promise<SaveDealResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveDealResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveDealResponseApiResult>(null as any);
    }

    /**
     * @param dealId (optional) 
     * @param salesPerson (optional) 
     * @param trademark (optional) 
     * @param model (optional) 
     * @param dealFrom (optional) 
     * @param dealCreated (optional) 
     * @param customer (optional) 
     * @param hasFinancing (optional) 
     * @param hasInsurance (optional) 
     * @param hasSubmitted (optional) 
     * @param isFleet (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    dealAdvancedSearch(dealId: string | undefined, salesPerson: string | undefined, trademark: string | undefined, model: string | undefined, dealFrom: Date | undefined, dealCreated: Date | undefined, customer: string | undefined, hasFinancing: boolean | undefined, hasInsurance: boolean | undefined, hasSubmitted: boolean | undefined, isFleet: boolean | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<DealOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/deal/search?";
        if (dealId === null)
            throw new Error("The parameter 'dealId' cannot be null.");
        else if (dealId !== undefined)
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (salesPerson === null)
            throw new Error("The parameter 'salesPerson' cannot be null.");
        else if (salesPerson !== undefined)
            url_ += "SalesPerson=" + encodeURIComponent("" + salesPerson) + "&";
        if (trademark === null)
            throw new Error("The parameter 'trademark' cannot be null.");
        else if (trademark !== undefined)
            url_ += "Trademark=" + encodeURIComponent("" + trademark) + "&";
        if (model === null)
            throw new Error("The parameter 'model' cannot be null.");
        else if (model !== undefined)
            url_ += "Model=" + encodeURIComponent("" + model) + "&";
        if (dealFrom === null)
            throw new Error("The parameter 'dealFrom' cannot be null.");
        else if (dealFrom !== undefined)
            url_ += "DealFrom=" + encodeURIComponent(dealFrom ? "" + dealFrom.toISOString() : "") + "&";
        if (dealCreated === null)
            throw new Error("The parameter 'dealCreated' cannot be null.");
        else if (dealCreated !== undefined)
            url_ += "DealCreated=" + encodeURIComponent(dealCreated ? "" + dealCreated.toISOString() : "") + "&";
        if (customer === null)
            throw new Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined)
            url_ += "Customer=" + encodeURIComponent("" + customer) + "&";
        if (hasFinancing === null)
            throw new Error("The parameter 'hasFinancing' cannot be null.");
        else if (hasFinancing !== undefined)
            url_ += "HasFinancing=" + encodeURIComponent("" + hasFinancing) + "&";
        if (hasInsurance === null)
            throw new Error("The parameter 'hasInsurance' cannot be null.");
        else if (hasInsurance !== undefined)
            url_ += "HasInsurance=" + encodeURIComponent("" + hasInsurance) + "&";
        if (hasSubmitted === null)
            throw new Error("The parameter 'hasSubmitted' cannot be null.");
        else if (hasSubmitted !== undefined)
            url_ += "HasSubmitted=" + encodeURIComponent("" + hasSubmitted) + "&";
        if (isFleet === null)
            throw new Error("The parameter 'isFleet' cannot be null.");
        else if (isFleet !== undefined)
            url_ += "IsFleet=" + encodeURIComponent("" + isFleet) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDealAdvancedSearch(_response);
        });
    }

    protected processDealAdvancedSearch(response: Response): Promise<DealOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDeal(id: number): Promise<GetDealResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeal(_response);
        });
    }

    protected processGetDeal(response: Response): Promise<GetDealResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDealResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDealResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDealCalculationsOverview(id: number): Promise<DealCalculationOverviewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/{id}/calculations";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealCalculationsOverview(_response);
        });
    }

    protected processGetDealCalculationsOverview(response: Response): Promise<DealCalculationOverviewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealCalculationOverviewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealCalculationOverviewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    isValidCustomer(dealId: number, customerId: number): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/{customerId}/valid";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsValidCustomer(_response);
        });
    }

    protected processIsValidCustomer(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @return Success
     */
    isValidInsuranceCustomer(dealId: number, customerId: number): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/{customerId}/valid/insurance";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsValidInsuranceCustomer(_response);
        });
    }

    protected processIsValidInsuranceCustomer(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @return Success
     */
    isKsvBypassApplicable(dealId: number, customerId: number): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/{customerId}/insurance/ksvBypassApplicable";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsKsvBypassApplicable(_response);
        });
    }

    protected processIsKsvBypassApplicable(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addCoApplicant(dealId: number, body: CoApplicantCustomer | undefined): Promise<AddCoApplicantResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/CoApplicant";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddCoApplicant(_response);
        });
    }

    protected processAddCoApplicant(response: Response): Promise<AddCoApplicantResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCoApplicantResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddCoApplicantResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDealCoApplicantOverview(dealId: number): Promise<CoApplicantOverviewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/ApplicantOverview";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealCoApplicantOverview(_response);
        });
    }

    protected processGetDealCoApplicantOverview(response: Response): Promise<CoApplicantOverviewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CoApplicantOverviewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CoApplicantOverviewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    deleteApplicant(dealId: number, customerId: number): Promise<DeleteCoApplicantResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/{customerId}/applicant";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteApplicant(_response);
        });
    }

    protected processDeleteApplicant(response: Response): Promise<DeleteCoApplicantResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCoApplicantResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeleteCoApplicantResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPrivateDealCustomer(dealId: number, customerId: number): Promise<PrivateCustomerViewApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/private/{customerId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrivateDealCustomer(_response);
        });
    }

    protected processGetPrivateDealCustomer(response: Response): Promise<PrivateCustomerViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrivateCustomerViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivateCustomerViewApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCommercialDealCustomer(dealId: number, customerId: number): Promise<CommercialCustomerViewApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/commercial/{customerId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommercialDealCustomer(_response);
        });
    }

    protected processGetCommercialDealCustomer(response: Response): Promise<CommercialCustomerViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommercialCustomerViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommercialCustomerViewApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editPrivateDealCustomer(body: EditPrivateDealCustomerRequest | undefined): Promise<EditPrivateCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/customer/private/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditPrivateDealCustomer(_response);
        });
    }

    protected processEditPrivateDealCustomer(response: Response): Promise<EditPrivateCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditPrivateCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditPrivateCustomerResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editCommercialDealCustomer(body: EditCommercialDealCustomerRequest | undefined): Promise<EditCommercialCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/customer/commercial/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditCommercialDealCustomer(_response);
        });
    }

    protected processEditCommercialDealCustomer(response: Response): Promise<EditCommercialCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditCommercialCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditCommercialCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    confirmStagingCustomer(dealId: number): Promise<ConfirmStagingCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/staging/confirm";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmStagingCustomer(_response);
        });
    }

    protected processConfirmStagingCustomer(response: Response): Promise<ConfirmStagingCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmStagingCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmStagingCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    confirmAmendedCustomer(dealId: number): Promise<ConfirmAmendedCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/staging/amend";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processConfirmAmendedCustomer(_response);
        });
    }

    protected processConfirmAmendedCustomer(response: Response): Promise<ConfirmAmendedCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmAmendedCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmAmendedCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    compareDealWithMainCustomer(dealId: number): Promise<CompareMainCustomerWithDealCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/compareDealWithMainCustomer?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompareDealWithMainCustomer(_response);
        });
    }

    protected processCompareDealWithMainCustomer(response: Response): Promise<CompareMainCustomerWithDealCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompareMainCustomerWithDealCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompareMainCustomerWithDealCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    updateDealCustomerWithMainCustomer(dealId: number): Promise<UpdateDealCustomerWithMainCustomerResponseApiResult> {
        let url_ = this.baseUrl + "/deal/updateDealCustomerWithMainCustomer?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDealCustomerWithMainCustomer(_response);
        });
    }

    protected processUpdateDealCustomerWithMainCustomer(response: Response): Promise<UpdateDealCustomerWithMainCustomerResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateDealCustomerWithMainCustomerResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateDealCustomerWithMainCustomerResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDealTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/type";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealTypes(_response);
        });
    }

    protected processGetDealTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSalesChannels(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/salesChannels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalesChannels(_response);
        });
    }

    protected processGetSalesChannels(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDiscountCategories(dealTypeId: number): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/discountCategories?";
        if (dealTypeId === undefined || dealTypeId === null)
            throw new Error("The parameter 'dealTypeId' must be defined and cannot be null.");
        else
            url_ += "DealTypeId=" + encodeURIComponent("" + dealTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscountCategories(_response);
        });
    }

    protected processGetDiscountCategories(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPredefinedValues(modelId: number): Promise<GetPredefinedValuesResponseApiResult> {
        let url_ = this.baseUrl + "/deal/predefinedValues/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPredefinedValues(_response);
        });
    }

    protected processGetPredefinedValues(response: Response): Promise<GetPredefinedValuesResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPredefinedValuesResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPredefinedValuesResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    validateVehicleAge(modelId: number, vehicleTypeConditionId: number, dealTypeId: number, registrationDate: Date): Promise<ValidateVehicleAgeResponseApiResult> {
        let url_ = this.baseUrl + "/deal/validateVehicleAge?";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined and cannot be null.");
        else
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (vehicleTypeConditionId === undefined || vehicleTypeConditionId === null)
            throw new Error("The parameter 'vehicleTypeConditionId' must be defined and cannot be null.");
        else
            url_ += "VehicleTypeConditionId=" + encodeURIComponent("" + vehicleTypeConditionId) + "&";
        if (dealTypeId === undefined || dealTypeId === null)
            throw new Error("The parameter 'dealTypeId' must be defined and cannot be null.");
        else
            url_ += "DealTypeId=" + encodeURIComponent("" + dealTypeId) + "&";
        if (registrationDate === undefined || registrationDate === null)
            throw new Error("The parameter 'registrationDate' must be defined and cannot be null.");
        else
            url_ += "RegistrationDate=" + encodeURIComponent(registrationDate ? "" + registrationDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateVehicleAge(_response);
        });
    }

    protected processValidateVehicleAge(response: Response): Promise<ValidateVehicleAgeResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVehicleAgeResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateVehicleAgeResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    validateVehicleAgeByDealId(dealId: number, registrationDate: Date): Promise<ValidateVehicleAgeResponseApiResult> {
        let url_ = this.baseUrl + "/deal/validateVehicleAgeByDealId?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (registrationDate === undefined || registrationDate === null)
            throw new Error("The parameter 'registrationDate' must be defined and cannot be null.");
        else
            url_ += "RegistrationDate=" + encodeURIComponent(registrationDate ? "" + registrationDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateVehicleAgeByDealId(_response);
        });
    }

    protected processValidateVehicleAgeByDealId(response: Response): Promise<ValidateVehicleAgeResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateVehicleAgeResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateVehicleAgeResponseApiResult>(null as any);
    }

    /**
     * @param orderSelectors (optional) 
     * @return Success
     */
    getInsuranceOverview(id: number, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<DealInsuranceOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/deal/{id}/insurances?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceOverview(_response);
        });
    }

    protected processGetInsuranceOverview(response: Response): Promise<DealInsuranceOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealInsuranceOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealInsuranceOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    transferDeal(offerId: string): Promise<DealTransferResponseApiResult> {
        let url_ = this.baseUrl + "/deal/transfer/{offerId}";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTransferDeal(_response);
        });
    }

    protected processTransferDeal(response: Response): Promise<DealTransferResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DealTransferResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DealTransferResponseApiResult>(null as any);
    }

    /**
     * @param salesPersonId (optional) 
     * @param registrationDate (optional) 
     * @param dId (optional) 
     * @param salesPersonName (optional) 
     * @param creationDate (optional) 
     * @param customerName (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    getSubmittedDealsForNewDeal(modelId: number, dealTypeId: number, vehicleTypeConditionId: number, distributionChannel: number, salesPersonId: number | undefined, registrationDate: Date | undefined, dId: string | undefined, salesPersonName: string | undefined, creationDate: Date | undefined, customerName: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<SubmittedDealOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/deal/submittedDealsForNewDeal?";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined and cannot be null.");
        else
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (dealTypeId === undefined || dealTypeId === null)
            throw new Error("The parameter 'dealTypeId' must be defined and cannot be null.");
        else
            url_ += "DealTypeId=" + encodeURIComponent("" + dealTypeId) + "&";
        if (vehicleTypeConditionId === undefined || vehicleTypeConditionId === null)
            throw new Error("The parameter 'vehicleTypeConditionId' must be defined and cannot be null.");
        else
            url_ += "VehicleTypeConditionId=" + encodeURIComponent("" + vehicleTypeConditionId) + "&";
        if (distributionChannel === undefined || distributionChannel === null)
            throw new Error("The parameter 'distributionChannel' must be defined and cannot be null.");
        else
            url_ += "DistributionChannel=" + encodeURIComponent("" + distributionChannel) + "&";
        if (salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' cannot be null.");
        else if (salesPersonId !== undefined)
            url_ += "SalesPersonId=" + encodeURIComponent("" + salesPersonId) + "&";
        if (registrationDate === null)
            throw new Error("The parameter 'registrationDate' cannot be null.");
        else if (registrationDate !== undefined)
            url_ += "RegistrationDate=" + encodeURIComponent(registrationDate ? "" + registrationDate.toISOString() : "") + "&";
        if (dId === null)
            throw new Error("The parameter 'dId' cannot be null.");
        else if (dId !== undefined)
            url_ += "dId=" + encodeURIComponent("" + dId) + "&";
        if (salesPersonName === null)
            throw new Error("The parameter 'salesPersonName' cannot be null.");
        else if (salesPersonName !== undefined)
            url_ += "SalesPersonName=" + encodeURIComponent("" + salesPersonName) + "&";
        if (creationDate === null)
            throw new Error("The parameter 'creationDate' cannot be null.");
        else if (creationDate !== undefined)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (customerName === null)
            throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmittedDealsForNewDeal(_response);
        });
    }

    protected processGetSubmittedDealsForNewDeal(response: Response): Promise<SubmittedDealOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmittedDealOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmittedDealOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @param calculationId (optional) 
     * @param dId (optional) 
     * @param salesPersonName (optional) 
     * @param creationDate (optional) 
     * @param customerName (optional) 
     * @param orderSelectors (optional) 
     * @return Success
     */
    getSubmittedDealsForExistingDeal(dealId: number, calculationId: number | undefined, dId: string | undefined, salesPersonName: string | undefined, creationDate: Date | undefined, customerName: string | undefined, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<SubmittedDealOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/deal/submittedDeals?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (calculationId === null)
            throw new Error("The parameter 'calculationId' cannot be null.");
        else if (calculationId !== undefined)
            url_ += "CalculationId=" + encodeURIComponent("" + calculationId) + "&";
        if (dId === null)
            throw new Error("The parameter 'dId' cannot be null.");
        else if (dId !== undefined)
            url_ += "dId=" + encodeURIComponent("" + dId) + "&";
        if (salesPersonName === null)
            throw new Error("The parameter 'salesPersonName' cannot be null.");
        else if (salesPersonName !== undefined)
            url_ += "SalesPersonName=" + encodeURIComponent("" + salesPersonName) + "&";
        if (creationDate === null)
            throw new Error("The parameter 'creationDate' cannot be null.");
        else if (creationDate !== undefined)
            url_ += "CreationDate=" + encodeURIComponent(creationDate ? "" + creationDate.toISOString() : "") + "&";
        if (customerName === null)
            throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined)
            url_ += "CustomerName=" + encodeURIComponent("" + customerName) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubmittedDealsForExistingDeal(_response);
        });
    }

    protected processGetSubmittedDealsForExistingDeal(response: Response): Promise<SubmittedDealOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmittedDealOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmittedDealOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getUploadedDocument(uploadedDocumentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/uploaded/{uploadedDocumentId}";
        if (uploadedDocumentId === undefined || uploadedDocumentId === null)
            throw new Error("The parameter 'uploadedDocumentId' must be defined.");
        url_ = url_.replace("{uploadedDocumentId}", encodeURIComponent("" + uploadedDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUploadedDocument(_response);
        });
    }

    protected processGetUploadedDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getVinStatus(vin: string): Promise<VinParametersApiResult> {
        let url_ = this.baseUrl + "/deal/vin/{vin}";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVinStatus(_response);
        });
    }

    protected processGetVinStatus(response: Response): Promise<VinParametersApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VinParametersApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VinParametersApiResult>(null as any);
    }

    /**
     * @return Success
     */
    extend(cmsId: number, dealId: number): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/extend/{cmsId}";
        if (cmsId === undefined || cmsId === null)
            throw new Error("The parameter 'cmsId' must be defined.");
        url_ = url_.replace("{cmsId}", encodeURIComponent("" + cmsId));
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExtend(_response);
        });
    }

    protected processExtend(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    replaceDealCustomer(dealId: number, customerId: number): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/customer/replace?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReplaceDealCustomer(_response);
        });
    }

    protected processReplaceDealCustomer(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    setSalesPerson(dealId: number, salesPersonId: number): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/salesperson?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (salesPersonId === undefined || salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' must be defined and cannot be null.");
        else
            url_ += "salesPersonId=" + encodeURIComponent("" + salesPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetSalesPerson(_response);
        });
    }

    protected processSetSalesPerson(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assignFleet(body: AssignFleetRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/fleet/assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAssignFleet(_response);
        });
    }

    protected processAssignFleet(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPossibleFleet(dealId: number): Promise<GetPossibleFleetResponseApiResult> {
        let url_ = this.baseUrl + "/deal/fleet/{dealId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPossibleFleet(_response);
        });
    }

    protected processGetPossibleFleet(response: Response): Promise<GetPossibleFleetResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPossibleFleetResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPossibleFleetResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getVinAssignments(dealId: number): Promise<VinAssignmentIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/vin";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVinAssignments(_response);
        });
    }

    protected processGetVinAssignments(response: Response): Promise<VinAssignmentIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VinAssignmentIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VinAssignmentIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getFleetHandOver(dealId: number): Promise<FleetVinAssignmentIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/fleet/handover";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFleetHandOver(_response);
        });
    }

    protected processGetFleetHandOver(response: Response): Promise<FleetVinAssignmentIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FleetVinAssignmentIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FleetVinAssignmentIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getCommissionDealer(dealId: number): Promise<CommissionDealerIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/dealer/commission";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCommissionDealer(_response);
        });
    }

    protected processGetCommissionDealer(response: Response): Promise<CommissionDealerIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommissionDealerIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionDealerIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    triggerTakeoverConditionAdjustment(dealId: number, id: number): Promise<TakeoverConditionAdjustmentResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTriggerTakeoverConditionAdjustment(_response);
        });
    }

    protected processTriggerTakeoverConditionAdjustment(response: Response): Promise<TakeoverConditionAdjustmentResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TakeoverConditionAdjustmentResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TakeoverConditionAdjustmentResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getTakeoverDispatchDate(dealId: number, id: number): Promise<TakeoverDispatchDateApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover/dispatch-date";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTakeoverDispatchDate(_response);
        });
    }

    protected processGetTakeoverDispatchDate(response: Response): Promise<TakeoverDispatchDateApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TakeoverDispatchDateApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TakeoverDispatchDateApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setTakeoverDispatchDate(dealId: number, id: number, body: TakeoverDispatchDate | undefined): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover/dispatch-date";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTakeoverDispatchDate(_response);
        });
    }

    protected processSetTakeoverDispatchDate(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveTakeoverPositions(dealId: number, id: number, body: TakeoverPositions | undefined): Promise<BooleanApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover/positions";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTakeoverPositions(_response);
        });
    }

    protected processSaveTakeoverPositions(response: Response): Promise<BooleanApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BooleanApiResult>(null as any);
    }

    /**
     * @return Success
     */
    printTakeoverConditionDocuments(dealId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover/print";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintTakeoverConditionDocuments(_response);
        });
    }

    protected processPrintTakeoverConditionDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    signTakeoverConditionDocuments(dealId: number, id: number): Promise<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/calculation/{id}/takeover/sign";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignTakeoverConditionDocuments(_response);
        });
    }

    protected processSignTakeoverConditionDocuments(response: Response): Promise<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getUploadedDocuments(dealId: number): Promise<UploadedDocumentViewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/uploaded";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUploadedDocuments(_response);
        });
    }

    protected processGetUploadedDocuments(response: Response): Promise<UploadedDocumentViewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadedDocumentViewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadedDocumentViewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getRequiredDocuments(dealId: number): Promise<RequiredDocumentViewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/required";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRequiredDocuments(_response);
        });
    }

    protected processGetRequiredDocuments(response: Response): Promise<RequiredDocumentViewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequiredDocumentViewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequiredDocumentViewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @param files (optional) 
     * @return Success
     */
    uploadDocument(dealId: number, documentId: number, files: FileParameter[] | undefined): Promise<UploadDocumentResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/upload/{documentId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: Response): Promise<UploadDocumentResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadDocumentResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDocumentResponseApiResult>(null as any);
    }

    /**
     * @param files (optional) 
     * @return Success
     */
    forceUploadDocument(dealId: number, documentId: number, files: FileParameter[] | undefined): Promise<UploadDocumentResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/upload/{documentId}/force";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files === null || files === undefined)
            throw new Error("The parameter 'files' cannot be null.");
        else
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processForceUploadDocument(_response);
        });
    }

    protected processForceUploadDocument(response: Response): Promise<UploadDocumentResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadDocumentResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadDocumentResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSignedDocuments(dealId: number): Promise<SignedDocumentOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/signed";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignedDocuments(_response);
        });
    }

    protected processGetSignedDocuments(response: Response): Promise<SignedDocumentOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignedDocumentOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignedDocumentOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSignedDocument(dealId: number, signedDocumentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/signed/{signedDocumentId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (signedDocumentId === undefined || signedDocumentId === null)
            throw new Error("The parameter 'signedDocumentId' must be defined.");
        url_ = url_.replace("{signedDocumentId}", encodeURIComponent("" + signedDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSignedDocument(_response);
        });
    }

    protected processGetSignedDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    notifySignatureWorkstepFinished(dealId: number, workstepId: string): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/signed/notify?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (workstepId === undefined || workstepId === null)
            throw new Error("The parameter 'workstepId' must be defined and cannot be null.");
        else
            url_ += "workstepId=" + encodeURIComponent("" + workstepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotifySignatureWorkstepFinished(_response);
        });
    }

    protected processNotifySignatureWorkstepFinished(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    cancelSignedDocument(dealId: number, signedDocumentId: number): Promise<ApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/signed/{signedDocumentId}/cancel";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (signedDocumentId === undefined || signedDocumentId === null)
            throw new Error("The parameter 'signedDocumentId' must be defined.");
        url_ = url_.replace("{signedDocumentId}", encodeURIComponent("" + signedDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelSignedDocument(_response);
        });
    }

    protected processCancelSignedDocument(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archiveSignedDocument(dealId: number, body: number[] | undefined): Promise<ArchiveSignedDocumentsResponseApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/signed/archive";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processArchiveSignedDocument(_response);
        });
    }

    protected processArchiveSignedDocument(response: Response): Promise<ArchiveSignedDocumentsResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArchiveSignedDocumentsResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArchiveSignedDocumentsResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getArchivedDocuments(dealId: number): Promise<ArchivedDocumentOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/archived";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetArchivedDocuments(_response);
        });
    }

    protected processGetArchivedDocuments(response: Response): Promise<ArchivedDocumentOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArchivedDocumentOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ArchivedDocumentOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getArchivedDocument(dealId: number, archivedDocumentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/archived/{archivedDocumentId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (archivedDocumentId === undefined || archivedDocumentId === null)
            throw new Error("The parameter 'archivedDocumentId' must be defined.");
        url_ = url_.replace("{archivedDocumentId}", encodeURIComponent("" + archivedDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetArchivedDocument(_response);
        });
    }

    protected processGetArchivedDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPrintedDocuments(dealId: number): Promise<PrintedDocumentViewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/printed";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintedDocuments(_response);
        });
    }

    protected processGetPrintedDocuments(response: Response): Promise<PrintedDocumentViewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintedDocumentViewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintedDocumentViewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPrintedDocument(dealId: number, printedDocumentId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/deal/{dealId}/documents/printed/{printedDocumentId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        if (printedDocumentId === undefined || printedDocumentId === null)
            throw new Error("The parameter 'printedDocumentId' must be defined.");
        url_ = url_.replace("{printedDocumentId}", encodeURIComponent("" + printedDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintedDocument(_response);
        });
    }

    protected processGetPrintedDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getVinStatusExternal(vin: string): Promise<VinParametersApiResult> {
        let url_ = this.baseUrl + "/external/vin/{vin}";
        if (vin === undefined || vin === null)
            throw new Error("The parameter 'vin' must be defined.");
        url_ = url_.replace("{vin}", encodeURIComponent("" + vin));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVinStatusExternal(_response);
        });
    }

    protected processGetVinStatusExternal(response: Response): Promise<VinParametersApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VinParametersApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VinParametersApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    completeCalculationExternal(body: CompleteCalculationRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/external/calculation/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteCalculationExternal(_response);
        });
    }

    protected processCompleteCalculationExternal(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateServiceContractExternal(body: UpdateServiceContractRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/external/calculation/service/contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateServiceContractExternal(_response);
        });
    }

    protected processUpdateServiceContractExternal(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportCalculationDocumentsExternal(body: ExportCalculationDocumentsRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/external/calculation/document/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExportCalculationDocumentsExternal(_response);
        });
    }

    protected processExportCalculationDocumentsExternal(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param position (optional) 
     * @return Success
     */
    getFundingApplicationXmlExternal(calculationId: number, position: number | undefined): Promise<ApplicationXmlResponseApiResult> {
        let url_ = this.baseUrl + "/external/calculation/funding/{calculationId}/application-xml?";
        if (calculationId === undefined || calculationId === null)
            throw new Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        if (position === null)
            throw new Error("The parameter 'position' cannot be null.");
        else if (position !== undefined)
            url_ += "position=" + encodeURIComponent("" + position) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFundingApplicationXmlExternal(_response);
        });
    }

    protected processGetFundingApplicationXmlExternal(response: Response): Promise<ApplicationXmlResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationXmlResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationXmlResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getInsuranceApplicationXmlExternal(calculationId: number): Promise<ApplicationXmlResponseApiResult> {
        let url_ = this.baseUrl + "/external/calculation/insurance/{calculationId}/application-xml";
        if (calculationId === undefined || calculationId === null)
            throw new Error("The parameter 'calculationId' must be defined.");
        url_ = url_.replace("{calculationId}", encodeURIComponent("" + calculationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceApplicationXmlExternal(_response);
        });
    }

    protected processGetInsuranceApplicationXmlExternal(response: Response): Promise<ApplicationXmlResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationXmlResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationXmlResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    postApplicationResultExternal(body: PostApplicationResultRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/external/calculation/application-result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostApplicationResultExternal(_response);
        });
    }

    protected processPostApplicationResultExternal(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    recalculateTakeoverExternal(body: RecalculateTakeoverRequest | undefined): Promise<TakeoverRecalculationApiResult> {
        let url_ = this.baseUrl + "/external/calculation/takeover/recalculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRecalculateTakeoverExternal(_response);
        });
    }

    protected processRecalculateTakeoverExternal(response: Response): Promise<TakeoverRecalculationApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TakeoverRecalculationApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TakeoverRecalculationApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyTakeoverExternal(body: ApplyTakeoverRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/external/calculation/takeover/apply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApplyTakeoverExternal(_response);
        });
    }

    protected processApplyTakeoverExternal(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDealSnapshotExternal(dealId: number): Promise<GetDealSnapshotResponseApiResult> {
        let url_ = this.baseUrl + "/external/deal/{dealId}/snapshot";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDealSnapshotExternal(_response);
        });
    }

    protected processGetDealSnapshotExternal(response: Response): Promise<GetDealSnapshotResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDealSnapshotResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDealSnapshotResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getMeExternal(): Promise<ExternalMeResponseApiResult> {
        let url_ = this.baseUrl + "/external/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeExternal(_response);
        });
    }

    protected processGetMeExternal(response: Response): Promise<ExternalMeResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalMeResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalMeResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getGlobalText(): Promise<GlobalTextViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/global/text";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalText(_response);
        });
    }

    protected processGetGlobalText(response: Response): Promise<GlobalTextViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GlobalTextViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalTextViewIReadOnlyCollectionApiResult>(null as any);
    }

    importBlackList(token: string): Promise<void> {
        let url_ = this.baseUrl + "/import/blacklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "token": token !== undefined && token !== null ? "" + token : "",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportBlackList(_response);
        });
    }

    protected processImportBlackList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getInsurance(id: number): Promise<GetInsuranceResponseApiResult> {
        let url_ = this.baseUrl + "/insurance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsurance(_response);
        });
    }

    protected processGetInsurance(response: Response): Promise<GetInsuranceResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInsuranceResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInsuranceResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultInsurance(dealId: number): Promise<GetInsuranceResponseApiResult> {
        let url_ = this.baseUrl + "/insurance/defaultInsurance?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDefaultInsurance(_response);
        });
    }

    protected processGetDefaultInsurance(response: Response): Promise<GetInsuranceResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInsuranceResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInsuranceResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveInsurance(body: SaveInsuranceRequest | undefined): Promise<SaveInsuranceResponseApiResult> {
        let url_ = this.baseUrl + "/insurance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveInsurance(_response);
        });
    }

    protected processSaveInsurance(response: Response): Promise<SaveInsuranceResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveInsuranceResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaveInsuranceResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateInsurance(body: CalculateInsuranceRequest | undefined): Promise<CalculatedInsuranceViewApiResult> {
        let url_ = this.baseUrl + "/insurance/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateInsurance(_response);
        });
    }

    protected processCalculateInsurance(response: Response): Promise<CalculatedInsuranceViewApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculatedInsuranceViewApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculatedInsuranceViewApiResult>(null as any);
    }

    /**
     * @param insuranceId (optional) 
     * @return Success
     */
    getBonusMalusLevels(dealId: number, insuranceId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/bonusMalusLevels?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (insuranceId === null)
            throw new Error("The parameter 'insuranceId' cannot be null.");
        else if (insuranceId !== undefined)
            url_ += "InsuranceId=" + encodeURIComponent("" + insuranceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBonusMalusLevels(_response);
        });
    }

    protected processGetBonusMalusLevels(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getUsageTypes(vehicleTypeId: number): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/usageTypes?";
        if (vehicleTypeId === undefined || vehicleTypeId === null)
            throw new Error("The parameter 'vehicleTypeId' must be defined and cannot be null.");
        else
            url_ += "VehicleTypeId=" + encodeURIComponent("" + vehicleTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsageTypes(_response);
        });
    }

    protected processGetUsageTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/paymentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentTypes(_response);
        });
    }

    protected processGetPaymentTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentPeriods(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/paymentPeriods";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPaymentPeriods(_response);
        });
    }

    protected processGetPaymentPeriods(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param liabilityInsuranceId (optional) 
     * @return Success
     */
    getLiabilityInsuranceCompanies(dealId: number, liabilityInsuranceId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/liabilityInsuranceCompanies?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (liabilityInsuranceId === null)
            throw new Error("The parameter 'liabilityInsuranceId' cannot be null.");
        else if (liabilityInsuranceId !== undefined)
            url_ += "LiabilityInsuranceId=" + encodeURIComponent("" + liabilityInsuranceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLiabilityInsuranceCompanies(_response);
        });
    }

    protected processGetLiabilityInsuranceCompanies(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param insuranceSpecialOfferId (optional) 
     * @param selectedInsuranceId (optional) 
     * @param usageTypeId (optional) 
     * @return Success
     */
    getLiabilityInsurances(dealId: number, insuranceCompanyId: number, insuranceSpecialOfferId: number | undefined, selectedInsuranceId: number | undefined, usageTypeId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/liabilityInsurances?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (insuranceCompanyId === undefined || insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' must be defined and cannot be null.");
        else
            url_ += "InsuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        if (insuranceSpecialOfferId === null)
            throw new Error("The parameter 'insuranceSpecialOfferId' cannot be null.");
        else if (insuranceSpecialOfferId !== undefined)
            url_ += "InsuranceSpecialOfferId=" + encodeURIComponent("" + insuranceSpecialOfferId) + "&";
        if (selectedInsuranceId === null)
            throw new Error("The parameter 'selectedInsuranceId' cannot be null.");
        else if (selectedInsuranceId !== undefined)
            url_ += "SelectedInsuranceId=" + encodeURIComponent("" + selectedInsuranceId) + "&";
        if (usageTypeId === null)
            throw new Error("The parameter 'usageTypeId' cannot be null.");
        else if (usageTypeId !== undefined)
            url_ += "UsageTypeId=" + encodeURIComponent("" + usageTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLiabilityInsurances(_response);
        });
    }

    protected processGetLiabilityInsurances(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getKaskoInsuranceCompanies(dealId: number): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/kaskoInsuranceCompanies?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKaskoInsuranceCompanies(_response);
        });
    }

    protected processGetKaskoInsuranceCompanies(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param insuranceSpecialOfferId (optional) 
     * @param selectedInsuranceId (optional) 
     * @param usageTypeId (optional) 
     * @return Success
     */
    getKaskoInsurances(dealId: number, insuranceCompanyId: number, insuranceSpecialOfferId: number | undefined, selectedInsuranceId: number | undefined, usageTypeId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/kaskoInsurances?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (insuranceCompanyId === undefined || insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' must be defined and cannot be null.");
        else
            url_ += "InsuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        if (insuranceSpecialOfferId === null)
            throw new Error("The parameter 'insuranceSpecialOfferId' cannot be null.");
        else if (insuranceSpecialOfferId !== undefined)
            url_ += "InsuranceSpecialOfferId=" + encodeURIComponent("" + insuranceSpecialOfferId) + "&";
        if (selectedInsuranceId === null)
            throw new Error("The parameter 'selectedInsuranceId' cannot be null.");
        else if (selectedInsuranceId !== undefined)
            url_ += "SelectedInsuranceId=" + encodeURIComponent("" + selectedInsuranceId) + "&";
        if (usageTypeId === null)
            throw new Error("The parameter 'usageTypeId' cannot be null.");
        else if (usageTypeId !== undefined)
            url_ += "UsageTypeId=" + encodeURIComponent("" + usageTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKaskoInsurances(_response);
        });
    }

    protected processGetKaskoInsurances(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param insuranceCompanyId (optional) 
     * @param kaskoInsuranceId (optional) 
     * @param usageTypeId (optional) 
     * @param specialOfferId (optional) 
     * @return Success
     */
    getKaskoAdditionalProducts(dealId: number, insuranceCompanyId: number | undefined, kaskoInsuranceId: number | undefined, usageTypeId: number | undefined, specialOfferId: number | undefined): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/kaskoAdditionalProducts?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (insuranceCompanyId === null)
            throw new Error("The parameter 'insuranceCompanyId' cannot be null.");
        else if (insuranceCompanyId !== undefined)
            url_ += "InsuranceCompanyId=" + encodeURIComponent("" + insuranceCompanyId) + "&";
        if (kaskoInsuranceId === null)
            throw new Error("The parameter 'kaskoInsuranceId' cannot be null.");
        else if (kaskoInsuranceId !== undefined)
            url_ += "KaskoInsuranceId=" + encodeURIComponent("" + kaskoInsuranceId) + "&";
        if (usageTypeId === null)
            throw new Error("The parameter 'usageTypeId' cannot be null.");
        else if (usageTypeId !== undefined)
            url_ += "UsageTypeId=" + encodeURIComponent("" + usageTypeId) + "&";
        if (specialOfferId === null)
            throw new Error("The parameter 'specialOfferId' cannot be null.");
        else if (specialOfferId !== undefined)
            url_ += "SpecialOfferId=" + encodeURIComponent("" + specialOfferId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKaskoAdditionalProducts(_response);
        });
    }

    protected processGetKaskoAdditionalProducts(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param bMLevel (optional) 
     * @param usageTypeId (optional) 
     * @return Success
     */
    getInsuranceSpecialOffers(dealId: number, bMLevel: number | undefined, usageTypeId: number | undefined): Promise<GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/insuranceSpecialOffers?";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined and cannot be null.");
        else
            url_ += "DealId=" + encodeURIComponent("" + dealId) + "&";
        if (bMLevel === null)
            throw new Error("The parameter 'bMLevel' cannot be null.");
        else if (bMLevel !== undefined)
            url_ += "BMLevel=" + encodeURIComponent("" + bMLevel) + "&";
        if (usageTypeId === null)
            throw new Error("The parameter 'usageTypeId' cannot be null.");
        else if (usageTypeId !== undefined)
            url_ += "UsageTypeId=" + encodeURIComponent("" + usageTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceSpecialOffers(_response);
        });
    }

    protected processGetInsuranceSpecialOffers(response: Response): Promise<GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getInsuranceContractTypes(): Promise<OptionItemIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/insuranceContractTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInsuranceContractTypes(_response);
        });
    }

    protected processGetInsuranceContractTypes(response: Response): Promise<OptionItemIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param commissionDealerId (optional) 
     * @return Success
     */
    submitInsurance(id: number, commissionDealerId: number | undefined, bypassKsv: boolean): Promise<ApiResult> {
        let url_ = this.baseUrl + "/insurance/submitInsurance/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (commissionDealerId === null)
            throw new Error("The parameter 'commissionDealerId' cannot be null.");
        else if (commissionDealerId !== undefined)
            url_ += "commissionDealerId=" + encodeURIComponent("" + commissionDealerId) + "&";
        if (bypassKsv === undefined || bypassKsv === null)
            throw new Error("The parameter 'bypassKsv' must be defined and cannot be null.");
        else
            url_ += "bypassKsv=" + encodeURIComponent("" + bypassKsv) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitInsurance(_response);
        });
    }

    protected processSubmitInsurance(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPrintInsuranceDocuments(insuranceCalculationId: number): Promise<GetPrintInsuranceDocumentsResponseApiResult> {
        let url_ = this.baseUrl + "/insurance/printInsuranceDocuments?";
        if (insuranceCalculationId === undefined || insuranceCalculationId === null)
            throw new Error("The parameter 'insuranceCalculationId' must be defined and cannot be null.");
        else
            url_ += "InsuranceCalculationId=" + encodeURIComponent("" + insuranceCalculationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPrintInsuranceDocuments(_response);
        });
    }

    protected processGetPrintInsuranceDocuments(response: Response): Promise<GetPrintInsuranceDocumentsResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPrintInsuranceDocumentsResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPrintInsuranceDocumentsResponseApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    printInsuranceDocuments(body: PrintInsuranceDocumentsRequest | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/insurance/printInsuranceDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPrintInsuranceDocuments(_response);
        });
    }

    protected processPrintInsuranceDocuments(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    getPreviousInsurers(): Promise<PreviousInsurerIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/insurance/previousInsurers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviousInsurers(_response);
        });
    }

    protected processGetPreviousInsurers(response: Response): Promise<PreviousInsurerIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreviousInsurerIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreviousInsurerIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInsuranceDocuments(body: SendInsuranceDocumentsRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/insurance/sendInsuranceDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInsuranceDocuments(_response);
        });
    }

    protected processSendInsuranceDocuments(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signInsuranceDocuments(body: SignInsuranceDocumentsRequest | undefined): Promise<SignInsuranceDocumentsResponseIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/insurance/signInsuranceDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignInsuranceDocuments(_response);
        });
    }

    protected processSignInsuranceDocuments(response: Response): Promise<SignInsuranceDocumentsResponseIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SignInsuranceDocumentsResponseIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SignInsuranceDocumentsResponseIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    sendInsurance(): Promise<ApiResult> {
        let url_ = this.baseUrl + "/insurance/sendInsurance";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendInsurance(_response);
        });
    }

    protected processSendInsurance(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setIsPrimary(body: SetPrimaryInsuranceRequest | undefined): Promise<ApiResult> {
        let url_ = this.baseUrl + "/insurance/primary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetIsPrimary(_response);
        });
    }

    protected processSetIsPrimary(response: Response): Promise<ApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResult>(null as any);
    }

    /**
     * @return Success
     */
    unlockDeal(dealId: number): Promise<void> {
        let url_ = this.baseUrl + "/lock/unlockDeal/{dealId}";
        if (dealId === undefined || dealId === null)
            throw new Error("The parameter 'dealId' must be defined.");
        url_ = url_.replace("{dealId}", encodeURIComponent("" + dealId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnlockDeal(_response);
        });
    }

    protected processUnlockDeal(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param salesPersonId (optional) 
     * @return Success
     */
    getTrademarks(salesPersonId: number | undefined): Promise<ModelOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/trademark?";
        if (salesPersonId === null)
            throw new Error("The parameter 'salesPersonId' cannot be null.");
        else if (salesPersonId !== undefined)
            url_ += "SalesPersonId=" + encodeURIComponent("" + salesPersonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrademarks(_response);
        });
    }

    protected processGetTrademarks(response: Response): Promise<ModelOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getVehicleTypes(trademarkId: number): Promise<ModelOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/vehicleType?";
        if (trademarkId === undefined || trademarkId === null)
            throw new Error("The parameter 'trademarkId' must be defined and cannot be null.");
        else
            url_ += "TrademarkId=" + encodeURIComponent("" + trademarkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicleTypes(_response);
        });
    }

    protected processGetVehicleTypes(response: Response): Promise<ModelOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getModelCategories(trademarkId: number, vehicleTypeId: number): Promise<ModelOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/modelCategory?";
        if (trademarkId === undefined || trademarkId === null)
            throw new Error("The parameter 'trademarkId' must be defined and cannot be null.");
        else
            url_ += "TrademarkId=" + encodeURIComponent("" + trademarkId) + "&";
        if (vehicleTypeId === undefined || vehicleTypeId === null)
            throw new Error("The parameter 'vehicleTypeId' must be defined and cannot be null.");
        else
            url_ += "VehicleTypeId=" + encodeURIComponent("" + vehicleTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelCategories(_response);
        });
    }

    protected processGetModelCategories(response: Response): Promise<ModelOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getEngineTypes(modelCategoryId: number): Promise<ModelOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/engineType?";
        if (modelCategoryId === undefined || modelCategoryId === null)
            throw new Error("The parameter 'modelCategoryId' must be defined and cannot be null.");
        else
            url_ += "ModelCategoryId=" + encodeURIComponent("" + modelCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEngineTypes(_response);
        });
    }

    protected processGetEngineTypes(response: Response): Promise<ModelOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getModels(modelCategoryId: number, engineTypeId: number): Promise<ModelOverviewIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model?";
        if (modelCategoryId === undefined || modelCategoryId === null)
            throw new Error("The parameter 'modelCategoryId' must be defined and cannot be null.");
        else
            url_ += "ModelCategoryId=" + encodeURIComponent("" + modelCategoryId) + "&";
        if (engineTypeId === undefined || engineTypeId === null)
            throw new Error("The parameter 'engineTypeId' must be defined and cannot be null.");
        else
            url_ += "EngineTypeId=" + encodeURIComponent("" + engineTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModels(_response);
        });
    }

    protected processGetModels(response: Response): Promise<ModelOverviewIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIReadOnlyListApiResult>(null as any);
    }

    /**
     * @param orderSelectors (optional) 
     * @return Success
     */
    findModelsByName(searchTerm: string, pageIndex: number, pageSize: number, orderSelectors: string[] | undefined): Promise<ModelOverviewIPagedListApiResult> {
        let url_ = this.baseUrl + "/model/find?";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
        else
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageIndex === undefined || pageIndex === null)
            throw new Error("The parameter 'pageIndex' must be defined and cannot be null.");
        else
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (orderSelectors === null)
            throw new Error("The parameter 'orderSelectors' cannot be null.");
        else if (orderSelectors !== undefined)
            orderSelectors && orderSelectors.forEach(item => { url_ += "OrderSelectors=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindModelsByName(_response);
        });
    }

    protected processFindModelsByName(response: Response): Promise<ModelOverviewIPagedListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelOverviewIPagedListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModelOverviewIPagedListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getVehicleConditionTypes(): Promise<OptionItemIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/vehicleConditionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVehicleConditionTypes(_response);
        });
    }

    protected processGetVehicleConditionTypes(response: Response): Promise<OptionItemIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getModelData(modelId: number): Promise<GetModelDataResponseApiResult> {
        let url_ = this.baseUrl + "/model/modelData/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelData(_response);
        });
    }

    protected processGetModelData(response: Response): Promise<GetModelDataResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetModelDataResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetModelDataResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getSalespersons(): Promise<OptionItemIReadOnlyListApiResult> {
        let url_ = this.baseUrl + "/model/salesperson";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSalespersons(_response);
        });
    }

    protected processGetSalespersons(response: Response): Promise<OptionItemIReadOnlyListApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OptionItemIReadOnlyListApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OptionItemIReadOnlyListApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getModelImage(modelId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/model/{modelId}/image";
        if (modelId === undefined || modelId === null)
            throw new Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetModelImage(_response);
        });
    }

    protected processGetModelImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param modelConfigurationFile (optional) 
     * @return Success
     */
    importModelConfiguration(modelConfigurationFile: FileParameter | undefined): Promise<ImportModelConfigurationResponseApiResult> {
        let url_ = this.baseUrl + "/model/importModelConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (modelConfigurationFile === null || modelConfigurationFile === undefined)
            throw new Error("The parameter 'modelConfigurationFile' cannot be null.");
        else
            content_.append("modelConfigurationFile", modelConfigurationFile.data, modelConfigurationFile.fileName ? modelConfigurationFile.fileName : "modelConfigurationFile");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportModelConfiguration(_response);
        });
    }

    protected processImportModelConfiguration(response: Response): Promise<ImportModelConfigurationResponseApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportModelConfigurationResponseApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportModelConfigurationResponseApiResult>(null as any);
    }

    /**
     * @return Success
     */
    notification(): Promise<NotificationViewIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNotification(_response);
        });
    }

    protected processNotification(response: Response): Promise<NotificationViewIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationViewIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationViewIReadOnlyCollectionApiResult>(null as any);
    }

    /**
     * @return Success
     */
    getPermissions(): Promise<PermissionIReadOnlyCollectionApiResult> {
        let url_ = this.baseUrl + "/permission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: Response): Promise<PermissionIReadOnlyCollectionApiResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetailsApiResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionIReadOnlyCollectionApiResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = UnauthorizedResult.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PermissionIReadOnlyCollectionApiResult>(null as any);
    }
}

export enum ActiveContractFilter {
    All = "All",
    ExpireInLessThan90Days = "ExpireInLessThan90Days",
    ExpireInLessThan180Days = "ExpireInLessThan180Days",
    Recently = "Recently",
    Settled = "Settled",
}

export class AddCoApplicantResponse implements IAddCoApplicantResponse {

    constructor(data?: IAddCoApplicantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddCoApplicantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddCoApplicantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAddCoApplicantResponse {
}

export class AddCoApplicantResponseApiResult implements IAddCoApplicantResponseApiResult {
    messages!: ApiMessages;
    data!: AddCoApplicantResponse;

    constructor(data?: IAddCoApplicantResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new AddCoApplicantResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? AddCoApplicantResponse.fromJS(_data["data"]) : new AddCoApplicantResponse();
        }
    }

    static fromJS(data: any): AddCoApplicantResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new AddCoApplicantResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddCoApplicantResponseApiResult {
    messages: ApiMessages;
    data: AddCoApplicantResponse;
}

/** Additional deal Data that needs to be saved after calculating */
export class AdditionalDealData implements IAdditionalDealData {
    salesAids!: SalesAidView[];
    credibilityCheck!: CredibilityCheck;
    vinAssignments!: VinAssignment[];

    constructor(data?: IAdditionalDealData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.salesAids = [];
            this.credibilityCheck = new CredibilityCheck();
            this.vinAssignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["salesAids"])) {
                this.salesAids = [] as any;
                for (let item of _data["salesAids"])
                    this.salesAids!.push(SalesAidView.fromJS(item));
            }
            this.credibilityCheck = _data["credibilityCheck"] ? CredibilityCheck.fromJS(_data["credibilityCheck"]) : new CredibilityCheck();
            if (Array.isArray(_data["vinAssignments"])) {
                this.vinAssignments = [] as any;
                for (let item of _data["vinAssignments"])
                    this.vinAssignments!.push(VinAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdditionalDealData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalDealData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.salesAids)) {
            data["salesAids"] = [];
            for (let item of this.salesAids)
                data["salesAids"].push(item.toJSON());
        }
        data["credibilityCheck"] = this.credibilityCheck ? this.credibilityCheck.toJSON() : <any>undefined;
        if (Array.isArray(this.vinAssignments)) {
            data["vinAssignments"] = [];
            for (let item of this.vinAssignments)
                data["vinAssignments"].push(item.toJSON());
        }
        return data;
    }
}

/** Additional deal Data that needs to be saved after calculating */
export interface IAdditionalDealData {
    salesAids: SalesAidView[];
    credibilityCheck: CredibilityCheck;
    vinAssignments: VinAssignment[];
}

export class AddressSnapshotData implements IAddressSnapshotData {
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    countryId?: number | undefined;
    phone?: string | undefined;
    additionalPhone?: string | undefined;
    email?: string | undefined;

    constructor(data?: IAddressSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.countryId = _data["countryId"];
            this.phone = _data["phone"];
            this.additionalPhone = _data["additionalPhone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AddressSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["countryId"] = this.countryId;
        data["phone"] = this.phone;
        data["additionalPhone"] = this.additionalPhone;
        data["email"] = this.email;
        return data;
    }
}

export interface IAddressSnapshotData {
    street?: string | undefined;
    houseNumber?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    countryId?: number | undefined;
    phone?: string | undefined;
    additionalPhone?: string | undefined;
    email?: string | undefined;
}

export class AgentOption implements IAgentOption {
    id?: number | undefined;
    title!: string;
    price!: number;
    dealerId!: number;

    constructor(data?: IAgentOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): AgentOption {
        data = typeof data === 'object' ? data : {};
        let result = new AgentOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["dealerId"] = this.dealerId;
        return data;
    }
}

export interface IAgentOption {
    id?: number | undefined;
    title: string;
    price: number;
    dealerId: number;
}

export class AgentOptionResponse implements IAgentOptionResponse {
    id!: number;
    title!: string;
    price!: number;
    dealerId!: number;

    constructor(data?: IAgentOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.dealerId = _data["dealerId"];
        }
    }

    static fromJS(data: any): AgentOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgentOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["dealerId"] = this.dealerId;
        return data;
    }
}

export interface IAgentOptionResponse {
    id: number;
    title: string;
    price: number;
    dealerId: number;
}

export enum AllowedSettingsReading {
    FileUpload_UserUploadMaxFileSizeMB = "FileUpload_UserUploadMaxFileSizeMB",
    FileUpload_UserUploadAllowedFileExtensions = "FileUpload_UserUploadAllowedFileExtensions",
    FileUpload_UserUploadFilenameAllowedCharsRegexPattern = "FileUpload_UserUploadFilenameAllowedCharsRegexPattern",
    FileDownload_SeparateDocuments = "FileDownload_SeparateDocuments",
}

export class ApiConIdNamePair implements IApiConIdNamePair {
    id?: string | undefined;
    name?: string | undefined;
    preSelected!: boolean;

    constructor(data?: IApiConIdNamePair) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.preSelected = _data["preSelected"];
        }
    }

    static fromJS(data: any): ApiConIdNamePair {
        data = typeof data === 'object' ? data : {};
        let result = new ApiConIdNamePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["preSelected"] = this.preSelected;
        return data;
    }
}

export interface IApiConIdNamePair {
    id?: string | undefined;
    name?: string | undefined;
    preSelected: boolean;
}

export class ApiMessages implements IApiMessages {
    readonly global!: GlobalApiMessage[];
    readonly local!: LocalApiMessage[];

    constructor(data?: IApiMessages) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.global = [];
            this.local = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["global"])) {
                (<any>this).global = [] as any;
                for (let item of _data["global"])
                    (<any>this).global!.push(GlobalApiMessage.fromJS(item));
            }
            if (Array.isArray(_data["local"])) {
                (<any>this).local = [] as any;
                for (let item of _data["local"])
                    (<any>this).local!.push(LocalApiMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApiMessages {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMessages();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.global)) {
            data["global"] = [];
            for (let item of this.global)
                data["global"].push(item.toJSON());
        }
        if (Array.isArray(this.local)) {
            data["local"] = [];
            for (let item of this.local)
                data["local"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApiMessages {
    global: GlobalApiMessage[];
    local: LocalApiMessage[];
}

export class ApiResult implements IApiResult {
    messages!: ApiMessages;

    constructor(data?: IApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
        }
    }

    static fromJS(data: any): ApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiResult {
    messages: ApiMessages;
}

export class ApiResult_1 extends ApiResult implements IApiResult_1 {
    data!: T;

    constructor(data?: IApiResult_1) {
        super(data);
        if (!data) {
            this.data = new T();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? T.fromJS(_data["data"]) : new T();
        }
    }

    static fromJS(data: any): ApiResult_1 {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResult_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IApiResult_1 extends IApiResult {
    data: T;
}

export class ApiconPriceForm implements IApiconPriceForm {
    priceFormState!: ApiconSpecialCasePriceFormState;
    priceFormUiState!: ApiconPriceFormUiState;
    cacheGuid?: string | undefined;
    isPriceRequest!: boolean;
    priceNet?: number | undefined;
    priceGross!: number;
    vatAsValue!: number;
    configurationID?: string | undefined;
    specialCaseMandatory!: boolean;
    totalPrice?: number | undefined;
    displayPriceOnRequest!: boolean;

    constructor(data?: IApiconPriceForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceFormState = _data["priceFormState"];
            this.priceFormUiState = _data["priceFormUiState"];
            this.cacheGuid = _data["cacheGuid"];
            this.isPriceRequest = _data["isPriceRequest"];
            this.priceNet = _data["priceNet"];
            this.priceGross = _data["priceGross"];
            this.vatAsValue = _data["vatAsValue"];
            this.configurationID = _data["configurationID"];
            this.specialCaseMandatory = _data["specialCaseMandatory"];
            this.totalPrice = _data["totalPrice"];
            this.displayPriceOnRequest = _data["displayPriceOnRequest"];
        }
    }

    static fromJS(data: any): ApiconPriceForm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconPriceForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceFormState"] = this.priceFormState;
        data["priceFormUiState"] = this.priceFormUiState;
        data["cacheGuid"] = this.cacheGuid;
        data["isPriceRequest"] = this.isPriceRequest;
        data["priceNet"] = this.priceNet;
        data["priceGross"] = this.priceGross;
        data["vatAsValue"] = this.vatAsValue;
        data["configurationID"] = this.configurationID;
        data["specialCaseMandatory"] = this.specialCaseMandatory;
        data["totalPrice"] = this.totalPrice;
        data["displayPriceOnRequest"] = this.displayPriceOnRequest;
        return data;
    }
}

export interface IApiconPriceForm {
    priceFormState: ApiconSpecialCasePriceFormState;
    priceFormUiState: ApiconPriceFormUiState;
    cacheGuid?: string | undefined;
    isPriceRequest: boolean;
    priceNet?: number | undefined;
    priceGross: number;
    vatAsValue: number;
    configurationID?: string | undefined;
    specialCaseMandatory: boolean;
    totalPrice?: number | undefined;
    displayPriceOnRequest: boolean;
}

export enum ApiconPriceFormUiState {
    Default = "Default",
    Initial = "Initial",
    SpecialCaseRequestIsPriceOnRequest = "SpecialCaseRequestIsPriceOnRequest",
    SpecialCaseRequestDisplayPrice = "SpecialCaseRequestDisplayPrice",
    SpecialCaseRequestInProgress = "SpecialCaseRequestInProgress",
    SpecialCaseRequestApproved = "SpecialCaseRequestApproved",
    SpecialCaseRequestRejected = "SpecialCaseRequestRejected",
    SpecialCaseRequestFinishedWithPrice = "SpecialCaseRequestFinishedWithPrice",
    SpecialCaseRequestFinishedIsPriceOnRequest = "SpecialCaseRequestFinishedIsPriceOnRequest",
}

export class ApiconProposalForm implements IApiconProposalForm {
    proposalCreationDate?: Date | undefined;
    proposalValidUntil?: Date | undefined;
    proposalId?: string | undefined;

    constructor(data?: IApiconProposalForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.proposalCreationDate = _data["proposalCreationDate"] ? new Date(_data["proposalCreationDate"].toString()) : <any>undefined;
            this.proposalValidUntil = _data["proposalValidUntil"] ? new Date(_data["proposalValidUntil"].toString()) : <any>undefined;
            this.proposalId = _data["proposalId"];
        }
    }

    static fromJS(data: any): ApiconProposalForm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconProposalForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["proposalCreationDate"] = this.proposalCreationDate ? this.proposalCreationDate.toISOString() : <any>undefined;
        data["proposalValidUntil"] = this.proposalValidUntil ? this.proposalValidUntil.toISOString() : <any>undefined;
        data["proposalId"] = this.proposalId;
        return data;
    }
}

export interface IApiconProposalForm {
    proposalCreationDate?: Date | undefined;
    proposalValidUntil?: Date | undefined;
    proposalId?: string | undefined;
}

export class ApiconServiceBundle implements IApiconServiceBundle {
    isUiUpdateModel!: boolean;
    isBundleCalculationRequest!: boolean;
    showModelPrototypeData!: boolean;
    requiresModelPrototypeData!: boolean;
    hasUserServicesRight!: boolean;
    cacheGuid?: string | undefined;
    serviceVariantId?: number | undefined;
    calculationId?: number | undefined;
    duration!: number;
    isDurationReadonly!: boolean;
    mileageId!: number;
    isMileageReadonly!: boolean;
    serviceChargeNet!: number;
    serviceCharge!: number;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    vin?: string | undefined;
    baumusterNstCodeReadOnly!: boolean;
    isReadOnly!: boolean;
    reversedChangesIfSpecialCaseRequesting!: boolean;
    isServiceVariantsResetRequired!: boolean;
    apiconServiceProduct?: ApiconServiceProduct | undefined;
    apiconPriceForm?: ApiconPriceForm | undefined;
    apiconSpecialCasePriceForm?: ApiconSpecialCasePriceForm | undefined;
    apiconProposalForm?: ApiconProposalForm | undefined;

    constructor(data?: IApiconServiceBundle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUiUpdateModel = _data["isUiUpdateModel"];
            this.isBundleCalculationRequest = _data["isBundleCalculationRequest"];
            this.showModelPrototypeData = _data["showModelPrototypeData"];
            this.requiresModelPrototypeData = _data["requiresModelPrototypeData"];
            this.hasUserServicesRight = _data["hasUserServicesRight"];
            this.cacheGuid = _data["cacheGuid"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.calculationId = _data["calculationId"];
            this.duration = _data["duration"];
            this.isDurationReadonly = _data["isDurationReadonly"];
            this.mileageId = _data["mileageId"];
            this.isMileageReadonly = _data["isMileageReadonly"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.serviceCharge = _data["serviceCharge"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.vin = _data["vin"];
            this.baumusterNstCodeReadOnly = _data["baumusterNstCodeReadOnly"];
            this.isReadOnly = _data["isReadOnly"];
            this.reversedChangesIfSpecialCaseRequesting = _data["reversedChangesIfSpecialCaseRequesting"];
            this.isServiceVariantsResetRequired = _data["isServiceVariantsResetRequired"];
            this.apiconServiceProduct = _data["apiconServiceProduct"] ? ApiconServiceProduct.fromJS(_data["apiconServiceProduct"]) : <any>undefined;
            this.apiconPriceForm = _data["apiconPriceForm"] ? ApiconPriceForm.fromJS(_data["apiconPriceForm"]) : <any>undefined;
            this.apiconSpecialCasePriceForm = _data["apiconSpecialCasePriceForm"] ? ApiconSpecialCasePriceForm.fromJS(_data["apiconSpecialCasePriceForm"]) : <any>undefined;
            this.apiconProposalForm = _data["apiconProposalForm"] ? ApiconProposalForm.fromJS(_data["apiconProposalForm"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiconServiceBundle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconServiceBundle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUiUpdateModel"] = this.isUiUpdateModel;
        data["isBundleCalculationRequest"] = this.isBundleCalculationRequest;
        data["showModelPrototypeData"] = this.showModelPrototypeData;
        data["requiresModelPrototypeData"] = this.requiresModelPrototypeData;
        data["hasUserServicesRight"] = this.hasUserServicesRight;
        data["cacheGuid"] = this.cacheGuid;
        data["serviceVariantId"] = this.serviceVariantId;
        data["calculationId"] = this.calculationId;
        data["duration"] = this.duration;
        data["isDurationReadonly"] = this.isDurationReadonly;
        data["mileageId"] = this.mileageId;
        data["isMileageReadonly"] = this.isMileageReadonly;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["serviceCharge"] = this.serviceCharge;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["vin"] = this.vin;
        data["baumusterNstCodeReadOnly"] = this.baumusterNstCodeReadOnly;
        data["isReadOnly"] = this.isReadOnly;
        data["reversedChangesIfSpecialCaseRequesting"] = this.reversedChangesIfSpecialCaseRequesting;
        data["isServiceVariantsResetRequired"] = this.isServiceVariantsResetRequired;
        data["apiconServiceProduct"] = this.apiconServiceProduct ? this.apiconServiceProduct.toJSON() : <any>undefined;
        data["apiconPriceForm"] = this.apiconPriceForm ? this.apiconPriceForm.toJSON() : <any>undefined;
        data["apiconSpecialCasePriceForm"] = this.apiconSpecialCasePriceForm ? this.apiconSpecialCasePriceForm.toJSON() : <any>undefined;
        data["apiconProposalForm"] = this.apiconProposalForm ? this.apiconProposalForm.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiconServiceBundle {
    isUiUpdateModel: boolean;
    isBundleCalculationRequest: boolean;
    showModelPrototypeData: boolean;
    requiresModelPrototypeData: boolean;
    hasUserServicesRight: boolean;
    cacheGuid?: string | undefined;
    serviceVariantId?: number | undefined;
    calculationId?: number | undefined;
    duration: number;
    isDurationReadonly: boolean;
    mileageId: number;
    isMileageReadonly: boolean;
    serviceChargeNet: number;
    serviceCharge: number;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    vin?: string | undefined;
    baumusterNstCodeReadOnly: boolean;
    isReadOnly: boolean;
    reversedChangesIfSpecialCaseRequesting: boolean;
    isServiceVariantsResetRequired: boolean;
    apiconServiceProduct?: ApiconServiceProduct | undefined;
    apiconPriceForm?: ApiconPriceForm | undefined;
    apiconSpecialCasePriceForm?: ApiconSpecialCasePriceForm | undefined;
    apiconProposalForm?: ApiconProposalForm | undefined;
}

export class ApiconServiceBundleApiResult implements IApiconServiceBundleApiResult {
    messages!: ApiMessages;
    data!: ApiconServiceBundle;

    constructor(data?: IApiconServiceBundleApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ApiconServiceBundle();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ApiconServiceBundle.fromJS(_data["data"]) : new ApiconServiceBundle();
        }
    }

    static fromJS(data: any): ApiconServiceBundleApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconServiceBundleApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApiconServiceBundleApiResult {
    messages: ApiMessages;
    data: ApiconServiceBundle;
}

export class ApiconServiceProduct implements IApiconServiceProduct {
    serviceProducts?: ServiceProduct[] | undefined;
    selectedServiceProductId?: string | undefined;
    productIndusties?: ProductIndustry[] | undefined;
    selectedProductIndustryId?: string | undefined;
    productUsages?: ProductUsage[] | undefined;
    selectedProductUsageId?: string | undefined;
    campaigns?: Campaign[] | undefined;
    selectedCampaignId?: string | undefined;
    productOptions?: ServiceOption[] | undefined;
    technicalOptions?: ServiceOption[] | undefined;
    isReadOnly!: boolean;

    constructor(data?: IApiconServiceProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceProducts"])) {
                this.serviceProducts = [] as any;
                for (let item of _data["serviceProducts"])
                    this.serviceProducts!.push(ServiceProduct.fromJS(item));
            }
            this.selectedServiceProductId = _data["selectedServiceProductId"];
            if (Array.isArray(_data["productIndusties"])) {
                this.productIndusties = [] as any;
                for (let item of _data["productIndusties"])
                    this.productIndusties!.push(ProductIndustry.fromJS(item));
            }
            this.selectedProductIndustryId = _data["selectedProductIndustryId"];
            if (Array.isArray(_data["productUsages"])) {
                this.productUsages = [] as any;
                for (let item of _data["productUsages"])
                    this.productUsages!.push(ProductUsage.fromJS(item));
            }
            this.selectedProductUsageId = _data["selectedProductUsageId"];
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(Campaign.fromJS(item));
            }
            this.selectedCampaignId = _data["selectedCampaignId"];
            if (Array.isArray(_data["productOptions"])) {
                this.productOptions = [] as any;
                for (let item of _data["productOptions"])
                    this.productOptions!.push(ServiceOption.fromJS(item));
            }
            if (Array.isArray(_data["technicalOptions"])) {
                this.technicalOptions = [] as any;
                for (let item of _data["technicalOptions"])
                    this.technicalOptions!.push(ServiceOption.fromJS(item));
            }
            this.isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): ApiconServiceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconServiceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceProducts)) {
            data["serviceProducts"] = [];
            for (let item of this.serviceProducts)
                data["serviceProducts"].push(item.toJSON());
        }
        data["selectedServiceProductId"] = this.selectedServiceProductId;
        if (Array.isArray(this.productIndusties)) {
            data["productIndusties"] = [];
            for (let item of this.productIndusties)
                data["productIndusties"].push(item.toJSON());
        }
        data["selectedProductIndustryId"] = this.selectedProductIndustryId;
        if (Array.isArray(this.productUsages)) {
            data["productUsages"] = [];
            for (let item of this.productUsages)
                data["productUsages"].push(item.toJSON());
        }
        data["selectedProductUsageId"] = this.selectedProductUsageId;
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item.toJSON());
        }
        data["selectedCampaignId"] = this.selectedCampaignId;
        if (Array.isArray(this.productOptions)) {
            data["productOptions"] = [];
            for (let item of this.productOptions)
                data["productOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.technicalOptions)) {
            data["technicalOptions"] = [];
            for (let item of this.technicalOptions)
                data["technicalOptions"].push(item.toJSON());
        }
        data["isReadOnly"] = this.isReadOnly;
        return data;
    }
}

export interface IApiconServiceProduct {
    serviceProducts?: ServiceProduct[] | undefined;
    selectedServiceProductId?: string | undefined;
    productIndusties?: ProductIndustry[] | undefined;
    selectedProductIndustryId?: string | undefined;
    productUsages?: ProductUsage[] | undefined;
    selectedProductUsageId?: string | undefined;
    campaigns?: Campaign[] | undefined;
    selectedCampaignId?: string | undefined;
    productOptions?: ServiceOption[] | undefined;
    technicalOptions?: ServiceOption[] | undefined;
    isReadOnly: boolean;
}

export class ApiconServiceRequestBundle implements IApiconServiceRequestBundle {
    cacheGuid?: string | undefined;
    dealId!: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId!: number;
    duration!: number;
    isServiceVariantsResetRequest!: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId!: number;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest!: boolean;
    preCheckServiceProductSelectionsFromApicon!: boolean;
    isPriceFormSpecialCaseMandatory!: boolean;
    isServiceVariantSaveRequest!: boolean;
    isBundle!: boolean;

    constructor(data?: IApiconServiceRequestBundle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheGuid = _data["cacheGuid"];
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.serviceProductId = _data["serviceProductId"];
            this.mileageId = _data["mileageId"];
            this.duration = _data["duration"];
            this.isServiceVariantsResetRequest = _data["isServiceVariantsResetRequest"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.configurationID = _data["configurationID"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.campaignId = _data["campaignId"];
            this.priceNet = _data["priceNet"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.fundingProductId = _data["fundingProductId"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.specialCaseRequestBundle = _data["specialCaseRequestBundle"] ? ApiconSpecialCaseRequestBundle.fromJS(_data["specialCaseRequestBundle"]) : <any>undefined;
            this.preCheckServiceProductSelectionsFromRequest = _data["preCheckServiceProductSelectionsFromRequest"];
            this.preCheckServiceProductSelectionsFromApicon = _data["preCheckServiceProductSelectionsFromApicon"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): ApiconServiceRequestBundle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconServiceRequestBundle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheGuid"] = this.cacheGuid;
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["serviceProductId"] = this.serviceProductId;
        data["mileageId"] = this.mileageId;
        data["duration"] = this.duration;
        data["isServiceVariantsResetRequest"] = this.isServiceVariantsResetRequest;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["configurationID"] = this.configurationID;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["campaignId"] = this.campaignId;
        data["priceNet"] = this.priceNet;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["fundingProductId"] = this.fundingProductId;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["specialCaseRequestBundle"] = this.specialCaseRequestBundle ? this.specialCaseRequestBundle.toJSON() : <any>undefined;
        data["preCheckServiceProductSelectionsFromRequest"] = this.preCheckServiceProductSelectionsFromRequest;
        data["preCheckServiceProductSelectionsFromApicon"] = this.preCheckServiceProductSelectionsFromApicon;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface IApiconServiceRequestBundle {
    cacheGuid?: string | undefined;
    dealId: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId: number;
    duration: number;
    isServiceVariantsResetRequest: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId: number;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest: boolean;
    preCheckServiceProductSelectionsFromApicon: boolean;
    isPriceFormSpecialCaseMandatory: boolean;
    isServiceVariantSaveRequest: boolean;
    isBundle: boolean;
}

export class ApiconServiceVariantIdNamePair extends ApiConIdNamePair implements IApiconServiceVariantIdNamePair {
    variantNumber!: number;
    serviceProduct?: string | undefined;
    productIndustry?: string | undefined;
    productUsage?: string | undefined;
    productOptions?: string | undefined;
    rate!: number;
    comment?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    answer?: string | undefined;

    constructor(data?: IApiconServiceVariantIdNamePair) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.variantNumber = _data["variantNumber"];
            this.serviceProduct = _data["serviceProduct"];
            this.productIndustry = _data["productIndustry"];
            this.productUsage = _data["productUsage"];
            this.productOptions = _data["productOptions"];
            this.rate = _data["rate"];
            this.comment = _data["comment"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): ApiconServiceVariantIdNamePair {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconServiceVariantIdNamePair();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["variantNumber"] = this.variantNumber;
        data["serviceProduct"] = this.serviceProduct;
        data["productIndustry"] = this.productIndustry;
        data["productUsage"] = this.productUsage;
        data["productOptions"] = this.productOptions;
        data["rate"] = this.rate;
        data["comment"] = this.comment;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["answer"] = this.answer;
        super.toJSON(data);
        return data;
    }
}

export interface IApiconServiceVariantIdNamePair extends IApiConIdNamePair {
    variantNumber: number;
    serviceProduct?: string | undefined;
    productIndustry?: string | undefined;
    productUsage?: string | undefined;
    productOptions?: string | undefined;
    rate: number;
    comment?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    answer?: string | undefined;
}

export class ApiconSpecialCasePriceForm extends ApiconPriceForm implements IApiconSpecialCasePriceForm {
    comment?: string | undefined;
    isCommentReadOnly!: boolean;
    phone?: string | undefined;
    isPhoneReadOnly!: boolean;
    eMail?: string | undefined;
    isEmailReadOnly!: boolean;
    answer?: string | undefined;
    answerAndInformationVisible!: boolean;
    information?: string | undefined;
    offerID?: string | undefined;
    specialCaseID?: string | undefined;

    constructor(data?: IApiconSpecialCasePriceForm) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comment = _data["comment"];
            this.isCommentReadOnly = _data["isCommentReadOnly"];
            this.phone = _data["phone"];
            this.isPhoneReadOnly = _data["isPhoneReadOnly"];
            this.eMail = _data["eMail"];
            this.isEmailReadOnly = _data["isEmailReadOnly"];
            this.answer = _data["answer"];
            this.answerAndInformationVisible = _data["answerAndInformationVisible"];
            this.information = _data["information"];
            this.offerID = _data["offerID"];
            this.specialCaseID = _data["specialCaseID"];
        }
    }

    static fromJS(data: any): ApiconSpecialCasePriceForm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconSpecialCasePriceForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["isCommentReadOnly"] = this.isCommentReadOnly;
        data["phone"] = this.phone;
        data["isPhoneReadOnly"] = this.isPhoneReadOnly;
        data["eMail"] = this.eMail;
        data["isEmailReadOnly"] = this.isEmailReadOnly;
        data["answer"] = this.answer;
        data["answerAndInformationVisible"] = this.answerAndInformationVisible;
        data["information"] = this.information;
        data["offerID"] = this.offerID;
        data["specialCaseID"] = this.specialCaseID;
        super.toJSON(data);
        return data;
    }
}

export interface IApiconSpecialCasePriceForm extends IApiconPriceForm {
    comment?: string | undefined;
    isCommentReadOnly: boolean;
    phone?: string | undefined;
    isPhoneReadOnly: boolean;
    eMail?: string | undefined;
    isEmailReadOnly: boolean;
    answer?: string | undefined;
    answerAndInformationVisible: boolean;
    information?: string | undefined;
    offerID?: string | undefined;
    specialCaseID?: string | undefined;
}

export enum ApiconSpecialCasePriceFormState {
    Initial = "Initial",
    SpecialCasePrice = "SpecialCasePrice",
    SpecialCaseRequestInProgress = "SpecialCaseRequestInProgress",
    SpecialCaseRequestApproved = "SpecialCaseRequestApproved",
    SpecialCaseRequestRejected = "SpecialCaseRequestRejected",
    SpecialCaseRequestFinished = "SpecialCaseRequestFinished",
}

export class ApiconSpecialCaseRequestBundle implements IApiconSpecialCaseRequestBundle {
    comment?: string | undefined;
    phone?: string | undefined;
    eMail?: string | undefined;
    offerID?: string | undefined;
    specialCaseID?: string | undefined;

    constructor(data?: IApiconSpecialCaseRequestBundle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.phone = _data["phone"];
            this.eMail = _data["eMail"];
            this.offerID = _data["offerID"];
            this.specialCaseID = _data["specialCaseID"];
        }
    }

    static fromJS(data: any): ApiconSpecialCaseRequestBundle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconSpecialCaseRequestBundle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["phone"] = this.phone;
        data["eMail"] = this.eMail;
        data["offerID"] = this.offerID;
        data["specialCaseID"] = this.specialCaseID;
        return data;
    }
}

export interface IApiconSpecialCaseRequestBundle {
    comment?: string | undefined;
    phone?: string | undefined;
    eMail?: string | undefined;
    offerID?: string | undefined;
    specialCaseID?: string | undefined;
}

export class ApiconUptimeInfosForm implements IApiconUptimeInfosForm {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fleetname?: string | undefined;

    constructor(data?: IApiconUptimeInfosForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.fleetname = _data["fleetname"];
        }
    }

    static fromJS(data: any): ApiconUptimeInfosForm {
        data = typeof data === 'object' ? data : {};
        let result = new ApiconUptimeInfosForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["fleetname"] = this.fleetname;
        return data;
    }
}

export interface IApiconUptimeInfosForm {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    fleetname?: string | undefined;
}

export class ApplicationErrorResult extends ApiResult implements IApplicationErrorResult {

    constructor(data?: IApplicationErrorResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationErrorResult extends IApiResult {
}

export class ApplicationModel implements IApplicationModel {
    dealId?: number | undefined;
    dealReference!: string;
    contractId!: number;
    customerName?: string | undefined;
    objectName?: string | undefined;
    licensePlate?: string | undefined;
    salesPerson?: string | undefined;
    fin?: string | undefined;
    creationDate?: Date | undefined;
    handOverDate?: Date | undefined;
    expirationDate?: Date | undefined;
    expireInLessThan90Days!: boolean;
    expireInLessThan180Days!: boolean;
    itemType!: ResultType;
    state?: ApplicationState | undefined;
    financingTypeDisplayName?: string | undefined;
    settled!: boolean;
    recently!: boolean;
    activationDate?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.dealReference = _data["dealReference"];
            this.contractId = _data["contractId"];
            this.customerName = _data["customerName"];
            this.objectName = _data["objectName"];
            this.licensePlate = _data["licensePlate"];
            this.salesPerson = _data["salesPerson"];
            this.fin = _data["fin"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.handOverDate = _data["handOverDate"] ? new Date(_data["handOverDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expireInLessThan90Days = _data["expireInLessThan90Days"];
            this.expireInLessThan180Days = _data["expireInLessThan180Days"];
            this.itemType = _data["itemType"];
            this.state = _data["state"] ? ApplicationState.fromJS(_data["state"]) : <any>undefined;
            this.financingTypeDisplayName = _data["financingTypeDisplayName"];
            this.settled = _data["settled"];
            this.recently = _data["recently"];
            this.activationDate = _data["activationDate"] ? new Date(_data["activationDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["dealReference"] = this.dealReference;
        data["contractId"] = this.contractId;
        data["customerName"] = this.customerName;
        data["objectName"] = this.objectName;
        data["licensePlate"] = this.licensePlate;
        data["salesPerson"] = this.salesPerson;
        data["fin"] = this.fin;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["handOverDate"] = this.handOverDate ? this.handOverDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["expireInLessThan90Days"] = this.expireInLessThan90Days;
        data["expireInLessThan180Days"] = this.expireInLessThan180Days;
        data["itemType"] = this.itemType;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["financingTypeDisplayName"] = this.financingTypeDisplayName;
        data["settled"] = this.settled;
        data["recently"] = this.recently;
        data["activationDate"] = this.activationDate ? this.activationDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicationModel {
    dealId?: number | undefined;
    dealReference: string;
    contractId: number;
    customerName?: string | undefined;
    objectName?: string | undefined;
    licensePlate?: string | undefined;
    salesPerson?: string | undefined;
    fin?: string | undefined;
    creationDate?: Date | undefined;
    handOverDate?: Date | undefined;
    expirationDate?: Date | undefined;
    expireInLessThan90Days: boolean;
    expireInLessThan180Days: boolean;
    itemType: ResultType;
    state?: ApplicationState | undefined;
    financingTypeDisplayName?: string | undefined;
    settled: boolean;
    recently: boolean;
    activationDate?: Date | undefined;
    endDate?: Date | undefined;
}

export class ApplicationModelIPagedList implements IApplicationModelIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: ApplicationModel[];

    constructor(data?: IApplicationModelIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(ApplicationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationModelIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModelIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationModelIPagedList {
    total: number;
    index: number;
    size: number;
    items: ApplicationModel[];
}

export class ApplicationModelIPagedListApiResult implements IApplicationModelIPagedListApiResult {
    messages!: ApiMessages;
    data!: ApplicationModelIPagedList;

    constructor(data?: IApplicationModelIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ApplicationModelIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ApplicationModelIPagedList.fromJS(_data["data"]) : new ApplicationModelIPagedList();
        }
    }

    static fromJS(data: any): ApplicationModelIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModelIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationModelIPagedListApiResult {
    messages: ApiMessages;
    data: ApplicationModelIPagedList;
}

export class ApplicationModelIReadOnlyCollectionApiResult implements IApplicationModelIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: ApplicationModel[];

    constructor(data?: IApplicationModelIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ApplicationModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationModelIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModelIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationModelIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: ApplicationModel[];
}

export class ApplicationResultBusinessPartner implements IApplicationResultBusinessPartner {
    dekatoId!: string;
    addressNumber?: number | undefined;
    customerType!: string;
    addressType!: string;

    constructor(data?: IApplicationResultBusinessPartner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dekatoId = _data["dekatoId"];
            this.addressNumber = _data["addressNumber"];
            this.customerType = _data["customerType"];
            this.addressType = _data["addressType"];
        }
    }

    static fromJS(data: any): ApplicationResultBusinessPartner {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationResultBusinessPartner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dekatoId"] = this.dekatoId;
        data["addressNumber"] = this.addressNumber;
        data["customerType"] = this.customerType;
        data["addressType"] = this.addressType;
        return data;
    }
}

export interface IApplicationResultBusinessPartner {
    dekatoId: string;
    addressNumber?: number | undefined;
    customerType: string;
    addressType: string;
}

export class ApplicationState implements IApplicationState {
    readonly name!: string;
    readonly value!: number;

    constructor(data?: IApplicationState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): ApplicationState {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IApplicationState {
    name: string;
    value: number;
}

export class ApplicationXmlResponse implements IApplicationXmlResponse {
    xml!: string;

    constructor(data?: IApplicationXmlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.xml = _data["xml"];
        }
    }

    static fromJS(data: any): ApplicationXmlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationXmlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["xml"] = this.xml;
        return data;
    }
}

export interface IApplicationXmlResponse {
    xml: string;
}

export class ApplicationXmlResponseApiResult implements IApplicationXmlResponseApiResult {
    messages!: ApiMessages;
    data!: ApplicationXmlResponse;

    constructor(data?: IApplicationXmlResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ApplicationXmlResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ApplicationXmlResponse.fromJS(_data["data"]) : new ApplicationXmlResponse();
        }
    }

    static fromJS(data: any): ApplicationXmlResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationXmlResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationXmlResponseApiResult {
    messages: ApiMessages;
    data: ApplicationXmlResponse;
}

export class ApplyTakeoverRequest implements IApplyTakeoverRequest {
    idempotencyKey!: string;

    constructor(data?: IApplyTakeoverRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idempotencyKey = _data["idempotencyKey"];
        }
    }

    static fromJS(data: any): ApplyTakeoverRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyTakeoverRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idempotencyKey"] = this.idempotencyKey;
        return data;
    }
}

export interface IApplyTakeoverRequest {
    idempotencyKey: string;
}

export class ArchiveSignedDocumentsResponse implements IArchiveSignedDocumentsResponse {
    archivedSignedDocumentIds!: number[];

    constructor(data?: IArchiveSignedDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.archivedSignedDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["archivedSignedDocumentIds"])) {
                this.archivedSignedDocumentIds = [] as any;
                for (let item of _data["archivedSignedDocumentIds"])
                    this.archivedSignedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ArchiveSignedDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveSignedDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.archivedSignedDocumentIds)) {
            data["archivedSignedDocumentIds"] = [];
            for (let item of this.archivedSignedDocumentIds)
                data["archivedSignedDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IArchiveSignedDocumentsResponse {
    archivedSignedDocumentIds: number[];
}

export class ArchiveSignedDocumentsResponseApiResult implements IArchiveSignedDocumentsResponseApiResult {
    messages!: ApiMessages;
    data!: ArchiveSignedDocumentsResponse;

    constructor(data?: IArchiveSignedDocumentsResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ArchiveSignedDocumentsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ArchiveSignedDocumentsResponse.fromJS(_data["data"]) : new ArchiveSignedDocumentsResponse();
        }
    }

    static fromJS(data: any): ArchiveSignedDocumentsResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveSignedDocumentsResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArchiveSignedDocumentsResponseApiResult {
    messages: ApiMessages;
    data: ArchiveSignedDocumentsResponse;
}

export class ArchivedDocumentOverview implements IArchivedDocumentOverview {
    readonly id!: string;
    readonly name!: string;

    constructor(data?: IArchivedDocumentOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            (<any>this).name = _data["name"];
        }
    }

    static fromJS(data: any): ArchivedDocumentOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedDocumentOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IArchivedDocumentOverview {
    id: string;
    name: string;
}

export class ArchivedDocumentOverviewIReadOnlyListApiResult implements IArchivedDocumentOverviewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: ArchivedDocumentOverview[];

    constructor(data?: IArchivedDocumentOverviewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ArchivedDocumentOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArchivedDocumentOverviewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ArchivedDocumentOverviewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArchivedDocumentOverviewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: ArchivedDocumentOverview[];
}

export class AssignFleetRequest implements IAssignFleetRequest {
    sourceId!: number;
    targetId!: number;

    constructor(data?: IAssignFleetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.targetId = _data["targetId"];
        }
    }

    static fromJS(data: any): AssignFleetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignFleetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["targetId"] = this.targetId;
        return data;
    }
}

export interface IAssignFleetRequest {
    sourceId: number;
    targetId: number;
}

export class BankAccountInfo implements IBankAccountInfo {
    accountHolder!: string;
    iban!: string;
    bic!: string;
    bankName!: string;
    bankCountry!: string;

    constructor(data?: IBankAccountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolder = _data["accountHolder"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.bankName = _data["bankName"];
            this.bankCountry = _data["bankCountry"];
        }
    }

    static fromJS(data: any): BankAccountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolder"] = this.accountHolder;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["bankName"] = this.bankName;
        data["bankCountry"] = this.bankCountry;
        return data;
    }
}

export interface IBankAccountInfo {
    accountHolder: string;
    iban: string;
    bic: string;
    bankName: string;
    bankCountry: string;
}

export class BinaryData implements IBinaryData {

    constructor(data?: IBinaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BinaryData {
        data = typeof data === 'object' ? data : {};
        let result = new BinaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IBinaryData {
}

export class BooleanApiResult implements IBooleanApiResult {
    messages!: ApiMessages;
    data!: boolean;

    constructor(data?: IBooleanApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): BooleanApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IBooleanApiResult {
    messages: ApiMessages;
    data: boolean;
}

export class CalculateInsuranceRequest implements ICalculateInsuranceRequest {
    dealId!: number;
    enableLiability!: boolean;
    enableKasko!: boolean;
    enableLegalProtection!: boolean;
    enableAccident!: boolean;
    kaskoInsuranceId?: number | undefined;
    kaskoInsuranceCompanyId?: number | undefined;
    liabilityInsuranceId?: number | undefined;
    liabilityInsuranceCompanyId?: number | undefined;
    applicantId!: number;
    additionalApplicantId?: number | undefined;
    paymentPeriodId!: number;
    paymentTypeId!: number;
    bmLevel?: number | undefined;
    liability_BonusMalus_Internal_Id?: number | undefined;
    kaskoPremiumOverride?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    liabilityPremiumOverride?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    inputTaxDeduction!: boolean;
    kaskoAdditionalProductIds!: number[];
    specialOfferId?: number | undefined;
    kw!: number;
    co2!: number;
    usageTypeId!: number;
    weight?: number | undefined;
    maxTotalWeight?: number | undefined;
    numberOfSeats?: number | undefined;
    removeCommission?: boolean | undefined;
    curbWeight?: number | undefined;

    constructor(data?: ICalculateInsuranceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kaskoAdditionalProductIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.enableLiability = _data["enableLiability"];
            this.enableKasko = _data["enableKasko"];
            this.enableLegalProtection = _data["enableLegalProtection"];
            this.enableAccident = _data["enableAccident"];
            this.kaskoInsuranceId = _data["kaskoInsuranceId"];
            this.kaskoInsuranceCompanyId = _data["kaskoInsuranceCompanyId"];
            this.liabilityInsuranceId = _data["liabilityInsuranceId"];
            this.liabilityInsuranceCompanyId = _data["liabilityInsuranceCompanyId"];
            this.applicantId = _data["applicantId"];
            this.additionalApplicantId = _data["additionalApplicantId"];
            this.paymentPeriodId = _data["paymentPeriodId"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.bmLevel = _data["bmLevel"];
            this.liability_BonusMalus_Internal_Id = _data["liability_BonusMalus_Internal_Id"];
            this.kaskoPremiumOverride = _data["kaskoPremiumOverride"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
            this.liabilityPremiumOverride = _data["liabilityPremiumOverride"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.inputTaxDeduction = _data["inputTaxDeduction"];
            if (Array.isArray(_data["kaskoAdditionalProductIds"])) {
                this.kaskoAdditionalProductIds = [] as any;
                for (let item of _data["kaskoAdditionalProductIds"])
                    this.kaskoAdditionalProductIds!.push(item);
            }
            this.specialOfferId = _data["specialOfferId"];
            this.kw = _data["kw"];
            this.co2 = _data["co2"];
            this.usageTypeId = _data["usageTypeId"];
            this.weight = _data["weight"];
            this.maxTotalWeight = _data["maxTotalWeight"];
            this.numberOfSeats = _data["numberOfSeats"];
            this.removeCommission = _data["removeCommission"];
            this.curbWeight = _data["curbWeight"];
        }
    }

    static fromJS(data: any): CalculateInsuranceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateInsuranceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["enableLiability"] = this.enableLiability;
        data["enableKasko"] = this.enableKasko;
        data["enableLegalProtection"] = this.enableLegalProtection;
        data["enableAccident"] = this.enableAccident;
        data["kaskoInsuranceId"] = this.kaskoInsuranceId;
        data["kaskoInsuranceCompanyId"] = this.kaskoInsuranceCompanyId;
        data["liabilityInsuranceId"] = this.liabilityInsuranceId;
        data["liabilityInsuranceCompanyId"] = this.liabilityInsuranceCompanyId;
        data["applicantId"] = this.applicantId;
        data["additionalApplicantId"] = this.additionalApplicantId;
        data["paymentPeriodId"] = this.paymentPeriodId;
        data["paymentTypeId"] = this.paymentTypeId;
        data["bmLevel"] = this.bmLevel;
        data["liability_BonusMalus_Internal_Id"] = this.liability_BonusMalus_Internal_Id;
        data["kaskoPremiumOverride"] = this.kaskoPremiumOverride;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        data["liabilityPremiumOverride"] = this.liabilityPremiumOverride;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["inputTaxDeduction"] = this.inputTaxDeduction;
        if (Array.isArray(this.kaskoAdditionalProductIds)) {
            data["kaskoAdditionalProductIds"] = [];
            for (let item of this.kaskoAdditionalProductIds)
                data["kaskoAdditionalProductIds"].push(item);
        }
        data["specialOfferId"] = this.specialOfferId;
        data["kw"] = this.kw;
        data["co2"] = this.co2;
        data["usageTypeId"] = this.usageTypeId;
        data["weight"] = this.weight;
        data["maxTotalWeight"] = this.maxTotalWeight;
        data["numberOfSeats"] = this.numberOfSeats;
        data["removeCommission"] = this.removeCommission;
        data["curbWeight"] = this.curbWeight;
        return data;
    }
}

export interface ICalculateInsuranceRequest {
    dealId: number;
    enableLiability: boolean;
    enableKasko: boolean;
    enableLegalProtection: boolean;
    enableAccident: boolean;
    kaskoInsuranceId?: number | undefined;
    kaskoInsuranceCompanyId?: number | undefined;
    liabilityInsuranceId?: number | undefined;
    liabilityInsuranceCompanyId?: number | undefined;
    applicantId: number;
    additionalApplicantId?: number | undefined;
    paymentPeriodId: number;
    paymentTypeId: number;
    bmLevel?: number | undefined;
    liability_BonusMalus_Internal_Id?: number | undefined;
    kaskoPremiumOverride?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    liabilityPremiumOverride?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    inputTaxDeduction: boolean;
    kaskoAdditionalProductIds: number[];
    specialOfferId?: number | undefined;
    kw: number;
    co2: number;
    usageTypeId: number;
    weight?: number | undefined;
    maxTotalWeight?: number | undefined;
    numberOfSeats?: number | undefined;
    removeCommission?: boolean | undefined;
    curbWeight?: number | undefined;
}

export class CalculateServicePriceRequest implements ICalculateServicePriceRequest {
    cacheGuid?: string | undefined;
    dealId!: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId!: number;
    duration!: number;
    isServiceVariantsResetRequest!: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId!: number;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest!: boolean;
    preCheckServiceProductSelectionsFromApicon!: boolean;
    isPriceFormSpecialCaseMandatory!: boolean;
    isServiceVariantSaveRequest!: boolean;
    isBundle!: boolean;
    modelId!: number;
    vat!: number;
    distributionChannel!: number;

    constructor(data?: ICalculateServicePriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheGuid = _data["cacheGuid"];
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.serviceProductId = _data["serviceProductId"];
            this.mileageId = _data["mileageId"];
            this.duration = _data["duration"];
            this.isServiceVariantsResetRequest = _data["isServiceVariantsResetRequest"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.configurationID = _data["configurationID"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.campaignId = _data["campaignId"];
            this.priceNet = _data["priceNet"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.fundingProductId = _data["fundingProductId"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.specialCaseRequestBundle = _data["specialCaseRequestBundle"] ? ApiconSpecialCaseRequestBundle.fromJS(_data["specialCaseRequestBundle"]) : <any>undefined;
            this.preCheckServiceProductSelectionsFromRequest = _data["preCheckServiceProductSelectionsFromRequest"];
            this.preCheckServiceProductSelectionsFromApicon = _data["preCheckServiceProductSelectionsFromApicon"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.isBundle = _data["isBundle"];
            this.modelId = _data["modelId"];
            this.vat = _data["vat"];
            this.distributionChannel = _data["distributionChannel"];
        }
    }

    static fromJS(data: any): CalculateServicePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateServicePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheGuid"] = this.cacheGuid;
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["serviceProductId"] = this.serviceProductId;
        data["mileageId"] = this.mileageId;
        data["duration"] = this.duration;
        data["isServiceVariantsResetRequest"] = this.isServiceVariantsResetRequest;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["configurationID"] = this.configurationID;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["campaignId"] = this.campaignId;
        data["priceNet"] = this.priceNet;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["fundingProductId"] = this.fundingProductId;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["specialCaseRequestBundle"] = this.specialCaseRequestBundle ? this.specialCaseRequestBundle.toJSON() : <any>undefined;
        data["preCheckServiceProductSelectionsFromRequest"] = this.preCheckServiceProductSelectionsFromRequest;
        data["preCheckServiceProductSelectionsFromApicon"] = this.preCheckServiceProductSelectionsFromApicon;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["isBundle"] = this.isBundle;
        data["modelId"] = this.modelId;
        data["vat"] = this.vat;
        data["distributionChannel"] = this.distributionChannel;
        return data;
    }
}

export interface ICalculateServicePriceRequest {
    cacheGuid?: string | undefined;
    dealId: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId: number;
    duration: number;
    isServiceVariantsResetRequest: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId: number;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest: boolean;
    preCheckServiceProductSelectionsFromApicon: boolean;
    isPriceFormSpecialCaseMandatory: boolean;
    isServiceVariantSaveRequest: boolean;
    isBundle: boolean;
    modelId: number;
    vat: number;
    distributionChannel: number;
}

export class CalculatedInsuranceView implements ICalculatedInsuranceView {
    engineTax?: number | undefined;
    liabilityPrice?: number | undefined;
    kaskoPrice?: number | undefined;
    accidentPremium?: number | undefined;
    legalProtectionPremium?: number | undefined;
    totalPrice!: number;
    commissionTotal?: number | undefined;
    additionalProductsTotal!: number;

    constructor(data?: ICalculatedInsuranceView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.engineTax = _data["engineTax"];
            this.liabilityPrice = _data["liabilityPrice"];
            this.kaskoPrice = _data["kaskoPrice"];
            this.accidentPremium = _data["accidentPremium"];
            this.legalProtectionPremium = _data["legalProtectionPremium"];
            this.totalPrice = _data["totalPrice"];
            this.commissionTotal = _data["commissionTotal"];
            this.additionalProductsTotal = _data["additionalProductsTotal"];
        }
    }

    static fromJS(data: any): CalculatedInsuranceView {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedInsuranceView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["engineTax"] = this.engineTax;
        data["liabilityPrice"] = this.liabilityPrice;
        data["kaskoPrice"] = this.kaskoPrice;
        data["accidentPremium"] = this.accidentPremium;
        data["legalProtectionPremium"] = this.legalProtectionPremium;
        data["totalPrice"] = this.totalPrice;
        data["commissionTotal"] = this.commissionTotal;
        data["additionalProductsTotal"] = this.additionalProductsTotal;
        return data;
    }
}

export interface ICalculatedInsuranceView {
    engineTax?: number | undefined;
    liabilityPrice?: number | undefined;
    kaskoPrice?: number | undefined;
    accidentPremium?: number | undefined;
    legalProtectionPremium?: number | undefined;
    totalPrice: number;
    commissionTotal?: number | undefined;
    additionalProductsTotal: number;
}

export class CalculatedInsuranceViewApiResult implements ICalculatedInsuranceViewApiResult {
    messages!: ApiMessages;
    data!: CalculatedInsuranceView;

    constructor(data?: ICalculatedInsuranceViewApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CalculatedInsuranceView();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CalculatedInsuranceView.fromJS(_data["data"]) : new CalculatedInsuranceView();
        }
    }

    static fromJS(data: any): CalculatedInsuranceViewApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedInsuranceViewApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICalculatedInsuranceViewApiResult {
    messages: ApiMessages;
    data: CalculatedInsuranceView;
}

export class CalculatedProduct implements ICalculatedProduct {
    /** Schlussrate Finazierungsleasing */
    finalRateFinancingLeasing?: number | undefined;
    /** Rate brutto */
    regularInstalmentGross?: number | undefined;
    /** Rate netto */
    regularInstalmentNet?: number | undefined;
    /** Rate Ust. */
    regularInstalmentVat?: number | undefined;
    /** Restwertsumme inkl. Conversionoptions und Restwertstützungen (proposed oder overwritten) */
    residualValueAbsolute?: number | undefined;
    /** Restwert % (proposed oder overwritten) */
    residualValuePercentage?: number | undefined;
    /** Restwert Fahrzeug inkl. Restwertstützungen (proposed oder overwritten) */
    residualValueVehicleAbsolute?: number | undefined;
    /** Schlussrate bzw. Offener Restsaldo */
    closingBalance!: number;
    /** Summe Eigenmittel */
    ownResources!: number;
    /** Restwert inkl. ConversionOptions laut Tabelle (proposed) */
    residualValueProposedWithConversionOptions?: number | undefined;
    /** Restwert ConversionOptions (proposed oder overwritten) */
    residualValueConversionOptions!: number;
    /** Restwert Stützungen */
    residualValueSubsidyFixum!: number;
    /** Restwert laut Tabelle ohne ConversionOptions (proposed) */
    residualValueProposed!: number;
    /** gibt an, ob es sich bei den berechneten Restwerten um überschriebene Werte handelt */
    residualValuesOverwritten!: boolean;
    /** Rate inklusive Servicerate brutto */
    regularInstalmentTotalGross?: number | undefined;
    /** Rate inklusive Servicerate netto */
    regularInstalmentTotalNet?: number | undefined;
    /** Rate inklusive Servicerate Ust. */
    regularInstalmentTotalVat?: number | undefined;
    /** Wenn das kalkulierte Produkt Services enthält */
    hasServices!: boolean;

    constructor(data?: ICalculatedProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.finalRateFinancingLeasing = _data["finalRateFinancingLeasing"];
            this.regularInstalmentGross = _data["regularInstalmentGross"];
            this.regularInstalmentNet = _data["regularInstalmentNet"];
            this.regularInstalmentVat = _data["regularInstalmentVat"];
            this.residualValueAbsolute = _data["residualValueAbsolute"];
            this.residualValuePercentage = _data["residualValuePercentage"];
            this.residualValueVehicleAbsolute = _data["residualValueVehicleAbsolute"];
            this.closingBalance = _data["closingBalance"];
            this.ownResources = _data["ownResources"];
            this.residualValueProposedWithConversionOptions = _data["residualValueProposedWithConversionOptions"];
            this.residualValueConversionOptions = _data["residualValueConversionOptions"];
            this.residualValueSubsidyFixum = _data["residualValueSubsidyFixum"];
            this.residualValueProposed = _data["residualValueProposed"];
            this.residualValuesOverwritten = _data["residualValuesOverwritten"];
            this.regularInstalmentTotalGross = _data["regularInstalmentTotalGross"];
            this.regularInstalmentTotalNet = _data["regularInstalmentTotalNet"];
            this.regularInstalmentTotalVat = _data["regularInstalmentTotalVat"];
            this.hasServices = _data["hasServices"];
        }
    }

    static fromJS(data: any): CalculatedProduct {
        data = typeof data === 'object' ? data : {};
        let result = new CalculatedProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["finalRateFinancingLeasing"] = this.finalRateFinancingLeasing;
        data["regularInstalmentGross"] = this.regularInstalmentGross;
        data["regularInstalmentNet"] = this.regularInstalmentNet;
        data["regularInstalmentVat"] = this.regularInstalmentVat;
        data["residualValueAbsolute"] = this.residualValueAbsolute;
        data["residualValuePercentage"] = this.residualValuePercentage;
        data["residualValueVehicleAbsolute"] = this.residualValueVehicleAbsolute;
        data["closingBalance"] = this.closingBalance;
        data["ownResources"] = this.ownResources;
        data["residualValueProposedWithConversionOptions"] = this.residualValueProposedWithConversionOptions;
        data["residualValueConversionOptions"] = this.residualValueConversionOptions;
        data["residualValueSubsidyFixum"] = this.residualValueSubsidyFixum;
        data["residualValueProposed"] = this.residualValueProposed;
        data["residualValuesOverwritten"] = this.residualValuesOverwritten;
        data["regularInstalmentTotalGross"] = this.regularInstalmentTotalGross;
        data["regularInstalmentTotalNet"] = this.regularInstalmentTotalNet;
        data["regularInstalmentTotalVat"] = this.regularInstalmentTotalVat;
        data["hasServices"] = this.hasServices;
        return data;
    }
}

export interface ICalculatedProduct {
    /** Schlussrate Finazierungsleasing */
    finalRateFinancingLeasing?: number | undefined;
    /** Rate brutto */
    regularInstalmentGross?: number | undefined;
    /** Rate netto */
    regularInstalmentNet?: number | undefined;
    /** Rate Ust. */
    regularInstalmentVat?: number | undefined;
    /** Restwertsumme inkl. Conversionoptions und Restwertstützungen (proposed oder overwritten) */
    residualValueAbsolute?: number | undefined;
    /** Restwert % (proposed oder overwritten) */
    residualValuePercentage?: number | undefined;
    /** Restwert Fahrzeug inkl. Restwertstützungen (proposed oder overwritten) */
    residualValueVehicleAbsolute?: number | undefined;
    /** Schlussrate bzw. Offener Restsaldo */
    closingBalance: number;
    /** Summe Eigenmittel */
    ownResources: number;
    /** Restwert inkl. ConversionOptions laut Tabelle (proposed) */
    residualValueProposedWithConversionOptions?: number | undefined;
    /** Restwert ConversionOptions (proposed oder overwritten) */
    residualValueConversionOptions: number;
    /** Restwert Stützungen */
    residualValueSubsidyFixum: number;
    /** Restwert laut Tabelle ohne ConversionOptions (proposed) */
    residualValueProposed: number;
    /** gibt an, ob es sich bei den berechneten Restwerten um überschriebene Werte handelt */
    residualValuesOverwritten: boolean;
    /** Rate inklusive Servicerate brutto */
    regularInstalmentTotalGross?: number | undefined;
    /** Rate inklusive Servicerate netto */
    regularInstalmentTotalNet?: number | undefined;
    /** Rate inklusive Servicerate Ust. */
    regularInstalmentTotalVat?: number | undefined;
    /** Wenn das kalkulierte Produkt Services enthält */
    hasServices: boolean;
}

export class CalculationMapping implements ICalculationMapping {
    calculationId!: number;
    conversionOptionIds!: number[];

    constructor(data?: ICalculationMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.conversionOptionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationId = _data["calculationId"];
            if (Array.isArray(_data["conversionOptionIds"])) {
                this.conversionOptionIds = [] as any;
                for (let item of _data["conversionOptionIds"])
                    this.conversionOptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CalculationMapping {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationId"] = this.calculationId;
        if (Array.isArray(this.conversionOptionIds)) {
            data["conversionOptionIds"] = [];
            for (let item of this.conversionOptionIds)
                data["conversionOptionIds"].push(item);
        }
        return data;
    }
}

export interface ICalculationMapping {
    calculationId: number;
    conversionOptionIds: number[];
}

export class CalculationMatchOverview implements ICalculationMatchOverview {
    calculationId!: number;
    calculationNr!: string;
    matchDate!: Date;
    features!: ConditionDebugFeatureView[];
    ruleSets!: RuleSetOverview[];

    constructor(data?: ICalculationMatchOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.features = [];
            this.ruleSets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationId = _data["calculationId"];
            this.calculationNr = _data["calculationNr"];
            this.matchDate = _data["matchDate"] ? new Date(_data["matchDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(ConditionDebugFeatureView.fromJS(item));
            }
            if (Array.isArray(_data["ruleSets"])) {
                this.ruleSets = [] as any;
                for (let item of _data["ruleSets"])
                    this.ruleSets!.push(RuleSetOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationMatchOverview {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationMatchOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationId"] = this.calculationId;
        data["calculationNr"] = this.calculationNr;
        data["matchDate"] = this.matchDate ? this.matchDate.toISOString() : <any>undefined;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        if (Array.isArray(this.ruleSets)) {
            data["ruleSets"] = [];
            for (let item of this.ruleSets)
                data["ruleSets"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculationMatchOverview {
    calculationId: number;
    calculationNr: string;
    matchDate: Date;
    features: ConditionDebugFeatureView[];
    ruleSets: RuleSetOverview[];
}

export class CalculationServiceRequest implements ICalculationServiceRequest {
    calculationId!: number;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    isServiceVariantSaveRequest!: boolean;
    cacheGuid?: string | undefined;
    mileageId!: number;
    serviceProductId!: string;
    productIndustryId!: string;
    productUsageId!: string;
    campaignId!: string;
    productOptionIds!: string[];
    technicalOptionIds!: string[];
    priceNet?: number | undefined;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    uptimeInfos?: ApiconUptimeInfosForm | undefined;
    configurationID!: string;
    requestSourceApiconServiceBundleResetCalculation!: boolean;
    duration!: number;

    constructor(data?: ICalculationServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productOptionIds = [];
            this.technicalOptionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.cacheGuid = _data["cacheGuid"];
            this.mileageId = _data["mileageId"];
            this.serviceProductId = _data["serviceProductId"];
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            this.campaignId = _data["campaignId"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.priceNet = _data["priceNet"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.uptimeInfos = _data["uptimeInfos"] ? ApiconUptimeInfosForm.fromJS(_data["uptimeInfos"]) : <any>undefined;
            this.configurationID = _data["configurationID"];
            this.requestSourceApiconServiceBundleResetCalculation = _data["requestSourceApiconServiceBundleResetCalculation"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): CalculationServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["cacheGuid"] = this.cacheGuid;
        data["mileageId"] = this.mileageId;
        data["serviceProductId"] = this.serviceProductId;
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        data["campaignId"] = this.campaignId;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["priceNet"] = this.priceNet;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["uptimeInfos"] = this.uptimeInfos ? this.uptimeInfos.toJSON() : <any>undefined;
        data["configurationID"] = this.configurationID;
        data["requestSourceApiconServiceBundleResetCalculation"] = this.requestSourceApiconServiceBundleResetCalculation;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ICalculationServiceRequest {
    calculationId: number;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    isServiceVariantSaveRequest: boolean;
    cacheGuid?: string | undefined;
    mileageId: number;
    serviceProductId: string;
    productIndustryId: string;
    productUsageId: string;
    campaignId: string;
    productOptionIds: string[];
    technicalOptionIds: string[];
    priceNet?: number | undefined;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    uptimeInfos?: ApiconUptimeInfosForm | undefined;
    configurationID: string;
    requestSourceApiconServiceBundleResetCalculation: boolean;
    duration: number;
}

export class Campaign implements ICampaign {
    campaignId?: string | undefined;
    designation?: string | undefined;

    constructor(data?: ICampaign) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campaignId = _data["campaignId"];
            this.designation = _data["designation"];
        }
    }

    static fromJS(data: any): Campaign {
        data = typeof data === 'object' ? data : {};
        let result = new Campaign();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campaignId"] = this.campaignId;
        data["designation"] = this.designation;
        return data;
    }
}

export interface ICampaign {
    campaignId?: string | undefined;
    designation?: string | undefined;
}

export class ClassificationGroupObjectLinkView implements IClassificationGroupObjectLinkView {
    objectId!: string;
    objectType!: ClassificationType;
    groupId!: string;
    groupName!: string;

    constructor(data?: IClassificationGroupObjectLinkView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): ClassificationGroupObjectLinkView {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationGroupObjectLinkView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IClassificationGroupObjectLinkView {
    objectId: string;
    objectType: ClassificationType;
    groupId: string;
    groupName: string;
}

export class ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult implements IClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: ClassificationGroupObjectLinkView[];

    constructor(data?: IClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassificationGroupObjectLinkView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClassificationGroupObjectLinkViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: ClassificationGroupObjectLinkView[];
}

export class ClassificationGroupView implements IClassificationGroupView {
    id!: string;
    name!: string;
    parentGroupId?: string | undefined;

    constructor(data?: IClassificationGroupView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentGroupId = _data["parentGroupId"];
        }
    }

    static fromJS(data: any): ClassificationGroupView {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationGroupView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentGroupId"] = this.parentGroupId;
        return data;
    }
}

export interface IClassificationGroupView {
    id: string;
    name: string;
    parentGroupId?: string | undefined;
}

export class ClassificationGroupViewIReadOnlyCollectionApiResult implements IClassificationGroupViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: ClassificationGroupView[];

    constructor(data?: IClassificationGroupViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ClassificationGroupView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClassificationGroupViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ClassificationGroupViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClassificationGroupViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: ClassificationGroupView[];
}

export enum ClassificationType {
    Deal = "Deal",
    Customer = "Customer",
    FinancingCalculation = "FinancingCalculation",
    Model = "Model",
    Trademark = "Trademark",
    SpecialOffer = "SpecialOffer",
    Condition = "Condition",
    Touchpoint = "Touchpoint",
    Vehicle = "Vehicle",
    Dealer = "Dealer",
    FinancingType = "FinancingType",
}

export class CoApplicantCustomer implements ICoApplicantCustomer {
    customerId?: number | undefined;
    privateCustomer?: PrivateCustomerView | undefined;
    commercialCustomer?: CommercialCustomerView | undefined;
    applyChangesToMainCustomer!: boolean;

    constructor(data?: ICoApplicantCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.privateCustomer = _data["privateCustomer"] ? PrivateCustomerView.fromJS(_data["privateCustomer"]) : <any>undefined;
            this.commercialCustomer = _data["commercialCustomer"] ? CommercialCustomerView.fromJS(_data["commercialCustomer"]) : <any>undefined;
            this.applyChangesToMainCustomer = _data["applyChangesToMainCustomer"];
        }
    }

    static fromJS(data: any): CoApplicantCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["privateCustomer"] = this.privateCustomer ? this.privateCustomer.toJSON() : <any>undefined;
        data["commercialCustomer"] = this.commercialCustomer ? this.commercialCustomer.toJSON() : <any>undefined;
        data["applyChangesToMainCustomer"] = this.applyChangesToMainCustomer;
        return data;
    }
}

export interface ICoApplicantCustomer {
    customerId?: number | undefined;
    privateCustomer?: PrivateCustomerView | undefined;
    commercialCustomer?: CommercialCustomerView | undefined;
    applyChangesToMainCustomer: boolean;
}

export class CoApplicantOverview implements ICoApplicantOverview {
    customerId!: number;
    firstName!: string;
    lastName!: string;

    constructor(data?: ICoApplicantOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): CoApplicantOverview {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ICoApplicantOverview {
    customerId: number;
    firstName: string;
    lastName: string;
}

export class CoApplicantOverviewIReadOnlyCollectionApiResult implements ICoApplicantOverviewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: CoApplicantOverview[];

    constructor(data?: ICoApplicantOverviewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CoApplicantOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CoApplicantOverviewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantOverviewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICoApplicantOverviewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: CoApplicantOverview[];
}

export class CoApplicantSnapshotData implements ICoApplicantSnapshotData {
    coApplicantRelationId!: number;
    isApplicantSpouse?: boolean | undefined;
    customer!: CustomerSnapshotData;

    constructor(data?: ICoApplicantSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new CustomerSnapshotData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coApplicantRelationId = _data["coApplicantRelationId"];
            this.isApplicantSpouse = _data["isApplicantSpouse"];
            this.customer = _data["customer"] ? CustomerSnapshotData.fromJS(_data["customer"]) : new CustomerSnapshotData();
        }
    }

    static fromJS(data: any): CoApplicantSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new CoApplicantSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coApplicantRelationId"] = this.coApplicantRelationId;
        data["isApplicantSpouse"] = this.isApplicantSpouse;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICoApplicantSnapshotData {
    coApplicantRelationId: number;
    isApplicantSpouse?: boolean | undefined;
    customer: CustomerSnapshotData;
}

export class CommercialCustomerKsvResponse implements ICommercialCustomerKsvResponse {
    readonly ksvId!: string;
    readonly street!: string;
    readonly companyName!: string;
    readonly zip!: string;
    readonly city!: string;
    readonly house!: string;

    constructor(data?: ICommercialCustomerKsvResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ksvId = _data["ksvId"];
            (<any>this).street = _data["street"];
            (<any>this).companyName = _data["companyName"];
            (<any>this).zip = _data["zip"];
            (<any>this).city = _data["city"];
            (<any>this).house = _data["house"];
        }
    }

    static fromJS(data: any): CommercialCustomerKsvResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialCustomerKsvResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ksvId"] = this.ksvId;
        data["street"] = this.street;
        data["companyName"] = this.companyName;
        data["zip"] = this.zip;
        data["city"] = this.city;
        data["house"] = this.house;
        return data;
    }
}

export interface ICommercialCustomerKsvResponse {
    ksvId: string;
    street: string;
    companyName: string;
    zip: string;
    city: string;
    house: string;
}

export class CommercialCustomerKsvResponseIReadOnlyCollectionApiResult implements ICommercialCustomerKsvResponseIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: CommercialCustomerKsvResponse[];

    constructor(data?: ICommercialCustomerKsvResponseIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommercialCustomerKsvResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommercialCustomerKsvResponseIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialCustomerKsvResponseIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommercialCustomerKsvResponseIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: CommercialCustomerKsvResponse[];
}

export class CommercialCustomerSnapshotData implements ICommercialCustomerSnapshotData {
    ceoDetails?: PersonalSnapshotData | undefined;
    companyName?: string | undefined;
    companyName2?: string | undefined;
    companyBusiness?: string | undefined;
    legalFormId?: number | undefined;
    branchId?: number | undefined;
    isGeneralPartner?: boolean | undefined;
    riskIncreasingCircumstances!: boolean;
    foundationDate?: Date | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;

    constructor(data?: ICommercialCustomerSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ceoDetails = _data["ceoDetails"] ? PersonalSnapshotData.fromJS(_data["ceoDetails"]) : <any>undefined;
            this.companyName = _data["companyName"];
            this.companyName2 = _data["companyName2"];
            this.companyBusiness = _data["companyBusiness"];
            this.legalFormId = _data["legalFormId"];
            this.branchId = _data["branchId"];
            this.isGeneralPartner = _data["isGeneralPartner"];
            this.riskIncreasingCircumstances = _data["riskIncreasingCircumstances"];
            this.foundationDate = _data["foundationDate"] ? new Date(_data["foundationDate"].toString()) : <any>undefined;
            this.uidNumber = _data["uidNumber"];
            this.commercialRegisterNumber = _data["commercialRegisterNumber"];
        }
    }

    static fromJS(data: any): CommercialCustomerSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialCustomerSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ceoDetails"] = this.ceoDetails ? this.ceoDetails.toJSON() : <any>undefined;
        data["companyName"] = this.companyName;
        data["companyName2"] = this.companyName2;
        data["companyBusiness"] = this.companyBusiness;
        data["legalFormId"] = this.legalFormId;
        data["branchId"] = this.branchId;
        data["isGeneralPartner"] = this.isGeneralPartner;
        data["riskIncreasingCircumstances"] = this.riskIncreasingCircumstances;
        data["foundationDate"] = this.foundationDate ? this.foundationDate.toISOString() : <any>undefined;
        data["uidNumber"] = this.uidNumber;
        data["commercialRegisterNumber"] = this.commercialRegisterNumber;
        return data;
    }
}

export interface ICommercialCustomerSnapshotData {
    ceoDetails?: PersonalSnapshotData | undefined;
    companyName?: string | undefined;
    companyName2?: string | undefined;
    companyBusiness?: string | undefined;
    legalFormId?: number | undefined;
    branchId?: number | undefined;
    isGeneralPartner?: boolean | undefined;
    riskIncreasingCircumstances: boolean;
    foundationDate?: Date | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;
}

export class CommercialCustomerView implements ICommercialCustomerView {
    legalFormId?: number | undefined;
    companyName?: string | undefined;
    addressStreet?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressCountryId?: number | undefined;
    phoneNumber?: string | undefined;
    additionalPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    foundationDate?: Date | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;
    branchId?: number | undefined;
    companyBusiness?: string | undefined;
    bankAccountIBAN?: string | undefined;
    bankAccountBIC?: string | undefined;
    bankAccountBankName?: string | undefined;
    ksvId?: string | undefined;
    ksvSearchDone?: boolean | undefined;
    identityCheckId?: string | undefined;
    dataInformationSheetTransferred!: boolean;
    emailMarketingAggreed?: boolean | undefined;
    phoneMarketingAggreed?: boolean | undefined;
    postalMarketingAggreed?: boolean | undefined;
    salutationId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    residencePermitValidSince?: Date | undefined;
    residencePermitValidTill?: Date | undefined;
    inAustriaSince?: Date | undefined;
    selfEmployedSince?: Date | undefined;
    isGeneralPartner!: boolean;
    isPotentialBuyer!: boolean;
    hashCode?: number | undefined;
    selfDisclosureAgreed!: boolean;
    selfDisclosureAgreedAt?: Date | undefined;
    riskIncreasingCircumstances!: boolean;

    constructor(data?: ICommercialCustomerView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalFormId = _data["legalFormId"];
            this.companyName = _data["companyName"];
            this.addressStreet = _data["addressStreet"];
            this.addressHouseNumber = _data["addressHouseNumber"];
            this.addressPostalCode = _data["addressPostalCode"];
            this.addressCity = _data["addressCity"];
            this.addressCountryId = _data["addressCountryId"];
            this.phoneNumber = _data["phoneNumber"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.foundationDate = _data["foundationDate"] ? new Date(_data["foundationDate"].toString()) : <any>undefined;
            this.uidNumber = _data["uidNumber"];
            this.commercialRegisterNumber = _data["commercialRegisterNumber"];
            this.branchId = _data["branchId"];
            this.companyBusiness = _data["companyBusiness"];
            this.bankAccountIBAN = _data["bankAccountIBAN"];
            this.bankAccountBIC = _data["bankAccountBIC"];
            this.bankAccountBankName = _data["bankAccountBankName"];
            this.ksvId = _data["ksvId"];
            this.ksvSearchDone = _data["ksvSearchDone"];
            this.identityCheckId = _data["identityCheckId"];
            this.dataInformationSheetTransferred = _data["dataInformationSheetTransferred"];
            this.emailMarketingAggreed = _data["emailMarketingAggreed"];
            this.phoneMarketingAggreed = _data["phoneMarketingAggreed"];
            this.postalMarketingAggreed = _data["postalMarketingAggreed"];
            this.salutationId = _data["salutationId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.maritalStatusId = _data["maritalStatusId"];
            this.citizenshipId = _data["citizenshipId"];
            this.pepSpecificationId = _data["pepSpecificationId"];
            this.politicalExposedPersonRelated = _data["politicalExposedPersonRelated"];
            this.numberOfSupportedChildren = _data["numberOfSupportedChildren"];
            this.numberOfChildrenUnderEighteen = _data["numberOfChildrenUnderEighteen"];
            this.residencePermitValidSince = _data["residencePermitValidSince"] ? new Date(_data["residencePermitValidSince"].toString()) : <any>undefined;
            this.residencePermitValidTill = _data["residencePermitValidTill"] ? new Date(_data["residencePermitValidTill"].toString()) : <any>undefined;
            this.inAustriaSince = _data["inAustriaSince"] ? new Date(_data["inAustriaSince"].toString()) : <any>undefined;
            this.selfEmployedSince = _data["selfEmployedSince"] ? new Date(_data["selfEmployedSince"].toString()) : <any>undefined;
            this.isGeneralPartner = _data["isGeneralPartner"];
            this.isPotentialBuyer = _data["isPotentialBuyer"];
            this.hashCode = _data["hashCode"];
            this.selfDisclosureAgreed = _data["selfDisclosureAgreed"];
            this.selfDisclosureAgreedAt = _data["selfDisclosureAgreedAt"] ? new Date(_data["selfDisclosureAgreedAt"].toString()) : <any>undefined;
            this.riskIncreasingCircumstances = _data["riskIncreasingCircumstances"];
        }
    }

    static fromJS(data: any): CommercialCustomerView {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialCustomerView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalFormId"] = this.legalFormId;
        data["companyName"] = this.companyName;
        data["addressStreet"] = this.addressStreet;
        data["addressHouseNumber"] = this.addressHouseNumber;
        data["addressPostalCode"] = this.addressPostalCode;
        data["addressCity"] = this.addressCity;
        data["addressCountryId"] = this.addressCountryId;
        data["phoneNumber"] = this.phoneNumber;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["foundationDate"] = this.foundationDate ? this.foundationDate.toISOString() : <any>undefined;
        data["uidNumber"] = this.uidNumber;
        data["commercialRegisterNumber"] = this.commercialRegisterNumber;
        data["branchId"] = this.branchId;
        data["companyBusiness"] = this.companyBusiness;
        data["bankAccountIBAN"] = this.bankAccountIBAN;
        data["bankAccountBIC"] = this.bankAccountBIC;
        data["bankAccountBankName"] = this.bankAccountBankName;
        data["ksvId"] = this.ksvId;
        data["ksvSearchDone"] = this.ksvSearchDone;
        data["identityCheckId"] = this.identityCheckId;
        data["dataInformationSheetTransferred"] = this.dataInformationSheetTransferred;
        data["emailMarketingAggreed"] = this.emailMarketingAggreed;
        data["phoneMarketingAggreed"] = this.phoneMarketingAggreed;
        data["postalMarketingAggreed"] = this.postalMarketingAggreed;
        data["salutationId"] = this.salutationId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["maritalStatusId"] = this.maritalStatusId;
        data["citizenshipId"] = this.citizenshipId;
        data["pepSpecificationId"] = this.pepSpecificationId;
        data["politicalExposedPersonRelated"] = this.politicalExposedPersonRelated;
        data["numberOfSupportedChildren"] = this.numberOfSupportedChildren;
        data["numberOfChildrenUnderEighteen"] = this.numberOfChildrenUnderEighteen;
        data["residencePermitValidSince"] = this.residencePermitValidSince ? this.residencePermitValidSince.toISOString() : <any>undefined;
        data["residencePermitValidTill"] = this.residencePermitValidTill ? this.residencePermitValidTill.toISOString() : <any>undefined;
        data["inAustriaSince"] = this.inAustriaSince ? this.inAustriaSince.toISOString() : <any>undefined;
        data["selfEmployedSince"] = this.selfEmployedSince ? this.selfEmployedSince.toISOString() : <any>undefined;
        data["isGeneralPartner"] = this.isGeneralPartner;
        data["isPotentialBuyer"] = this.isPotentialBuyer;
        data["hashCode"] = this.hashCode;
        data["selfDisclosureAgreed"] = this.selfDisclosureAgreed;
        data["selfDisclosureAgreedAt"] = this.selfDisclosureAgreedAt ? this.selfDisclosureAgreedAt.toISOString() : <any>undefined;
        data["riskIncreasingCircumstances"] = this.riskIncreasingCircumstances;
        return data;
    }
}

export interface ICommercialCustomerView {
    legalFormId?: number | undefined;
    companyName?: string | undefined;
    addressStreet?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressCountryId?: number | undefined;
    phoneNumber?: string | undefined;
    additionalPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    foundationDate?: Date | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;
    branchId?: number | undefined;
    companyBusiness?: string | undefined;
    bankAccountIBAN?: string | undefined;
    bankAccountBIC?: string | undefined;
    bankAccountBankName?: string | undefined;
    ksvId?: string | undefined;
    ksvSearchDone?: boolean | undefined;
    identityCheckId?: string | undefined;
    dataInformationSheetTransferred: boolean;
    emailMarketingAggreed?: boolean | undefined;
    phoneMarketingAggreed?: boolean | undefined;
    postalMarketingAggreed?: boolean | undefined;
    salutationId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    residencePermitValidSince?: Date | undefined;
    residencePermitValidTill?: Date | undefined;
    inAustriaSince?: Date | undefined;
    selfEmployedSince?: Date | undefined;
    isGeneralPartner: boolean;
    isPotentialBuyer: boolean;
    hashCode?: number | undefined;
    selfDisclosureAgreed: boolean;
    selfDisclosureAgreedAt?: Date | undefined;
    riskIncreasingCircumstances: boolean;
}

export class CommercialCustomerViewApiResult implements ICommercialCustomerViewApiResult {
    messages!: ApiMessages;
    data!: CommercialCustomerView;

    constructor(data?: ICommercialCustomerViewApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CommercialCustomerView();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CommercialCustomerView.fromJS(_data["data"]) : new CommercialCustomerView();
        }
    }

    static fromJS(data: any): CommercialCustomerViewApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CommercialCustomerViewApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommercialCustomerViewApiResult {
    messages: ApiMessages;
    data: CommercialCustomerView;
}

export class OptionItem implements IOptionItem {
    value!: number;
    label!: string;

    constructor(data?: IOptionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): OptionItem {
        data = typeof data === 'object' ? data : {};
        let result = new OptionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface IOptionItem {
    value: number;
    label: string;
}

export class CommissionDealer extends OptionItem implements ICommissionDealer {
    isDefault!: boolean;

    constructor(data?: ICommissionDealer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): CommissionDealer {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionDealer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDefault"] = this.isDefault;
        super.toJSON(data);
        return data;
    }
}

export interface ICommissionDealer extends IOptionItem {
    isDefault: boolean;
}

export class CommissionDealerIReadOnlyCollectionApiResult implements ICommissionDealerIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: CommissionDealer[];

    constructor(data?: ICommissionDealerIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CommissionDealer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommissionDealerIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionDealerIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommissionDealerIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: CommissionDealer[];
}

export class CompareMainCustomerWithDealCustomerResponse implements ICompareMainCustomerWithDealCustomerResponse {
    readonly areEqual!: boolean;
    readonly differences!: CompareResult[];

    constructor(data?: ICompareMainCustomerWithDealCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.differences = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).areEqual = _data["areEqual"];
            if (Array.isArray(_data["differences"])) {
                (<any>this).differences = [] as any;
                for (let item of _data["differences"])
                    (<any>this).differences!.push(CompareResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompareMainCustomerWithDealCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CompareMainCustomerWithDealCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areEqual"] = this.areEqual;
        if (Array.isArray(this.differences)) {
            data["differences"] = [];
            for (let item of this.differences)
                data["differences"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICompareMainCustomerWithDealCustomerResponse {
    areEqual: boolean;
    differences: CompareResult[];
}

export class CompareMainCustomerWithDealCustomerResponseApiResult implements ICompareMainCustomerWithDealCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: CompareMainCustomerWithDealCustomerResponse;

    constructor(data?: ICompareMainCustomerWithDealCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CompareMainCustomerWithDealCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CompareMainCustomerWithDealCustomerResponse.fromJS(_data["data"]) : new CompareMainCustomerWithDealCustomerResponse();
        }
    }

    static fromJS(data: any): CompareMainCustomerWithDealCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CompareMainCustomerWithDealCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICompareMainCustomerWithDealCustomerResponseApiResult {
    messages: ApiMessages;
    data: CompareMainCustomerWithDealCustomerResponse;
}

export class CompareResult implements ICompareResult {
    propertyName!: string;
    mainCustomerValue!: string;
    dealCustomerValue!: string;

    constructor(data?: ICompareResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.mainCustomerValue = _data["mainCustomerValue"];
            this.dealCustomerValue = _data["dealCustomerValue"];
        }
    }

    static fromJS(data: any): CompareResult {
        data = typeof data === 'object' ? data : {};
        let result = new CompareResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["mainCustomerValue"] = this.mainCustomerValue;
        data["dealCustomerValue"] = this.dealCustomerValue;
        return data;
    }
}

export interface ICompareResult {
    propertyName: string;
    mainCustomerValue: string;
    dealCustomerValue: string;
}

export class CompleteCalculationRequest implements ICompleteCalculationRequest {
    dealId!: number;
    variantNr!: number;
    vin!: string;
    registrationDate?: Date | undefined;
    licensePlate!: string;
    signatureDate?: Date | undefined;

    constructor(data?: ICompleteCalculationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.variantNr = _data["variantNr"];
            this.vin = _data["vin"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
            this.signatureDate = _data["signatureDate"] ? new Date(_data["signatureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CompleteCalculationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteCalculationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["variantNr"] = this.variantNr;
        data["vin"] = this.vin;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICompleteCalculationRequest {
    dealId: number;
    variantNr: number;
    vin: string;
    registrationDate?: Date | undefined;
    licensePlate: string;
    signatureDate?: Date | undefined;
}

export class CompleteSpecialCasePriceRequest implements ICompleteSpecialCasePriceRequest {
    cacheGuid?: string | undefined;
    dealId!: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId!: number;
    duration!: number;
    isServiceVariantsResetRequest!: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId!: number;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest!: boolean;
    preCheckServiceProductSelectionsFromApicon!: boolean;
    isPriceFormSpecialCaseMandatory!: boolean;
    isServiceVariantSaveRequest!: boolean;
    isBundle!: boolean;

    constructor(data?: ICompleteSpecialCasePriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheGuid = _data["cacheGuid"];
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.serviceProductId = _data["serviceProductId"];
            this.mileageId = _data["mileageId"];
            this.duration = _data["duration"];
            this.isServiceVariantsResetRequest = _data["isServiceVariantsResetRequest"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.configurationID = _data["configurationID"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.campaignId = _data["campaignId"];
            this.priceNet = _data["priceNet"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.fundingProductId = _data["fundingProductId"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.specialCaseRequestBundle = _data["specialCaseRequestBundle"] ? ApiconSpecialCaseRequestBundle.fromJS(_data["specialCaseRequestBundle"]) : <any>undefined;
            this.preCheckServiceProductSelectionsFromRequest = _data["preCheckServiceProductSelectionsFromRequest"];
            this.preCheckServiceProductSelectionsFromApicon = _data["preCheckServiceProductSelectionsFromApicon"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): CompleteSpecialCasePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteSpecialCasePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheGuid"] = this.cacheGuid;
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["serviceProductId"] = this.serviceProductId;
        data["mileageId"] = this.mileageId;
        data["duration"] = this.duration;
        data["isServiceVariantsResetRequest"] = this.isServiceVariantsResetRequest;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["configurationID"] = this.configurationID;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["campaignId"] = this.campaignId;
        data["priceNet"] = this.priceNet;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["fundingProductId"] = this.fundingProductId;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["specialCaseRequestBundle"] = this.specialCaseRequestBundle ? this.specialCaseRequestBundle.toJSON() : <any>undefined;
        data["preCheckServiceProductSelectionsFromRequest"] = this.preCheckServiceProductSelectionsFromRequest;
        data["preCheckServiceProductSelectionsFromApicon"] = this.preCheckServiceProductSelectionsFromApicon;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface ICompleteSpecialCasePriceRequest {
    cacheGuid?: string | undefined;
    dealId: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId: number;
    duration: number;
    isServiceVariantsResetRequest: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId: number;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest: boolean;
    preCheckServiceProductSelectionsFromApicon: boolean;
    isPriceFormSpecialCaseMandatory: boolean;
    isServiceVariantSaveRequest: boolean;
    isBundle: boolean;
}

export enum ConditionAdjustmentDecision {
    OK = "OK",
    NOK = "NOK",
    Error = "Error",
}

export class ConditionAdjustmentSnapshotData implements IConditionAdjustmentSnapshotData {
    id!: number;
    attemptKey!: string;
    status!: string;
    decision?: string | undefined;
    reason?: string | undefined;
    decredoInstanceId?: string | undefined;
    handOverCmsIds?: string[] | undefined;
    createdAt!: Date;
    completedAt?: Date | undefined;
    euriborApplied!: number;
    euriborNew!: number;
    delta!: number;
    zinsNew!: number;
    interestRate?: number | undefined;
    effectiveCustomerRate?: number | undefined;
    borrowingInterestRate?: number | undefined;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    monthlyNetPayment?: number | undefined;
    monthlyGrossPayment?: number | undefined;
    totalLoad?: number | undefined;
    legalTransactionFee?: number | undefined;
    additionalMileageCharge?: number | undefined;

    constructor(data?: IConditionAdjustmentSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attemptKey = _data["attemptKey"];
            this.status = _data["status"];
            this.decision = _data["decision"];
            this.reason = _data["reason"];
            this.decredoInstanceId = _data["decredoInstanceId"];
            if (Array.isArray(_data["handOverCmsIds"])) {
                this.handOverCmsIds = [] as any;
                for (let item of _data["handOverCmsIds"])
                    this.handOverCmsIds!.push(item);
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : <any>undefined;
            this.euriborApplied = _data["euriborApplied"];
            this.euriborNew = _data["euriborNew"];
            this.delta = _data["delta"];
            this.zinsNew = _data["zinsNew"];
            this.interestRate = _data["interestRate"];
            this.effectiveCustomerRate = _data["effectiveCustomerRate"];
            this.borrowingInterestRate = _data["borrowingInterestRate"];
            this.regularInstalment = _data["regularInstalment"];
            this.regularInstalmentExact = _data["regularInstalmentExact"];
            this.monthlyNetPayment = _data["monthlyNetPayment"];
            this.monthlyGrossPayment = _data["monthlyGrossPayment"];
            this.totalLoad = _data["totalLoad"];
            this.legalTransactionFee = _data["legalTransactionFee"];
            this.additionalMileageCharge = _data["additionalMileageCharge"];
        }
    }

    static fromJS(data: any): ConditionAdjustmentSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionAdjustmentSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attemptKey"] = this.attemptKey;
        data["status"] = this.status;
        data["decision"] = this.decision;
        data["reason"] = this.reason;
        data["decredoInstanceId"] = this.decredoInstanceId;
        if (Array.isArray(this.handOverCmsIds)) {
            data["handOverCmsIds"] = [];
            for (let item of this.handOverCmsIds)
                data["handOverCmsIds"].push(item);
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["euriborApplied"] = this.euriborApplied;
        data["euriborNew"] = this.euriborNew;
        data["delta"] = this.delta;
        data["zinsNew"] = this.zinsNew;
        data["interestRate"] = this.interestRate;
        data["effectiveCustomerRate"] = this.effectiveCustomerRate;
        data["borrowingInterestRate"] = this.borrowingInterestRate;
        data["regularInstalment"] = this.regularInstalment;
        data["regularInstalmentExact"] = this.regularInstalmentExact;
        data["monthlyNetPayment"] = this.monthlyNetPayment;
        data["monthlyGrossPayment"] = this.monthlyGrossPayment;
        data["totalLoad"] = this.totalLoad;
        data["legalTransactionFee"] = this.legalTransactionFee;
        data["additionalMileageCharge"] = this.additionalMileageCharge;
        return data;
    }
}

export interface IConditionAdjustmentSnapshotData {
    id: number;
    attemptKey: string;
    status: string;
    decision?: string | undefined;
    reason?: string | undefined;
    decredoInstanceId?: string | undefined;
    handOverCmsIds?: string[] | undefined;
    createdAt: Date;
    completedAt?: Date | undefined;
    euriborApplied: number;
    euriborNew: number;
    delta: number;
    zinsNew: number;
    interestRate?: number | undefined;
    effectiveCustomerRate?: number | undefined;
    borrowingInterestRate?: number | undefined;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    monthlyNetPayment?: number | undefined;
    monthlyGrossPayment?: number | undefined;
    totalLoad?: number | undefined;
    legalTransactionFee?: number | undefined;
    additionalMileageCharge?: number | undefined;
}

export class ConditionDebugFeatureView implements IConditionDebugFeatureView {
    name!: string;
    value!: string;
    source!: string;
    isOverwritten!: boolean;

    constructor(data?: IConditionDebugFeatureView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
            this.source = _data["source"];
            this.isOverwritten = _data["isOverwritten"];
        }
    }

    static fromJS(data: any): ConditionDebugFeatureView {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDebugFeatureView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        data["source"] = this.source;
        data["isOverwritten"] = this.isOverwritten;
        return data;
    }
}

export interface IConditionDebugFeatureView {
    name: string;
    value: string;
    source: string;
    isOverwritten: boolean;
}

/** Eine Zeile des Auswertungsbaums - Dekato.Web.Api.Handlers.Classification.Simulation.ConditionDebugRuleView.Depth ergibt die Einrueckung im UI. */
export class ConditionDebugRuleView implements IConditionDebugRuleView {
    depth!: number;
    combinator?: string | undefined;
    not!: boolean;
    field?: string | undefined;
    operator?: string | undefined;
    expectedValue?: string | undefined;
    actualValue?: string | undefined;
    featureFound!: boolean;
    matched!: boolean;
    error?: string | undefined;

    constructor(data?: IConditionDebugRuleView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depth = _data["depth"];
            this.combinator = _data["combinator"];
            this.not = _data["not"];
            this.field = _data["field"];
            this.operator = _data["operator"];
            this.expectedValue = _data["expectedValue"];
            this.actualValue = _data["actualValue"];
            this.featureFound = _data["featureFound"];
            this.matched = _data["matched"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ConditionDebugRuleView {
        data = typeof data === 'object' ? data : {};
        let result = new ConditionDebugRuleView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depth"] = this.depth;
        data["combinator"] = this.combinator;
        data["not"] = this.not;
        data["field"] = this.field;
        data["operator"] = this.operator;
        data["expectedValue"] = this.expectedValue;
        data["actualValue"] = this.actualValue;
        data["featureFound"] = this.featureFound;
        data["matched"] = this.matched;
        data["error"] = this.error;
        return data;
    }
}

/** Eine Zeile des Auswertungsbaums - Dekato.Web.Api.Handlers.Classification.Simulation.ConditionDebugRuleView.Depth ergibt die Einrueckung im UI. */
export interface IConditionDebugRuleView {
    depth: number;
    combinator?: string | undefined;
    not: boolean;
    field?: string | undefined;
    operator?: string | undefined;
    expectedValue?: string | undefined;
    actualValue?: string | undefined;
    featureFound: boolean;
    matched: boolean;
    error?: string | undefined;
}

export class ConfirmAmendedCustomerResponse implements IConfirmAmendedCustomerResponse {
    newCustomerId!: number;

    constructor(data?: IConfirmAmendedCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newCustomerId = _data["newCustomerId"];
        }
    }

    static fromJS(data: any): ConfirmAmendedCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAmendedCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newCustomerId"] = this.newCustomerId;
        return data;
    }
}

export interface IConfirmAmendedCustomerResponse {
    newCustomerId: number;
}

export class ConfirmAmendedCustomerResponseApiResult implements IConfirmAmendedCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: ConfirmAmendedCustomerResponse;

    constructor(data?: IConfirmAmendedCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ConfirmAmendedCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ConfirmAmendedCustomerResponse.fromJS(_data["data"]) : new ConfirmAmendedCustomerResponse();
        }
    }

    static fromJS(data: any): ConfirmAmendedCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAmendedCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfirmAmendedCustomerResponseApiResult {
    messages: ApiMessages;
    data: ConfirmAmendedCustomerResponse;
}

export class ConfirmStagingCustomerResponse implements IConfirmStagingCustomerResponse {
    isValid!: boolean;

    constructor(data?: IConfirmStagingCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ConfirmStagingCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmStagingCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IConfirmStagingCustomerResponse {
    isValid: boolean;
}

export class ConfirmStagingCustomerResponseApiResult implements IConfirmStagingCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: ConfirmStagingCustomerResponse;

    constructor(data?: IConfirmStagingCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ConfirmStagingCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ConfirmStagingCustomerResponse.fromJS(_data["data"]) : new ConfirmStagingCustomerResponse();
        }
    }

    static fromJS(data: any): ConfirmStagingCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmStagingCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConfirmStagingCustomerResponseApiResult {
    messages: ApiMessages;
    data: ConfirmStagingCustomerResponse;
}

export class ContractDetail implements IContractDetail {
    refreshDate!: Date;
    salesPerson?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    financingType!: string;
    financingTypeId!: string;
    duration?: string | undefined;
    mileage?: number | undefined;
    prepayment?: number | undefined;
    purchasePrice?: number | undefined;
    residualValue?: number | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    dateOfApproval?: Date | undefined;
    note?: string | undefined;
    rate?: number | undefined;
    isNet!: boolean;
    allowExtend!: boolean;
    residualValueSubsidy?: number | undefined;

    constructor(data?: IContractDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshDate = _data["refreshDate"] ? new Date(_data["refreshDate"].toString()) : <any>undefined;
            this.salesPerson = _data["salesPerson"];
            this.customerName = _data["customerName"];
            this.customerAddress = _data["customerAddress"];
            this.financingType = _data["financingType"];
            this.financingTypeId = _data["financingTypeId"];
            this.duration = _data["duration"];
            this.mileage = _data["mileage"];
            this.prepayment = _data["prepayment"];
            this.purchasePrice = _data["purchasePrice"];
            this.residualValue = _data["residualValue"];
            this.contractStartDate = _data["contractStartDate"] ? new Date(_data["contractStartDate"].toString()) : <any>undefined;
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            this.dateOfApproval = _data["dateOfApproval"] ? new Date(_data["dateOfApproval"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.rate = _data["rate"];
            this.isNet = _data["isNet"];
            this.allowExtend = _data["allowExtend"];
            this.residualValueSubsidy = _data["residualValueSubsidy"];
        }
    }

    static fromJS(data: any): ContractDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshDate"] = this.refreshDate ? this.refreshDate.toISOString() : <any>undefined;
        data["salesPerson"] = this.salesPerson;
        data["customerName"] = this.customerName;
        data["customerAddress"] = this.customerAddress;
        data["financingType"] = this.financingType;
        data["financingTypeId"] = this.financingTypeId;
        data["duration"] = this.duration;
        data["mileage"] = this.mileage;
        data["prepayment"] = this.prepayment;
        data["purchasePrice"] = this.purchasePrice;
        data["residualValue"] = this.residualValue;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : <any>undefined;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["dateOfApproval"] = this.dateOfApproval ? this.dateOfApproval.toISOString() : <any>undefined;
        data["note"] = this.note;
        data["rate"] = this.rate;
        data["isNet"] = this.isNet;
        data["allowExtend"] = this.allowExtend;
        data["residualValueSubsidy"] = this.residualValueSubsidy;
        return data;
    }
}

export interface IContractDetail {
    refreshDate: Date;
    salesPerson?: string | undefined;
    customerName?: string | undefined;
    customerAddress?: string | undefined;
    financingType: string;
    financingTypeId: string;
    duration?: string | undefined;
    mileage?: number | undefined;
    prepayment?: number | undefined;
    purchasePrice?: number | undefined;
    residualValue?: number | undefined;
    contractStartDate?: Date | undefined;
    contractEndDate?: Date | undefined;
    dateOfApproval?: Date | undefined;
    note?: string | undefined;
    rate?: number | undefined;
    isNet: boolean;
    allowExtend: boolean;
    residualValueSubsidy?: number | undefined;
}

export class ConversionOption implements IConversionOption {
    id?: number | undefined;
    title!: string;
    price!: number;
    supplierId?: number | undefined;
    unknownSupplier?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    isFileArchived?: boolean | undefined;

    constructor(data?: IConversionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.supplierId = _data["supplierId"];
            this.unknownSupplier = _data["unknownSupplier"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.isFileArchived = _data["isFileArchived"];
        }
    }

    static fromJS(data: any): ConversionOption {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["supplierId"] = this.supplierId;
        data["unknownSupplier"] = this.unknownSupplier;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["isFileArchived"] = this.isFileArchived;
        return data;
    }
}

export interface IConversionOption {
    id?: number | undefined;
    title: string;
    price: number;
    supplierId?: number | undefined;
    unknownSupplier?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    isFileArchived?: boolean | undefined;
}

export class ConversionOptionResponse implements IConversionOptionResponse {
    id!: number;
    title!: string;
    price!: number;
    supplierId?: number | undefined;
    unknownSupplier?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    isFileArchived?: boolean | undefined;

    constructor(data?: IConversionOptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.price = _data["price"];
            this.supplierId = _data["supplierId"];
            this.unknownSupplier = _data["unknownSupplier"];
            this.fileId = _data["fileId"];
            this.fileName = _data["fileName"];
            this.isFileArchived = _data["isFileArchived"];
        }
    }

    static fromJS(data: any): ConversionOptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["price"] = this.price;
        data["supplierId"] = this.supplierId;
        data["unknownSupplier"] = this.unknownSupplier;
        data["fileId"] = this.fileId;
        data["fileName"] = this.fileName;
        data["isFileArchived"] = this.isFileArchived;
        return data;
    }
}

export interface IConversionOptionResponse {
    id: number;
    title: string;
    price: number;
    supplierId?: number | undefined;
    unknownSupplier?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
    isFileArchived?: boolean | undefined;
}

export class CreateClassifiedObjectRequest implements ICreateClassifiedObjectRequest {
    objectId!: string;
    objectType!: ClassificationType;
    classificationGroupId!: string;

    constructor(data?: ICreateClassifiedObjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
            this.classificationGroupId = _data["classificationGroupId"];
        }
    }

    static fromJS(data: any): CreateClassifiedObjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClassifiedObjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        data["classificationGroupId"] = this.classificationGroupId;
        return data;
    }
}

export interface ICreateClassifiedObjectRequest {
    objectId: string;
    objectType: ClassificationType;
    classificationGroupId: string;
}

export class CreateClasssificationGroupRequest implements ICreateClasssificationGroupRequest {
    name!: string;
    parentId?: string | undefined;

    constructor(data?: ICreateClasssificationGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): CreateClasssificationGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClasssificationGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface ICreateClasssificationGroupRequest {
    name: string;
    parentId?: string | undefined;
}

export class CreateCommercialCustomerRequest extends CommercialCustomerView implements ICreateCommercialCustomerRequest {

    constructor(data?: ICreateCommercialCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreateCommercialCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommercialCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreateCommercialCustomerRequest extends ICommercialCustomerView {
}

export class CreateCommercialCustomerResponse implements ICreateCommercialCustomerResponse {
    customerId!: number;

    constructor(data?: ICreateCommercialCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CreateCommercialCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommercialCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface ICreateCommercialCustomerResponse {
    customerId: number;
}

export class CreateCommercialCustomerResponseApiResult implements ICreateCommercialCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: CreateCommercialCustomerResponse;

    constructor(data?: ICreateCommercialCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CreateCommercialCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CreateCommercialCustomerResponse.fromJS(_data["data"]) : new CreateCommercialCustomerResponse();
        }
    }

    static fromJS(data: any): CreateCommercialCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommercialCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateCommercialCustomerResponseApiResult {
    messages: ApiMessages;
    data: CreateCommercialCustomerResponse;
}

export class CreateFeatureClassificationsRequest implements ICreateFeatureClassificationsRequest {
    classificationGroupId!: string;
    featureDefinitionId!: string;
    isOverrideable!: boolean;
    defaultValue!: string;
    sortOrder!: number;

    constructor(data?: ICreateFeatureClassificationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classificationGroupId = _data["classificationGroupId"];
            this.featureDefinitionId = _data["featureDefinitionId"];
            this.isOverrideable = _data["isOverrideable"];
            this.defaultValue = _data["defaultValue"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): CreateFeatureClassificationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeatureClassificationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classificationGroupId"] = this.classificationGroupId;
        data["featureDefinitionId"] = this.featureDefinitionId;
        data["isOverrideable"] = this.isOverrideable;
        data["defaultValue"] = this.defaultValue;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ICreateFeatureClassificationsRequest {
    classificationGroupId: string;
    featureDefinitionId: string;
    isOverrideable: boolean;
    defaultValue: string;
    sortOrder: number;
}

export class CreateFeatureDefinitionRequest implements ICreateFeatureDefinitionRequest {
    name!: string;
    featureType!: FeatureType;
    format!: string;

    constructor(data?: ICreateFeatureDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.featureType = _data["featureType"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): CreateFeatureDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFeatureDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["featureType"] = this.featureType;
        data["format"] = this.format;
        return data;
    }
}

export interface ICreateFeatureDefinitionRequest {
    name: string;
    featureType: FeatureType;
    format: string;
}

export class PrivateCustomerView implements IPrivateCustomerView {
    firstName!: string;
    lastName!: string;
    salutationId?: number | undefined;
    titleId?: number | undefined;
    titleInternationalId?: number | undefined;
    birthDate?: Date | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    addressStreet?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressCountryId?: number | undefined;
    phoneNumber?: string | undefined;
    additionalPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    residencePermitValidSince?: Date | undefined;
    residencePermitValidTill?: Date | undefined;
    inAustriaSince?: Date | undefined;
    workPermitValidSince?: Date | undefined;
    workPermitValidTill?: Date | undefined;
    bankAccountIBAN?: string | undefined;
    bankAccountBIC?: string | undefined;
    bankAccountBankName?: string | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    dataInformationSheetTransferred!: boolean;
    emailMarketingAggreed?: boolean | undefined;
    phoneMarketingAggreed?: boolean | undefined;
    postalMarketingAggreed?: boolean | undefined;
    verifiableMonthlyIncome?: number | undefined;
    verifiableMonthlyAddIncome?: number | undefined;
    verifiableMonthlyAddIncomeType?: string | undefined;
    jobTitleId?: number | undefined;
    employedSince?: Date | undefined;
    currentEmployerName?: string | undefined;
    currentEmployerAddress?: string | undefined;
    residenceTypeId?: number | undefined;
    monthlyRentInclAddCharges?: number | undefined;
    monthlyLoanRepayment?: number | undefined;
    currentBankLoansAndOverdrafts?: number | undefined;
    maintenanceObligations?: number | undefined;
    currentHousehold?: number | undefined;
    assetSize?: string | undefined;
    assetCity?: string | undefined;
    assetTypeId?: number | undefined;
    otherAssets?: number | undefined;
    otherAssetTypeId?: number | undefined;
    ksvId?: string | undefined;
    ksvSearchDone?: boolean | undefined;
    identityCheckId?: string | undefined;
    isPotentialBuyer!: boolean;
    isApplicantSpouse?: boolean | undefined;
    isCoApplicant!: boolean;
    selfDisclosureAgreed!: boolean;
    selfDisclosureAgreedAt?: Date | undefined;

    constructor(data?: IPrivateCustomerView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.salutationId = _data["salutationId"];
            this.titleId = _data["titleId"];
            this.titleInternationalId = _data["titleInternationalId"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.maritalStatusId = _data["maritalStatusId"];
            this.citizenshipId = _data["citizenshipId"];
            this.addressStreet = _data["addressStreet"];
            this.addressHouseNumber = _data["addressHouseNumber"];
            this.addressPostalCode = _data["addressPostalCode"];
            this.addressCity = _data["addressCity"];
            this.addressCountryId = _data["addressCountryId"];
            this.phoneNumber = _data["phoneNumber"];
            this.additionalPhoneNumber = _data["additionalPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.numberOfSupportedChildren = _data["numberOfSupportedChildren"];
            this.numberOfChildrenUnderEighteen = _data["numberOfChildrenUnderEighteen"];
            this.residencePermitValidSince = _data["residencePermitValidSince"] ? new Date(_data["residencePermitValidSince"].toString()) : <any>undefined;
            this.residencePermitValidTill = _data["residencePermitValidTill"] ? new Date(_data["residencePermitValidTill"].toString()) : <any>undefined;
            this.inAustriaSince = _data["inAustriaSince"] ? new Date(_data["inAustriaSince"].toString()) : <any>undefined;
            this.workPermitValidSince = _data["workPermitValidSince"] ? new Date(_data["workPermitValidSince"].toString()) : <any>undefined;
            this.workPermitValidTill = _data["workPermitValidTill"] ? new Date(_data["workPermitValidTill"].toString()) : <any>undefined;
            this.bankAccountIBAN = _data["bankAccountIBAN"];
            this.bankAccountBIC = _data["bankAccountBIC"];
            this.bankAccountBankName = _data["bankAccountBankName"];
            this.pepSpecificationId = _data["pepSpecificationId"];
            this.politicalExposedPersonRelated = _data["politicalExposedPersonRelated"];
            this.dataInformationSheetTransferred = _data["dataInformationSheetTransferred"];
            this.emailMarketingAggreed = _data["emailMarketingAggreed"];
            this.phoneMarketingAggreed = _data["phoneMarketingAggreed"];
            this.postalMarketingAggreed = _data["postalMarketingAggreed"];
            this.verifiableMonthlyIncome = _data["verifiableMonthlyIncome"];
            this.verifiableMonthlyAddIncome = _data["verifiableMonthlyAddIncome"];
            this.verifiableMonthlyAddIncomeType = _data["verifiableMonthlyAddIncomeType"];
            this.jobTitleId = _data["jobTitleId"];
            this.employedSince = _data["employedSince"] ? new Date(_data["employedSince"].toString()) : <any>undefined;
            this.currentEmployerName = _data["currentEmployerName"];
            this.currentEmployerAddress = _data["currentEmployerAddress"];
            this.residenceTypeId = _data["residenceTypeId"];
            this.monthlyRentInclAddCharges = _data["monthlyRentInclAddCharges"];
            this.monthlyLoanRepayment = _data["monthlyLoanRepayment"];
            this.currentBankLoansAndOverdrafts = _data["currentBankLoansAndOverdrafts"];
            this.maintenanceObligations = _data["maintenanceObligations"];
            this.currentHousehold = _data["currentHousehold"];
            this.assetSize = _data["assetSize"];
            this.assetCity = _data["assetCity"];
            this.assetTypeId = _data["assetTypeId"];
            this.otherAssets = _data["otherAssets"];
            this.otherAssetTypeId = _data["otherAssetTypeId"];
            this.ksvId = _data["ksvId"];
            this.ksvSearchDone = _data["ksvSearchDone"];
            this.identityCheckId = _data["identityCheckId"];
            this.isPotentialBuyer = _data["isPotentialBuyer"];
            this.isApplicantSpouse = _data["isApplicantSpouse"];
            this.isCoApplicant = _data["isCoApplicant"];
            this.selfDisclosureAgreed = _data["selfDisclosureAgreed"];
            this.selfDisclosureAgreedAt = _data["selfDisclosureAgreedAt"] ? new Date(_data["selfDisclosureAgreedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrivateCustomerView {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateCustomerView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["salutationId"] = this.salutationId;
        data["titleId"] = this.titleId;
        data["titleInternationalId"] = this.titleInternationalId;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["maritalStatusId"] = this.maritalStatusId;
        data["citizenshipId"] = this.citizenshipId;
        data["addressStreet"] = this.addressStreet;
        data["addressHouseNumber"] = this.addressHouseNumber;
        data["addressPostalCode"] = this.addressPostalCode;
        data["addressCity"] = this.addressCity;
        data["addressCountryId"] = this.addressCountryId;
        data["phoneNumber"] = this.phoneNumber;
        data["additionalPhoneNumber"] = this.additionalPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["numberOfSupportedChildren"] = this.numberOfSupportedChildren;
        data["numberOfChildrenUnderEighteen"] = this.numberOfChildrenUnderEighteen;
        data["residencePermitValidSince"] = this.residencePermitValidSince ? this.residencePermitValidSince.toISOString() : <any>undefined;
        data["residencePermitValidTill"] = this.residencePermitValidTill ? this.residencePermitValidTill.toISOString() : <any>undefined;
        data["inAustriaSince"] = this.inAustriaSince ? this.inAustriaSince.toISOString() : <any>undefined;
        data["workPermitValidSince"] = this.workPermitValidSince ? this.workPermitValidSince.toISOString() : <any>undefined;
        data["workPermitValidTill"] = this.workPermitValidTill ? this.workPermitValidTill.toISOString() : <any>undefined;
        data["bankAccountIBAN"] = this.bankAccountIBAN;
        data["bankAccountBIC"] = this.bankAccountBIC;
        data["bankAccountBankName"] = this.bankAccountBankName;
        data["pepSpecificationId"] = this.pepSpecificationId;
        data["politicalExposedPersonRelated"] = this.politicalExposedPersonRelated;
        data["dataInformationSheetTransferred"] = this.dataInformationSheetTransferred;
        data["emailMarketingAggreed"] = this.emailMarketingAggreed;
        data["phoneMarketingAggreed"] = this.phoneMarketingAggreed;
        data["postalMarketingAggreed"] = this.postalMarketingAggreed;
        data["verifiableMonthlyIncome"] = this.verifiableMonthlyIncome;
        data["verifiableMonthlyAddIncome"] = this.verifiableMonthlyAddIncome;
        data["verifiableMonthlyAddIncomeType"] = this.verifiableMonthlyAddIncomeType;
        data["jobTitleId"] = this.jobTitleId;
        data["employedSince"] = this.employedSince ? this.employedSince.toISOString() : <any>undefined;
        data["currentEmployerName"] = this.currentEmployerName;
        data["currentEmployerAddress"] = this.currentEmployerAddress;
        data["residenceTypeId"] = this.residenceTypeId;
        data["monthlyRentInclAddCharges"] = this.monthlyRentInclAddCharges;
        data["monthlyLoanRepayment"] = this.monthlyLoanRepayment;
        data["currentBankLoansAndOverdrafts"] = this.currentBankLoansAndOverdrafts;
        data["maintenanceObligations"] = this.maintenanceObligations;
        data["currentHousehold"] = this.currentHousehold;
        data["assetSize"] = this.assetSize;
        data["assetCity"] = this.assetCity;
        data["assetTypeId"] = this.assetTypeId;
        data["otherAssets"] = this.otherAssets;
        data["otherAssetTypeId"] = this.otherAssetTypeId;
        data["ksvId"] = this.ksvId;
        data["ksvSearchDone"] = this.ksvSearchDone;
        data["identityCheckId"] = this.identityCheckId;
        data["isPotentialBuyer"] = this.isPotentialBuyer;
        data["isApplicantSpouse"] = this.isApplicantSpouse;
        data["isCoApplicant"] = this.isCoApplicant;
        data["selfDisclosureAgreed"] = this.selfDisclosureAgreed;
        data["selfDisclosureAgreedAt"] = this.selfDisclosureAgreedAt ? this.selfDisclosureAgreedAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPrivateCustomerView {
    firstName: string;
    lastName: string;
    salutationId?: number | undefined;
    titleId?: number | undefined;
    titleInternationalId?: number | undefined;
    birthDate?: Date | undefined;
    maritalStatusId?: number | undefined;
    citizenshipId?: number | undefined;
    addressStreet?: string | undefined;
    addressHouseNumber?: string | undefined;
    addressPostalCode?: string | undefined;
    addressCity?: string | undefined;
    addressCountryId?: number | undefined;
    phoneNumber?: string | undefined;
    additionalPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    residencePermitValidSince?: Date | undefined;
    residencePermitValidTill?: Date | undefined;
    inAustriaSince?: Date | undefined;
    workPermitValidSince?: Date | undefined;
    workPermitValidTill?: Date | undefined;
    bankAccountIBAN?: string | undefined;
    bankAccountBIC?: string | undefined;
    bankAccountBankName?: string | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    dataInformationSheetTransferred: boolean;
    emailMarketingAggreed?: boolean | undefined;
    phoneMarketingAggreed?: boolean | undefined;
    postalMarketingAggreed?: boolean | undefined;
    verifiableMonthlyIncome?: number | undefined;
    verifiableMonthlyAddIncome?: number | undefined;
    verifiableMonthlyAddIncomeType?: string | undefined;
    jobTitleId?: number | undefined;
    employedSince?: Date | undefined;
    currentEmployerName?: string | undefined;
    currentEmployerAddress?: string | undefined;
    residenceTypeId?: number | undefined;
    monthlyRentInclAddCharges?: number | undefined;
    monthlyLoanRepayment?: number | undefined;
    currentBankLoansAndOverdrafts?: number | undefined;
    maintenanceObligations?: number | undefined;
    currentHousehold?: number | undefined;
    assetSize?: string | undefined;
    assetCity?: string | undefined;
    assetTypeId?: number | undefined;
    otherAssets?: number | undefined;
    otherAssetTypeId?: number | undefined;
    ksvId?: string | undefined;
    ksvSearchDone?: boolean | undefined;
    identityCheckId?: string | undefined;
    isPotentialBuyer: boolean;
    isApplicantSpouse?: boolean | undefined;
    isCoApplicant: boolean;
    selfDisclosureAgreed: boolean;
    selfDisclosureAgreedAt?: Date | undefined;
}

export class CreatePrivateCustomerRequest extends PrivateCustomerView implements ICreatePrivateCustomerRequest {

    constructor(data?: ICreatePrivateCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CreatePrivateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrivateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICreatePrivateCustomerRequest extends IPrivateCustomerView {
}

export class CreatePrivateCustomerResponse implements ICreatePrivateCustomerResponse {
    customerId!: number;

    constructor(data?: ICreatePrivateCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CreatePrivateCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrivateCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface ICreatePrivateCustomerResponse {
    customerId: number;
}

export class CreatePrivateCustomerResponseApiResult implements ICreatePrivateCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: CreatePrivateCustomerResponse;

    constructor(data?: ICreatePrivateCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CreatePrivateCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CreatePrivateCustomerResponse.fromJS(_data["data"]) : new CreatePrivateCustomerResponse();
        }
    }

    static fromJS(data: any): CreatePrivateCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePrivateCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreatePrivateCustomerResponseApiResult {
    messages: ApiMessages;
    data: CreatePrivateCustomerResponse;
}

export class CreateSpecialCasePriceRequest implements ICreateSpecialCasePriceRequest {
    cacheGuid?: string | undefined;
    dealId!: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId!: number;
    duration!: number;
    isServiceVariantsResetRequest!: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId!: number;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest!: boolean;
    preCheckServiceProductSelectionsFromApicon!: boolean;
    isPriceFormSpecialCaseMandatory!: boolean;
    isServiceVariantSaveRequest!: boolean;
    isBundle!: boolean;

    constructor(data?: ICreateSpecialCasePriceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheGuid = _data["cacheGuid"];
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.serviceProductId = _data["serviceProductId"];
            this.mileageId = _data["mileageId"];
            this.duration = _data["duration"];
            this.isServiceVariantsResetRequest = _data["isServiceVariantsResetRequest"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.configurationID = _data["configurationID"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.campaignId = _data["campaignId"];
            this.priceNet = _data["priceNet"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.fundingProductId = _data["fundingProductId"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.specialCaseRequestBundle = _data["specialCaseRequestBundle"] ? ApiconSpecialCaseRequestBundle.fromJS(_data["specialCaseRequestBundle"]) : <any>undefined;
            this.preCheckServiceProductSelectionsFromRequest = _data["preCheckServiceProductSelectionsFromRequest"];
            this.preCheckServiceProductSelectionsFromApicon = _data["preCheckServiceProductSelectionsFromApicon"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): CreateSpecialCasePriceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialCasePriceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheGuid"] = this.cacheGuid;
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["serviceProductId"] = this.serviceProductId;
        data["mileageId"] = this.mileageId;
        data["duration"] = this.duration;
        data["isServiceVariantsResetRequest"] = this.isServiceVariantsResetRequest;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["configurationID"] = this.configurationID;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["campaignId"] = this.campaignId;
        data["priceNet"] = this.priceNet;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["fundingProductId"] = this.fundingProductId;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["specialCaseRequestBundle"] = this.specialCaseRequestBundle ? this.specialCaseRequestBundle.toJSON() : <any>undefined;
        data["preCheckServiceProductSelectionsFromRequest"] = this.preCheckServiceProductSelectionsFromRequest;
        data["preCheckServiceProductSelectionsFromApicon"] = this.preCheckServiceProductSelectionsFromApicon;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface ICreateSpecialCasePriceRequest {
    cacheGuid?: string | undefined;
    dealId: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId: number;
    duration: number;
    isServiceVariantsResetRequest: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId: number;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest: boolean;
    preCheckServiceProductSelectionsFromApicon: boolean;
    isPriceFormSpecialCaseMandatory: boolean;
    isServiceVariantSaveRequest: boolean;
    isBundle: boolean;
}

export class CredibilityCheck implements ICredibilityCheck {
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;

    constructor(data?: ICredibilityCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ksvRating = _data["ksvRating"];
            this.roracUrl = _data["roracUrl"];
        }
    }

    static fromJS(data: any): CredibilityCheck {
        data = typeof data === 'object' ? data : {};
        let result = new CredibilityCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ksvRating"] = this.ksvRating;
        data["roracUrl"] = this.roracUrl;
        return data;
    }
}

export interface ICredibilityCheck {
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;
}

export class CustomerOverview implements ICustomerOverview {
    id!: number;
    name!: string;
    name2!: string;
    address!: string;
    customerType!: DealType;
    isValidCustomer!: boolean;

    constructor(data?: ICustomerOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.name2 = _data["name2"];
            this.address = _data["address"];
            this.customerType = _data["customerType"];
            this.isValidCustomer = _data["isValidCustomer"];
        }
    }

    static fromJS(data: any): CustomerOverview {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["name2"] = this.name2;
        data["address"] = this.address;
        data["customerType"] = this.customerType;
        data["isValidCustomer"] = this.isValidCustomer;
        return data;
    }
}

export interface ICustomerOverview {
    id: number;
    name: string;
    name2: string;
    address: string;
    customerType: DealType;
    isValidCustomer: boolean;
}

export class CustomerOverviewIPagedList implements ICustomerOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: CustomerOverview[];

    constructor(data?: ICustomerOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(CustomerOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: CustomerOverview[];
}

export class CustomerOverviewIPagedListApiResult implements ICustomerOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: CustomerOverviewIPagedList;

    constructor(data?: ICustomerOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new CustomerOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? CustomerOverviewIPagedList.fromJS(_data["data"]) : new CustomerOverviewIPagedList();
        }
    }

    static fromJS(data: any): CustomerOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: CustomerOverviewIPagedList;
}

export class CustomerSnapshotData implements ICustomerSnapshotData {
    id!: number;
    customerTypeId!: number;
    businessPartnerId?: string | undefined;
    ksvId?: string | undefined;
    ksvSearchDone!: boolean;
    identityCheckId?: string | undefined;
    selfDisclosureAgreed!: boolean;
    selfDisclosureAgreedAt?: Date | undefined;
    dataInformationSheetTransferred!: boolean;
    iban?: string | undefined;
    bic?: string | undefined;
    address?: AddressSnapshotData | undefined;
    privateDetails?: PrivateCustomerSnapshotData | undefined;
    commercialDetails?: CommercialCustomerSnapshotData | undefined;

    constructor(data?: ICustomerSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerTypeId = _data["customerTypeId"];
            this.businessPartnerId = _data["businessPartnerId"];
            this.ksvId = _data["ksvId"];
            this.ksvSearchDone = _data["ksvSearchDone"];
            this.identityCheckId = _data["identityCheckId"];
            this.selfDisclosureAgreed = _data["selfDisclosureAgreed"];
            this.selfDisclosureAgreedAt = _data["selfDisclosureAgreedAt"] ? new Date(_data["selfDisclosureAgreedAt"].toString()) : <any>undefined;
            this.dataInformationSheetTransferred = _data["dataInformationSheetTransferred"];
            this.iban = _data["iban"];
            this.bic = _data["bic"];
            this.address = _data["address"] ? AddressSnapshotData.fromJS(_data["address"]) : <any>undefined;
            this.privateDetails = _data["privateDetails"] ? PrivateCustomerSnapshotData.fromJS(_data["privateDetails"]) : <any>undefined;
            this.commercialDetails = _data["commercialDetails"] ? CommercialCustomerSnapshotData.fromJS(_data["commercialDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerTypeId"] = this.customerTypeId;
        data["businessPartnerId"] = this.businessPartnerId;
        data["ksvId"] = this.ksvId;
        data["ksvSearchDone"] = this.ksvSearchDone;
        data["identityCheckId"] = this.identityCheckId;
        data["selfDisclosureAgreed"] = this.selfDisclosureAgreed;
        data["selfDisclosureAgreedAt"] = this.selfDisclosureAgreedAt ? this.selfDisclosureAgreedAt.toISOString() : <any>undefined;
        data["dataInformationSheetTransferred"] = this.dataInformationSheetTransferred;
        data["iban"] = this.iban;
        data["bic"] = this.bic;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["privateDetails"] = this.privateDetails ? this.privateDetails.toJSON() : <any>undefined;
        data["commercialDetails"] = this.commercialDetails ? this.commercialDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICustomerSnapshotData {
    id: number;
    customerTypeId: number;
    businessPartnerId?: string | undefined;
    ksvId?: string | undefined;
    ksvSearchDone: boolean;
    identityCheckId?: string | undefined;
    selfDisclosureAgreed: boolean;
    selfDisclosureAgreedAt?: Date | undefined;
    dataInformationSheetTransferred: boolean;
    iban?: string | undefined;
    bic?: string | undefined;
    address?: AddressSnapshotData | undefined;
    privateDetails?: PrivateCustomerSnapshotData | undefined;
    commercialDetails?: CommercialCustomerSnapshotData | undefined;
}

export enum CustomerType {
    Undefined = "Undefined",
    Private = "Private",
    Commercial = "Commercial",
}

export class CustomerTypeApiResult implements ICustomerTypeApiResult {
    messages!: ApiMessages;
    data!: CustomerType;

    constructor(data?: ICustomerTypeApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): CustomerTypeApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTypeApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface ICustomerTypeApiResult {
    messages: ApiMessages;
    data: CustomerType;
}

export class DashboardConfiguration implements IDashboardConfiguration {
    rate!: number;
    displayAsGross!: boolean;
    purchaseApplicationId?: string | undefined;
    purchaseBy?: PurchaseBy | undefined;

    constructor(data?: IDashboardConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["rate"];
            this.displayAsGross = _data["displayAsGross"];
            this.purchaseApplicationId = _data["purchaseApplicationId"];
            this.purchaseBy = _data["purchaseBy"];
        }
    }

    static fromJS(data: any): DashboardConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate;
        data["displayAsGross"] = this.displayAsGross;
        data["purchaseApplicationId"] = this.purchaseApplicationId;
        data["purchaseBy"] = this.purchaseBy;
        return data;
    }
}

export interface IDashboardConfiguration {
    rate: number;
    displayAsGross: boolean;
    purchaseApplicationId?: string | undefined;
    purchaseBy?: PurchaseBy | undefined;
}

export class DealCalculation implements IDealCalculation {
    id!: number;
    financingTypeId!: number;
    duration!: number;
    mileageId!: number;
    businessRelationshipId!: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig!: ObjectConfigurationRequest;
    calculationServiceRequest!: CalculationServiceRequest;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    salesAid?: SalesAidView | undefined;
    purchaseContractDate?: Date | undefined;
    agentOptions!: AgentOption[];
    conversionOptions!: ConversionOption[];
    calculationFeatureValues!: FeatureValueWrapper[];
    dealFeatureValues!: FeatureValueWrapper[];
    isDirectInkasso!: boolean;
    hasGhgPremium?: boolean | undefined;
    isBundle!: boolean;

    constructor(data?: IDealCalculation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.objectConfig = new ObjectConfigurationRequest();
            this.calculationServiceRequest = new CalculationServiceRequest();
            this.agentOptions = [];
            this.conversionOptions = [];
            this.calculationFeatureValues = [];
            this.dealFeatureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.financingTypeId = _data["financingTypeId"];
            this.duration = _data["duration"];
            this.mileageId = _data["mileageId"];
            this.businessRelationshipId = _data["businessRelationshipId"];
            this.interestRateCalculationMethodId = _data["interestRateCalculationMethodId"];
            this.rateCategoryId = _data["rateCategoryId"];
            this.downpayment = _data["downpayment"];
            this.downPaymentPercent = _data["downPaymentPercent"];
            this.deposit = _data["deposit"];
            this.depositPercent = _data["depositPercent"];
            this.residualValueContractId = _data["residualValueContractId"];
            this.sourceOfFoundsId = _data["sourceOfFoundsId"];
            this.accountOwner = _data["accountOwner"];
            this.residualValueVehicleAbsolute = _data["residualValueVehicleAbsolute"];
            this.residualValueConversionOptions = _data["residualValueConversionOptions"];
            this.residualValuePercentage = _data["residualValuePercentage"];
            this.referencesDealId = _data["referencesDealId"];
            this.referencesCalculationId = _data["referencesCalculationId"];
            this.objectConfig = _data["objectConfig"] ? ObjectConfigurationRequest.fromJS(_data["objectConfig"]) : new ObjectConfigurationRequest();
            this.calculationServiceRequest = _data["calculationServiceRequest"] ? CalculationServiceRequest.fromJS(_data["calculationServiceRequest"]) : new CalculationServiceRequest();
            this.specialOfferId = _data["specialOfferId"];
            this.selectedFuelServiceProductId = _data["selectedFuelServiceProductId"];
            this.ksvRating = _data["ksvRating"];
            this.salesAid = _data["salesAid"] ? SalesAidView.fromJS(_data["salesAid"]) : <any>undefined;
            this.purchaseContractDate = _data["purchaseContractDate"] ? new Date(_data["purchaseContractDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["agentOptions"])) {
                this.agentOptions = [] as any;
                for (let item of _data["agentOptions"])
                    this.agentOptions!.push(AgentOption.fromJS(item));
            }
            if (Array.isArray(_data["conversionOptions"])) {
                this.conversionOptions = [] as any;
                for (let item of _data["conversionOptions"])
                    this.conversionOptions!.push(ConversionOption.fromJS(item));
            }
            if (Array.isArray(_data["calculationFeatureValues"])) {
                this.calculationFeatureValues = [] as any;
                for (let item of _data["calculationFeatureValues"])
                    this.calculationFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            this.isDirectInkasso = _data["isDirectInkasso"];
            this.hasGhgPremium = _data["hasGhgPremium"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): DealCalculation {
        data = typeof data === 'object' ? data : {};
        let result = new DealCalculation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["financingTypeId"] = this.financingTypeId;
        data["duration"] = this.duration;
        data["mileageId"] = this.mileageId;
        data["businessRelationshipId"] = this.businessRelationshipId;
        data["interestRateCalculationMethodId"] = this.interestRateCalculationMethodId;
        data["rateCategoryId"] = this.rateCategoryId;
        data["downpayment"] = this.downpayment;
        data["downPaymentPercent"] = this.downPaymentPercent;
        data["deposit"] = this.deposit;
        data["depositPercent"] = this.depositPercent;
        data["residualValueContractId"] = this.residualValueContractId;
        data["sourceOfFoundsId"] = this.sourceOfFoundsId;
        data["accountOwner"] = this.accountOwner;
        data["residualValueVehicleAbsolute"] = this.residualValueVehicleAbsolute;
        data["residualValueConversionOptions"] = this.residualValueConversionOptions;
        data["residualValuePercentage"] = this.residualValuePercentage;
        data["referencesDealId"] = this.referencesDealId;
        data["referencesCalculationId"] = this.referencesCalculationId;
        data["objectConfig"] = this.objectConfig ? this.objectConfig.toJSON() : <any>undefined;
        data["calculationServiceRequest"] = this.calculationServiceRequest ? this.calculationServiceRequest.toJSON() : <any>undefined;
        data["specialOfferId"] = this.specialOfferId;
        data["selectedFuelServiceProductId"] = this.selectedFuelServiceProductId;
        data["ksvRating"] = this.ksvRating;
        data["salesAid"] = this.salesAid ? this.salesAid.toJSON() : <any>undefined;
        data["purchaseContractDate"] = this.purchaseContractDate ? this.purchaseContractDate.toISOString() : <any>undefined;
        if (Array.isArray(this.agentOptions)) {
            data["agentOptions"] = [];
            for (let item of this.agentOptions)
                data["agentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.conversionOptions)) {
            data["conversionOptions"] = [];
            for (let item of this.conversionOptions)
                data["conversionOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.calculationFeatureValues)) {
            data["calculationFeatureValues"] = [];
            for (let item of this.calculationFeatureValues)
                data["calculationFeatureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        data["isDirectInkasso"] = this.isDirectInkasso;
        data["hasGhgPremium"] = this.hasGhgPremium;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface IDealCalculation {
    id: number;
    financingTypeId: number;
    duration: number;
    mileageId: number;
    businessRelationshipId: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig: ObjectConfigurationRequest;
    calculationServiceRequest: CalculationServiceRequest;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    salesAid?: SalesAidView | undefined;
    purchaseContractDate?: Date | undefined;
    agentOptions: AgentOption[];
    conversionOptions: ConversionOption[];
    calculationFeatureValues: FeatureValueWrapper[];
    dealFeatureValues: FeatureValueWrapper[];
    isDirectInkasso: boolean;
    hasGhgPremium?: boolean | undefined;
    isBundle: boolean;
}

export class DealCalculationOverview implements IDealCalculationOverview {
    fundingProductId!: number;
    calculationNumber!: string;
    isPrimaryCalculation!: boolean;
    calculationTypeCode!: string;
    financingTypeName!: string;
    sendToContractManagementSystemDate?: Date | undefined;
    financingCalculationNumber!: string;
    duration!: number;
    regularInstalment!: number;
    downpaymentAbsoltue!: number;
    residualValue?: number | undefined;
    residualValueContractId?: number | undefined;
    residualValueContractName?: string | undefined;
    rateCategoryId?: number | undefined;
    rateCategoryName?: string | undefined;
    mileage?: number | undefined;
    deposit!: number;
    isLeasing!: boolean;
    isCredit!: boolean;
    serviceInstalment!: number;
    insuranceTotalPrice!: number;
    purchasePrice!: number;
    isFinancingCalculationReadonly!: boolean;
    isCreditCheckAvailable!: boolean;
    incomplete!: boolean;
    isFuelFinancingType!: boolean;
    isSalesAidLocked!: boolean;
    extendedAt?: Date | undefined;
    submissionStage?: number | undefined;
    readonly salesAidLimitViolationVotingDate?: Date | undefined;
    isVariablePayment!: boolean;
    isSubmittedAndApproved!: boolean;

    constructor(data?: IDealCalculationOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingProductId = _data["fundingProductId"];
            this.calculationNumber = _data["calculationNumber"];
            this.isPrimaryCalculation = _data["isPrimaryCalculation"];
            this.calculationTypeCode = _data["calculationTypeCode"];
            this.financingTypeName = _data["financingTypeName"];
            this.sendToContractManagementSystemDate = _data["sendToContractManagementSystemDate"] ? new Date(_data["sendToContractManagementSystemDate"].toString()) : <any>undefined;
            this.financingCalculationNumber = _data["financingCalculationNumber"];
            this.duration = _data["duration"];
            this.regularInstalment = _data["regularInstalment"];
            this.downpaymentAbsoltue = _data["downpaymentAbsoltue"];
            this.residualValue = _data["residualValue"];
            this.residualValueContractId = _data["residualValueContractId"];
            this.residualValueContractName = _data["residualValueContractName"];
            this.rateCategoryId = _data["rateCategoryId"];
            this.rateCategoryName = _data["rateCategoryName"];
            this.mileage = _data["mileage"];
            this.deposit = _data["deposit"];
            this.isLeasing = _data["isLeasing"];
            this.isCredit = _data["isCredit"];
            this.serviceInstalment = _data["serviceInstalment"];
            this.insuranceTotalPrice = _data["insuranceTotalPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.isFinancingCalculationReadonly = _data["isFinancingCalculationReadonly"];
            this.isCreditCheckAvailable = _data["isCreditCheckAvailable"];
            this.incomplete = _data["incomplete"];
            this.isFuelFinancingType = _data["isFuelFinancingType"];
            this.isSalesAidLocked = _data["isSalesAidLocked"];
            this.extendedAt = _data["extendedAt"] ? new Date(_data["extendedAt"].toString()) : <any>undefined;
            this.submissionStage = _data["submissionStage"];
            (<any>this).salesAidLimitViolationVotingDate = _data["salesAidLimitViolationVotingDate"] ? new Date(_data["salesAidLimitViolationVotingDate"].toString()) : <any>undefined;
            this.isVariablePayment = _data["isVariablePayment"];
            this.isSubmittedAndApproved = _data["isSubmittedAndApproved"];
        }
    }

    static fromJS(data: any): DealCalculationOverview {
        data = typeof data === 'object' ? data : {};
        let result = new DealCalculationOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingProductId"] = this.fundingProductId;
        data["calculationNumber"] = this.calculationNumber;
        data["isPrimaryCalculation"] = this.isPrimaryCalculation;
        data["calculationTypeCode"] = this.calculationTypeCode;
        data["financingTypeName"] = this.financingTypeName;
        data["sendToContractManagementSystemDate"] = this.sendToContractManagementSystemDate ? this.sendToContractManagementSystemDate.toISOString() : <any>undefined;
        data["financingCalculationNumber"] = this.financingCalculationNumber;
        data["duration"] = this.duration;
        data["regularInstalment"] = this.regularInstalment;
        data["downpaymentAbsoltue"] = this.downpaymentAbsoltue;
        data["residualValue"] = this.residualValue;
        data["residualValueContractId"] = this.residualValueContractId;
        data["residualValueContractName"] = this.residualValueContractName;
        data["rateCategoryId"] = this.rateCategoryId;
        data["rateCategoryName"] = this.rateCategoryName;
        data["mileage"] = this.mileage;
        data["deposit"] = this.deposit;
        data["isLeasing"] = this.isLeasing;
        data["isCredit"] = this.isCredit;
        data["serviceInstalment"] = this.serviceInstalment;
        data["insuranceTotalPrice"] = this.insuranceTotalPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["isFinancingCalculationReadonly"] = this.isFinancingCalculationReadonly;
        data["isCreditCheckAvailable"] = this.isCreditCheckAvailable;
        data["incomplete"] = this.incomplete;
        data["isFuelFinancingType"] = this.isFuelFinancingType;
        data["isSalesAidLocked"] = this.isSalesAidLocked;
        data["extendedAt"] = this.extendedAt ? this.extendedAt.toISOString() : <any>undefined;
        data["submissionStage"] = this.submissionStage;
        data["salesAidLimitViolationVotingDate"] = this.salesAidLimitViolationVotingDate ? this.salesAidLimitViolationVotingDate.toISOString() : <any>undefined;
        data["isVariablePayment"] = this.isVariablePayment;
        data["isSubmittedAndApproved"] = this.isSubmittedAndApproved;
        return data;
    }
}

export interface IDealCalculationOverview {
    fundingProductId: number;
    calculationNumber: string;
    isPrimaryCalculation: boolean;
    calculationTypeCode: string;
    financingTypeName: string;
    sendToContractManagementSystemDate?: Date | undefined;
    financingCalculationNumber: string;
    duration: number;
    regularInstalment: number;
    downpaymentAbsoltue: number;
    residualValue?: number | undefined;
    residualValueContractId?: number | undefined;
    residualValueContractName?: string | undefined;
    rateCategoryId?: number | undefined;
    rateCategoryName?: string | undefined;
    mileage?: number | undefined;
    deposit: number;
    isLeasing: boolean;
    isCredit: boolean;
    serviceInstalment: number;
    insuranceTotalPrice: number;
    purchasePrice: number;
    isFinancingCalculationReadonly: boolean;
    isCreditCheckAvailable: boolean;
    incomplete: boolean;
    isFuelFinancingType: boolean;
    isSalesAidLocked: boolean;
    extendedAt?: Date | undefined;
    submissionStage?: number | undefined;
    salesAidLimitViolationVotingDate?: Date | undefined;
    isVariablePayment: boolean;
    isSubmittedAndApproved: boolean;
}

export class DealCalculationOverviewIReadOnlyCollectionApiResult implements IDealCalculationOverviewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: DealCalculationOverview[];

    constructor(data?: IDealCalculationOverviewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(DealCalculationOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealCalculationOverviewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DealCalculationOverviewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealCalculationOverviewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: DealCalculationOverview[];
}

export class DealCustomer implements IDealCustomer {
    customerId?: number | undefined;
    privateCustomer?: PrivateCustomerView | undefined;
    commercialCustomer?: CommercialCustomerView | undefined;
    applyChangesToMainCustomer!: boolean;

    constructor(data?: IDealCustomer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.privateCustomer = _data["privateCustomer"] ? PrivateCustomerView.fromJS(_data["privateCustomer"]) : <any>undefined;
            this.commercialCustomer = _data["commercialCustomer"] ? CommercialCustomerView.fromJS(_data["commercialCustomer"]) : <any>undefined;
            this.applyChangesToMainCustomer = _data["applyChangesToMainCustomer"];
        }
    }

    static fromJS(data: any): DealCustomer {
        data = typeof data === 'object' ? data : {};
        let result = new DealCustomer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["privateCustomer"] = this.privateCustomer ? this.privateCustomer.toJSON() : <any>undefined;
        data["commercialCustomer"] = this.commercialCustomer ? this.commercialCustomer.toJSON() : <any>undefined;
        data["applyChangesToMainCustomer"] = this.applyChangesToMainCustomer;
        return data;
    }
}

export interface IDealCustomer {
    customerId?: number | undefined;
    privateCustomer?: PrivateCustomerView | undefined;
    commercialCustomer?: CommercialCustomerView | undefined;
    applyChangesToMainCustomer: boolean;
}

export class DealInsuranceOverview implements IDealInsuranceOverview {
    id!: string;
    insuranceCalculationNumber!: string;
    sendToContractManagementSystemDate?: Date | undefined;
    liabilityPrice?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPrice?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    engineTax?: number | undefined;
    totalPrice!: number;
    kw?: number | undefined;
    kaskoInsuranceVariableFranchise?: number | undefined;
    isUnlocked!: boolean;
    isPrimary!: boolean;

    constructor(data?: IDealInsuranceOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insuranceCalculationNumber = _data["insuranceCalculationNumber"];
            this.sendToContractManagementSystemDate = _data["sendToContractManagementSystemDate"] ? new Date(_data["sendToContractManagementSystemDate"].toString()) : <any>undefined;
            this.liabilityPrice = _data["liabilityPrice"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.kaskoPrice = _data["kaskoPrice"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
            this.engineTax = _data["engineTax"];
            this.totalPrice = _data["totalPrice"];
            this.kw = _data["kw"];
            this.kaskoInsuranceVariableFranchise = _data["kaskoInsuranceVariableFranchise"];
            this.isUnlocked = _data["isUnlocked"];
            this.isPrimary = _data["isPrimary"];
        }
    }

    static fromJS(data: any): DealInsuranceOverview {
        data = typeof data === 'object' ? data : {};
        let result = new DealInsuranceOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insuranceCalculationNumber"] = this.insuranceCalculationNumber;
        data["sendToContractManagementSystemDate"] = this.sendToContractManagementSystemDate ? this.sendToContractManagementSystemDate.toISOString() : <any>undefined;
        data["liabilityPrice"] = this.liabilityPrice;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["kaskoPrice"] = this.kaskoPrice;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        data["engineTax"] = this.engineTax;
        data["totalPrice"] = this.totalPrice;
        data["kw"] = this.kw;
        data["kaskoInsuranceVariableFranchise"] = this.kaskoInsuranceVariableFranchise;
        data["isUnlocked"] = this.isUnlocked;
        data["isPrimary"] = this.isPrimary;
        return data;
    }
}

export interface IDealInsuranceOverview {
    id: string;
    insuranceCalculationNumber: string;
    sendToContractManagementSystemDate?: Date | undefined;
    liabilityPrice?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPrice?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    engineTax?: number | undefined;
    totalPrice: number;
    kw?: number | undefined;
    kaskoInsuranceVariableFranchise?: number | undefined;
    isUnlocked: boolean;
    isPrimary: boolean;
}

export class DealInsuranceOverviewIPagedList implements IDealInsuranceOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: DealInsuranceOverview[];

    constructor(data?: IDealInsuranceOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(DealInsuranceOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealInsuranceOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new DealInsuranceOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealInsuranceOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: DealInsuranceOverview[];
}

export class DealInsuranceOverviewIPagedListApiResult implements IDealInsuranceOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: DealInsuranceOverviewIPagedList;

    constructor(data?: IDealInsuranceOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new DealInsuranceOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? DealInsuranceOverviewIPagedList.fromJS(_data["data"]) : new DealInsuranceOverviewIPagedList();
        }
    }

    static fromJS(data: any): DealInsuranceOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DealInsuranceOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealInsuranceOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: DealInsuranceOverviewIPagedList;
}

export class DealOverview implements IDealOverview {
    id!: number;
    salesPersonName!: string;
    dId!: number;
    creationDate!: Date;
    customerName!: string;
    trademarkName!: string;
    modelName!: string;
    hasFinancingCalculation!: boolean;
    hasInsuranceCalculation!: boolean;
    isFleet!: boolean;

    constructor(data?: IDealOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salesPersonName = _data["salesPersonName"];
            this.dId = _data["dId"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.trademarkName = _data["trademarkName"];
            this.modelName = _data["modelName"];
            this.hasFinancingCalculation = _data["hasFinancingCalculation"];
            this.hasInsuranceCalculation = _data["hasInsuranceCalculation"];
            this.isFleet = _data["isFleet"];
        }
    }

    static fromJS(data: any): DealOverview {
        data = typeof data === 'object' ? data : {};
        let result = new DealOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesPersonName"] = this.salesPersonName;
        data["dId"] = this.dId;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["trademarkName"] = this.trademarkName;
        data["modelName"] = this.modelName;
        data["hasFinancingCalculation"] = this.hasFinancingCalculation;
        data["hasInsuranceCalculation"] = this.hasInsuranceCalculation;
        data["isFleet"] = this.isFleet;
        return data;
    }
}

export interface IDealOverview {
    id: number;
    salesPersonName: string;
    dId: number;
    creationDate: Date;
    customerName: string;
    trademarkName: string;
    modelName: string;
    hasFinancingCalculation: boolean;
    hasInsuranceCalculation: boolean;
    isFleet: boolean;
}

export class DealOverviewIPagedList implements IDealOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: DealOverview[];

    constructor(data?: IDealOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(DealOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new DealOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDealOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: DealOverview[];
}

export class DealOverviewIPagedListApiResult implements IDealOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: DealOverviewIPagedList;

    constructor(data?: IDealOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new DealOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? DealOverviewIPagedList.fromJS(_data["data"]) : new DealOverviewIPagedList();
        }
    }

    static fromJS(data: any): DealOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DealOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: DealOverviewIPagedList;
}

/** Deal Parameters should be relevant for the Calculation */
export class DealParameters implements IDealParameters {
    modelId!: number;
    dealTypeId!: number;
    vehicleTypeConditionId!: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice!: number;
    extrasPrice!: number;
    purchasePrice!: number;
    discountPercent?: number | undefined;
    discountInEuro!: number;
    numberOfVehicles!: number;
    vat!: number;
    isIncludeVat!: boolean;
    registrationDate?: Date | undefined;
    distributionChannel!: number;
    modelPrototypeId?: number | undefined;
    modelAddition?: string | undefined;
    chassisNumber?: string | undefined;
    useCampaign!: boolean;
    dealFeatureValues!: FeatureValueWrapper[];

    constructor(data?: IDealParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dealFeatureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.dealTypeId = _data["dealTypeId"];
            this.vehicleTypeConditionId = _data["vehicleTypeConditionId"];
            this.discountCategoryId = _data["discountCategoryId"];
            this.salesPersonId = _data["salesPersonId"];
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.vat = _data["vat"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.distributionChannel = _data["distributionChannel"];
            this.modelPrototypeId = _data["modelPrototypeId"];
            this.modelAddition = _data["modelAddition"];
            this.chassisNumber = _data["chassisNumber"];
            this.useCampaign = _data["useCampaign"];
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DealParameters {
        data = typeof data === 'object' ? data : {};
        let result = new DealParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["dealTypeId"] = this.dealTypeId;
        data["vehicleTypeConditionId"] = this.vehicleTypeConditionId;
        data["discountCategoryId"] = this.discountCategoryId;
        data["salesPersonId"] = this.salesPersonId;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["vat"] = this.vat;
        data["isIncludeVat"] = this.isIncludeVat;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["distributionChannel"] = this.distributionChannel;
        data["modelPrototypeId"] = this.modelPrototypeId;
        data["modelAddition"] = this.modelAddition;
        data["chassisNumber"] = this.chassisNumber;
        data["useCampaign"] = this.useCampaign;
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        return data;
    }
}

/** Deal Parameters should be relevant for the Calculation */
export interface IDealParameters {
    modelId: number;
    dealTypeId: number;
    vehicleTypeConditionId: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice: number;
    extrasPrice: number;
    purchasePrice: number;
    discountPercent?: number | undefined;
    discountInEuro: number;
    numberOfVehicles: number;
    vat: number;
    isIncludeVat: boolean;
    registrationDate?: Date | undefined;
    distributionChannel: number;
    modelPrototypeId?: number | undefined;
    modelAddition?: string | undefined;
    chassisNumber?: string | undefined;
    useCampaign: boolean;
    dealFeatureValues: FeatureValueWrapper[];
}

export class DealSnapshotData implements IDealSnapshotData {
    id!: number;
    dealerId!: number;
    dealType?: string | undefined;
    dealSubType?: string | undefined;
    creationState?: number | undefined;
    creationDate!: Date;
    modelName!: string;
    modelDescription?: string | undefined;
    vehicleCondition!: string;
    listPrice!: number;
    extrasPrice?: number | undefined;
    purchasePrice!: number;
    discount?: number | undefined;
    discountAbsolute?: number | undefined;
    coFinancedExtras?: number | undefined;
    mbksExtrasPrice?: number | undefined;
    vat!: number;
    isIncludeVat!: boolean;
    registrationDate?: Date | undefined;
    chassisNumber?: string | undefined;
    licensePlate?: string | undefined;
    kmStand?: number | undefined;
    numberOfVehicles!: number;
    kw?: number | undefined;
    weight?: number | undefined;
    curbWeight?: number | undefined;
    ccm?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    co2?: number | undefined;
    noVa?: number | undefined;
    novaPercent?: number | undefined;
    novaAddition?: number | undefined;
    novaBonus?: number | undefined;
    novaMalus?: number | undefined;
    novaPayed?: boolean | undefined;
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;
    commissionNumber?: string | undefined;
    poseidonOfferId?: string | undefined;
    isKaskoResigned!: boolean;
    mayProceedWithExceededLimit!: boolean;
    useCampaign!: boolean;
    primaryCalculationId?: number | undefined;
    amendsDealId?: number | undefined;
    amendedByDealId?: number | undefined;
    discountCategoryId?: number | undefined;

    constructor(data?: IDealSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dealerId = _data["dealerId"];
            this.dealType = _data["dealType"];
            this.dealSubType = _data["dealSubType"];
            this.creationState = _data["creationState"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.modelName = _data["modelName"];
            this.modelDescription = _data["modelDescription"];
            this.vehicleCondition = _data["vehicleCondition"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.discount = _data["discount"];
            this.discountAbsolute = _data["discountAbsolute"];
            this.coFinancedExtras = _data["coFinancedExtras"];
            this.mbksExtrasPrice = _data["mbksExtrasPrice"];
            this.vat = _data["vat"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.chassisNumber = _data["chassisNumber"];
            this.licensePlate = _data["licensePlate"];
            this.kmStand = _data["kmStand"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.kw = _data["kw"];
            this.weight = _data["weight"];
            this.curbWeight = _data["curbWeight"];
            this.ccm = _data["ccm"];
            this.numberOfSeats = _data["numberOfSeats"];
            this.maxTotalWeight = _data["maxTotalWeight"];
            this.co2 = _data["co2"];
            this.noVa = _data["noVa"];
            this.novaPercent = _data["novaPercent"];
            this.novaAddition = _data["novaAddition"];
            this.novaBonus = _data["novaBonus"];
            this.novaMalus = _data["novaMalus"];
            this.novaPayed = _data["novaPayed"];
            this.ksvRating = _data["ksvRating"];
            this.roracUrl = _data["roracUrl"];
            this.commissionNumber = _data["commissionNumber"];
            this.poseidonOfferId = _data["poseidonOfferId"];
            this.isKaskoResigned = _data["isKaskoResigned"];
            this.mayProceedWithExceededLimit = _data["mayProceedWithExceededLimit"];
            this.useCampaign = _data["useCampaign"];
            this.primaryCalculationId = _data["primaryCalculationId"];
            this.amendsDealId = _data["amendsDealId"];
            this.amendedByDealId = _data["amendedByDealId"];
            this.discountCategoryId = _data["discountCategoryId"];
        }
    }

    static fromJS(data: any): DealSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new DealSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dealerId"] = this.dealerId;
        data["dealType"] = this.dealType;
        data["dealSubType"] = this.dealSubType;
        data["creationState"] = this.creationState;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["modelName"] = this.modelName;
        data["modelDescription"] = this.modelDescription;
        data["vehicleCondition"] = this.vehicleCondition;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["discount"] = this.discount;
        data["discountAbsolute"] = this.discountAbsolute;
        data["coFinancedExtras"] = this.coFinancedExtras;
        data["mbksExtrasPrice"] = this.mbksExtrasPrice;
        data["vat"] = this.vat;
        data["isIncludeVat"] = this.isIncludeVat;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["chassisNumber"] = this.chassisNumber;
        data["licensePlate"] = this.licensePlate;
        data["kmStand"] = this.kmStand;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["kw"] = this.kw;
        data["weight"] = this.weight;
        data["curbWeight"] = this.curbWeight;
        data["ccm"] = this.ccm;
        data["numberOfSeats"] = this.numberOfSeats;
        data["maxTotalWeight"] = this.maxTotalWeight;
        data["co2"] = this.co2;
        data["noVa"] = this.noVa;
        data["novaPercent"] = this.novaPercent;
        data["novaAddition"] = this.novaAddition;
        data["novaBonus"] = this.novaBonus;
        data["novaMalus"] = this.novaMalus;
        data["novaPayed"] = this.novaPayed;
        data["ksvRating"] = this.ksvRating;
        data["roracUrl"] = this.roracUrl;
        data["commissionNumber"] = this.commissionNumber;
        data["poseidonOfferId"] = this.poseidonOfferId;
        data["isKaskoResigned"] = this.isKaskoResigned;
        data["mayProceedWithExceededLimit"] = this.mayProceedWithExceededLimit;
        data["useCampaign"] = this.useCampaign;
        data["primaryCalculationId"] = this.primaryCalculationId;
        data["amendsDealId"] = this.amendsDealId;
        data["amendedByDealId"] = this.amendedByDealId;
        data["discountCategoryId"] = this.discountCategoryId;
        return data;
    }
}

export interface IDealSnapshotData {
    id: number;
    dealerId: number;
    dealType?: string | undefined;
    dealSubType?: string | undefined;
    creationState?: number | undefined;
    creationDate: Date;
    modelName: string;
    modelDescription?: string | undefined;
    vehicleCondition: string;
    listPrice: number;
    extrasPrice?: number | undefined;
    purchasePrice: number;
    discount?: number | undefined;
    discountAbsolute?: number | undefined;
    coFinancedExtras?: number | undefined;
    mbksExtrasPrice?: number | undefined;
    vat: number;
    isIncludeVat: boolean;
    registrationDate?: Date | undefined;
    chassisNumber?: string | undefined;
    licensePlate?: string | undefined;
    kmStand?: number | undefined;
    numberOfVehicles: number;
    kw?: number | undefined;
    weight?: number | undefined;
    curbWeight?: number | undefined;
    ccm?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    co2?: number | undefined;
    noVa?: number | undefined;
    novaPercent?: number | undefined;
    novaAddition?: number | undefined;
    novaBonus?: number | undefined;
    novaMalus?: number | undefined;
    novaPayed?: boolean | undefined;
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;
    commissionNumber?: string | undefined;
    poseidonOfferId?: string | undefined;
    isKaskoResigned: boolean;
    mayProceedWithExceededLimit: boolean;
    useCampaign: boolean;
    primaryCalculationId?: number | undefined;
    amendsDealId?: number | undefined;
    amendedByDealId?: number | undefined;
    discountCategoryId?: number | undefined;
}

export class DealTransferResponse implements IDealTransferResponse {
    isSuccess!: boolean;
    isNotFound!: boolean;
    isNotAllowed!: boolean;
    isNotInDekato!: boolean;
    isDealerNotFound!: boolean;
    isErrorAtPoseidon!: boolean;

    constructor(data?: IDealTransferResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.isNotFound = _data["isNotFound"];
            this.isNotAllowed = _data["isNotAllowed"];
            this.isNotInDekato = _data["isNotInDekato"];
            this.isDealerNotFound = _data["isDealerNotFound"];
            this.isErrorAtPoseidon = _data["isErrorAtPoseidon"];
        }
    }

    static fromJS(data: any): DealTransferResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DealTransferResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["isNotFound"] = this.isNotFound;
        data["isNotAllowed"] = this.isNotAllowed;
        data["isNotInDekato"] = this.isNotInDekato;
        data["isDealerNotFound"] = this.isDealerNotFound;
        data["isErrorAtPoseidon"] = this.isErrorAtPoseidon;
        return data;
    }
}

export interface IDealTransferResponse {
    isSuccess: boolean;
    isNotFound: boolean;
    isNotAllowed: boolean;
    isNotInDekato: boolean;
    isDealerNotFound: boolean;
    isErrorAtPoseidon: boolean;
}

export class DealTransferResponseApiResult implements IDealTransferResponseApiResult {
    messages!: ApiMessages;
    data!: DealTransferResponse;

    constructor(data?: IDealTransferResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new DealTransferResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? DealTransferResponse.fromJS(_data["data"]) : new DealTransferResponse();
        }
    }

    static fromJS(data: any): DealTransferResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DealTransferResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDealTransferResponseApiResult {
    messages: ApiMessages;
    data: DealTransferResponse;
}

export enum DealType {
    Unknown = "Unknown",
    Private = "Private",
    Commercial = "Commercial",
    Fleet = "Fleet",
    Taxi = "Taxi",
    Agency = "Agency",
}

export class DeleteCoApplicantResponse implements IDeleteCoApplicantResponse {

    constructor(data?: IDeleteCoApplicantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteCoApplicantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCoApplicantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteCoApplicantResponse {
}

export class DeleteCoApplicantResponseApiResult implements IDeleteCoApplicantResponseApiResult {
    messages!: ApiMessages;
    data!: DeleteCoApplicantResponse;

    constructor(data?: IDeleteCoApplicantResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new DeleteCoApplicantResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? DeleteCoApplicantResponse.fromJS(_data["data"]) : new DeleteCoApplicantResponse();
        }
    }

    static fromJS(data: any): DeleteCoApplicantResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCoApplicantResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteCoApplicantResponseApiResult {
    messages: ApiMessages;
    data: DeleteCoApplicantResponse;
}

export class DeleteFeatureClassificationRequest implements IDeleteFeatureClassificationRequest {
    classificationGroupId!: string;
    featureDefinitionId!: string;

    constructor(data?: IDeleteFeatureClassificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classificationGroupId = _data["classificationGroupId"];
            this.featureDefinitionId = _data["featureDefinitionId"];
        }
    }

    static fromJS(data: any): DeleteFeatureClassificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFeatureClassificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classificationGroupId"] = this.classificationGroupId;
        data["featureDefinitionId"] = this.featureDefinitionId;
        return data;
    }
}

export interface IDeleteFeatureClassificationRequest {
    classificationGroupId: string;
    featureDefinitionId: string;
}

export class DisolveDetail implements IDisolveDetail {
    dueDate?: Date | undefined;
    dissolveValue?: number | undefined;
    nextMonth?: number | undefined;
    theMonthAfterNextMonth?: number | undefined;
    previousMonth?: number | undefined;
    pickDate?: Date | undefined;

    constructor(data?: IDisolveDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.dissolveValue = _data["dissolveValue"];
            this.nextMonth = _data["nextMonth"];
            this.theMonthAfterNextMonth = _data["theMonthAfterNextMonth"];
            this.previousMonth = _data["previousMonth"];
            this.pickDate = _data["pickDate"] ? new Date(_data["pickDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DisolveDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DisolveDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dissolveValue"] = this.dissolveValue;
        data["nextMonth"] = this.nextMonth;
        data["theMonthAfterNextMonth"] = this.theMonthAfterNextMonth;
        data["previousMonth"] = this.previousMonth;
        data["pickDate"] = this.pickDate ? this.pickDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDisolveDetail {
    dueDate?: Date | undefined;
    dissolveValue?: number | undefined;
    nextMonth?: number | undefined;
    theMonthAfterNextMonth?: number | undefined;
    previousMonth?: number | undefined;
    pickDate?: Date | undefined;
}

export class DissolveValueModel implements IDissolveValueModel {
    cmsId!: number;
    dissolveDate!: Date;
    dissolveValue!: number;
    purchasePrice?: number | undefined;
    commissionNumber?: string | undefined;
    deduction?: number | undefined;
    addition?: number | undefined;
    isSurchargeCancelled!: boolean;

    constructor(data?: IDissolveValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmsId = _data["cmsId"];
            this.dissolveDate = _data["dissolveDate"] ? new Date(_data["dissolveDate"].toString()) : <any>undefined;
            this.dissolveValue = _data["dissolveValue"];
            this.purchasePrice = _data["purchasePrice"];
            this.commissionNumber = _data["commissionNumber"];
            this.deduction = _data["deduction"];
            this.addition = _data["addition"];
            this.isSurchargeCancelled = _data["isSurchargeCancelled"];
        }
    }

    static fromJS(data: any): DissolveValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new DissolveValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmsId"] = this.cmsId;
        data["dissolveDate"] = this.dissolveDate ? this.dissolveDate.toISOString() : <any>undefined;
        data["dissolveValue"] = this.dissolveValue;
        data["purchasePrice"] = this.purchasePrice;
        data["commissionNumber"] = this.commissionNumber;
        data["deduction"] = this.deduction;
        data["addition"] = this.addition;
        data["isSurchargeCancelled"] = this.isSurchargeCancelled;
        return data;
    }
}

export interface IDissolveValueModel {
    cmsId: number;
    dissolveDate: Date;
    dissolveValue: number;
    purchasePrice?: number | undefined;
    commissionNumber?: string | undefined;
    deduction?: number | undefined;
    addition?: number | undefined;
    isSurchargeCancelled: boolean;
}

export class DmsDocumentModel implements IDmsDocumentModel {
    id!: string;
    documentName!: string;
    variant!: string;

    constructor(data?: IDmsDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.variant = _data["variant"];
        }
    }

    static fromJS(data: any): DmsDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DmsDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["variant"] = this.variant;
        return data;
    }
}

export interface IDmsDocumentModel {
    id: string;
    documentName: string;
    variant: string;
}

export enum DocumentCategory {
    Uncategorized = "Uncategorized",
    SpecialOffer = "SpecialOffer",
    Incentive = "Incentive",
}

export class DocumentDefinition implements IDocumentDefinition {
    id!: number;
    customerId!: number;
    name?: string | undefined;
    readonly!: boolean;
    selected!: boolean;
    signable!: boolean;
    visible!: boolean;
    subDocuments?: DocumentDefinition[] | undefined;

    constructor(data?: IDocumentDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.readonly = _data["readonly"];
            this.selected = _data["selected"];
            this.signable = _data["signable"];
            this.visible = _data["visible"];
            if (Array.isArray(_data["subDocuments"])) {
                this.subDocuments = [] as any;
                for (let item of _data["subDocuments"])
                    this.subDocuments!.push(DocumentDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["readonly"] = this.readonly;
        data["selected"] = this.selected;
        data["signable"] = this.signable;
        data["visible"] = this.visible;
        if (Array.isArray(this.subDocuments)) {
            data["subDocuments"] = [];
            for (let item of this.subDocuments)
                data["subDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentDefinition {
    id: number;
    customerId: number;
    name?: string | undefined;
    readonly: boolean;
    selected: boolean;
    signable: boolean;
    visible: boolean;
    subDocuments?: DocumentDefinition[] | undefined;
}

export class DocumentDetail implements IDocumentDetail {
    missingDocuments!: string[];
    documents!: DmsDocumentModel[];

    constructor(data?: IDocumentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.missingDocuments = [];
            this.documents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["missingDocuments"])) {
                this.missingDocuments = [] as any;
                for (let item of _data["missingDocuments"])
                    this.missingDocuments!.push(item);
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DmsDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.missingDocuments)) {
            data["missingDocuments"] = [];
            for (let item of this.missingDocuments)
                data["missingDocuments"].push(item);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentDetail {
    missingDocuments: string[];
    documents: DmsDocumentModel[];
}

export class DocumentOverview implements IDocumentOverview {
    id!: string;
    name?: string | undefined;
    group?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    attachmentId?: string | undefined;
    external!: boolean;
    externalUrl?: string | undefined;
    contentType!: string;

    constructor(data?: IDocumentOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.attachmentId = _data["attachmentId"];
            this.external = _data["external"];
            this.externalUrl = _data["externalUrl"];
            this.contentType = _data["contentType"];
        }
    }

    static fromJS(data: any): DocumentOverview {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["group"] = this.group;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["attachmentId"] = this.attachmentId;
        data["external"] = this.external;
        data["externalUrl"] = this.externalUrl;
        data["contentType"] = this.contentType;
        return data;
    }
}

export interface IDocumentOverview {
    id: string;
    name?: string | undefined;
    group?: string | undefined;
    from?: Date | undefined;
    to?: Date | undefined;
    attachmentId?: string | undefined;
    external: boolean;
    externalUrl?: string | undefined;
    contentType: string;
}

export class DocumentOverviewIPagedList implements IDocumentOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: DocumentOverview[];

    constructor(data?: IDocumentOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(DocumentOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: DocumentOverview[];
}

export class DocumentOverviewIPagedListApiResult implements IDocumentOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: DocumentOverviewIPagedList;

    constructor(data?: IDocumentOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new DocumentOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? DocumentOverviewIPagedList.fromJS(_data["data"]) : new DocumentOverviewIPagedList();
        }
    }

    static fromJS(data: any): DocumentOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: DocumentOverviewIPagedList;
}

export class DoubleApiResult implements IDoubleApiResult {
    messages!: ApiMessages;
    data!: number;

    constructor(data?: IDoubleApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): DoubleApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IDoubleApiResult {
    messages: ApiMessages;
    data: number;
}

export class DropdownCollection implements IDropdownCollection {
    businessRelationships!: OptionItem[];
    financingTypes!: OptionItem[];
    interestCalculationMethods!: OptionItem[];
    milages!: OptionItem[];
    rateCategories!: OptionItem[];
    residualValueContracts!: OptionItem[];
    sourceOfFunds!: OptionItem[];
    specialOffers!: SalesAidView[];
    salesAids!: SalesAidView[];
    dealers!: OptionItem[];
    fuelServiceProducts!: OptionItem[];

    constructor(data?: IDropdownCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.businessRelationships = [];
            this.financingTypes = [];
            this.interestCalculationMethods = [];
            this.milages = [];
            this.rateCategories = [];
            this.residualValueContracts = [];
            this.sourceOfFunds = [];
            this.specialOffers = [];
            this.salesAids = [];
            this.dealers = [];
            this.fuelServiceProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessRelationships"])) {
                this.businessRelationships = [] as any;
                for (let item of _data["businessRelationships"])
                    this.businessRelationships!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["financingTypes"])) {
                this.financingTypes = [] as any;
                for (let item of _data["financingTypes"])
                    this.financingTypes!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["interestCalculationMethods"])) {
                this.interestCalculationMethods = [] as any;
                for (let item of _data["interestCalculationMethods"])
                    this.interestCalculationMethods!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["milages"])) {
                this.milages = [] as any;
                for (let item of _data["milages"])
                    this.milages!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["rateCategories"])) {
                this.rateCategories = [] as any;
                for (let item of _data["rateCategories"])
                    this.rateCategories!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["residualValueContracts"])) {
                this.residualValueContracts = [] as any;
                for (let item of _data["residualValueContracts"])
                    this.residualValueContracts!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["sourceOfFunds"])) {
                this.sourceOfFunds = [] as any;
                for (let item of _data["sourceOfFunds"])
                    this.sourceOfFunds!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["specialOffers"])) {
                this.specialOffers = [] as any;
                for (let item of _data["specialOffers"])
                    this.specialOffers!.push(SalesAidView.fromJS(item));
            }
            if (Array.isArray(_data["salesAids"])) {
                this.salesAids = [] as any;
                for (let item of _data["salesAids"])
                    this.salesAids!.push(SalesAidView.fromJS(item));
            }
            if (Array.isArray(_data["dealers"])) {
                this.dealers = [] as any;
                for (let item of _data["dealers"])
                    this.dealers!.push(OptionItem.fromJS(item));
            }
            if (Array.isArray(_data["fuelServiceProducts"])) {
                this.fuelServiceProducts = [] as any;
                for (let item of _data["fuelServiceProducts"])
                    this.fuelServiceProducts!.push(OptionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropdownCollection {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessRelationships)) {
            data["businessRelationships"] = [];
            for (let item of this.businessRelationships)
                data["businessRelationships"].push(item.toJSON());
        }
        if (Array.isArray(this.financingTypes)) {
            data["financingTypes"] = [];
            for (let item of this.financingTypes)
                data["financingTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.interestCalculationMethods)) {
            data["interestCalculationMethods"] = [];
            for (let item of this.interestCalculationMethods)
                data["interestCalculationMethods"].push(item.toJSON());
        }
        if (Array.isArray(this.milages)) {
            data["milages"] = [];
            for (let item of this.milages)
                data["milages"].push(item.toJSON());
        }
        if (Array.isArray(this.rateCategories)) {
            data["rateCategories"] = [];
            for (let item of this.rateCategories)
                data["rateCategories"].push(item.toJSON());
        }
        if (Array.isArray(this.residualValueContracts)) {
            data["residualValueContracts"] = [];
            for (let item of this.residualValueContracts)
                data["residualValueContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.sourceOfFunds)) {
            data["sourceOfFunds"] = [];
            for (let item of this.sourceOfFunds)
                data["sourceOfFunds"].push(item.toJSON());
        }
        if (Array.isArray(this.specialOffers)) {
            data["specialOffers"] = [];
            for (let item of this.specialOffers)
                data["specialOffers"].push(item.toJSON());
        }
        if (Array.isArray(this.salesAids)) {
            data["salesAids"] = [];
            for (let item of this.salesAids)
                data["salesAids"].push(item.toJSON());
        }
        if (Array.isArray(this.dealers)) {
            data["dealers"] = [];
            for (let item of this.dealers)
                data["dealers"].push(item.toJSON());
        }
        if (Array.isArray(this.fuelServiceProducts)) {
            data["fuelServiceProducts"] = [];
            for (let item of this.fuelServiceProducts)
                data["fuelServiceProducts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDropdownCollection {
    businessRelationships: OptionItem[];
    financingTypes: OptionItem[];
    interestCalculationMethods: OptionItem[];
    milages: OptionItem[];
    rateCategories: OptionItem[];
    residualValueContracts: OptionItem[];
    sourceOfFunds: OptionItem[];
    specialOffers: SalesAidView[];
    salesAids: SalesAidView[];
    dealers: OptionItem[];
    fuelServiceProducts: OptionItem[];
}

export class EditCommercialCustomerRequest extends CommercialCustomerView implements IEditCommercialCustomerRequest {
    customerId!: number;

    constructor(data?: IEditCommercialCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): EditCommercialCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommercialCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        super.toJSON(data);
        return data;
    }
}

export interface IEditCommercialCustomerRequest extends ICommercialCustomerView {
    customerId: number;
}

export class EditCommercialCustomerResponse implements IEditCommercialCustomerResponse {
    customerId!: number;

    constructor(data?: IEditCommercialCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): EditCommercialCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommercialCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IEditCommercialCustomerResponse {
    customerId: number;
}

export class EditCommercialCustomerResponseApiResult implements IEditCommercialCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: EditCommercialCustomerResponse;

    constructor(data?: IEditCommercialCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new EditCommercialCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? EditCommercialCustomerResponse.fromJS(_data["data"]) : new EditCommercialCustomerResponse();
        }
    }

    static fromJS(data: any): EditCommercialCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommercialCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditCommercialCustomerResponseApiResult {
    messages: ApiMessages;
    data: EditCommercialCustomerResponse;
}

export class EditCommercialDealCustomerRequest extends CommercialCustomerView implements IEditCommercialDealCustomerRequest {
    customerId!: number;
    dealId!: number;
    applyChangesToMainCustomer!: boolean;
    hasRelevantChanges!: boolean;

    constructor(data?: IEditCommercialDealCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.dealId = _data["dealId"];
            this.applyChangesToMainCustomer = _data["applyChangesToMainCustomer"];
            this.hasRelevantChanges = _data["hasRelevantChanges"];
        }
    }

    static fromJS(data: any): EditCommercialDealCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommercialDealCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["dealId"] = this.dealId;
        data["applyChangesToMainCustomer"] = this.applyChangesToMainCustomer;
        data["hasRelevantChanges"] = this.hasRelevantChanges;
        super.toJSON(data);
        return data;
    }
}

export interface IEditCommercialDealCustomerRequest extends ICommercialCustomerView {
    customerId: number;
    dealId: number;
    applyChangesToMainCustomer: boolean;
    hasRelevantChanges: boolean;
}

export class EditPrivateCustomerRequest extends PrivateCustomerView implements IEditPrivateCustomerRequest {
    customerId!: number;

    constructor(data?: IEditPrivateCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): EditPrivateCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrivateCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        super.toJSON(data);
        return data;
    }
}

export interface IEditPrivateCustomerRequest extends IPrivateCustomerView {
    customerId: number;
}

export class EditPrivateCustomerResponse implements IEditPrivateCustomerResponse {
    customerId!: number;

    constructor(data?: IEditPrivateCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): EditPrivateCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrivateCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IEditPrivateCustomerResponse {
    customerId: number;
}

export class EditPrivateCustomerResponseApiResult implements IEditPrivateCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: EditPrivateCustomerResponse;

    constructor(data?: IEditPrivateCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new EditPrivateCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? EditPrivateCustomerResponse.fromJS(_data["data"]) : new EditPrivateCustomerResponse();
        }
    }

    static fromJS(data: any): EditPrivateCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrivateCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditPrivateCustomerResponseApiResult {
    messages: ApiMessages;
    data: EditPrivateCustomerResponse;
}

export class EditPrivateDealCustomerRequest extends PrivateCustomerView implements IEditPrivateDealCustomerRequest {
    customerId!: number;
    dealId!: number;
    applyChangesToMainCustomer!: boolean;
    hasRelevantChanges!: boolean;

    constructor(data?: IEditPrivateDealCustomerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerId = _data["customerId"];
            this.dealId = _data["dealId"];
            this.applyChangesToMainCustomer = _data["applyChangesToMainCustomer"];
            this.hasRelevantChanges = _data["hasRelevantChanges"];
        }
    }

    static fromJS(data: any): EditPrivateDealCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrivateDealCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["dealId"] = this.dealId;
        data["applyChangesToMainCustomer"] = this.applyChangesToMainCustomer;
        data["hasRelevantChanges"] = this.hasRelevantChanges;
        super.toJSON(data);
        return data;
    }
}

export interface IEditPrivateDealCustomerRequest extends IPrivateCustomerView {
    customerId: number;
    dealId: number;
    applyChangesToMainCustomer: boolean;
    hasRelevantChanges: boolean;
}

export enum ExpiredDealState {
    LessThan14Days = "LessThan14Days",
    LessThan25Days = "LessThan25Days",
}

export class ExportCalculationDocumentsRequest implements IExportCalculationDocumentsRequest {
    dealId!: number;
    variantNr!: number;
    kendoxDocuments!: string[];
    templateId!: number;

    constructor(data?: IExportCalculationDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kendoxDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.variantNr = _data["variantNr"];
            if (Array.isArray(_data["kendoxDocuments"])) {
                this.kendoxDocuments = [] as any;
                for (let item of _data["kendoxDocuments"])
                    this.kendoxDocuments!.push(item);
            }
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): ExportCalculationDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportCalculationDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["variantNr"] = this.variantNr;
        if (Array.isArray(this.kendoxDocuments)) {
            data["kendoxDocuments"] = [];
            for (let item of this.kendoxDocuments)
                data["kendoxDocuments"].push(item);
        }
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IExportCalculationDocumentsRequest {
    dealId: number;
    variantNr: number;
    kendoxDocuments: string[];
    templateId: number;
}

export class ExtendedConfiguration implements IExtendedConfiguration {
    /** Laufzeit Min */
    fundingLifetimeMin!: number;
    /** Laufzeit Max */
    fundingLifetimeMax!: number;
    /** Vorauszahlung Min */
    prepaymentMin?: number | undefined;
    /** Gesamtbetrag */
    totalAmountPayable!: number;
    /** Provision (in Prozent) */
    commissionInPercent?: number | undefined;
    /** Provision (in Zahlen) */
    commissionInNumbers?: number | undefined;
    /** Bearbeitungsgebühr (BGeb) */
    processingFee!: number;
    /** Rechtsgeschäftgebühr (VGeb) */
    legalTransactionFee!: number;
    /** Effektivzinssatz */
    effectiveInterestRate!: number;
    /** Sollzinssatz */
    nominalInterestRate!: number;
    /** Kalkulationszinssatz */
    fundingInterestRate!: number;
    /** Kalkulationszinssatz Depot */
    depositInterestRate!: number;
    /** Gebühren */
    fees!: Fee[];
    /** Erstellt von */
    createdBy?: string | undefined;
    /** Erzeugt */
    creationDate?: Date | undefined;
    /** Geändert von */
    editedBy?: string | undefined;
    /** Änderungsdatum */
    editedDate?: Date | undefined;
    /** Stützungen */
    subsidies!: SubsidyView[];
    /** Euribor-Rate */
    euriborRate!: number;
    voterUser?: string | undefined;
    voterDate?: Date | undefined;
    limitViolations!: SalesAidLimitViolationView[];

    constructor(data?: IExtendedConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fees = [];
            this.subsidies = [];
            this.limitViolations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingLifetimeMin = _data["fundingLifetimeMin"];
            this.fundingLifetimeMax = _data["fundingLifetimeMax"];
            this.prepaymentMin = _data["prepaymentMin"];
            this.totalAmountPayable = _data["totalAmountPayable"];
            this.commissionInPercent = _data["commissionInPercent"];
            this.commissionInNumbers = _data["commissionInNumbers"];
            this.processingFee = _data["processingFee"];
            this.legalTransactionFee = _data["legalTransactionFee"];
            this.effectiveInterestRate = _data["effectiveInterestRate"];
            this.nominalInterestRate = _data["nominalInterestRate"];
            this.fundingInterestRate = _data["fundingInterestRate"];
            this.depositInterestRate = _data["depositInterestRate"];
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(Fee.fromJS(item));
            }
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.editedBy = _data["editedBy"];
            this.editedDate = _data["editedDate"] ? new Date(_data["editedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["subsidies"])) {
                this.subsidies = [] as any;
                for (let item of _data["subsidies"])
                    this.subsidies!.push(SubsidyView.fromJS(item));
            }
            this.euriborRate = _data["euriborRate"];
            this.voterUser = _data["voterUser"];
            this.voterDate = _data["voterDate"] ? new Date(_data["voterDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["limitViolations"])) {
                this.limitViolations = [] as any;
                for (let item of _data["limitViolations"])
                    this.limitViolations!.push(SalesAidLimitViolationView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExtendedConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendedConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingLifetimeMin"] = this.fundingLifetimeMin;
        data["fundingLifetimeMax"] = this.fundingLifetimeMax;
        data["prepaymentMin"] = this.prepaymentMin;
        data["totalAmountPayable"] = this.totalAmountPayable;
        data["commissionInPercent"] = this.commissionInPercent;
        data["commissionInNumbers"] = this.commissionInNumbers;
        data["processingFee"] = this.processingFee;
        data["legalTransactionFee"] = this.legalTransactionFee;
        data["effectiveInterestRate"] = this.effectiveInterestRate;
        data["nominalInterestRate"] = this.nominalInterestRate;
        data["fundingInterestRate"] = this.fundingInterestRate;
        data["depositInterestRate"] = this.depositInterestRate;
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["editedBy"] = this.editedBy;
        data["editedDate"] = this.editedDate ? this.editedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.subsidies)) {
            data["subsidies"] = [];
            for (let item of this.subsidies)
                data["subsidies"].push(item.toJSON());
        }
        data["euriborRate"] = this.euriborRate;
        data["voterUser"] = this.voterUser;
        data["voterDate"] = this.voterDate ? this.voterDate.toISOString() : <any>undefined;
        if (Array.isArray(this.limitViolations)) {
            data["limitViolations"] = [];
            for (let item of this.limitViolations)
                data["limitViolations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExtendedConfiguration {
    /** Laufzeit Min */
    fundingLifetimeMin: number;
    /** Laufzeit Max */
    fundingLifetimeMax: number;
    /** Vorauszahlung Min */
    prepaymentMin?: number | undefined;
    /** Gesamtbetrag */
    totalAmountPayable: number;
    /** Provision (in Prozent) */
    commissionInPercent?: number | undefined;
    /** Provision (in Zahlen) */
    commissionInNumbers?: number | undefined;
    /** Bearbeitungsgebühr (BGeb) */
    processingFee: number;
    /** Rechtsgeschäftgebühr (VGeb) */
    legalTransactionFee: number;
    /** Effektivzinssatz */
    effectiveInterestRate: number;
    /** Sollzinssatz */
    nominalInterestRate: number;
    /** Kalkulationszinssatz */
    fundingInterestRate: number;
    /** Kalkulationszinssatz Depot */
    depositInterestRate: number;
    /** Gebühren */
    fees: Fee[];
    /** Erstellt von */
    createdBy?: string | undefined;
    /** Erzeugt */
    creationDate?: Date | undefined;
    /** Geändert von */
    editedBy?: string | undefined;
    /** Änderungsdatum */
    editedDate?: Date | undefined;
    /** Stützungen */
    subsidies: SubsidyView[];
    /** Euribor-Rate */
    euriborRate: number;
    voterUser?: string | undefined;
    voterDate?: Date | undefined;
    limitViolations: SalesAidLimitViolationView[];
}

export class ExternalMeResponse implements IExternalMeResponse {
    applicationName!: string;
    version!: string;
    apiKeyName!: string;

    constructor(data?: IExternalMeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationName = _data["applicationName"];
            this.version = _data["version"];
            this.apiKeyName = _data["apiKeyName"];
        }
    }

    static fromJS(data: any): ExternalMeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalMeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationName"] = this.applicationName;
        data["version"] = this.version;
        data["apiKeyName"] = this.apiKeyName;
        return data;
    }
}

export interface IExternalMeResponse {
    applicationName: string;
    version: string;
    apiKeyName: string;
}

export class ExternalMeResponseApiResult implements IExternalMeResponseApiResult {
    messages!: ApiMessages;
    data!: ExternalMeResponse;

    constructor(data?: IExternalMeResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ExternalMeResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ExternalMeResponse.fromJS(_data["data"]) : new ExternalMeResponse();
        }
    }

    static fromJS(data: any): ExternalMeResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalMeResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExternalMeResponseApiResult {
    messages: ApiMessages;
    data: ExternalMeResponse;
}

export class FeatureClassificationView implements IFeatureClassificationView {
    id!: string;
    defaultValue?: string | undefined;
    definitionId!: string;
    name!: string;
    featureType!: FeatureType;
    format?: string | undefined;
    isSystem!: boolean;
    isInherited!: boolean;
    isOverrideable!: boolean;
    sortOrder!: number;

    constructor(data?: IFeatureClassificationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.defaultValue = _data["defaultValue"];
            this.definitionId = _data["definitionId"];
            this.name = _data["name"];
            this.featureType = _data["featureType"];
            this.format = _data["format"];
            this.isSystem = _data["isSystem"];
            this.isInherited = _data["isInherited"];
            this.isOverrideable = _data["isOverrideable"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): FeatureClassificationView {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureClassificationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["defaultValue"] = this.defaultValue;
        data["definitionId"] = this.definitionId;
        data["name"] = this.name;
        data["featureType"] = this.featureType;
        data["format"] = this.format;
        data["isSystem"] = this.isSystem;
        data["isInherited"] = this.isInherited;
        data["isOverrideable"] = this.isOverrideable;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IFeatureClassificationView {
    id: string;
    defaultValue?: string | undefined;
    definitionId: string;
    name: string;
    featureType: FeatureType;
    format?: string | undefined;
    isSystem: boolean;
    isInherited: boolean;
    isOverrideable: boolean;
    sortOrder: number;
}

export class FeatureClassificationViewIReadOnlyCollectionApiResult implements IFeatureClassificationViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: FeatureClassificationView[];

    constructor(data?: IFeatureClassificationViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeatureClassificationView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureClassificationViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureClassificationViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureClassificationViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: FeatureClassificationView[];
}

export class FeatureDefinitionView implements IFeatureDefinitionView {
    id!: string;
    name!: string;
    featureType!: FeatureType;
    format!: string;
    isSystem!: boolean;

    constructor(data?: IFeatureDefinitionView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.featureType = _data["featureType"];
            this.format = _data["format"];
            this.isSystem = _data["isSystem"];
        }
    }

    static fromJS(data: any): FeatureDefinitionView {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDefinitionView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["featureType"] = this.featureType;
        data["format"] = this.format;
        data["isSystem"] = this.isSystem;
        return data;
    }
}

export interface IFeatureDefinitionView {
    id: string;
    name: string;
    featureType: FeatureType;
    format: string;
    isSystem: boolean;
}

export class FeatureDefinitionViewIReadOnlyCollectionApiResult implements IFeatureDefinitionViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: FeatureDefinitionView[];

    constructor(data?: IFeatureDefinitionViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeatureDefinitionView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureDefinitionViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureDefinitionViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureDefinitionViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: FeatureDefinitionView[];
}

export enum FeatureType {
    Text = "Text",
    Number = "Number",
    Boolean = "Boolean",
    Reference = "Reference",
    Date = "Date",
}

export class FeatureValueView implements IFeatureValueView {
    featureId!: string;
    value?: string | undefined;
    name!: string;
    featureType!: FeatureType;
    format?: string | undefined;
    isSystem!: boolean;
    sortOrder!: number;
    isOverwritten!: boolean;

    constructor(data?: IFeatureValueView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.value = _data["value"];
            this.name = _data["name"];
            this.featureType = _data["featureType"];
            this.format = _data["format"];
            this.isSystem = _data["isSystem"];
            this.sortOrder = _data["sortOrder"];
            this.isOverwritten = _data["isOverwritten"];
        }
    }

    static fromJS(data: any): FeatureValueView {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureValueView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["value"] = this.value;
        data["name"] = this.name;
        data["featureType"] = this.featureType;
        data["format"] = this.format;
        data["isSystem"] = this.isSystem;
        data["sortOrder"] = this.sortOrder;
        data["isOverwritten"] = this.isOverwritten;
        return data;
    }
}

export interface IFeatureValueView {
    featureId: string;
    value?: string | undefined;
    name: string;
    featureType: FeatureType;
    format?: string | undefined;
    isSystem: boolean;
    sortOrder: number;
    isOverwritten: boolean;
}

export class FeatureValueViewIReadOnlyCollectionApiResult implements IFeatureValueViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: FeatureValueView[];

    constructor(data?: IFeatureValueViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FeatureValueView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureValueViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureValueViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureValueViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: FeatureValueView[];
}

export class FeatureValueWrapper implements IFeatureValueWrapper {
    featureId!: string;
    value?: string | undefined;
    isSystem!: boolean;
    isOverwritten!: boolean;
    domainId?: number | undefined;
    objectType!: ClassificationType;

    constructor(data?: IFeatureValueWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.value = _data["value"];
            this.isSystem = _data["isSystem"];
            this.isOverwritten = _data["isOverwritten"];
            this.domainId = _data["domainId"];
            this.objectType = _data["objectType"];
        }
    }

    static fromJS(data: any): FeatureValueWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureValueWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["value"] = this.value;
        data["isSystem"] = this.isSystem;
        data["isOverwritten"] = this.isOverwritten;
        data["domainId"] = this.domainId;
        data["objectType"] = this.objectType;
        return data;
    }
}

export interface IFeatureValueWrapper {
    featureId: string;
    value?: string | undefined;
    isSystem: boolean;
    isOverwritten: boolean;
    domainId?: number | undefined;
    objectType: ClassificationType;
}

export class Fee implements IFee {
    feeTypeId!: number;
    calculatedFeeAbsolute!: number;

    constructor(data?: IFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.feeTypeId = _data["feeTypeId"];
            this.calculatedFeeAbsolute = _data["calculatedFeeAbsolute"];
        }
    }

    static fromJS(data: any): Fee {
        data = typeof data === 'object' ? data : {};
        let result = new Fee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeTypeId"] = this.feeTypeId;
        data["calculatedFeeAbsolute"] = this.calculatedFeeAbsolute;
        return data;
    }
}

export interface IFee {
    feeTypeId: number;
    calculatedFeeAbsolute: number;
}

export class FinancingCalculationSnapshotData implements IFinancingCalculationSnapshotData {
    id!: number;
    calculationNumber!: string;
    commissionNumber?: string | undefined;
    financingTypeName!: string;
    status!: number;
    version!: number;
    incomplete!: boolean;
    creationDate!: Date;
    changeDate?: Date | undefined;
    durationInMonths!: number;
    paymentQuantity?: number | undefined;
    minLifetime!: number;
    maxLifetime!: number;
    annualInterestRate!: number;
    interestRate!: number;
    euriborRate!: number;
    euriborDate!: Date;
    expectedDispatchDate?: Date | undefined;
    effectiveMbfsarate!: number;
    effectiveCustomerRate!: number;
    effectiveAnnualRate!: number;
    borrowingInterestRate!: number;
    interestRateMethod?: string | undefined;
    depot!: number;
    standardRateDepot!: number;
    rateDepot!: number;
    prepayment!: number;
    minPrepayment?: number | undefined;
    monthlyNetPayment!: number;
    monthlyGrossPayment!: number;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    isVariablePayment!: boolean;
    listPrice!: number;
    purchasePrice!: number;
    extrasPrice?: number | undefined;
    calculationBasis!: number;
    coFinancedExtras?: number | undefined;
    mbksExtrasPrice?: number | undefined;
    discount?: number | undefined;
    discountAbsolute?: number | undefined;
    campaignDiscount?: number | undefined;
    specialOfferDiscount?: number | undefined;
    totalContractCharge!: number;
    totalLoad!: number;
    legalTransactionFee?: number | undefined;
    prepaymentLegalTransactionFee?: number | undefined;
    financingLegalTransactionFee?: number | undefined;
    selfPayFee?: number | undefined;
    dealerSupport?: number | undefined;
    providerSupport?: number | undefined;
    totalDealerSupport!: number;
    totalProviderSupport!: number;
    dealerSupportPercent?: number | undefined;
    providerSupportPercent?: number | undefined;
    dealerSupportRate?: number | undefined;
    providerSupportRate?: number | undefined;
    dealerInterestSupport?: number | undefined;
    providerInterestSupport?: number | undefined;
    internalSupport?: number | undefined;
    leasingSupportUsed?: number | undefined;
    novaAddition?: number | undefined;
    novaBonus?: number | undefined;
    novaMalus?: number | undefined;
    novaPercent?: number | undefined;
    novaPayed?: boolean | undefined;
    db?: number | undefined;
    increasedResidualValue?: number | undefined;
    openResidualBalance?: number | undefined;
    additionalMileageCharge?: number | undefined;
    kilometrageValue?: number | undefined;
    insuranceCalculationId?: number | undefined;
    businessRelationship?: string | undefined;
    isDirectInkasso!: boolean;
    hasGhgPremium!: boolean;
    isBundle!: boolean;
    eccRequired?: string | undefined;
    submissionStage?: number | undefined;
    sourceOfFundsId?: number | undefined;
    registrationDate?: Date | undefined;
    kmStand?: number | undefined;
    chassisNumber?: string | undefined;
    accountOwner?: string | undefined;
    proposedResidualValue?: ResidualValueSnapshotData | undefined;
    overwrittenResidualValue?: ResidualValueSnapshotData | undefined;
    cmsId?: string | undefined;
    euriborId!: number;
    sendToContractManagementSystemDate?: Date | undefined;
    submissionEuriborRate?: number | undefined;
    submissionEuriborDate?: Date | undefined;
    submissionNominalInterestRate?: number | undefined;
    conditionAdjustments!: ConditionAdjustmentSnapshotData[];
    euriborRateToday?: number | undefined;
    euriborDateToday?: Date | undefined;

    constructor(data?: IFinancingCalculationSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.conditionAdjustments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calculationNumber = _data["calculationNumber"];
            this.commissionNumber = _data["commissionNumber"];
            this.financingTypeName = _data["financingTypeName"];
            this.status = _data["status"];
            this.version = _data["version"];
            this.incomplete = _data["incomplete"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.durationInMonths = _data["durationInMonths"];
            this.paymentQuantity = _data["paymentQuantity"];
            this.minLifetime = _data["minLifetime"];
            this.maxLifetime = _data["maxLifetime"];
            this.annualInterestRate = _data["annualInterestRate"];
            this.interestRate = _data["interestRate"];
            this.euriborRate = _data["euriborRate"];
            this.euriborDate = _data["euriborDate"] ? new Date(_data["euriborDate"].toString()) : <any>undefined;
            this.expectedDispatchDate = _data["expectedDispatchDate"] ? new Date(_data["expectedDispatchDate"].toString()) : <any>undefined;
            this.effectiveMbfsarate = _data["effectiveMbfsarate"];
            this.effectiveCustomerRate = _data["effectiveCustomerRate"];
            this.effectiveAnnualRate = _data["effectiveAnnualRate"];
            this.borrowingInterestRate = _data["borrowingInterestRate"];
            this.interestRateMethod = _data["interestRateMethod"];
            this.depot = _data["depot"];
            this.standardRateDepot = _data["standardRateDepot"];
            this.rateDepot = _data["rateDepot"];
            this.prepayment = _data["prepayment"];
            this.minPrepayment = _data["minPrepayment"];
            this.monthlyNetPayment = _data["monthlyNetPayment"];
            this.monthlyGrossPayment = _data["monthlyGrossPayment"];
            this.regularInstalment = _data["regularInstalment"];
            this.regularInstalmentExact = _data["regularInstalmentExact"];
            this.isVariablePayment = _data["isVariablePayment"];
            this.listPrice = _data["listPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.calculationBasis = _data["calculationBasis"];
            this.coFinancedExtras = _data["coFinancedExtras"];
            this.mbksExtrasPrice = _data["mbksExtrasPrice"];
            this.discount = _data["discount"];
            this.discountAbsolute = _data["discountAbsolute"];
            this.campaignDiscount = _data["campaignDiscount"];
            this.specialOfferDiscount = _data["specialOfferDiscount"];
            this.totalContractCharge = _data["totalContractCharge"];
            this.totalLoad = _data["totalLoad"];
            this.legalTransactionFee = _data["legalTransactionFee"];
            this.prepaymentLegalTransactionFee = _data["prepaymentLegalTransactionFee"];
            this.financingLegalTransactionFee = _data["financingLegalTransactionFee"];
            this.selfPayFee = _data["selfPayFee"];
            this.dealerSupport = _data["dealerSupport"];
            this.providerSupport = _data["providerSupport"];
            this.totalDealerSupport = _data["totalDealerSupport"];
            this.totalProviderSupport = _data["totalProviderSupport"];
            this.dealerSupportPercent = _data["dealerSupportPercent"];
            this.providerSupportPercent = _data["providerSupportPercent"];
            this.dealerSupportRate = _data["dealerSupportRate"];
            this.providerSupportRate = _data["providerSupportRate"];
            this.dealerInterestSupport = _data["dealerInterestSupport"];
            this.providerInterestSupport = _data["providerInterestSupport"];
            this.internalSupport = _data["internalSupport"];
            this.leasingSupportUsed = _data["leasingSupportUsed"];
            this.novaAddition = _data["novaAddition"];
            this.novaBonus = _data["novaBonus"];
            this.novaMalus = _data["novaMalus"];
            this.novaPercent = _data["novaPercent"];
            this.novaPayed = _data["novaPayed"];
            this.db = _data["db"];
            this.increasedResidualValue = _data["increasedResidualValue"];
            this.openResidualBalance = _data["openResidualBalance"];
            this.additionalMileageCharge = _data["additionalMileageCharge"];
            this.kilometrageValue = _data["kilometrageValue"];
            this.insuranceCalculationId = _data["insuranceCalculationId"];
            this.businessRelationship = _data["businessRelationship"];
            this.isDirectInkasso = _data["isDirectInkasso"];
            this.hasGhgPremium = _data["hasGhgPremium"];
            this.isBundle = _data["isBundle"];
            this.eccRequired = _data["eccRequired"];
            this.submissionStage = _data["submissionStage"];
            this.sourceOfFundsId = _data["sourceOfFundsId"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.kmStand = _data["kmStand"];
            this.chassisNumber = _data["chassisNumber"];
            this.accountOwner = _data["accountOwner"];
            this.proposedResidualValue = _data["proposedResidualValue"] ? ResidualValueSnapshotData.fromJS(_data["proposedResidualValue"]) : <any>undefined;
            this.overwrittenResidualValue = _data["overwrittenResidualValue"] ? ResidualValueSnapshotData.fromJS(_data["overwrittenResidualValue"]) : <any>undefined;
            this.cmsId = _data["cmsId"];
            this.euriborId = _data["euriborId"];
            this.sendToContractManagementSystemDate = _data["sendToContractManagementSystemDate"] ? new Date(_data["sendToContractManagementSystemDate"].toString()) : <any>undefined;
            this.submissionEuriborRate = _data["submissionEuriborRate"];
            this.submissionEuriborDate = _data["submissionEuriborDate"] ? new Date(_data["submissionEuriborDate"].toString()) : <any>undefined;
            this.submissionNominalInterestRate = _data["submissionNominalInterestRate"];
            if (Array.isArray(_data["conditionAdjustments"])) {
                this.conditionAdjustments = [] as any;
                for (let item of _data["conditionAdjustments"])
                    this.conditionAdjustments!.push(ConditionAdjustmentSnapshotData.fromJS(item));
            }
            this.euriborRateToday = _data["euriborRateToday"];
            this.euriborDateToday = _data["euriborDateToday"] ? new Date(_data["euriborDateToday"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FinancingCalculationSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new FinancingCalculationSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calculationNumber"] = this.calculationNumber;
        data["commissionNumber"] = this.commissionNumber;
        data["financingTypeName"] = this.financingTypeName;
        data["status"] = this.status;
        data["version"] = this.version;
        data["incomplete"] = this.incomplete;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["durationInMonths"] = this.durationInMonths;
        data["paymentQuantity"] = this.paymentQuantity;
        data["minLifetime"] = this.minLifetime;
        data["maxLifetime"] = this.maxLifetime;
        data["annualInterestRate"] = this.annualInterestRate;
        data["interestRate"] = this.interestRate;
        data["euriborRate"] = this.euriborRate;
        data["euriborDate"] = this.euriborDate ? this.euriborDate.toISOString() : <any>undefined;
        data["expectedDispatchDate"] = this.expectedDispatchDate ? this.expectedDispatchDate.toISOString() : <any>undefined;
        data["effectiveMbfsarate"] = this.effectiveMbfsarate;
        data["effectiveCustomerRate"] = this.effectiveCustomerRate;
        data["effectiveAnnualRate"] = this.effectiveAnnualRate;
        data["borrowingInterestRate"] = this.borrowingInterestRate;
        data["interestRateMethod"] = this.interestRateMethod;
        data["depot"] = this.depot;
        data["standardRateDepot"] = this.standardRateDepot;
        data["rateDepot"] = this.rateDepot;
        data["prepayment"] = this.prepayment;
        data["minPrepayment"] = this.minPrepayment;
        data["monthlyNetPayment"] = this.monthlyNetPayment;
        data["monthlyGrossPayment"] = this.monthlyGrossPayment;
        data["regularInstalment"] = this.regularInstalment;
        data["regularInstalmentExact"] = this.regularInstalmentExact;
        data["isVariablePayment"] = this.isVariablePayment;
        data["listPrice"] = this.listPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["extrasPrice"] = this.extrasPrice;
        data["calculationBasis"] = this.calculationBasis;
        data["coFinancedExtras"] = this.coFinancedExtras;
        data["mbksExtrasPrice"] = this.mbksExtrasPrice;
        data["discount"] = this.discount;
        data["discountAbsolute"] = this.discountAbsolute;
        data["campaignDiscount"] = this.campaignDiscount;
        data["specialOfferDiscount"] = this.specialOfferDiscount;
        data["totalContractCharge"] = this.totalContractCharge;
        data["totalLoad"] = this.totalLoad;
        data["legalTransactionFee"] = this.legalTransactionFee;
        data["prepaymentLegalTransactionFee"] = this.prepaymentLegalTransactionFee;
        data["financingLegalTransactionFee"] = this.financingLegalTransactionFee;
        data["selfPayFee"] = this.selfPayFee;
        data["dealerSupport"] = this.dealerSupport;
        data["providerSupport"] = this.providerSupport;
        data["totalDealerSupport"] = this.totalDealerSupport;
        data["totalProviderSupport"] = this.totalProviderSupport;
        data["dealerSupportPercent"] = this.dealerSupportPercent;
        data["providerSupportPercent"] = this.providerSupportPercent;
        data["dealerSupportRate"] = this.dealerSupportRate;
        data["providerSupportRate"] = this.providerSupportRate;
        data["dealerInterestSupport"] = this.dealerInterestSupport;
        data["providerInterestSupport"] = this.providerInterestSupport;
        data["internalSupport"] = this.internalSupport;
        data["leasingSupportUsed"] = this.leasingSupportUsed;
        data["novaAddition"] = this.novaAddition;
        data["novaBonus"] = this.novaBonus;
        data["novaMalus"] = this.novaMalus;
        data["novaPercent"] = this.novaPercent;
        data["novaPayed"] = this.novaPayed;
        data["db"] = this.db;
        data["increasedResidualValue"] = this.increasedResidualValue;
        data["openResidualBalance"] = this.openResidualBalance;
        data["additionalMileageCharge"] = this.additionalMileageCharge;
        data["kilometrageValue"] = this.kilometrageValue;
        data["insuranceCalculationId"] = this.insuranceCalculationId;
        data["businessRelationship"] = this.businessRelationship;
        data["isDirectInkasso"] = this.isDirectInkasso;
        data["hasGhgPremium"] = this.hasGhgPremium;
        data["isBundle"] = this.isBundle;
        data["eccRequired"] = this.eccRequired;
        data["submissionStage"] = this.submissionStage;
        data["sourceOfFundsId"] = this.sourceOfFundsId;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["kmStand"] = this.kmStand;
        data["chassisNumber"] = this.chassisNumber;
        data["accountOwner"] = this.accountOwner;
        data["proposedResidualValue"] = this.proposedResidualValue ? this.proposedResidualValue.toJSON() : <any>undefined;
        data["overwrittenResidualValue"] = this.overwrittenResidualValue ? this.overwrittenResidualValue.toJSON() : <any>undefined;
        data["cmsId"] = this.cmsId;
        data["euriborId"] = this.euriborId;
        data["sendToContractManagementSystemDate"] = this.sendToContractManagementSystemDate ? this.sendToContractManagementSystemDate.toISOString() : <any>undefined;
        data["submissionEuriborRate"] = this.submissionEuriborRate;
        data["submissionEuriborDate"] = this.submissionEuriborDate ? this.submissionEuriborDate.toISOString() : <any>undefined;
        data["submissionNominalInterestRate"] = this.submissionNominalInterestRate;
        if (Array.isArray(this.conditionAdjustments)) {
            data["conditionAdjustments"] = [];
            for (let item of this.conditionAdjustments)
                data["conditionAdjustments"].push(item.toJSON());
        }
        data["euriborRateToday"] = this.euriborRateToday;
        data["euriborDateToday"] = this.euriborDateToday ? this.euriborDateToday.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFinancingCalculationSnapshotData {
    id: number;
    calculationNumber: string;
    commissionNumber?: string | undefined;
    financingTypeName: string;
    status: number;
    version: number;
    incomplete: boolean;
    creationDate: Date;
    changeDate?: Date | undefined;
    durationInMonths: number;
    paymentQuantity?: number | undefined;
    minLifetime: number;
    maxLifetime: number;
    annualInterestRate: number;
    interestRate: number;
    euriborRate: number;
    euriborDate: Date;
    expectedDispatchDate?: Date | undefined;
    effectiveMbfsarate: number;
    effectiveCustomerRate: number;
    effectiveAnnualRate: number;
    borrowingInterestRate: number;
    interestRateMethod?: string | undefined;
    depot: number;
    standardRateDepot: number;
    rateDepot: number;
    prepayment: number;
    minPrepayment?: number | undefined;
    monthlyNetPayment: number;
    monthlyGrossPayment: number;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    isVariablePayment: boolean;
    listPrice: number;
    purchasePrice: number;
    extrasPrice?: number | undefined;
    calculationBasis: number;
    coFinancedExtras?: number | undefined;
    mbksExtrasPrice?: number | undefined;
    discount?: number | undefined;
    discountAbsolute?: number | undefined;
    campaignDiscount?: number | undefined;
    specialOfferDiscount?: number | undefined;
    totalContractCharge: number;
    totalLoad: number;
    legalTransactionFee?: number | undefined;
    prepaymentLegalTransactionFee?: number | undefined;
    financingLegalTransactionFee?: number | undefined;
    selfPayFee?: number | undefined;
    dealerSupport?: number | undefined;
    providerSupport?: number | undefined;
    totalDealerSupport: number;
    totalProviderSupport: number;
    dealerSupportPercent?: number | undefined;
    providerSupportPercent?: number | undefined;
    dealerSupportRate?: number | undefined;
    providerSupportRate?: number | undefined;
    dealerInterestSupport?: number | undefined;
    providerInterestSupport?: number | undefined;
    internalSupport?: number | undefined;
    leasingSupportUsed?: number | undefined;
    novaAddition?: number | undefined;
    novaBonus?: number | undefined;
    novaMalus?: number | undefined;
    novaPercent?: number | undefined;
    novaPayed?: boolean | undefined;
    db?: number | undefined;
    increasedResidualValue?: number | undefined;
    openResidualBalance?: number | undefined;
    additionalMileageCharge?: number | undefined;
    kilometrageValue?: number | undefined;
    insuranceCalculationId?: number | undefined;
    businessRelationship?: string | undefined;
    isDirectInkasso: boolean;
    hasGhgPremium: boolean;
    isBundle: boolean;
    eccRequired?: string | undefined;
    submissionStage?: number | undefined;
    sourceOfFundsId?: number | undefined;
    registrationDate?: Date | undefined;
    kmStand?: number | undefined;
    chassisNumber?: string | undefined;
    accountOwner?: string | undefined;
    proposedResidualValue?: ResidualValueSnapshotData | undefined;
    overwrittenResidualValue?: ResidualValueSnapshotData | undefined;
    cmsId?: string | undefined;
    euriborId: number;
    sendToContractManagementSystemDate?: Date | undefined;
    submissionEuriborRate?: number | undefined;
    submissionEuriborDate?: Date | undefined;
    submissionNominalInterestRate?: number | undefined;
    conditionAdjustments: ConditionAdjustmentSnapshotData[];
    euriborRateToday?: number | undefined;
    euriborDateToday?: Date | undefined;
}

export class FinancingType implements IFinancingType {
    hasDeposit!: boolean;
    hasClosingBalance!: boolean;
    hasResidualValue!: boolean;
    isFinancingLeasing!: boolean;
    vatFree!: boolean;
    isFullService!: boolean;
    isCharterway!: boolean;

    constructor(data?: IFinancingType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasDeposit = _data["hasDeposit"];
            this.hasClosingBalance = _data["hasClosingBalance"];
            this.hasResidualValue = _data["hasResidualValue"];
            this.isFinancingLeasing = _data["isFinancingLeasing"];
            this.vatFree = _data["vatFree"];
            this.isFullService = _data["isFullService"];
            this.isCharterway = _data["isCharterway"];
        }
    }

    static fromJS(data: any): FinancingType {
        data = typeof data === 'object' ? data : {};
        let result = new FinancingType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasDeposit"] = this.hasDeposit;
        data["hasClosingBalance"] = this.hasClosingBalance;
        data["hasResidualValue"] = this.hasResidualValue;
        data["isFinancingLeasing"] = this.isFinancingLeasing;
        data["vatFree"] = this.vatFree;
        data["isFullService"] = this.isFullService;
        data["isCharterway"] = this.isCharterway;
        return data;
    }
}

export interface IFinancingType {
    hasDeposit: boolean;
    hasClosingBalance: boolean;
    hasResidualValue: boolean;
    isFinancingLeasing: boolean;
    vatFree: boolean;
    isFullService: boolean;
    isCharterway: boolean;
}

export class FleetEntry implements IFleetEntry {
    dealId!: number;
    offerId?: string | undefined;
    createdAt!: Date;

    constructor(data?: IFleetEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.offerId = _data["offerId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetEntry {
        data = typeof data === 'object' ? data : {};
        let result = new FleetEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["offerId"] = this.offerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFleetEntry {
    dealId: number;
    offerId?: string | undefined;
    createdAt: Date;
}

export class FleetVinAssignment implements IFleetVinAssignment {
    position!: number;
    vin?: string | undefined;
    status!: VinAssignmentStatus;
    commissionNumber?: string | undefined;
    cmsId!: string;
    expectedDispatchDate?: Date | undefined;

    constructor(data?: IFleetVinAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.vin = _data["vin"];
            this.status = _data["status"];
            this.commissionNumber = _data["commissionNumber"];
            this.cmsId = _data["cmsId"];
            this.expectedDispatchDate = _data["expectedDispatchDate"] ? new Date(_data["expectedDispatchDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FleetVinAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new FleetVinAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["vin"] = this.vin;
        data["status"] = this.status;
        data["commissionNumber"] = this.commissionNumber;
        data["cmsId"] = this.cmsId;
        data["expectedDispatchDate"] = this.expectedDispatchDate ? this.expectedDispatchDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFleetVinAssignment {
    position: number;
    vin?: string | undefined;
    status: VinAssignmentStatus;
    commissionNumber?: string | undefined;
    cmsId: string;
    expectedDispatchDate?: Date | undefined;
}

export class FleetVinAssignmentIReadOnlyCollectionApiResult implements IFleetVinAssignmentIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: FleetVinAssignment[];

    constructor(data?: IFleetVinAssignmentIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(FleetVinAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FleetVinAssignmentIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new FleetVinAssignmentIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFleetVinAssignmentIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: FleetVinAssignment[];
}

export class FundingProductView implements IFundingProductView {
    financingTypeId!: number;
    duration!: number;
    mileageId!: number;
    businessRelationshipId!: number;
    interestRateCalculationMethodId!: number;
    rateCategoryId?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    hasMoneyLaunderingRelevantPayments!: boolean;
    accountOwnerRequired!: boolean;
    accountOwner?: string | undefined;
    isDownPaymentReadonly!: boolean;
    isDepositReadonly!: boolean;
    isDurationReadonly!: boolean;
    isMileageReadonly!: boolean;
    downpayment?: number | undefined;
    downpaymentPercentage?: number | undefined;
    deposit?: number | undefined;
    depositPercentage?: number | undefined;
    financingType!: FinancingType;
    isLeasing!: boolean;
    isCredit!: boolean;
    salesAidId?: number | undefined;
    purchaseContractDate?: Date | undefined;
    calculationNumber!: string;
    isResidualValueReadonly!: boolean;
    isResidualValueConversionOptionsReadonly!: boolean;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    displayGross!: boolean;
    isDirectInkassoAllowed!: boolean;
    isDirectInkasso!: boolean;
    isGhgPremiumAvailable!: boolean;
    hasGhgPremium!: boolean;
    isBundle!: boolean;

    constructor(data?: IFundingProductView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.financingType = new FinancingType();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financingTypeId = _data["financingTypeId"];
            this.duration = _data["duration"];
            this.mileageId = _data["mileageId"];
            this.businessRelationshipId = _data["businessRelationshipId"];
            this.interestRateCalculationMethodId = _data["interestRateCalculationMethodId"];
            this.rateCategoryId = _data["rateCategoryId"];
            this.residualValueContractId = _data["residualValueContractId"];
            this.sourceOfFoundsId = _data["sourceOfFoundsId"];
            this.hasMoneyLaunderingRelevantPayments = _data["hasMoneyLaunderingRelevantPayments"];
            this.accountOwnerRequired = _data["accountOwnerRequired"];
            this.accountOwner = _data["accountOwner"];
            this.isDownPaymentReadonly = _data["isDownPaymentReadonly"];
            this.isDepositReadonly = _data["isDepositReadonly"];
            this.isDurationReadonly = _data["isDurationReadonly"];
            this.isMileageReadonly = _data["isMileageReadonly"];
            this.downpayment = _data["downpayment"];
            this.downpaymentPercentage = _data["downpaymentPercentage"];
            this.deposit = _data["deposit"];
            this.depositPercentage = _data["depositPercentage"];
            this.financingType = _data["financingType"] ? FinancingType.fromJS(_data["financingType"]) : new FinancingType();
            this.isLeasing = _data["isLeasing"];
            this.isCredit = _data["isCredit"];
            this.salesAidId = _data["salesAidId"];
            this.purchaseContractDate = _data["purchaseContractDate"] ? new Date(_data["purchaseContractDate"].toString()) : <any>undefined;
            this.calculationNumber = _data["calculationNumber"];
            this.isResidualValueReadonly = _data["isResidualValueReadonly"];
            this.isResidualValueConversionOptionsReadonly = _data["isResidualValueConversionOptionsReadonly"];
            this.referencesDealId = _data["referencesDealId"];
            this.referencesCalculationId = _data["referencesCalculationId"];
            this.displayGross = _data["displayGross"];
            this.isDirectInkassoAllowed = _data["isDirectInkassoAllowed"];
            this.isDirectInkasso = _data["isDirectInkasso"];
            this.isGhgPremiumAvailable = _data["isGhgPremiumAvailable"];
            this.hasGhgPremium = _data["hasGhgPremium"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): FundingProductView {
        data = typeof data === 'object' ? data : {};
        let result = new FundingProductView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingTypeId"] = this.financingTypeId;
        data["duration"] = this.duration;
        data["mileageId"] = this.mileageId;
        data["businessRelationshipId"] = this.businessRelationshipId;
        data["interestRateCalculationMethodId"] = this.interestRateCalculationMethodId;
        data["rateCategoryId"] = this.rateCategoryId;
        data["residualValueContractId"] = this.residualValueContractId;
        data["sourceOfFoundsId"] = this.sourceOfFoundsId;
        data["hasMoneyLaunderingRelevantPayments"] = this.hasMoneyLaunderingRelevantPayments;
        data["accountOwnerRequired"] = this.accountOwnerRequired;
        data["accountOwner"] = this.accountOwner;
        data["isDownPaymentReadonly"] = this.isDownPaymentReadonly;
        data["isDepositReadonly"] = this.isDepositReadonly;
        data["isDurationReadonly"] = this.isDurationReadonly;
        data["isMileageReadonly"] = this.isMileageReadonly;
        data["downpayment"] = this.downpayment;
        data["downpaymentPercentage"] = this.downpaymentPercentage;
        data["deposit"] = this.deposit;
        data["depositPercentage"] = this.depositPercentage;
        data["financingType"] = this.financingType ? this.financingType.toJSON() : <any>undefined;
        data["isLeasing"] = this.isLeasing;
        data["isCredit"] = this.isCredit;
        data["salesAidId"] = this.salesAidId;
        data["purchaseContractDate"] = this.purchaseContractDate ? this.purchaseContractDate.toISOString() : <any>undefined;
        data["calculationNumber"] = this.calculationNumber;
        data["isResidualValueReadonly"] = this.isResidualValueReadonly;
        data["isResidualValueConversionOptionsReadonly"] = this.isResidualValueConversionOptionsReadonly;
        data["referencesDealId"] = this.referencesDealId;
        data["referencesCalculationId"] = this.referencesCalculationId;
        data["displayGross"] = this.displayGross;
        data["isDirectInkassoAllowed"] = this.isDirectInkassoAllowed;
        data["isDirectInkasso"] = this.isDirectInkasso;
        data["isGhgPremiumAvailable"] = this.isGhgPremiumAvailable;
        data["hasGhgPremium"] = this.hasGhgPremium;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface IFundingProductView {
    financingTypeId: number;
    duration: number;
    mileageId: number;
    businessRelationshipId: number;
    interestRateCalculationMethodId: number;
    rateCategoryId?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    hasMoneyLaunderingRelevantPayments: boolean;
    accountOwnerRequired: boolean;
    accountOwner?: string | undefined;
    isDownPaymentReadonly: boolean;
    isDepositReadonly: boolean;
    isDurationReadonly: boolean;
    isMileageReadonly: boolean;
    downpayment?: number | undefined;
    downpaymentPercentage?: number | undefined;
    deposit?: number | undefined;
    depositPercentage?: number | undefined;
    financingType: FinancingType;
    isLeasing: boolean;
    isCredit: boolean;
    salesAidId?: number | undefined;
    purchaseContractDate?: Date | undefined;
    calculationNumber: string;
    isResidualValueReadonly: boolean;
    isResidualValueConversionOptionsReadonly: boolean;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    displayGross: boolean;
    isDirectInkassoAllowed: boolean;
    isDirectInkasso: boolean;
    isGhgPremiumAvailable: boolean;
    hasGhgPremium: boolean;
    isBundle: boolean;
}

export class GetArchivedDocumentResponse extends ArchivedDocumentOverview implements IGetArchivedDocumentResponse {
    content!: BinaryData;

    constructor(data?: IGetArchivedDocumentResponse) {
        super(data);
        if (!data) {
            this.content = new BinaryData();
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.content = _data["content"] ? BinaryData.fromJS(_data["content"]) : new BinaryData();
        }
    }

    static fromJS(data: any): GetArchivedDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetArchivedDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content ? this.content.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGetArchivedDocumentResponse extends IArchivedDocumentOverview {
    content: BinaryData;
}

export class GetBankByIbanResponse implements IGetBankByIbanResponse {
    bic?: string | undefined;
    bankName?: string | undefined;

    constructor(data?: IGetBankByIbanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bic = _data["bic"];
            this.bankName = _data["bankName"];
        }
    }

    static fromJS(data: any): GetBankByIbanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankByIbanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bic"] = this.bic;
        data["bankName"] = this.bankName;
        return data;
    }
}

export interface IGetBankByIbanResponse {
    bic?: string | undefined;
    bankName?: string | undefined;
}

export class GetBankByIbanResponseApiResult implements IGetBankByIbanResponseApiResult {
    messages!: ApiMessages;
    data!: GetBankByIbanResponse;

    constructor(data?: IGetBankByIbanResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetBankByIbanResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetBankByIbanResponse.fromJS(_data["data"]) : new GetBankByIbanResponse();
        }
    }

    static fromJS(data: any): GetBankByIbanResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBankByIbanResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBankByIbanResponseApiResult {
    messages: ApiMessages;
    data: GetBankByIbanResponse;
}

export class GetCalculatedProductForExistingDealRequest implements IGetCalculatedProductForExistingDealRequest {
    dealId!: number;
    calculationId?: number | undefined;
    financingTypeId!: number;
    duration!: number;
    mileageId!: number;
    businessRelationshipId!: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig!: ObjectConfigurationRequest;
    purchaseContractDate?: Date | undefined;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    hasGhgPremium?: boolean | undefined;
    salesAid?: SalesAidView | undefined;
    agentOptions!: AgentOption[];
    conversionOptions!: ConversionOption[];
    calculationFeatureValues!: FeatureValueWrapper[];
    dealFeatureValues!: FeatureValueWrapper[];
    apiconServiceRequestBundle!: ApiconServiceRequestBundle;
    serviceVariantId?: number | undefined;
    cacheGuid?: string | undefined;
    isBundle!: boolean;

    constructor(data?: IGetCalculatedProductForExistingDealRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.objectConfig = new ObjectConfigurationRequest();
            this.agentOptions = [];
            this.conversionOptions = [];
            this.calculationFeatureValues = [];
            this.dealFeatureValues = [];
            this.apiconServiceRequestBundle = new ApiconServiceRequestBundle();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.financingTypeId = _data["financingTypeId"];
            this.duration = _data["duration"];
            this.mileageId = _data["mileageId"];
            this.businessRelationshipId = _data["businessRelationshipId"];
            this.interestRateCalculationMethodId = _data["interestRateCalculationMethodId"];
            this.rateCategoryId = _data["rateCategoryId"];
            this.downpayment = _data["downpayment"];
            this.downPaymentPercent = _data["downPaymentPercent"];
            this.deposit = _data["deposit"];
            this.depositPercent = _data["depositPercent"];
            this.residualValueContractId = _data["residualValueContractId"];
            this.sourceOfFoundsId = _data["sourceOfFoundsId"];
            this.accountOwner = _data["accountOwner"];
            this.residualValueVehicleAbsolute = _data["residualValueVehicleAbsolute"];
            this.residualValueConversionOptions = _data["residualValueConversionOptions"];
            this.residualValuePercentage = _data["residualValuePercentage"];
            this.referencesDealId = _data["referencesDealId"];
            this.referencesCalculationId = _data["referencesCalculationId"];
            this.objectConfig = _data["objectConfig"] ? ObjectConfigurationRequest.fromJS(_data["objectConfig"]) : new ObjectConfigurationRequest();
            this.purchaseContractDate = _data["purchaseContractDate"] ? new Date(_data["purchaseContractDate"].toString()) : <any>undefined;
            this.specialOfferId = _data["specialOfferId"];
            this.selectedFuelServiceProductId = _data["selectedFuelServiceProductId"];
            this.ksvRating = _data["ksvRating"];
            this.hasGhgPremium = _data["hasGhgPremium"];
            this.salesAid = _data["salesAid"] ? SalesAidView.fromJS(_data["salesAid"]) : <any>undefined;
            if (Array.isArray(_data["agentOptions"])) {
                this.agentOptions = [] as any;
                for (let item of _data["agentOptions"])
                    this.agentOptions!.push(AgentOption.fromJS(item));
            }
            if (Array.isArray(_data["conversionOptions"])) {
                this.conversionOptions = [] as any;
                for (let item of _data["conversionOptions"])
                    this.conversionOptions!.push(ConversionOption.fromJS(item));
            }
            if (Array.isArray(_data["calculationFeatureValues"])) {
                this.calculationFeatureValues = [] as any;
                for (let item of _data["calculationFeatureValues"])
                    this.calculationFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            this.apiconServiceRequestBundle = _data["apiconServiceRequestBundle"] ? ApiconServiceRequestBundle.fromJS(_data["apiconServiceRequestBundle"]) : new ApiconServiceRequestBundle();
            this.serviceVariantId = _data["serviceVariantId"];
            this.cacheGuid = _data["cacheGuid"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): GetCalculatedProductForExistingDealRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculatedProductForExistingDealRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["financingTypeId"] = this.financingTypeId;
        data["duration"] = this.duration;
        data["mileageId"] = this.mileageId;
        data["businessRelationshipId"] = this.businessRelationshipId;
        data["interestRateCalculationMethodId"] = this.interestRateCalculationMethodId;
        data["rateCategoryId"] = this.rateCategoryId;
        data["downpayment"] = this.downpayment;
        data["downPaymentPercent"] = this.downPaymentPercent;
        data["deposit"] = this.deposit;
        data["depositPercent"] = this.depositPercent;
        data["residualValueContractId"] = this.residualValueContractId;
        data["sourceOfFoundsId"] = this.sourceOfFoundsId;
        data["accountOwner"] = this.accountOwner;
        data["residualValueVehicleAbsolute"] = this.residualValueVehicleAbsolute;
        data["residualValueConversionOptions"] = this.residualValueConversionOptions;
        data["residualValuePercentage"] = this.residualValuePercentage;
        data["referencesDealId"] = this.referencesDealId;
        data["referencesCalculationId"] = this.referencesCalculationId;
        data["objectConfig"] = this.objectConfig ? this.objectConfig.toJSON() : <any>undefined;
        data["purchaseContractDate"] = this.purchaseContractDate ? this.purchaseContractDate.toISOString() : <any>undefined;
        data["specialOfferId"] = this.specialOfferId;
        data["selectedFuelServiceProductId"] = this.selectedFuelServiceProductId;
        data["ksvRating"] = this.ksvRating;
        data["hasGhgPremium"] = this.hasGhgPremium;
        data["salesAid"] = this.salesAid ? this.salesAid.toJSON() : <any>undefined;
        if (Array.isArray(this.agentOptions)) {
            data["agentOptions"] = [];
            for (let item of this.agentOptions)
                data["agentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.conversionOptions)) {
            data["conversionOptions"] = [];
            for (let item of this.conversionOptions)
                data["conversionOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.calculationFeatureValues)) {
            data["calculationFeatureValues"] = [];
            for (let item of this.calculationFeatureValues)
                data["calculationFeatureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        data["apiconServiceRequestBundle"] = this.apiconServiceRequestBundle ? this.apiconServiceRequestBundle.toJSON() : <any>undefined;
        data["serviceVariantId"] = this.serviceVariantId;
        data["cacheGuid"] = this.cacheGuid;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface IGetCalculatedProductForExistingDealRequest {
    dealId: number;
    calculationId?: number | undefined;
    financingTypeId: number;
    duration: number;
    mileageId: number;
    businessRelationshipId: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig: ObjectConfigurationRequest;
    purchaseContractDate?: Date | undefined;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    hasGhgPremium?: boolean | undefined;
    salesAid?: SalesAidView | undefined;
    agentOptions: AgentOption[];
    conversionOptions: ConversionOption[];
    calculationFeatureValues: FeatureValueWrapper[];
    dealFeatureValues: FeatureValueWrapper[];
    apiconServiceRequestBundle: ApiconServiceRequestBundle;
    serviceVariantId?: number | undefined;
    cacheGuid?: string | undefined;
    isBundle: boolean;
}

export class GetCalculatedProductRequest implements IGetCalculatedProductRequest {
    modelId!: number;
    dealTypeId!: number;
    vehicleTypeConditionId!: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice!: number;
    extrasPrice!: number;
    purchasePrice!: number;
    discountPercent?: number | undefined;
    discountInEuro!: number;
    numberOfVehicles!: number;
    vat!: number;
    modelPrototypeId?: number | undefined;
    isIncludeVat!: boolean;
    registrationDate?: Date | undefined;
    distributionChannel!: number;
    financingTypeId!: number;
    duration!: number;
    mileageId!: number;
    businessRelationshipId!: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig!: ObjectConfigurationRequest;
    apiconServiceRequestBundle!: ApiconServiceRequestBundle;
    purchaseContractDate?: Date | undefined;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    hasGhgPremium?: boolean | undefined;
    useCampaign!: boolean;
    salesAid?: SalesAidView | undefined;
    agentOptions!: AgentOption[];
    conversionOptions!: ConversionOption[];
    calculationFeatureValues!: FeatureValueWrapper[];
    dealFeatureValues!: FeatureValueWrapper[];
    isBundle!: boolean;

    constructor(data?: IGetCalculatedProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.objectConfig = new ObjectConfigurationRequest();
            this.apiconServiceRequestBundle = new ApiconServiceRequestBundle();
            this.agentOptions = [];
            this.conversionOptions = [];
            this.calculationFeatureValues = [];
            this.dealFeatureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.dealTypeId = _data["dealTypeId"];
            this.vehicleTypeConditionId = _data["vehicleTypeConditionId"];
            this.discountCategoryId = _data["discountCategoryId"];
            this.salesPersonId = _data["salesPersonId"];
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.vat = _data["vat"];
            this.modelPrototypeId = _data["modelPrototypeId"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.distributionChannel = _data["distributionChannel"];
            this.financingTypeId = _data["financingTypeId"];
            this.duration = _data["duration"];
            this.mileageId = _data["mileageId"];
            this.businessRelationshipId = _data["businessRelationshipId"];
            this.interestRateCalculationMethodId = _data["interestRateCalculationMethodId"];
            this.rateCategoryId = _data["rateCategoryId"];
            this.downpayment = _data["downpayment"];
            this.downPaymentPercent = _data["downPaymentPercent"];
            this.deposit = _data["deposit"];
            this.depositPercent = _data["depositPercent"];
            this.residualValueContractId = _data["residualValueContractId"];
            this.sourceOfFoundsId = _data["sourceOfFoundsId"];
            this.accountOwner = _data["accountOwner"];
            this.residualValueVehicleAbsolute = _data["residualValueVehicleAbsolute"];
            this.residualValueConversionOptions = _data["residualValueConversionOptions"];
            this.residualValuePercentage = _data["residualValuePercentage"];
            this.referencesDealId = _data["referencesDealId"];
            this.referencesCalculationId = _data["referencesCalculationId"];
            this.objectConfig = _data["objectConfig"] ? ObjectConfigurationRequest.fromJS(_data["objectConfig"]) : new ObjectConfigurationRequest();
            this.apiconServiceRequestBundle = _data["apiconServiceRequestBundle"] ? ApiconServiceRequestBundle.fromJS(_data["apiconServiceRequestBundle"]) : new ApiconServiceRequestBundle();
            this.purchaseContractDate = _data["purchaseContractDate"] ? new Date(_data["purchaseContractDate"].toString()) : <any>undefined;
            this.specialOfferId = _data["specialOfferId"];
            this.selectedFuelServiceProductId = _data["selectedFuelServiceProductId"];
            this.ksvRating = _data["ksvRating"];
            this.hasGhgPremium = _data["hasGhgPremium"];
            this.useCampaign = _data["useCampaign"];
            this.salesAid = _data["salesAid"] ? SalesAidView.fromJS(_data["salesAid"]) : <any>undefined;
            if (Array.isArray(_data["agentOptions"])) {
                this.agentOptions = [] as any;
                for (let item of _data["agentOptions"])
                    this.agentOptions!.push(AgentOption.fromJS(item));
            }
            if (Array.isArray(_data["conversionOptions"])) {
                this.conversionOptions = [] as any;
                for (let item of _data["conversionOptions"])
                    this.conversionOptions!.push(ConversionOption.fromJS(item));
            }
            if (Array.isArray(_data["calculationFeatureValues"])) {
                this.calculationFeatureValues = [] as any;
                for (let item of _data["calculationFeatureValues"])
                    this.calculationFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): GetCalculatedProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculatedProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["dealTypeId"] = this.dealTypeId;
        data["vehicleTypeConditionId"] = this.vehicleTypeConditionId;
        data["discountCategoryId"] = this.discountCategoryId;
        data["salesPersonId"] = this.salesPersonId;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["vat"] = this.vat;
        data["modelPrototypeId"] = this.modelPrototypeId;
        data["isIncludeVat"] = this.isIncludeVat;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["distributionChannel"] = this.distributionChannel;
        data["financingTypeId"] = this.financingTypeId;
        data["duration"] = this.duration;
        data["mileageId"] = this.mileageId;
        data["businessRelationshipId"] = this.businessRelationshipId;
        data["interestRateCalculationMethodId"] = this.interestRateCalculationMethodId;
        data["rateCategoryId"] = this.rateCategoryId;
        data["downpayment"] = this.downpayment;
        data["downPaymentPercent"] = this.downPaymentPercent;
        data["deposit"] = this.deposit;
        data["depositPercent"] = this.depositPercent;
        data["residualValueContractId"] = this.residualValueContractId;
        data["sourceOfFoundsId"] = this.sourceOfFoundsId;
        data["accountOwner"] = this.accountOwner;
        data["residualValueVehicleAbsolute"] = this.residualValueVehicleAbsolute;
        data["residualValueConversionOptions"] = this.residualValueConversionOptions;
        data["residualValuePercentage"] = this.residualValuePercentage;
        data["referencesDealId"] = this.referencesDealId;
        data["referencesCalculationId"] = this.referencesCalculationId;
        data["objectConfig"] = this.objectConfig ? this.objectConfig.toJSON() : <any>undefined;
        data["apiconServiceRequestBundle"] = this.apiconServiceRequestBundle ? this.apiconServiceRequestBundle.toJSON() : <any>undefined;
        data["purchaseContractDate"] = this.purchaseContractDate ? this.purchaseContractDate.toISOString() : <any>undefined;
        data["specialOfferId"] = this.specialOfferId;
        data["selectedFuelServiceProductId"] = this.selectedFuelServiceProductId;
        data["ksvRating"] = this.ksvRating;
        data["hasGhgPremium"] = this.hasGhgPremium;
        data["useCampaign"] = this.useCampaign;
        data["salesAid"] = this.salesAid ? this.salesAid.toJSON() : <any>undefined;
        if (Array.isArray(this.agentOptions)) {
            data["agentOptions"] = [];
            for (let item of this.agentOptions)
                data["agentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.conversionOptions)) {
            data["conversionOptions"] = [];
            for (let item of this.conversionOptions)
                data["conversionOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.calculationFeatureValues)) {
            data["calculationFeatureValues"] = [];
            for (let item of this.calculationFeatureValues)
                data["calculationFeatureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface IGetCalculatedProductRequest {
    modelId: number;
    dealTypeId: number;
    vehicleTypeConditionId: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice: number;
    extrasPrice: number;
    purchasePrice: number;
    discountPercent?: number | undefined;
    discountInEuro: number;
    numberOfVehicles: number;
    vat: number;
    modelPrototypeId?: number | undefined;
    isIncludeVat: boolean;
    registrationDate?: Date | undefined;
    distributionChannel: number;
    financingTypeId: number;
    duration: number;
    mileageId: number;
    businessRelationshipId: number;
    interestRateCalculationMethodId?: number | undefined;
    rateCategoryId?: number | undefined;
    downpayment?: number | undefined;
    downPaymentPercent?: number | undefined;
    deposit?: number | undefined;
    depositPercent?: number | undefined;
    residualValueContractId?: number | undefined;
    sourceOfFoundsId?: number | undefined;
    accountOwner?: string | undefined;
    residualValueVehicleAbsolute?: number | undefined;
    residualValueConversionOptions?: number | undefined;
    residualValuePercentage?: number | undefined;
    referencesDealId?: number | undefined;
    referencesCalculationId?: number | undefined;
    objectConfig: ObjectConfigurationRequest;
    apiconServiceRequestBundle: ApiconServiceRequestBundle;
    purchaseContractDate?: Date | undefined;
    specialOfferId?: number | undefined;
    selectedFuelServiceProductId?: number | undefined;
    ksvRating?: number | undefined;
    hasGhgPremium?: boolean | undefined;
    useCampaign: boolean;
    salesAid?: SalesAidView | undefined;
    agentOptions: AgentOption[];
    conversionOptions: ConversionOption[];
    calculationFeatureValues: FeatureValueWrapper[];
    dealFeatureValues: FeatureValueWrapper[];
    isBundle: boolean;
}

export class GetCalculationResponse implements IGetCalculationResponse {
    fundingProductOverView!: FundingProductView;
    calculatedProduct!: CalculatedProduct;
    dropdownCollection!: DropdownCollection;
    extendedConfiguration!: ExtendedConfiguration;
    objectConfiguration!: ObjectConfigurationResponse;
    agentOptions!: AgentOptionResponse[];
    conversionOptions!: ConversionOptionResponse[];
    serviceConfiguration!: ServiceConfigurationResponse;
    serviceResponse!: ApiconServiceBundle;
    isValid!: boolean;
    hasPermissionsToVote!: boolean;
    submissionStage?: number | undefined;
    salesAidLimitViolationVotingDate?: Date | undefined;
    featureValues!: FeatureValueView[];

    constructor(data?: IGetCalculationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fundingProductOverView = new FundingProductView();
            this.calculatedProduct = new CalculatedProduct();
            this.dropdownCollection = new DropdownCollection();
            this.extendedConfiguration = new ExtendedConfiguration();
            this.objectConfiguration = new ObjectConfigurationResponse();
            this.agentOptions = [];
            this.conversionOptions = [];
            this.serviceConfiguration = new ServiceConfigurationResponse();
            this.serviceResponse = new ApiconServiceBundle();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingProductOverView = _data["fundingProductOverView"] ? FundingProductView.fromJS(_data["fundingProductOverView"]) : new FundingProductView();
            this.calculatedProduct = _data["calculatedProduct"] ? CalculatedProduct.fromJS(_data["calculatedProduct"]) : new CalculatedProduct();
            this.dropdownCollection = _data["dropdownCollection"] ? DropdownCollection.fromJS(_data["dropdownCollection"]) : new DropdownCollection();
            this.extendedConfiguration = _data["extendedConfiguration"] ? ExtendedConfiguration.fromJS(_data["extendedConfiguration"]) : new ExtendedConfiguration();
            this.objectConfiguration = _data["objectConfiguration"] ? ObjectConfigurationResponse.fromJS(_data["objectConfiguration"]) : new ObjectConfigurationResponse();
            if (Array.isArray(_data["agentOptions"])) {
                this.agentOptions = [] as any;
                for (let item of _data["agentOptions"])
                    this.agentOptions!.push(AgentOptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["conversionOptions"])) {
                this.conversionOptions = [] as any;
                for (let item of _data["conversionOptions"])
                    this.conversionOptions!.push(ConversionOptionResponse.fromJS(item));
            }
            this.serviceConfiguration = _data["serviceConfiguration"] ? ServiceConfigurationResponse.fromJS(_data["serviceConfiguration"]) : new ServiceConfigurationResponse();
            this.serviceResponse = _data["serviceResponse"] ? ApiconServiceBundle.fromJS(_data["serviceResponse"]) : new ApiconServiceBundle();
            this.isValid = _data["isValid"];
            this.hasPermissionsToVote = _data["hasPermissionsToVote"];
            this.submissionStage = _data["submissionStage"];
            this.salesAidLimitViolationVotingDate = _data["salesAidLimitViolationVotingDate"] ? new Date(_data["salesAidLimitViolationVotingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(FeatureValueView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCalculationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingProductOverView"] = this.fundingProductOverView ? this.fundingProductOverView.toJSON() : <any>undefined;
        data["calculatedProduct"] = this.calculatedProduct ? this.calculatedProduct.toJSON() : <any>undefined;
        data["dropdownCollection"] = this.dropdownCollection ? this.dropdownCollection.toJSON() : <any>undefined;
        data["extendedConfiguration"] = this.extendedConfiguration ? this.extendedConfiguration.toJSON() : <any>undefined;
        data["objectConfiguration"] = this.objectConfiguration ? this.objectConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.agentOptions)) {
            data["agentOptions"] = [];
            for (let item of this.agentOptions)
                data["agentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.conversionOptions)) {
            data["conversionOptions"] = [];
            for (let item of this.conversionOptions)
                data["conversionOptions"].push(item.toJSON());
        }
        data["serviceConfiguration"] = this.serviceConfiguration ? this.serviceConfiguration.toJSON() : <any>undefined;
        data["serviceResponse"] = this.serviceResponse ? this.serviceResponse.toJSON() : <any>undefined;
        data["isValid"] = this.isValid;
        data["hasPermissionsToVote"] = this.hasPermissionsToVote;
        data["submissionStage"] = this.submissionStage;
        data["salesAidLimitViolationVotingDate"] = this.salesAidLimitViolationVotingDate ? this.salesAidLimitViolationVotingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetCalculationResponse {
    fundingProductOverView: FundingProductView;
    calculatedProduct: CalculatedProduct;
    dropdownCollection: DropdownCollection;
    extendedConfiguration: ExtendedConfiguration;
    objectConfiguration: ObjectConfigurationResponse;
    agentOptions: AgentOptionResponse[];
    conversionOptions: ConversionOptionResponse[];
    serviceConfiguration: ServiceConfigurationResponse;
    serviceResponse: ApiconServiceBundle;
    isValid: boolean;
    hasPermissionsToVote: boolean;
    submissionStage?: number | undefined;
    salesAidLimitViolationVotingDate?: Date | undefined;
    featureValues: FeatureValueView[];
}

export class GetCalculationResponseApiResult implements IGetCalculationResponseApiResult {
    messages!: ApiMessages;
    data!: GetCalculationResponse;

    constructor(data?: IGetCalculationResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetCalculationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetCalculationResponse.fromJS(_data["data"]) : new GetCalculationResponse();
        }
    }

    static fromJS(data: any): GetCalculationResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculationResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCalculationResponseApiResult {
    messages: ApiMessages;
    data: GetCalculationResponse;
}

export class GetCalculationResponseForReconsideredProduct implements IGetCalculationResponseForReconsideredProduct {
    fundingProductOverView!: FundingProductView;
    calculatedProduct!: CalculatedProduct;
    dropdownCollection!: DropdownCollection;
    extendedConfiguration!: ExtendedConfiguration;
    objectConfiguration!: ObjectConfigurationResponse;
    agentOptions!: AgentOptionResponse[];
    conversionOptions!: ConversionOptionResponse[];
    serviceConfiguration!: ServiceConfigurationResponse;
    serviceResponse!: ApiconServiceBundle;
    overtakenCustomerId?: number | undefined;
    previousCustomerId?: number | undefined;

    constructor(data?: IGetCalculationResponseForReconsideredProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fundingProductOverView = new FundingProductView();
            this.calculatedProduct = new CalculatedProduct();
            this.dropdownCollection = new DropdownCollection();
            this.extendedConfiguration = new ExtendedConfiguration();
            this.objectConfiguration = new ObjectConfigurationResponse();
            this.agentOptions = [];
            this.conversionOptions = [];
            this.serviceConfiguration = new ServiceConfigurationResponse();
            this.serviceResponse = new ApiconServiceBundle();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fundingProductOverView = _data["fundingProductOverView"] ? FundingProductView.fromJS(_data["fundingProductOverView"]) : new FundingProductView();
            this.calculatedProduct = _data["calculatedProduct"] ? CalculatedProduct.fromJS(_data["calculatedProduct"]) : new CalculatedProduct();
            this.dropdownCollection = _data["dropdownCollection"] ? DropdownCollection.fromJS(_data["dropdownCollection"]) : new DropdownCollection();
            this.extendedConfiguration = _data["extendedConfiguration"] ? ExtendedConfiguration.fromJS(_data["extendedConfiguration"]) : new ExtendedConfiguration();
            this.objectConfiguration = _data["objectConfiguration"] ? ObjectConfigurationResponse.fromJS(_data["objectConfiguration"]) : new ObjectConfigurationResponse();
            if (Array.isArray(_data["agentOptions"])) {
                this.agentOptions = [] as any;
                for (let item of _data["agentOptions"])
                    this.agentOptions!.push(AgentOptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["conversionOptions"])) {
                this.conversionOptions = [] as any;
                for (let item of _data["conversionOptions"])
                    this.conversionOptions!.push(ConversionOptionResponse.fromJS(item));
            }
            this.serviceConfiguration = _data["serviceConfiguration"] ? ServiceConfigurationResponse.fromJS(_data["serviceConfiguration"]) : new ServiceConfigurationResponse();
            this.serviceResponse = _data["serviceResponse"] ? ApiconServiceBundle.fromJS(_data["serviceResponse"]) : new ApiconServiceBundle();
            this.overtakenCustomerId = _data["overtakenCustomerId"];
            this.previousCustomerId = _data["previousCustomerId"];
        }
    }

    static fromJS(data: any): GetCalculationResponseForReconsideredProduct {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculationResponseForReconsideredProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fundingProductOverView"] = this.fundingProductOverView ? this.fundingProductOverView.toJSON() : <any>undefined;
        data["calculatedProduct"] = this.calculatedProduct ? this.calculatedProduct.toJSON() : <any>undefined;
        data["dropdownCollection"] = this.dropdownCollection ? this.dropdownCollection.toJSON() : <any>undefined;
        data["extendedConfiguration"] = this.extendedConfiguration ? this.extendedConfiguration.toJSON() : <any>undefined;
        data["objectConfiguration"] = this.objectConfiguration ? this.objectConfiguration.toJSON() : <any>undefined;
        if (Array.isArray(this.agentOptions)) {
            data["agentOptions"] = [];
            for (let item of this.agentOptions)
                data["agentOptions"].push(item.toJSON());
        }
        if (Array.isArray(this.conversionOptions)) {
            data["conversionOptions"] = [];
            for (let item of this.conversionOptions)
                data["conversionOptions"].push(item.toJSON());
        }
        data["serviceConfiguration"] = this.serviceConfiguration ? this.serviceConfiguration.toJSON() : <any>undefined;
        data["serviceResponse"] = this.serviceResponse ? this.serviceResponse.toJSON() : <any>undefined;
        data["overtakenCustomerId"] = this.overtakenCustomerId;
        data["previousCustomerId"] = this.previousCustomerId;
        return data;
    }
}

export interface IGetCalculationResponseForReconsideredProduct {
    fundingProductOverView: FundingProductView;
    calculatedProduct: CalculatedProduct;
    dropdownCollection: DropdownCollection;
    extendedConfiguration: ExtendedConfiguration;
    objectConfiguration: ObjectConfigurationResponse;
    agentOptions: AgentOptionResponse[];
    conversionOptions: ConversionOptionResponse[];
    serviceConfiguration: ServiceConfigurationResponse;
    serviceResponse: ApiconServiceBundle;
    overtakenCustomerId?: number | undefined;
    previousCustomerId?: number | undefined;
}

export class GetCalculationResponseForReconsideredProductApiResult implements IGetCalculationResponseForReconsideredProductApiResult {
    messages!: ApiMessages;
    data!: GetCalculationResponseForReconsideredProduct;

    constructor(data?: IGetCalculationResponseForReconsideredProductApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetCalculationResponseForReconsideredProduct();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetCalculationResponseForReconsideredProduct.fromJS(_data["data"]) : new GetCalculationResponseForReconsideredProduct();
        }
    }

    static fromJS(data: any): GetCalculationResponseForReconsideredProductApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCalculationResponseForReconsideredProductApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCalculationResponseForReconsideredProductApiResult {
    messages: ApiMessages;
    data: GetCalculationResponseForReconsideredProduct;
}

export class GetConfigurationValuesResponse implements IGetConfigurationValuesResponse {
    value!: string;

    constructor(data?: IGetConfigurationValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GetConfigurationValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigurationValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IGetConfigurationValuesResponse {
    value: string;
}

export class GetConfigurationValuesResponseApiResult implements IGetConfigurationValuesResponseApiResult {
    messages!: ApiMessages;
    data!: GetConfigurationValuesResponse;

    constructor(data?: IGetConfigurationValuesResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetConfigurationValuesResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetConfigurationValuesResponse.fromJS(_data["data"]) : new GetConfigurationValuesResponse();
        }
    }

    static fromJS(data: any): GetConfigurationValuesResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetConfigurationValuesResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetConfigurationValuesResponseApiResult {
    messages: ApiMessages;
    data: GetConfigurationValuesResponse;
}

export class GetCreditCheckResponse implements IGetCreditCheckResponse {
    financialCalculationId!: number;
    dealId!: number;
    termsheet?: string | undefined;
    providerId?: number | undefined;
    selectedEuriborDateId!: number;
    handoverDealerIdEnabled!: boolean;
    handoverDealerId?: number | undefined;
    commissionDealerId?: number | undefined;

    constructor(data?: IGetCreditCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialCalculationId = _data["financialCalculationId"];
            this.dealId = _data["dealId"];
            this.termsheet = _data["termsheet"];
            this.providerId = _data["providerId"];
            this.selectedEuriborDateId = _data["selectedEuriborDateId"];
            this.handoverDealerIdEnabled = _data["handoverDealerIdEnabled"];
            this.handoverDealerId = _data["handoverDealerId"];
            this.commissionDealerId = _data["commissionDealerId"];
        }
    }

    static fromJS(data: any): GetCreditCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreditCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialCalculationId"] = this.financialCalculationId;
        data["dealId"] = this.dealId;
        data["termsheet"] = this.termsheet;
        data["providerId"] = this.providerId;
        data["selectedEuriborDateId"] = this.selectedEuriborDateId;
        data["handoverDealerIdEnabled"] = this.handoverDealerIdEnabled;
        data["handoverDealerId"] = this.handoverDealerId;
        data["commissionDealerId"] = this.commissionDealerId;
        return data;
    }
}

export interface IGetCreditCheckResponse {
    financialCalculationId: number;
    dealId: number;
    termsheet?: string | undefined;
    providerId?: number | undefined;
    selectedEuriborDateId: number;
    handoverDealerIdEnabled: boolean;
    handoverDealerId?: number | undefined;
    commissionDealerId?: number | undefined;
}

export class GetCreditCheckResponseApiResult implements IGetCreditCheckResponseApiResult {
    messages!: ApiMessages;
    data!: GetCreditCheckResponse;

    constructor(data?: IGetCreditCheckResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetCreditCheckResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetCreditCheckResponse.fromJS(_data["data"]) : new GetCreditCheckResponse();
        }
    }

    static fromJS(data: any): GetCreditCheckResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetCreditCheckResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCreditCheckResponseApiResult {
    messages: ApiMessages;
    data: GetCreditCheckResponse;
}

export class GetDealResponse implements IGetDealResponse {
    vehicleTypeName!: string;
    vehicleConditionName!: string;
    modelName!: string;
    registrationDate?: Date | undefined;
    engineTypeName!: string;
    calculationBase!: number;
    coFinancedExtras?: number | undefined;
    purchasePrice!: number;
    listPriceIncludingExtras!: number;
    vatPercentage!: number;
    isIncludeVat!: boolean;
    listPrice!: number;
    extrasPrice!: number;
    dealTypeId!: number;
    discountCategoryId?: number | undefined;
    source?: string | undefined;
    modelId!: number;
    customerId?: number | undefined;
    hasSubmittedFinancingCalculations!: boolean;
    creationState?: number | undefined;
    isReadonly!: boolean;
    singleInsuranceId?: number | undefined;
    modelIsActive!: boolean;
    vehicleAgeIsValid!: boolean;
    chassisNumber?: string | undefined;
    amendsDealId?: number | undefined;
    amendedByDealId?: number | undefined;
    salesPersonId!: number;
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;
    isFleetAllowed!: boolean;
    isFleet!: boolean;
    replacedByFleetDealId?: number | undefined;
    useCampaign!: boolean;
    features!: FeatureValueView[];

    constructor(data?: IGetDealResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.features = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.vehicleConditionName = _data["vehicleConditionName"];
            this.modelName = _data["modelName"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.engineTypeName = _data["engineTypeName"];
            this.calculationBase = _data["calculationBase"];
            this.coFinancedExtras = _data["coFinancedExtras"];
            this.purchasePrice = _data["purchasePrice"];
            this.listPriceIncludingExtras = _data["listPriceIncludingExtras"];
            this.vatPercentage = _data["vatPercentage"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.dealTypeId = _data["dealTypeId"];
            this.discountCategoryId = _data["discountCategoryId"];
            this.source = _data["source"];
            this.modelId = _data["modelId"];
            this.customerId = _data["customerId"];
            this.hasSubmittedFinancingCalculations = _data["hasSubmittedFinancingCalculations"];
            this.creationState = _data["creationState"];
            this.isReadonly = _data["isReadonly"];
            this.singleInsuranceId = _data["singleInsuranceId"];
            this.modelIsActive = _data["modelIsActive"];
            this.vehicleAgeIsValid = _data["vehicleAgeIsValid"];
            this.chassisNumber = _data["chassisNumber"];
            this.amendsDealId = _data["amendsDealId"];
            this.amendedByDealId = _data["amendedByDealId"];
            this.salesPersonId = _data["salesPersonId"];
            this.ksvRating = _data["ksvRating"];
            this.roracUrl = _data["roracUrl"];
            this.isFleetAllowed = _data["isFleetAllowed"];
            this.isFleet = _data["isFleet"];
            this.replacedByFleetDealId = _data["replacedByFleetDealId"];
            this.useCampaign = _data["useCampaign"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FeatureValueView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDealResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDealResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["vehicleConditionName"] = this.vehicleConditionName;
        data["modelName"] = this.modelName;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["engineTypeName"] = this.engineTypeName;
        data["calculationBase"] = this.calculationBase;
        data["coFinancedExtras"] = this.coFinancedExtras;
        data["purchasePrice"] = this.purchasePrice;
        data["listPriceIncludingExtras"] = this.listPriceIncludingExtras;
        data["vatPercentage"] = this.vatPercentage;
        data["isIncludeVat"] = this.isIncludeVat;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["dealTypeId"] = this.dealTypeId;
        data["discountCategoryId"] = this.discountCategoryId;
        data["source"] = this.source;
        data["modelId"] = this.modelId;
        data["customerId"] = this.customerId;
        data["hasSubmittedFinancingCalculations"] = this.hasSubmittedFinancingCalculations;
        data["creationState"] = this.creationState;
        data["isReadonly"] = this.isReadonly;
        data["singleInsuranceId"] = this.singleInsuranceId;
        data["modelIsActive"] = this.modelIsActive;
        data["vehicleAgeIsValid"] = this.vehicleAgeIsValid;
        data["chassisNumber"] = this.chassisNumber;
        data["amendsDealId"] = this.amendsDealId;
        data["amendedByDealId"] = this.amendedByDealId;
        data["salesPersonId"] = this.salesPersonId;
        data["ksvRating"] = this.ksvRating;
        data["roracUrl"] = this.roracUrl;
        data["isFleetAllowed"] = this.isFleetAllowed;
        data["isFleet"] = this.isFleet;
        data["replacedByFleetDealId"] = this.replacedByFleetDealId;
        data["useCampaign"] = this.useCampaign;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDealResponse {
    vehicleTypeName: string;
    vehicleConditionName: string;
    modelName: string;
    registrationDate?: Date | undefined;
    engineTypeName: string;
    calculationBase: number;
    coFinancedExtras?: number | undefined;
    purchasePrice: number;
    listPriceIncludingExtras: number;
    vatPercentage: number;
    isIncludeVat: boolean;
    listPrice: number;
    extrasPrice: number;
    dealTypeId: number;
    discountCategoryId?: number | undefined;
    source?: string | undefined;
    modelId: number;
    customerId?: number | undefined;
    hasSubmittedFinancingCalculations: boolean;
    creationState?: number | undefined;
    isReadonly: boolean;
    singleInsuranceId?: number | undefined;
    modelIsActive: boolean;
    vehicleAgeIsValid: boolean;
    chassisNumber?: string | undefined;
    amendsDealId?: number | undefined;
    amendedByDealId?: number | undefined;
    salesPersonId: number;
    ksvRating?: number | undefined;
    roracUrl?: string | undefined;
    isFleetAllowed: boolean;
    isFleet: boolean;
    replacedByFleetDealId?: number | undefined;
    useCampaign: boolean;
    features: FeatureValueView[];
}

export class GetDealResponseApiResult implements IGetDealResponseApiResult {
    messages!: ApiMessages;
    data!: GetDealResponse;

    constructor(data?: IGetDealResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetDealResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetDealResponse.fromJS(_data["data"]) : new GetDealResponse();
        }
    }

    static fromJS(data: any): GetDealResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDealResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDealResponseApiResult {
    messages: ApiMessages;
    data: GetDealResponse;
}

export class GetDealSnapshotResponse implements IGetDealSnapshotResponse {
    deal!: DealSnapshotData;
    touchpoint?: TouchpointSnapshotData | undefined;
    model!: ModelSnapshotData;
    customer?: CustomerSnapshotData | undefined;
    coApplicants!: CoApplicantSnapshotData[];
    financingCalculations!: FinancingCalculationSnapshotData[];
    insuranceCalculations!: InsuranceCalculationSnapshotData[];
    vinAssignments!: VinAssignmentSnapshotData[];

    constructor(data?: IGetDealSnapshotResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.deal = new DealSnapshotData();
            this.model = new ModelSnapshotData();
            this.coApplicants = [];
            this.financingCalculations = [];
            this.insuranceCalculations = [];
            this.vinAssignments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deal = _data["deal"] ? DealSnapshotData.fromJS(_data["deal"]) : new DealSnapshotData();
            this.touchpoint = _data["touchpoint"] ? TouchpointSnapshotData.fromJS(_data["touchpoint"]) : <any>undefined;
            this.model = _data["model"] ? ModelSnapshotData.fromJS(_data["model"]) : new ModelSnapshotData();
            this.customer = _data["customer"] ? CustomerSnapshotData.fromJS(_data["customer"]) : <any>undefined;
            if (Array.isArray(_data["coApplicants"])) {
                this.coApplicants = [] as any;
                for (let item of _data["coApplicants"])
                    this.coApplicants!.push(CoApplicantSnapshotData.fromJS(item));
            }
            if (Array.isArray(_data["financingCalculations"])) {
                this.financingCalculations = [] as any;
                for (let item of _data["financingCalculations"])
                    this.financingCalculations!.push(FinancingCalculationSnapshotData.fromJS(item));
            }
            if (Array.isArray(_data["insuranceCalculations"])) {
                this.insuranceCalculations = [] as any;
                for (let item of _data["insuranceCalculations"])
                    this.insuranceCalculations!.push(InsuranceCalculationSnapshotData.fromJS(item));
            }
            if (Array.isArray(_data["vinAssignments"])) {
                this.vinAssignments = [] as any;
                for (let item of _data["vinAssignments"])
                    this.vinAssignments!.push(VinAssignmentSnapshotData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDealSnapshotResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDealSnapshotResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deal"] = this.deal ? this.deal.toJSON() : <any>undefined;
        data["touchpoint"] = this.touchpoint ? this.touchpoint.toJSON() : <any>undefined;
        data["model"] = this.model ? this.model.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.coApplicants)) {
            data["coApplicants"] = [];
            for (let item of this.coApplicants)
                data["coApplicants"].push(item.toJSON());
        }
        if (Array.isArray(this.financingCalculations)) {
            data["financingCalculations"] = [];
            for (let item of this.financingCalculations)
                data["financingCalculations"].push(item.toJSON());
        }
        if (Array.isArray(this.insuranceCalculations)) {
            data["insuranceCalculations"] = [];
            for (let item of this.insuranceCalculations)
                data["insuranceCalculations"].push(item.toJSON());
        }
        if (Array.isArray(this.vinAssignments)) {
            data["vinAssignments"] = [];
            for (let item of this.vinAssignments)
                data["vinAssignments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDealSnapshotResponse {
    deal: DealSnapshotData;
    touchpoint?: TouchpointSnapshotData | undefined;
    model: ModelSnapshotData;
    customer?: CustomerSnapshotData | undefined;
    coApplicants: CoApplicantSnapshotData[];
    financingCalculations: FinancingCalculationSnapshotData[];
    insuranceCalculations: InsuranceCalculationSnapshotData[];
    vinAssignments: VinAssignmentSnapshotData[];
}

export class GetDealSnapshotResponseApiResult implements IGetDealSnapshotResponseApiResult {
    messages!: ApiMessages;
    data!: GetDealSnapshotResponse;

    constructor(data?: IGetDealSnapshotResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetDealSnapshotResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetDealSnapshotResponse.fromJS(_data["data"]) : new GetDealSnapshotResponse();
        }
    }

    static fromJS(data: any): GetDealSnapshotResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDealSnapshotResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDealSnapshotResponseApiResult {
    messages: ApiMessages;
    data: GetDealSnapshotResponse;
}

export class GetDefaultFundingProductRequest implements IGetDefaultFundingProductRequest {
    modelId!: number;
    dealTypeId!: number;
    vehicleTypeConditionId!: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice!: number;
    extrasPrice!: number;
    purchasePrice!: number;
    discountPercent?: number | undefined;
    discountInEuro!: number;
    numberOfVehicles!: number;
    vat!: number;
    isIncludeVat!: boolean;
    modelPrototypeId?: number | undefined;
    registrationDate?: Date | undefined;
    distributionChannel!: number;
    useCampaign!: boolean;
    dealFeatureValues!: FeatureValueWrapper[];

    constructor(data?: IGetDefaultFundingProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dealFeatureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.dealTypeId = _data["dealTypeId"];
            this.vehicleTypeConditionId = _data["vehicleTypeConditionId"];
            this.discountCategoryId = _data["discountCategoryId"];
            this.salesPersonId = _data["salesPersonId"];
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.vat = _data["vat"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.modelPrototypeId = _data["modelPrototypeId"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.distributionChannel = _data["distributionChannel"];
            this.useCampaign = _data["useCampaign"];
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDefaultFundingProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultFundingProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["dealTypeId"] = this.dealTypeId;
        data["vehicleTypeConditionId"] = this.vehicleTypeConditionId;
        data["discountCategoryId"] = this.discountCategoryId;
        data["salesPersonId"] = this.salesPersonId;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["vat"] = this.vat;
        data["isIncludeVat"] = this.isIncludeVat;
        data["modelPrototypeId"] = this.modelPrototypeId;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["distributionChannel"] = this.distributionChannel;
        data["useCampaign"] = this.useCampaign;
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDefaultFundingProductRequest {
    modelId: number;
    dealTypeId: number;
    vehicleTypeConditionId: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice: number;
    extrasPrice: number;
    purchasePrice: number;
    discountPercent?: number | undefined;
    discountInEuro: number;
    numberOfVehicles: number;
    vat: number;
    isIncludeVat: boolean;
    modelPrototypeId?: number | undefined;
    registrationDate?: Date | undefined;
    distributionChannel: number;
    useCampaign: boolean;
    dealFeatureValues: FeatureValueWrapper[];
}

export class GetDetailResponse implements IGetDetailResponse {
    contractId!: number;
    dealReference!: string;
    dealId?: number | undefined;
    contract!: ContractDetail;
    disolve!: DisolveDetail;
    vehicle!: VehicleDetail;
    document!: DocumentDetail;
    configuration?: DashboardConfiguration | undefined;

    constructor(data?: IGetDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contract = new ContractDetail();
            this.disolve = new DisolveDetail();
            this.vehicle = new VehicleDetail();
            this.document = new DocumentDetail();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.dealReference = _data["dealReference"];
            this.dealId = _data["dealId"];
            this.contract = _data["contract"] ? ContractDetail.fromJS(_data["contract"]) : new ContractDetail();
            this.disolve = _data["disolve"] ? DisolveDetail.fromJS(_data["disolve"]) : new DisolveDetail();
            this.vehicle = _data["vehicle"] ? VehicleDetail.fromJS(_data["vehicle"]) : new VehicleDetail();
            this.document = _data["document"] ? DocumentDetail.fromJS(_data["document"]) : new DocumentDetail();
            this.configuration = _data["configuration"] ? DashboardConfiguration.fromJS(_data["configuration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["dealReference"] = this.dealReference;
        data["dealId"] = this.dealId;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["disolve"] = this.disolve ? this.disolve.toJSON() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDetailResponse {
    contractId: number;
    dealReference: string;
    dealId?: number | undefined;
    contract: ContractDetail;
    disolve: DisolveDetail;
    vehicle: VehicleDetail;
    document: DocumentDetail;
    configuration?: DashboardConfiguration | undefined;
}

export class GetDetailResponseApiResult implements IGetDetailResponseApiResult {
    messages!: ApiMessages;
    data!: GetDetailResponse;

    constructor(data?: IGetDetailResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetDetailResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetDetailResponse.fromJS(_data["data"]) : new GetDetailResponse();
        }
    }

    static fromJS(data: any): GetDetailResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetDetailResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetDetailResponseApiResult {
    messages: ApiMessages;
    data: GetDetailResponse;
}

export class GetInsuranceResponse implements IGetInsuranceResponse {
    id?: number | undefined;
    bmLevel?: number | undefined;
    enableBMLevel!: boolean;
    liability_BonusMalus_Internal_Id?: number | undefined;
    usageTypeId?: number | undefined;
    isPKW!: boolean;
    isCo2Required!: boolean;
    vehicleTypeId!: number;
    kw?: number | undefined;
    co2?: number | undefined;
    weight?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    paymentPeriodId!: number;
    paymentTypeId!: number;
    specialOfferId!: number;
    insuranceCompanySelectionEnabled!: boolean;
    enableLiability!: boolean;
    liabilityInsuranceCompanyId!: number;
    liabilityInsuranceId?: number | undefined;
    mayShowLegalProtectionInsurance!: boolean;
    enableLegalProtection!: boolean;
    mayShowAccidentInsurance!: boolean;
    enableAccident!: boolean;
    enableKasko!: boolean;
    kaskoInsuranceCompanyId?: number | undefined;
    kaskoInsuranceId?: number | undefined;
    kaskoAdditionalProductIds!: number[];
    inputTaxDeduction!: boolean;
    enableOmdsFields!: boolean;
    externalCalculationNumber!: string;
    externalCalculationInfo!: string;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    engineTax?: number | undefined;
    kaskoPrice?: number | undefined;
    liabilityPrice?: number | undefined;
    additionalProductsPremium!: number;
    totalPrice!: number;
    accidentPremium!: number;
    legalProtectionPremium!: number;
    commissionTotal?: number | undefined;
    removeCommission?: boolean | undefined;
    applicantId!: number;
    additionalApplicantId?: number | undefined;
    curbWeight?: number | undefined;
    isCurbWeightRequired!: boolean;
    isPrimary!: boolean;
    licenseHolders!: OptionItem[];
    limits!: InsuranceCalculationLimit;
    isMBCar!: boolean;

    constructor(data?: IGetInsuranceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kaskoAdditionalProductIds = [];
            this.licenseHolders = [];
            this.limits = new InsuranceCalculationLimit();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bmLevel = _data["bmLevel"];
            this.enableBMLevel = _data["enableBMLevel"];
            this.liability_BonusMalus_Internal_Id = _data["liability_BonusMalus_Internal_Id"];
            this.usageTypeId = _data["usageTypeId"];
            this.isPKW = _data["isPKW"];
            this.isCo2Required = _data["isCo2Required"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.kw = _data["kw"];
            this.co2 = _data["co2"];
            this.weight = _data["weight"];
            this.numberOfSeats = _data["numberOfSeats"];
            this.maxTotalWeight = _data["maxTotalWeight"];
            this.paymentPeriodId = _data["paymentPeriodId"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.specialOfferId = _data["specialOfferId"];
            this.insuranceCompanySelectionEnabled = _data["insuranceCompanySelectionEnabled"];
            this.enableLiability = _data["enableLiability"];
            this.liabilityInsuranceCompanyId = _data["liabilityInsuranceCompanyId"];
            this.liabilityInsuranceId = _data["liabilityInsuranceId"];
            this.mayShowLegalProtectionInsurance = _data["mayShowLegalProtectionInsurance"];
            this.enableLegalProtection = _data["enableLegalProtection"];
            this.mayShowAccidentInsurance = _data["mayShowAccidentInsurance"];
            this.enableAccident = _data["enableAccident"];
            this.enableKasko = _data["enableKasko"];
            this.kaskoInsuranceCompanyId = _data["kaskoInsuranceCompanyId"];
            this.kaskoInsuranceId = _data["kaskoInsuranceId"];
            if (Array.isArray(_data["kaskoAdditionalProductIds"])) {
                this.kaskoAdditionalProductIds = [] as any;
                for (let item of _data["kaskoAdditionalProductIds"])
                    this.kaskoAdditionalProductIds!.push(item);
            }
            this.inputTaxDeduction = _data["inputTaxDeduction"];
            this.enableOmdsFields = _data["enableOmdsFields"];
            this.externalCalculationNumber = _data["externalCalculationNumber"];
            this.externalCalculationInfo = _data["externalCalculationInfo"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
            this.engineTax = _data["engineTax"];
            this.kaskoPrice = _data["kaskoPrice"];
            this.liabilityPrice = _data["liabilityPrice"];
            this.additionalProductsPremium = _data["additionalProductsPremium"];
            this.totalPrice = _data["totalPrice"];
            this.accidentPremium = _data["accidentPremium"];
            this.legalProtectionPremium = _data["legalProtectionPremium"];
            this.commissionTotal = _data["commissionTotal"];
            this.removeCommission = _data["removeCommission"];
            this.applicantId = _data["applicantId"];
            this.additionalApplicantId = _data["additionalApplicantId"];
            this.curbWeight = _data["curbWeight"];
            this.isCurbWeightRequired = _data["isCurbWeightRequired"];
            this.isPrimary = _data["isPrimary"];
            if (Array.isArray(_data["licenseHolders"])) {
                this.licenseHolders = [] as any;
                for (let item of _data["licenseHolders"])
                    this.licenseHolders!.push(OptionItem.fromJS(item));
            }
            this.limits = _data["limits"] ? InsuranceCalculationLimit.fromJS(_data["limits"]) : new InsuranceCalculationLimit();
            this.isMBCar = _data["isMBCar"];
        }
    }

    static fromJS(data: any): GetInsuranceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsuranceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bmLevel"] = this.bmLevel;
        data["enableBMLevel"] = this.enableBMLevel;
        data["liability_BonusMalus_Internal_Id"] = this.liability_BonusMalus_Internal_Id;
        data["usageTypeId"] = this.usageTypeId;
        data["isPKW"] = this.isPKW;
        data["isCo2Required"] = this.isCo2Required;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["kw"] = this.kw;
        data["co2"] = this.co2;
        data["weight"] = this.weight;
        data["numberOfSeats"] = this.numberOfSeats;
        data["maxTotalWeight"] = this.maxTotalWeight;
        data["paymentPeriodId"] = this.paymentPeriodId;
        data["paymentTypeId"] = this.paymentTypeId;
        data["specialOfferId"] = this.specialOfferId;
        data["insuranceCompanySelectionEnabled"] = this.insuranceCompanySelectionEnabled;
        data["enableLiability"] = this.enableLiability;
        data["liabilityInsuranceCompanyId"] = this.liabilityInsuranceCompanyId;
        data["liabilityInsuranceId"] = this.liabilityInsuranceId;
        data["mayShowLegalProtectionInsurance"] = this.mayShowLegalProtectionInsurance;
        data["enableLegalProtection"] = this.enableLegalProtection;
        data["mayShowAccidentInsurance"] = this.mayShowAccidentInsurance;
        data["enableAccident"] = this.enableAccident;
        data["enableKasko"] = this.enableKasko;
        data["kaskoInsuranceCompanyId"] = this.kaskoInsuranceCompanyId;
        data["kaskoInsuranceId"] = this.kaskoInsuranceId;
        if (Array.isArray(this.kaskoAdditionalProductIds)) {
            data["kaskoAdditionalProductIds"] = [];
            for (let item of this.kaskoAdditionalProductIds)
                data["kaskoAdditionalProductIds"].push(item);
        }
        data["inputTaxDeduction"] = this.inputTaxDeduction;
        data["enableOmdsFields"] = this.enableOmdsFields;
        data["externalCalculationNumber"] = this.externalCalculationNumber;
        data["externalCalculationInfo"] = this.externalCalculationInfo;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        data["engineTax"] = this.engineTax;
        data["kaskoPrice"] = this.kaskoPrice;
        data["liabilityPrice"] = this.liabilityPrice;
        data["additionalProductsPremium"] = this.additionalProductsPremium;
        data["totalPrice"] = this.totalPrice;
        data["accidentPremium"] = this.accidentPremium;
        data["legalProtectionPremium"] = this.legalProtectionPremium;
        data["commissionTotal"] = this.commissionTotal;
        data["removeCommission"] = this.removeCommission;
        data["applicantId"] = this.applicantId;
        data["additionalApplicantId"] = this.additionalApplicantId;
        data["curbWeight"] = this.curbWeight;
        data["isCurbWeightRequired"] = this.isCurbWeightRequired;
        data["isPrimary"] = this.isPrimary;
        if (Array.isArray(this.licenseHolders)) {
            data["licenseHolders"] = [];
            for (let item of this.licenseHolders)
                data["licenseHolders"].push(item.toJSON());
        }
        data["limits"] = this.limits ? this.limits.toJSON() : <any>undefined;
        data["isMBCar"] = this.isMBCar;
        return data;
    }
}

export interface IGetInsuranceResponse {
    id?: number | undefined;
    bmLevel?: number | undefined;
    enableBMLevel: boolean;
    liability_BonusMalus_Internal_Id?: number | undefined;
    usageTypeId?: number | undefined;
    isPKW: boolean;
    isCo2Required: boolean;
    vehicleTypeId: number;
    kw?: number | undefined;
    co2?: number | undefined;
    weight?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    paymentPeriodId: number;
    paymentTypeId: number;
    specialOfferId: number;
    insuranceCompanySelectionEnabled: boolean;
    enableLiability: boolean;
    liabilityInsuranceCompanyId: number;
    liabilityInsuranceId?: number | undefined;
    mayShowLegalProtectionInsurance: boolean;
    enableLegalProtection: boolean;
    mayShowAccidentInsurance: boolean;
    enableAccident: boolean;
    enableKasko: boolean;
    kaskoInsuranceCompanyId?: number | undefined;
    kaskoInsuranceId?: number | undefined;
    kaskoAdditionalProductIds: number[];
    inputTaxDeduction: boolean;
    enableOmdsFields: boolean;
    externalCalculationNumber: string;
    externalCalculationInfo: string;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    engineTax?: number | undefined;
    kaskoPrice?: number | undefined;
    liabilityPrice?: number | undefined;
    additionalProductsPremium: number;
    totalPrice: number;
    accidentPremium: number;
    legalProtectionPremium: number;
    commissionTotal?: number | undefined;
    removeCommission?: boolean | undefined;
    applicantId: number;
    additionalApplicantId?: number | undefined;
    curbWeight?: number | undefined;
    isCurbWeightRequired: boolean;
    isPrimary: boolean;
    licenseHolders: OptionItem[];
    limits: InsuranceCalculationLimit;
    isMBCar: boolean;
}

export class GetInsuranceResponseApiResult implements IGetInsuranceResponseApiResult {
    messages!: ApiMessages;
    data!: GetInsuranceResponse;

    constructor(data?: IGetInsuranceResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetInsuranceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetInsuranceResponse.fromJS(_data["data"]) : new GetInsuranceResponse();
        }
    }

    static fromJS(data: any): GetInsuranceResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsuranceResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetInsuranceResponseApiResult {
    messages: ApiMessages;
    data: GetInsuranceResponse;
}

export class GetInsuranceSpecialOffersResponse implements IGetInsuranceSpecialOffersResponse {
    id!: number;
    name!: string;
    validFrom!: Date;
    validTo?: Date | undefined;
    instructionalText!: string;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;

    constructor(data?: IGetInsuranceSpecialOffersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.instructionalText = _data["instructionalText"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
        }
    }

    static fromJS(data: any): GetInsuranceSpecialOffersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsuranceSpecialOffersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["instructionalText"] = this.instructionalText;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        return data;
    }
}

export interface IGetInsuranceSpecialOffersResponse {
    id: number;
    name: string;
    validFrom: Date;
    validTo?: Date | undefined;
    instructionalText: string;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
}

export class GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult implements IGetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: GetInsuranceSpecialOffersResponse[];

    constructor(data?: IGetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GetInsuranceSpecialOffersResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInsuranceSpecialOffersResponseIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: GetInsuranceSpecialOffersResponse[];
}

export class GetMatchingCampaignResponse implements IGetMatchingCampaignResponse {
    dealId!: number;
    useCampaign!: boolean;
    calculations!: CalculationMatchOverview[];

    constructor(data?: IGetMatchingCampaignResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.calculations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.useCampaign = _data["useCampaign"];
            if (Array.isArray(_data["calculations"])) {
                this.calculations = [] as any;
                for (let item of _data["calculations"])
                    this.calculations!.push(CalculationMatchOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMatchingCampaignResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchingCampaignResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["useCampaign"] = this.useCampaign;
        if (Array.isArray(this.calculations)) {
            data["calculations"] = [];
            for (let item of this.calculations)
                data["calculations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMatchingCampaignResponse {
    dealId: number;
    useCampaign: boolean;
    calculations: CalculationMatchOverview[];
}

export class GetMatchingCampaignResponseApiResult implements IGetMatchingCampaignResponseApiResult {
    messages!: ApiMessages;
    data!: GetMatchingCampaignResponse;

    constructor(data?: IGetMatchingCampaignResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetMatchingCampaignResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetMatchingCampaignResponse.fromJS(_data["data"]) : new GetMatchingCampaignResponse();
        }
    }

    static fromJS(data: any): GetMatchingCampaignResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchingCampaignResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetMatchingCampaignResponseApiResult {
    messages: ApiMessages;
    data: GetMatchingCampaignResponse;
}

export class GetModelDataResponse implements IGetModelDataResponse {
    modelData!: ModelData;

    constructor(data?: IGetModelDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.modelData = new ModelData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelData = _data["modelData"] ? ModelData.fromJS(_data["modelData"]) : new ModelData();
        }
    }

    static fromJS(data: any): GetModelDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelData"] = this.modelData ? this.modelData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetModelDataResponse {
    modelData: ModelData;
}

export class GetModelDataResponseApiResult implements IGetModelDataResponseApiResult {
    messages!: ApiMessages;
    data!: GetModelDataResponse;

    constructor(data?: IGetModelDataResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetModelDataResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetModelDataResponse.fromJS(_data["data"]) : new GetModelDataResponse();
        }
    }

    static fromJS(data: any): GetModelDataResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetModelDataResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetModelDataResponseApiResult {
    messages: ApiMessages;
    data: GetModelDataResponse;
}

export class GetPossibleFleetResponse implements IGetPossibleFleetResponse {
    source!: FleetEntry;
    possibleEntries!: FleetEntry[];

    constructor(data?: IGetPossibleFleetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.source = new FleetEntry();
            this.possibleEntries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] ? FleetEntry.fromJS(_data["source"]) : new FleetEntry();
            if (Array.isArray(_data["possibleEntries"])) {
                this.possibleEntries = [] as any;
                for (let item of _data["possibleEntries"])
                    this.possibleEntries!.push(FleetEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPossibleFleetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPossibleFleetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.possibleEntries)) {
            data["possibleEntries"] = [];
            for (let item of this.possibleEntries)
                data["possibleEntries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPossibleFleetResponse {
    source: FleetEntry;
    possibleEntries: FleetEntry[];
}

export class GetPossibleFleetResponseApiResult implements IGetPossibleFleetResponseApiResult {
    messages!: ApiMessages;
    data!: GetPossibleFleetResponse;

    constructor(data?: IGetPossibleFleetResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetPossibleFleetResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetPossibleFleetResponse.fromJS(_data["data"]) : new GetPossibleFleetResponse();
        }
    }

    static fromJS(data: any): GetPossibleFleetResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPossibleFleetResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPossibleFleetResponseApiResult {
    messages: ApiMessages;
    data: GetPossibleFleetResponse;
}

export class GetPredefinedValuesResponse implements IGetPredefinedValuesResponse {
    distributionChannel!: number;
    isIncludeVat!: boolean;
    showDemonstrationCarMessage!: boolean;
    isDistributionChannelEditable!: boolean;

    constructor(data?: IGetPredefinedValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distributionChannel = _data["distributionChannel"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.showDemonstrationCarMessage = _data["showDemonstrationCarMessage"];
            this.isDistributionChannelEditable = _data["isDistributionChannelEditable"];
        }
    }

    static fromJS(data: any): GetPredefinedValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distributionChannel"] = this.distributionChannel;
        data["isIncludeVat"] = this.isIncludeVat;
        data["showDemonstrationCarMessage"] = this.showDemonstrationCarMessage;
        data["isDistributionChannelEditable"] = this.isDistributionChannelEditable;
        return data;
    }
}

export interface IGetPredefinedValuesResponse {
    distributionChannel: number;
    isIncludeVat: boolean;
    showDemonstrationCarMessage: boolean;
    isDistributionChannelEditable: boolean;
}

export class GetPredefinedValuesResponseApiResult implements IGetPredefinedValuesResponseApiResult {
    messages!: ApiMessages;
    data!: GetPredefinedValuesResponse;

    constructor(data?: IGetPredefinedValuesResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetPredefinedValuesResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetPredefinedValuesResponse.fromJS(_data["data"]) : new GetPredefinedValuesResponse();
        }
    }

    static fromJS(data: any): GetPredefinedValuesResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPredefinedValuesResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPredefinedValuesResponseApiResult {
    messages: ApiMessages;
    data: GetPredefinedValuesResponse;
}

export class GetPreselectedDealerResponse implements IGetPreselectedDealerResponse {
    preselectedDealerId?: number | undefined;

    constructor(data?: IGetPreselectedDealerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preselectedDealerId = _data["preselectedDealerId"];
        }
    }

    static fromJS(data: any): GetPreselectedDealerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreselectedDealerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preselectedDealerId"] = this.preselectedDealerId;
        return data;
    }
}

export interface IGetPreselectedDealerResponse {
    preselectedDealerId?: number | undefined;
}

export class GetPreselectedDealerResponseApiResult implements IGetPreselectedDealerResponseApiResult {
    messages!: ApiMessages;
    data!: GetPreselectedDealerResponse;

    constructor(data?: IGetPreselectedDealerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetPreselectedDealerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetPreselectedDealerResponse.fromJS(_data["data"]) : new GetPreselectedDealerResponse();
        }
    }

    static fromJS(data: any): GetPreselectedDealerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreselectedDealerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPreselectedDealerResponseApiResult {
    messages: ApiMessages;
    data: GetPreselectedDealerResponse;
}

export class GetPrintFinancialCalculationDocumentsResponse implements IGetPrintFinancialCalculationDocumentsResponse {
    euriborDatesEnabled!: boolean;
    /** Euribor Datum */
    selectedEuriborId!: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    hasViewPrintDetailsPermission!: boolean;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross!: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross!: boolean;
    /** Fahrzeug mit Umsatzsteuerausweis drucken? */
    isFlexPurchase!: boolean;
    /** Kontodaten verweden von? */
    hasMultipleAccounts!: boolean;
    /** Angebots-Dokumente */
    offerDocuments!: DocumentDefinition[];
    /** Einreichblatt-Dokumente */
    termsheetDocuments!: DocumentDefinition[];
    /** Vertrags-Dokumente */
    contractDocuments!: DocumentDefinition[];
    /** Sonstige-Dokumente */
    miscellaneousDocuments!: DocumentDefinition[];
    /** Kunden-Dokumente */
    customerDocuments!: DocumentDefinition[];
    /** Ob der Kunde seine Email Addresse hinterlegt hat */
    hasCustomerEmail!: boolean;

    constructor(data?: IGetPrintFinancialCalculationDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.offerDocuments = [];
            this.termsheetDocuments = [];
            this.contractDocuments = [];
            this.miscellaneousDocuments = [];
            this.customerDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.euriborDatesEnabled = _data["euriborDatesEnabled"];
            this.selectedEuriborId = _data["selectedEuriborId"];
            this.termsheet = _data["termsheet"];
            this.hasViewPrintDetailsPermission = _data["hasViewPrintDetailsPermission"];
            this.leasingContractNotes = _data["leasingContractNotes"];
            this.offerSupplement = _data["offerSupplement"];
            this.calculationGross = _data["calculationGross"];
            this.termsheetCalculationGross = _data["termsheetCalculationGross"];
            this.isFlexPurchase = _data["isFlexPurchase"];
            this.hasMultipleAccounts = _data["hasMultipleAccounts"];
            if (Array.isArray(_data["offerDocuments"])) {
                this.offerDocuments = [] as any;
                for (let item of _data["offerDocuments"])
                    this.offerDocuments!.push(DocumentDefinition.fromJS(item));
            }
            if (Array.isArray(_data["termsheetDocuments"])) {
                this.termsheetDocuments = [] as any;
                for (let item of _data["termsheetDocuments"])
                    this.termsheetDocuments!.push(DocumentDefinition.fromJS(item));
            }
            if (Array.isArray(_data["contractDocuments"])) {
                this.contractDocuments = [] as any;
                for (let item of _data["contractDocuments"])
                    this.contractDocuments!.push(DocumentDefinition.fromJS(item));
            }
            if (Array.isArray(_data["miscellaneousDocuments"])) {
                this.miscellaneousDocuments = [] as any;
                for (let item of _data["miscellaneousDocuments"])
                    this.miscellaneousDocuments!.push(DocumentDefinition.fromJS(item));
            }
            if (Array.isArray(_data["customerDocuments"])) {
                this.customerDocuments = [] as any;
                for (let item of _data["customerDocuments"])
                    this.customerDocuments!.push(DocumentDefinition.fromJS(item));
            }
            this.hasCustomerEmail = _data["hasCustomerEmail"];
        }
    }

    static fromJS(data: any): GetPrintFinancialCalculationDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintFinancialCalculationDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["euriborDatesEnabled"] = this.euriborDatesEnabled;
        data["selectedEuriborId"] = this.selectedEuriborId;
        data["termsheet"] = this.termsheet;
        data["hasViewPrintDetailsPermission"] = this.hasViewPrintDetailsPermission;
        data["leasingContractNotes"] = this.leasingContractNotes;
        data["offerSupplement"] = this.offerSupplement;
        data["calculationGross"] = this.calculationGross;
        data["termsheetCalculationGross"] = this.termsheetCalculationGross;
        data["isFlexPurchase"] = this.isFlexPurchase;
        data["hasMultipleAccounts"] = this.hasMultipleAccounts;
        if (Array.isArray(this.offerDocuments)) {
            data["offerDocuments"] = [];
            for (let item of this.offerDocuments)
                data["offerDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.termsheetDocuments)) {
            data["termsheetDocuments"] = [];
            for (let item of this.termsheetDocuments)
                data["termsheetDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.contractDocuments)) {
            data["contractDocuments"] = [];
            for (let item of this.contractDocuments)
                data["contractDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.miscellaneousDocuments)) {
            data["miscellaneousDocuments"] = [];
            for (let item of this.miscellaneousDocuments)
                data["miscellaneousDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.customerDocuments)) {
            data["customerDocuments"] = [];
            for (let item of this.customerDocuments)
                data["customerDocuments"].push(item.toJSON());
        }
        data["hasCustomerEmail"] = this.hasCustomerEmail;
        return data;
    }
}

export interface IGetPrintFinancialCalculationDocumentsResponse {
    euriborDatesEnabled: boolean;
    /** Euribor Datum */
    selectedEuriborId: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    hasViewPrintDetailsPermission: boolean;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross: boolean;
    /** Fahrzeug mit Umsatzsteuerausweis drucken? */
    isFlexPurchase: boolean;
    /** Kontodaten verweden von? */
    hasMultipleAccounts: boolean;
    /** Angebots-Dokumente */
    offerDocuments: DocumentDefinition[];
    /** Einreichblatt-Dokumente */
    termsheetDocuments: DocumentDefinition[];
    /** Vertrags-Dokumente */
    contractDocuments: DocumentDefinition[];
    /** Sonstige-Dokumente */
    miscellaneousDocuments: DocumentDefinition[];
    /** Kunden-Dokumente */
    customerDocuments: DocumentDefinition[];
    /** Ob der Kunde seine Email Addresse hinterlegt hat */
    hasCustomerEmail: boolean;
}

export class GetPrintFinancialCalculationDocumentsResponseApiResult implements IGetPrintFinancialCalculationDocumentsResponseApiResult {
    messages!: ApiMessages;
    data!: GetPrintFinancialCalculationDocumentsResponse;

    constructor(data?: IGetPrintFinancialCalculationDocumentsResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetPrintFinancialCalculationDocumentsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetPrintFinancialCalculationDocumentsResponse.fromJS(_data["data"]) : new GetPrintFinancialCalculationDocumentsResponse();
        }
    }

    static fromJS(data: any): GetPrintFinancialCalculationDocumentsResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintFinancialCalculationDocumentsResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPrintFinancialCalculationDocumentsResponseApiResult {
    messages: ApiMessages;
    data: GetPrintFinancialCalculationDocumentsResponse;
}

export class GetPrintInsuranceDocumentsResponse implements IGetPrintInsuranceDocumentsResponse {
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired!: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Kontodaten verweden von? */
    hasMultipleAccounts!: boolean;
    /** Versicherungs-Dokumente */
    insuranceDocuments!: DocumentDefinition[];
    /** Kunden-Dokumente */
    customerDocuments!: DocumentDefinition[];
    /** Ob der Kunde seine Email Addresse hinterlegt hat */
    hasCustomerEmail!: boolean;

    constructor(data?: IGetPrintInsuranceDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.insuranceDocuments = [];
            this.customerDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offerSupplement = _data["offerSupplement"];
            this.previousInsuranceInfoRequired = _data["previousInsuranceInfoRequired"];
            this.previousInsuranceCompanyName = _data["previousInsuranceCompanyName"];
            this.previousTerminateContract = _data["previousTerminateContract"];
            this.previousContractNumber = _data["previousContractNumber"];
            this.previousLicensePlate = _data["previousLicensePlate"];
            this.previousContractTypeId = _data["previousContractTypeId"];
            this.waiverOfBonus = _data["waiverOfBonus"];
            this.hasMultipleAccounts = _data["hasMultipleAccounts"];
            if (Array.isArray(_data["insuranceDocuments"])) {
                this.insuranceDocuments = [] as any;
                for (let item of _data["insuranceDocuments"])
                    this.insuranceDocuments!.push(DocumentDefinition.fromJS(item));
            }
            if (Array.isArray(_data["customerDocuments"])) {
                this.customerDocuments = [] as any;
                for (let item of _data["customerDocuments"])
                    this.customerDocuments!.push(DocumentDefinition.fromJS(item));
            }
            this.hasCustomerEmail = _data["hasCustomerEmail"];
        }
    }

    static fromJS(data: any): GetPrintInsuranceDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintInsuranceDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offerSupplement"] = this.offerSupplement;
        data["previousInsuranceInfoRequired"] = this.previousInsuranceInfoRequired;
        data["previousInsuranceCompanyName"] = this.previousInsuranceCompanyName;
        data["previousTerminateContract"] = this.previousTerminateContract;
        data["previousContractNumber"] = this.previousContractNumber;
        data["previousLicensePlate"] = this.previousLicensePlate;
        data["previousContractTypeId"] = this.previousContractTypeId;
        data["waiverOfBonus"] = this.waiverOfBonus;
        data["hasMultipleAccounts"] = this.hasMultipleAccounts;
        if (Array.isArray(this.insuranceDocuments)) {
            data["insuranceDocuments"] = [];
            for (let item of this.insuranceDocuments)
                data["insuranceDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.customerDocuments)) {
            data["customerDocuments"] = [];
            for (let item of this.customerDocuments)
                data["customerDocuments"].push(item.toJSON());
        }
        data["hasCustomerEmail"] = this.hasCustomerEmail;
        return data;
    }
}

export interface IGetPrintInsuranceDocumentsResponse {
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Kontodaten verweden von? */
    hasMultipleAccounts: boolean;
    /** Versicherungs-Dokumente */
    insuranceDocuments: DocumentDefinition[];
    /** Kunden-Dokumente */
    customerDocuments: DocumentDefinition[];
    /** Ob der Kunde seine Email Addresse hinterlegt hat */
    hasCustomerEmail: boolean;
}

export class GetPrintInsuranceDocumentsResponseApiResult implements IGetPrintInsuranceDocumentsResponseApiResult {
    messages!: ApiMessages;
    data!: GetPrintInsuranceDocumentsResponse;

    constructor(data?: IGetPrintInsuranceDocumentsResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetPrintInsuranceDocumentsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetPrintInsuranceDocumentsResponse.fromJS(_data["data"]) : new GetPrintInsuranceDocumentsResponse();
        }
    }

    static fromJS(data: any): GetPrintInsuranceDocumentsResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrintInsuranceDocumentsResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPrintInsuranceDocumentsResponseApiResult {
    messages: ApiMessages;
    data: GetPrintInsuranceDocumentsResponse;
}

export class GetReconsideratedFundingProductRequest implements IGetReconsideratedFundingProductRequest {
    modelId!: number;
    dealTypeId!: number;
    vehicleTypeConditionId!: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice!: number;
    extrasPrice!: number;
    purchasePrice!: number;
    discountPercent?: number | undefined;
    discountInEuro!: number;
    numberOfVehicles!: number;
    vat!: number;
    isIncludeVat!: boolean;
    registrationDate?: Date | undefined;
    distributionChannel!: number;
    referencesDealId?: number | undefined;
    overtakeCustomer?: boolean | undefined;
    modelPrototypeId?: number | undefined;
    previousCalculation?: DealCalculation | undefined;
    useCampaign!: boolean;
    dealFeatureValues!: FeatureValueWrapper[];

    constructor(data?: IGetReconsideratedFundingProductRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dealFeatureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.dealTypeId = _data["dealTypeId"];
            this.vehicleTypeConditionId = _data["vehicleTypeConditionId"];
            this.discountCategoryId = _data["discountCategoryId"];
            this.salesPersonId = _data["salesPersonId"];
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.purchasePrice = _data["purchasePrice"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.numberOfVehicles = _data["numberOfVehicles"];
            this.vat = _data["vat"];
            this.isIncludeVat = _data["isIncludeVat"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.distributionChannel = _data["distributionChannel"];
            this.referencesDealId = _data["referencesDealId"];
            this.overtakeCustomer = _data["overtakeCustomer"];
            this.modelPrototypeId = _data["modelPrototypeId"];
            this.previousCalculation = _data["previousCalculation"] ? DealCalculation.fromJS(_data["previousCalculation"]) : <any>undefined;
            this.useCampaign = _data["useCampaign"];
            if (Array.isArray(_data["dealFeatureValues"])) {
                this.dealFeatureValues = [] as any;
                for (let item of _data["dealFeatureValues"])
                    this.dealFeatureValues!.push(FeatureValueWrapper.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetReconsideratedFundingProductRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReconsideratedFundingProductRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["dealTypeId"] = this.dealTypeId;
        data["vehicleTypeConditionId"] = this.vehicleTypeConditionId;
        data["discountCategoryId"] = this.discountCategoryId;
        data["salesPersonId"] = this.salesPersonId;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["purchasePrice"] = this.purchasePrice;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["numberOfVehicles"] = this.numberOfVehicles;
        data["vat"] = this.vat;
        data["isIncludeVat"] = this.isIncludeVat;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["distributionChannel"] = this.distributionChannel;
        data["referencesDealId"] = this.referencesDealId;
        data["overtakeCustomer"] = this.overtakeCustomer;
        data["modelPrototypeId"] = this.modelPrototypeId;
        data["previousCalculation"] = this.previousCalculation ? this.previousCalculation.toJSON() : <any>undefined;
        data["useCampaign"] = this.useCampaign;
        if (Array.isArray(this.dealFeatureValues)) {
            data["dealFeatureValues"] = [];
            for (let item of this.dealFeatureValues)
                data["dealFeatureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetReconsideratedFundingProductRequest {
    modelId: number;
    dealTypeId: number;
    vehicleTypeConditionId: number;
    discountCategoryId?: number | undefined;
    salesPersonId?: number | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
    listPrice: number;
    extrasPrice: number;
    purchasePrice: number;
    discountPercent?: number | undefined;
    discountInEuro: number;
    numberOfVehicles: number;
    vat: number;
    isIncludeVat: boolean;
    registrationDate?: Date | undefined;
    distributionChannel: number;
    referencesDealId?: number | undefined;
    overtakeCustomer?: boolean | undefined;
    modelPrototypeId?: number | undefined;
    previousCalculation?: DealCalculation | undefined;
    useCampaign: boolean;
    dealFeatureValues: FeatureValueWrapper[];
}

export class GetSalesContestResponse implements IGetSalesContestResponse {
    hasAccepted?: boolean | undefined;
    termsOfConditionId?: string | undefined;

    constructor(data?: IGetSalesContestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAccepted = _data["hasAccepted"];
            this.termsOfConditionId = _data["termsOfConditionId"];
        }
    }

    static fromJS(data: any): GetSalesContestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesContestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAccepted"] = this.hasAccepted;
        data["termsOfConditionId"] = this.termsOfConditionId;
        return data;
    }
}

export interface IGetSalesContestResponse {
    hasAccepted?: boolean | undefined;
    termsOfConditionId?: string | undefined;
}

export class GetSalesContestResponseApiResult implements IGetSalesContestResponseApiResult {
    messages!: ApiMessages;
    data!: GetSalesContestResponse;

    constructor(data?: IGetSalesContestResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetSalesContestResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetSalesContestResponse.fromJS(_data["data"]) : new GetSalesContestResponse();
        }
    }

    static fromJS(data: any): GetSalesContestResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesContestResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetSalesContestResponseApiResult {
    messages: ApiMessages;
    data: GetSalesContestResponse;
}

export class GetServiceVariantsResponse implements IGetServiceVariantsResponse {
    serviceVariants!: ApiconServiceVariantIdNamePair[];
    selectedServiceVariantId?: number | undefined;
    isReadOnly!: boolean;

    constructor(data?: IGetServiceVariantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceVariants = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceVariants"])) {
                this.serviceVariants = [] as any;
                for (let item of _data["serviceVariants"])
                    this.serviceVariants!.push(ApiconServiceVariantIdNamePair.fromJS(item));
            }
            this.selectedServiceVariantId = _data["selectedServiceVariantId"];
            this.isReadOnly = _data["isReadOnly"];
        }
    }

    static fromJS(data: any): GetServiceVariantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceVariantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceVariants)) {
            data["serviceVariants"] = [];
            for (let item of this.serviceVariants)
                data["serviceVariants"].push(item.toJSON());
        }
        data["selectedServiceVariantId"] = this.selectedServiceVariantId;
        data["isReadOnly"] = this.isReadOnly;
        return data;
    }
}

export interface IGetServiceVariantsResponse {
    serviceVariants: ApiconServiceVariantIdNamePair[];
    selectedServiceVariantId?: number | undefined;
    isReadOnly: boolean;
}

export class GetServiceVariantsResponseApiResult implements IGetServiceVariantsResponseApiResult {
    messages!: ApiMessages;
    data!: GetServiceVariantsResponse;

    constructor(data?: IGetServiceVariantsResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetServiceVariantsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetServiceVariantsResponse.fromJS(_data["data"]) : new GetServiceVariantsResponse();
        }
    }

    static fromJS(data: any): GetServiceVariantsResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetServiceVariantsResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetServiceVariantsResponseApiResult {
    messages: ApiMessages;
    data: GetServiceVariantsResponse;
}

export class GetTypeCertificateInfoResponse implements IGetTypeCertificateInfoResponse {
    recipient!: string;
    additionalInfo!: string;
    street!: string;
    postalCode!: string;
    country!: string;
    city!: string;
    reasons!: TypeCertificateReason[];

    constructor(data?: IGetTypeCertificateInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reasons = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recipient = _data["recipient"];
            this.additionalInfo = _data["additionalInfo"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.city = _data["city"];
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(TypeCertificateReason.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTypeCertificateInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeCertificateInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recipient"] = this.recipient;
        data["additionalInfo"] = this.additionalInfo;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["city"] = this.city;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTypeCertificateInfoResponse {
    recipient: string;
    additionalInfo: string;
    street: string;
    postalCode: string;
    country: string;
    city: string;
    reasons: TypeCertificateReason[];
}

export class GetTypeCertificateInfoResponseApiResult implements IGetTypeCertificateInfoResponseApiResult {
    messages!: ApiMessages;
    data!: GetTypeCertificateInfoResponse;

    constructor(data?: IGetTypeCertificateInfoResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new GetTypeCertificateInfoResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? GetTypeCertificateInfoResponse.fromJS(_data["data"]) : new GetTypeCertificateInfoResponse();
        }
    }

    static fromJS(data: any): GetTypeCertificateInfoResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetTypeCertificateInfoResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTypeCertificateInfoResponseApiResult {
    messages: ApiMessages;
    data: GetTypeCertificateInfoResponse;
}

export class GlobalApiMessage implements IGlobalApiMessage {
    severity!: MessageSeverity;
    message!: string;
    readonly translate!: boolean;
    readonly arguments!: string[];
    readonly showForceUnlockDeal!: boolean;

    constructor(data?: IGlobalApiMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.arguments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.message = _data["message"];
            (<any>this).translate = _data["translate"];
            if (Array.isArray(_data["arguments"])) {
                (<any>this).arguments = [] as any;
                for (let item of _data["arguments"])
                    (<any>this).arguments!.push(item);
            }
            (<any>this).showForceUnlockDeal = _data["showForceUnlockDeal"];
        }
    }

    static fromJS(data: any): GlobalApiMessage {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalApiMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["message"] = this.message;
        data["translate"] = this.translate;
        if (Array.isArray(this.arguments)) {
            data["arguments"] = [];
            for (let item of this.arguments)
                data["arguments"].push(item);
        }
        data["showForceUnlockDeal"] = this.showForceUnlockDeal;
        return data;
    }
}

export interface IGlobalApiMessage {
    severity: MessageSeverity;
    message: string;
    translate: boolean;
    arguments: string[];
    showForceUnlockDeal: boolean;
}

export class GlobalTextView implements IGlobalTextView {
    id!: string;
    text!: string;

    constructor(data?: IGlobalTextView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): GlobalTextView {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalTextView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IGlobalTextView {
    id: string;
    text: string;
}

export class GlobalTextViewIReadOnlyCollectionApiResult implements IGlobalTextViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: GlobalTextView[];

    constructor(data?: IGlobalTextViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(GlobalTextView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalTextViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalTextViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGlobalTextViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: GlobalTextView[];
}

export class GuidApiResult implements IGuidApiResult {
    messages!: ApiMessages;
    data!: string;

    constructor(data?: IGuidApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): GuidApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new GuidApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data;
        return data;
    }
}

export interface IGuidApiResult {
    messages: ApiMessages;
    data: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    readonly errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                (<any>this).errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>(<any>this).errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class IdentityCheckDetails implements IIdentityCheckDetails {
    bankAccount!: BankAccountInfo;
    nameCheckVerified?: boolean | undefined;

    constructor(data?: IIdentityCheckDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bankAccount = new BankAccountInfo();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccount = _data["bankAccount"] ? BankAccountInfo.fromJS(_data["bankAccount"]) : new BankAccountInfo();
            this.nameCheckVerified = _data["nameCheckVerified"];
        }
    }

    static fromJS(data: any): IdentityCheckDetails {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityCheckDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount ? this.bankAccount.toJSON() : <any>undefined;
        data["nameCheckVerified"] = this.nameCheckVerified;
        return data;
    }
}

export interface IIdentityCheckDetails {
    bankAccount: BankAccountInfo;
    nameCheckVerified?: boolean | undefined;
}

export class IdentityCheckResponse implements IIdentityCheckResponse {
    checkId!: string;
    customerId?: number | undefined;
    url!: string;
    status!: IdentityCheckStatusEnum;
    checkDate?: Date | undefined;
    expirationDate?: Date | undefined;
    details!: IdentityCheckDetails;

    constructor(data?: IIdentityCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.details = new IdentityCheckDetails();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkId = _data["checkId"];
            this.customerId = _data["customerId"];
            this.url = _data["url"];
            this.status = _data["status"];
            this.checkDate = _data["checkDate"] ? new Date(_data["checkDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.details = _data["details"] ? IdentityCheckDetails.fromJS(_data["details"]) : new IdentityCheckDetails();
        }
    }

    static fromJS(data: any): IdentityCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkId"] = this.checkId;
        data["customerId"] = this.customerId;
        data["url"] = this.url;
        data["status"] = this.status;
        data["checkDate"] = this.checkDate ? this.checkDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIdentityCheckResponse {
    checkId: string;
    customerId?: number | undefined;
    url: string;
    status: IdentityCheckStatusEnum;
    checkDate?: Date | undefined;
    expirationDate?: Date | undefined;
    details: IdentityCheckDetails;
}

export class IdentityCheckResponseApiResult implements IIdentityCheckResponseApiResult {
    messages!: ApiMessages;
    data!: IdentityCheckResponse;

    constructor(data?: IIdentityCheckResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new IdentityCheckResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? IdentityCheckResponse.fromJS(_data["data"]) : new IdentityCheckResponse();
        }
    }

    static fromJS(data: any): IdentityCheckResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityCheckResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIdentityCheckResponseApiResult {
    messages: ApiMessages;
    data: IdentityCheckResponse;
}

export enum IdentityCheckStatusEnum {
    Pending = "Pending",
    Processing = "Processing",
    Completed = "Completed",
    Accepted = "Accepted",
    Discarded = "Discarded",
    Cancelled = "Cancelled",
    Expired = "Expired",
}

export class ImportModelConfigurationResponse implements IImportModelConfigurationResponse {
    result!: ImportModelConfigurationResult;
    readonly success!: boolean;
    validationErrors!: string[];

    constructor(data?: IImportModelConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = new ImportModelConfigurationResult();
            this.validationErrors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ImportModelConfigurationResult.fromJS(_data["result"]) : new ImportModelConfigurationResult();
            (<any>this).success = _data["success"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportModelConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportModelConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["success"] = this.success;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        return data;
    }
}

export interface IImportModelConfigurationResponse {
    result: ImportModelConfigurationResult;
    success: boolean;
    validationErrors: string[];
}

export class ImportModelConfigurationResponseApiResult implements IImportModelConfigurationResponseApiResult {
    messages!: ApiMessages;
    data!: ImportModelConfigurationResponse;

    constructor(data?: IImportModelConfigurationResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ImportModelConfigurationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ImportModelConfigurationResponse.fromJS(_data["data"]) : new ImportModelConfigurationResponse();
        }
    }

    static fromJS(data: any): ImportModelConfigurationResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportModelConfigurationResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportModelConfigurationResponseApiResult {
    messages: ApiMessages;
    data: ImportModelConfigurationResponse;
}

export class ImportModelConfigurationResult implements IImportModelConfigurationResult {
    customer!: DealCustomer;
    /** Deal Parameters should be relevant for the Calculation */
    deal!: DealParameters;
    vinAssignment!: VinAssignment;

    constructor(data?: IImportModelConfigurationResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new DealCustomer();
            this.deal = new DealParameters();
            this.vinAssignment = new VinAssignment();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? DealCustomer.fromJS(_data["customer"]) : new DealCustomer();
            this.deal = _data["deal"] ? DealParameters.fromJS(_data["deal"]) : new DealParameters();
            this.vinAssignment = _data["vinAssignment"] ? VinAssignment.fromJS(_data["vinAssignment"]) : new VinAssignment();
        }
    }

    static fromJS(data: any): ImportModelConfigurationResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportModelConfigurationResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["deal"] = this.deal ? this.deal.toJSON() : <any>undefined;
        data["vinAssignment"] = this.vinAssignment ? this.vinAssignment.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportModelConfigurationResult {
    customer: DealCustomer;
    /** Deal Parameters should be relevant for the Calculation */
    deal: DealParameters;
    vinAssignment: VinAssignment;
}

export class InsuranceCalculationLimit implements IInsuranceCalculationLimit {
    vehicleTypeId!: number;
    id!: number;
    maxListPriceNonMbcar!: number;
    maxListPriceMbcar!: number;
    maxListPriceExceededText?: string | undefined;

    constructor(data?: IInsuranceCalculationLimit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.id = _data["id"];
            this.maxListPriceNonMbcar = _data["maxListPriceNonMbcar"];
            this.maxListPriceMbcar = _data["maxListPriceMbcar"];
            this.maxListPriceExceededText = _data["maxListPriceExceededText"];
        }
    }

    static fromJS(data: any): InsuranceCalculationLimit {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCalculationLimit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["id"] = this.id;
        data["maxListPriceNonMbcar"] = this.maxListPriceNonMbcar;
        data["maxListPriceMbcar"] = this.maxListPriceMbcar;
        data["maxListPriceExceededText"] = this.maxListPriceExceededText;
        return data;
    }
}

export interface IInsuranceCalculationLimit {
    vehicleTypeId: number;
    id: number;
    maxListPriceNonMbcar: number;
    maxListPriceMbcar: number;
    maxListPriceExceededText?: string | undefined;
}

export class InsuranceCalculationSnapshotData implements IInsuranceCalculationSnapshotData {
    id!: number;
    calculationNumber?: string | undefined;
    isPrimary!: boolean;
    creationDate!: Date;
    changeDate?: Date | undefined;
    kaskoPrice?: number | undefined;
    liabilityPrice?: number | undefined;
    engineTax?: number | undefined;
    totalPrice!: number;
    supportKaskoWithVat?: number | undefined;
    legalTransactionFee?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    isInputTaxDeduction!: boolean;
    postalCode?: string | undefined;
    birthday?: Date | undefined;
    applicantId?: number | undefined;
    additionalApplicantId?: number | undefined;
    externalCalculationNumber?: string | undefined;
    externalCalculationInfo?: string | undefined;
    registrationDate?: Date | undefined;

    constructor(data?: IInsuranceCalculationSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.calculationNumber = _data["calculationNumber"];
            this.isPrimary = _data["isPrimary"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>undefined;
            this.kaskoPrice = _data["kaskoPrice"];
            this.liabilityPrice = _data["liabilityPrice"];
            this.engineTax = _data["engineTax"];
            this.totalPrice = _data["totalPrice"];
            this.supportKaskoWithVat = _data["supportKaskoWithVat"];
            this.legalTransactionFee = _data["legalTransactionFee"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.isInputTaxDeduction = _data["isInputTaxDeduction"];
            this.postalCode = _data["postalCode"];
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.applicantId = _data["applicantId"];
            this.additionalApplicantId = _data["additionalApplicantId"];
            this.externalCalculationNumber = _data["externalCalculationNumber"];
            this.externalCalculationInfo = _data["externalCalculationInfo"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InsuranceCalculationSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new InsuranceCalculationSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["calculationNumber"] = this.calculationNumber;
        data["isPrimary"] = this.isPrimary;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>undefined;
        data["kaskoPrice"] = this.kaskoPrice;
        data["liabilityPrice"] = this.liabilityPrice;
        data["engineTax"] = this.engineTax;
        data["totalPrice"] = this.totalPrice;
        data["supportKaskoWithVat"] = this.supportKaskoWithVat;
        data["legalTransactionFee"] = this.legalTransactionFee;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["isInputTaxDeduction"] = this.isInputTaxDeduction;
        data["postalCode"] = this.postalCode;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["applicantId"] = this.applicantId;
        data["additionalApplicantId"] = this.additionalApplicantId;
        data["externalCalculationNumber"] = this.externalCalculationNumber;
        data["externalCalculationInfo"] = this.externalCalculationInfo;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInsuranceCalculationSnapshotData {
    id: number;
    calculationNumber?: string | undefined;
    isPrimary: boolean;
    creationDate: Date;
    changeDate?: Date | undefined;
    kaskoPrice?: number | undefined;
    liabilityPrice?: number | undefined;
    engineTax?: number | undefined;
    totalPrice: number;
    supportKaskoWithVat?: number | undefined;
    legalTransactionFee?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    liabilityPremiumDiscount?: number | undefined;
    isInputTaxDeduction: boolean;
    postalCode?: string | undefined;
    birthday?: Date | undefined;
    applicantId?: number | undefined;
    additionalApplicantId?: number | undefined;
    externalCalculationNumber?: string | undefined;
    externalCalculationInfo?: string | undefined;
    registrationDate?: Date | undefined;
}

export class JobTitleView implements IJobTitleView {
    id!: number;
    name!: string;
    noIncome!: boolean;

    constructor(data?: IJobTitleView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.noIncome = _data["noIncome"];
        }
    }

    static fromJS(data: any): JobTitleView {
        data = typeof data === 'object' ? data : {};
        let result = new JobTitleView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["noIncome"] = this.noIncome;
        return data;
    }
}

export interface IJobTitleView {
    id: number;
    name: string;
    noIncome: boolean;
}

export class JobTitleViewIReadOnlyCollectionApiResult implements IJobTitleViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: JobTitleView[];

    constructor(data?: IJobTitleViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(JobTitleView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobTitleViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new JobTitleViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobTitleViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: JobTitleView[];
}

export class LeasmanDissolveValue implements ILeasmanDissolveValue {
    cmsId!: number;
    dissolveDate!: Date;
    dissolveValue!: number;
    purchasePrice?: number | undefined;
    commissionNumber?: string | undefined;
    deduction?: number | undefined;
    addition?: number | undefined;
    isSurchargeCancelled!: boolean;

    constructor(data?: ILeasmanDissolveValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmsId = _data["cmsId"];
            this.dissolveDate = _data["dissolveDate"] ? new Date(_data["dissolveDate"].toString()) : <any>undefined;
            this.dissolveValue = _data["dissolveValue"];
            this.purchasePrice = _data["purchasePrice"];
            this.commissionNumber = _data["commissionNumber"];
            this.deduction = _data["deduction"];
            this.addition = _data["addition"];
            this.isSurchargeCancelled = _data["isSurchargeCancelled"];
        }
    }

    static fromJS(data: any): LeasmanDissolveValue {
        data = typeof data === 'object' ? data : {};
        let result = new LeasmanDissolveValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmsId"] = this.cmsId;
        data["dissolveDate"] = this.dissolveDate ? this.dissolveDate.toISOString() : <any>undefined;
        data["dissolveValue"] = this.dissolveValue;
        data["purchasePrice"] = this.purchasePrice;
        data["commissionNumber"] = this.commissionNumber;
        data["deduction"] = this.deduction;
        data["addition"] = this.addition;
        data["isSurchargeCancelled"] = this.isSurchargeCancelled;
        return data;
    }
}

export interface ILeasmanDissolveValue {
    cmsId: number;
    dissolveDate: Date;
    dissolveValue: number;
    purchasePrice?: number | undefined;
    commissionNumber?: string | undefined;
    deduction?: number | undefined;
    addition?: number | undefined;
    isSurchargeCancelled: boolean;
}

export class LeasmanDissolveValueIReadOnlyCollectionApiResult implements ILeasmanDissolveValueIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: LeasmanDissolveValue[];

    constructor(data?: ILeasmanDissolveValueIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(LeasmanDissolveValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeasmanDissolveValueIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new LeasmanDissolveValueIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeasmanDissolveValueIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: LeasmanDissolveValue[];
}

export enum LimitViolationVoting {
    Accept = "Accept",
    Reject = "Reject",
}

export class LocalApiMessage implements ILocalApiMessage {
    target!: string;
    message!: string;
    readonly translate!: boolean;

    constructor(data?: ILocalApiMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.message = _data["message"];
            (<any>this).translate = _data["translate"];
        }
    }

    static fromJS(data: any): LocalApiMessage {
        data = typeof data === 'object' ? data : {};
        let result = new LocalApiMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["message"] = this.message;
        data["translate"] = this.translate;
        return data;
    }
}

export interface ILocalApiMessage {
    target: string;
    message: string;
    translate: boolean;
}

export class MergeCustomerView implements IMergeCustomerView {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    address?: string | undefined;
    birthDate?: Date | undefined;
    dealer?: string | undefined;
    countSubmittedCalculations!: number;
    countSubmittedInsurances!: number;
    isValid!: boolean;

    constructor(data?: IMergeCustomerView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyName = _data["companyName"];
            this.address = _data["address"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.dealer = _data["dealer"];
            this.countSubmittedCalculations = _data["countSubmittedCalculations"];
            this.countSubmittedInsurances = _data["countSubmittedInsurances"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): MergeCustomerView {
        data = typeof data === 'object' ? data : {};
        let result = new MergeCustomerView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["address"] = this.address;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["dealer"] = this.dealer;
        data["countSubmittedCalculations"] = this.countSubmittedCalculations;
        data["countSubmittedInsurances"] = this.countSubmittedInsurances;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IMergeCustomerView {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    address?: string | undefined;
    birthDate?: Date | undefined;
    dealer?: string | undefined;
    countSubmittedCalculations: number;
    countSubmittedInsurances: number;
    isValid: boolean;
}

export class MergeCustomerViewApiResult implements IMergeCustomerViewApiResult {
    messages!: ApiMessages;
    data!: MergeCustomerView;

    constructor(data?: IMergeCustomerViewApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new MergeCustomerView();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? MergeCustomerView.fromJS(_data["data"]) : new MergeCustomerView();
        }
    }

    static fromJS(data: any): MergeCustomerViewApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new MergeCustomerViewApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMergeCustomerViewApiResult {
    messages: ApiMessages;
    data: MergeCustomerView;
}

export class MergeCustomerViewIPagedList implements IMergeCustomerViewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: MergeCustomerView[];

    constructor(data?: IMergeCustomerViewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(MergeCustomerView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MergeCustomerViewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new MergeCustomerViewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMergeCustomerViewIPagedList {
    total: number;
    index: number;
    size: number;
    items: MergeCustomerView[];
}

export class MergeCustomerViewIPagedListApiResult implements IMergeCustomerViewIPagedListApiResult {
    messages!: ApiMessages;
    data!: MergeCustomerViewIPagedList;

    constructor(data?: IMergeCustomerViewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new MergeCustomerViewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? MergeCustomerViewIPagedList.fromJS(_data["data"]) : new MergeCustomerViewIPagedList();
        }
    }

    static fromJS(data: any): MergeCustomerViewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new MergeCustomerViewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMergeCustomerViewIPagedListApiResult {
    messages: ApiMessages;
    data: MergeCustomerViewIPagedList;
}

export enum MessageSeverity {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export class ModelData implements IModelData {
    tradeMark!: string;
    modelCategory!: string;
    vehicleType!: string;
    engineType!: string;
    model!: string;
    vehicleTypeId!: number;
    id!: number;
    amortizationPeriod!: number;

    constructor(data?: IModelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tradeMark = _data["tradeMark"];
            this.modelCategory = _data["modelCategory"];
            this.vehicleType = _data["vehicleType"];
            this.engineType = _data["engineType"];
            this.model = _data["model"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.id = _data["id"];
            this.amortizationPeriod = _data["amortizationPeriod"];
        }
    }

    static fromJS(data: any): ModelData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tradeMark"] = this.tradeMark;
        data["modelCategory"] = this.modelCategory;
        data["vehicleType"] = this.vehicleType;
        data["engineType"] = this.engineType;
        data["model"] = this.model;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["id"] = this.id;
        data["amortizationPeriod"] = this.amortizationPeriod;
        return data;
    }
}

export interface IModelData {
    tradeMark: string;
    modelCategory: string;
    vehicleType: string;
    engineType: string;
    model: string;
    vehicleTypeId: number;
    id: number;
    amortizationPeriod: number;
}

export class ModelOverview implements IModelOverview {
    id!: number;
    name!: string;
    nodeType!: NodeType;

    constructor(data?: IModelOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeType = _data["nodeType"];
        }
    }

    static fromJS(data: any): ModelOverview {
        data = typeof data === 'object' ? data : {};
        let result = new ModelOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeType"] = this.nodeType;
        return data;
    }
}

export interface IModelOverview {
    id: number;
    name: string;
    nodeType: NodeType;
}

export class ModelOverviewIPagedList implements IModelOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: ModelOverview[];

    constructor(data?: IModelOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(ModelOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new ModelOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: ModelOverview[];
}

export class ModelOverviewIPagedListApiResult implements IModelOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: ModelOverviewIPagedList;

    constructor(data?: IModelOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ModelOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ModelOverviewIPagedList.fromJS(_data["data"]) : new ModelOverviewIPagedList();
        }
    }

    static fromJS(data: any): ModelOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IModelOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: ModelOverviewIPagedList;
}

export class ModelOverviewIReadOnlyListApiResult implements IModelOverviewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: ModelOverview[];

    constructor(data?: IModelOverviewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ModelOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelOverviewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ModelOverviewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IModelOverviewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: ModelOverview[];
}

export class ModelSnapshotData implements IModelSnapshotData {
    id!: number;
    name!: string;
    engineTypeName!: string;
    vehicleTypeName!: string;
    modelCategoryName!: string;
    modelTypeName?: string | undefined;
    serialTypeNumber?: string | undefined;
    eurotaxCode!: string;
    isActive!: boolean;
    amortizationPeriod!: number;

    constructor(data?: IModelSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.engineTypeName = _data["engineTypeName"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.modelCategoryName = _data["modelCategoryName"];
            this.modelTypeName = _data["modelTypeName"];
            this.serialTypeNumber = _data["serialTypeNumber"];
            this.eurotaxCode = _data["eurotaxCode"];
            this.isActive = _data["isActive"];
            this.amortizationPeriod = _data["amortizationPeriod"];
        }
    }

    static fromJS(data: any): ModelSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["engineTypeName"] = this.engineTypeName;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["modelCategoryName"] = this.modelCategoryName;
        data["modelTypeName"] = this.modelTypeName;
        data["serialTypeNumber"] = this.serialTypeNumber;
        data["eurotaxCode"] = this.eurotaxCode;
        data["isActive"] = this.isActive;
        data["amortizationPeriod"] = this.amortizationPeriod;
        return data;
    }
}

export interface IModelSnapshotData {
    id: number;
    name: string;
    engineTypeName: string;
    vehicleTypeName: string;
    modelCategoryName: string;
    modelTypeName?: string | undefined;
    serialTypeNumber?: string | undefined;
    eurotaxCode: string;
    isActive: boolean;
    amortizationPeriod: number;
}

export enum NodeType {
    Trademark = "Trademark",
    VehicleType = "VehicleType",
    ModelCategory = "ModelCategory",
    EngineType = "EngineType",
    Model = "Model",
}

export enum NotificationLocation {
    None = "None",
    Dashboard = "Dashboard",
    Deals = "Deals",
    Deal = "Deal",
    Financing = "Financing",
    Insurance = "Insurance",
    DealCustomer = "DealCustomer",
    CoApplicants = "CoApplicants",
    Documents = "Documents",
    Customers = "Customers",
    Customer = "Customer",
    Login = "Login",
    Navigation = "Navigation",
}

export class NotificationModel implements INotificationModel {
    messageBody!: string;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageBody = _data["messageBody"];
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageBody"] = this.messageBody;
        return data;
    }
}

export interface INotificationModel {
    messageBody: string;
}

export class NotificationParameter implements INotificationParameter {
    type!: NotificationParameterType;
    id!: number;

    constructor(data?: INotificationParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): NotificationParameter {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface INotificationParameter {
    type: NotificationParameterType;
    id: number;
}

export enum NotificationParameterType {
    FinancingType = "FinancingType",
}

export enum NotificationSeverity {
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
}

export class NotificationView implements INotificationView {
    id!: string;
    validFrom!: Date;
    validTo?: Date | undefined;
    content!: string;
    locations!: NotificationLocation[];
    parameters!: NotificationParameter[];
    isPopUp!: boolean;
    severity!: NotificationSeverity;
    isRecurring!: boolean;

    constructor(data?: INotificationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.locations = [];
            this.parameters = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.content = _data["content"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(item);
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(NotificationParameter.fromJS(item));
            }
            this.isPopUp = _data["isPopUp"];
            this.severity = _data["severity"];
            this.isRecurring = _data["isRecurring"];
        }
    }

    static fromJS(data: any): NotificationView {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["content"] = this.content;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item);
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["isPopUp"] = this.isPopUp;
        data["severity"] = this.severity;
        data["isRecurring"] = this.isRecurring;
        return data;
    }
}

export interface INotificationView {
    id: string;
    validFrom: Date;
    validTo?: Date | undefined;
    content: string;
    locations: NotificationLocation[];
    parameters: NotificationParameter[];
    isPopUp: boolean;
    severity: NotificationSeverity;
    isRecurring: boolean;
}

export class NotificationViewIReadOnlyCollectionApiResult implements INotificationViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: NotificationView[];

    constructor(data?: INotificationViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(NotificationView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: NotificationView[];
}

export class ObjectConfigurationRequest implements IObjectConfigurationRequest {
    /** Listenpreis */
    listPrice!: number;
    /** Sonderausstattungen */
    extrasPrice!: number;
    /** Listenpreis + Sonderausstattungen */
    listPriceIncludingExtras!: number;
    /** Gesamtpreis */
    totalPrice!: number;
    /** Gesamtpreis aus Tab "Novafreies Zubehör" */
    coFinancedExtras!: number;
    /** Gesamtpreis inkl. mitfinanziertem NOVA-freien Sonderzubehör */
    purchasePrice!: number;
    /** Kalkulationsbasis */
    calculationBase!: number;
    /** Nachlass in % */
    discountPercent!: number;
    /** Nachlass absolut */
    discountInEuro!: number;
    /** Baujahr */
    registrationDate?: Date | undefined;
    /** Kilometerstand */
    initialMileage?: number | undefined;
    /** Kommissionsnummer */
    commissionNumber?: string | undefined;

    constructor(data?: IObjectConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.listPriceIncludingExtras = _data["listPriceIncludingExtras"];
            this.totalPrice = _data["totalPrice"];
            this.coFinancedExtras = _data["coFinancedExtras"];
            this.purchasePrice = _data["purchasePrice"];
            this.calculationBase = _data["calculationBase"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
        }
    }

    static fromJS(data: any): ObjectConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["listPriceIncludingExtras"] = this.listPriceIncludingExtras;
        data["totalPrice"] = this.totalPrice;
        data["coFinancedExtras"] = this.coFinancedExtras;
        data["purchasePrice"] = this.purchasePrice;
        data["calculationBase"] = this.calculationBase;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        return data;
    }
}

export interface IObjectConfigurationRequest {
    /** Listenpreis */
    listPrice: number;
    /** Sonderausstattungen */
    extrasPrice: number;
    /** Listenpreis + Sonderausstattungen */
    listPriceIncludingExtras: number;
    /** Gesamtpreis */
    totalPrice: number;
    /** Gesamtpreis aus Tab "Novafreies Zubehör" */
    coFinancedExtras: number;
    /** Gesamtpreis inkl. mitfinanziertem NOVA-freien Sonderzubehör */
    purchasePrice: number;
    /** Kalkulationsbasis */
    calculationBase: number;
    /** Nachlass in % */
    discountPercent: number;
    /** Nachlass absolut */
    discountInEuro: number;
    /** Baujahr */
    registrationDate?: Date | undefined;
    /** Kilometerstand */
    initialMileage?: number | undefined;
    /** Kommissionsnummer */
    commissionNumber?: string | undefined;
}

export class ObjectConfigurationResponse implements IObjectConfigurationResponse {
    listPrice!: number;
    extrasPrice!: number;
    listPriceIncludingExtras!: number;
    totalPrice!: number;
    coFinancedExtras!: number;
    purchasePrice!: number;
    calculationBase!: number;
    discountPercent?: number | undefined;
    discountInEuro!: number;
    registrationDate?: Date | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;

    constructor(data?: IObjectConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listPrice = _data["listPrice"];
            this.extrasPrice = _data["extrasPrice"];
            this.listPriceIncludingExtras = _data["listPriceIncludingExtras"];
            this.totalPrice = _data["totalPrice"];
            this.coFinancedExtras = _data["coFinancedExtras"];
            this.purchasePrice = _data["purchasePrice"];
            this.calculationBase = _data["calculationBase"];
            this.discountPercent = _data["discountPercent"];
            this.discountInEuro = _data["discountInEuro"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.initialMileage = _data["initialMileage"];
            this.commissionNumber = _data["commissionNumber"];
        }
    }

    static fromJS(data: any): ObjectConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice;
        data["extrasPrice"] = this.extrasPrice;
        data["listPriceIncludingExtras"] = this.listPriceIncludingExtras;
        data["totalPrice"] = this.totalPrice;
        data["coFinancedExtras"] = this.coFinancedExtras;
        data["purchasePrice"] = this.purchasePrice;
        data["calculationBase"] = this.calculationBase;
        data["discountPercent"] = this.discountPercent;
        data["discountInEuro"] = this.discountInEuro;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["initialMileage"] = this.initialMileage;
        data["commissionNumber"] = this.commissionNumber;
        return data;
    }
}

export interface IObjectConfigurationResponse {
    listPrice: number;
    extrasPrice: number;
    listPriceIncludingExtras: number;
    totalPrice: number;
    coFinancedExtras: number;
    purchasePrice: number;
    calculationBase: number;
    discountPercent?: number | undefined;
    discountInEuro: number;
    registrationDate?: Date | undefined;
    initialMileage?: number | undefined;
    commissionNumber?: string | undefined;
}

export class OptionItemIReadOnlyCollectionApiResult implements IOptionItemIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: OptionItem[];

    constructor(data?: IOptionItemIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OptionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OptionItemIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new OptionItemIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOptionItemIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: OptionItem[];
}

export class OptionItemIReadOnlyListApiResult implements IOptionItemIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: OptionItem[];

    constructor(data?: IOptionItemIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(OptionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OptionItemIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new OptionItemIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOptionItemIReadOnlyListApiResult {
    messages: ApiMessages;
    data: OptionItem[];
}

export class Permission implements IPermission {
    resource!: string;
    action!: string;

    constructor(data?: IPermission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): Permission {
        data = typeof data === 'object' ? data : {};
        let result = new Permission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource;
        data["action"] = this.action;
        return data;
    }
}

export interface IPermission {
    resource: string;
    action: string;
}

export class PermissionIReadOnlyCollectionApiResult implements IPermissionIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: Permission[];

    constructor(data?: IPermissionIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Permission.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPermissionIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: Permission[];
}

export class PersonalSnapshotData implements IPersonalSnapshotData {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    salutationId?: number | undefined;
    titleId?: number | undefined;
    titleInternationalId?: number | undefined;
    citizenshipId?: number | undefined;
    maritalStatusId?: number | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    employedSince?: Date | undefined;
    inAustriaSince?: Date | undefined;
    residancePermitValidSince?: Date | undefined;
    residancePermitValidTill?: Date | undefined;

    constructor(data?: IPersonalSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.salutationId = _data["salutationId"];
            this.titleId = _data["titleId"];
            this.titleInternationalId = _data["titleInternationalId"];
            this.citizenshipId = _data["citizenshipId"];
            this.maritalStatusId = _data["maritalStatusId"];
            this.pepSpecificationId = _data["pepSpecificationId"];
            this.politicalExposedPersonRelated = _data["politicalExposedPersonRelated"];
            this.numberOfSupportedChildren = _data["numberOfSupportedChildren"];
            this.numberOfChildrenUnderEighteen = _data["numberOfChildrenUnderEighteen"];
            this.employedSince = _data["employedSince"] ? new Date(_data["employedSince"].toString()) : <any>undefined;
            this.inAustriaSince = _data["inAustriaSince"] ? new Date(_data["inAustriaSince"].toString()) : <any>undefined;
            this.residancePermitValidSince = _data["residancePermitValidSince"] ? new Date(_data["residancePermitValidSince"].toString()) : <any>undefined;
            this.residancePermitValidTill = _data["residancePermitValidTill"] ? new Date(_data["residancePermitValidTill"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PersonalSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["salutationId"] = this.salutationId;
        data["titleId"] = this.titleId;
        data["titleInternationalId"] = this.titleInternationalId;
        data["citizenshipId"] = this.citizenshipId;
        data["maritalStatusId"] = this.maritalStatusId;
        data["pepSpecificationId"] = this.pepSpecificationId;
        data["politicalExposedPersonRelated"] = this.politicalExposedPersonRelated;
        data["numberOfSupportedChildren"] = this.numberOfSupportedChildren;
        data["numberOfChildrenUnderEighteen"] = this.numberOfChildrenUnderEighteen;
        data["employedSince"] = this.employedSince ? this.employedSince.toISOString() : <any>undefined;
        data["inAustriaSince"] = this.inAustriaSince ? this.inAustriaSince.toISOString() : <any>undefined;
        data["residancePermitValidSince"] = this.residancePermitValidSince ? this.residancePermitValidSince.toISOString() : <any>undefined;
        data["residancePermitValidTill"] = this.residancePermitValidTill ? this.residancePermitValidTill.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPersonalSnapshotData {
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    salutationId?: number | undefined;
    titleId?: number | undefined;
    titleInternationalId?: number | undefined;
    citizenshipId?: number | undefined;
    maritalStatusId?: number | undefined;
    pepSpecificationId?: number | undefined;
    politicalExposedPersonRelated?: boolean | undefined;
    numberOfSupportedChildren?: number | undefined;
    numberOfChildrenUnderEighteen?: number | undefined;
    employedSince?: Date | undefined;
    inAustriaSince?: Date | undefined;
    residancePermitValidSince?: Date | undefined;
    residancePermitValidTill?: Date | undefined;
}

export class PostApplicationResultRequest implements IPostApplicationResultRequest {
    submittedCalculationId!: number;
    isSuccess?: boolean | undefined;
    contractNumber?: number | undefined;
    businessPartners?: ApplicationResultBusinessPartner[] | undefined;
    position?: number | undefined;
    errorMessage?: string | undefined;

    constructor(data?: IPostApplicationResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedCalculationId = _data["submittedCalculationId"];
            this.isSuccess = _data["isSuccess"];
            this.contractNumber = _data["contractNumber"];
            if (Array.isArray(_data["businessPartners"])) {
                this.businessPartners = [] as any;
                for (let item of _data["businessPartners"])
                    this.businessPartners!.push(ApplicationResultBusinessPartner.fromJS(item));
            }
            this.position = _data["position"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): PostApplicationResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostApplicationResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedCalculationId"] = this.submittedCalculationId;
        data["isSuccess"] = this.isSuccess;
        data["contractNumber"] = this.contractNumber;
        if (Array.isArray(this.businessPartners)) {
            data["businessPartners"] = [];
            for (let item of this.businessPartners)
                data["businessPartners"].push(item.toJSON());
        }
        data["position"] = this.position;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IPostApplicationResultRequest {
    submittedCalculationId: number;
    isSuccess?: boolean | undefined;
    contractNumber?: number | undefined;
    businessPartners?: ApplicationResultBusinessPartner[] | undefined;
    position?: number | undefined;
    errorMessage?: string | undefined;
}

export class PreviousInsurer implements IPreviousInsurer {
    value!: string;
    name!: string;

    constructor(data?: IPreviousInsurer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PreviousInsurer {
        data = typeof data === 'object' ? data : {};
        let result = new PreviousInsurer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IPreviousInsurer {
    value: string;
    name: string;
}

export class PreviousInsurerIReadOnlyCollectionApiResult implements IPreviousInsurerIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: PreviousInsurer[];

    constructor(data?: IPreviousInsurerIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PreviousInsurer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreviousInsurerIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new PreviousInsurerIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreviousInsurerIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: PreviousInsurer[];
}

export class PrintFinancingCalculationDocumentsRequest implements IPrintFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId!: number;
    /** Euribor Datum */
    selectedEuriborId!: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross!: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross!: boolean;
    turnOverTaxStatementRequested!: boolean;
    useCoApplicantAccount!: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds!: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds!: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds!: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];
    suppressEuriborAutoUpdate!: boolean;

    constructor(data?: IPrintFinancingCalculationDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.offerDocumentIds = [];
            this.termsheetDocumentIds = [];
            this.contractDocumentIds = [];
            this.miscellaneousDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financingCalculationId = _data["financingCalculationId"];
            this.selectedEuriborId = _data["selectedEuriborId"];
            this.termsheet = _data["termsheet"];
            this.leasingContractNotes = _data["leasingContractNotes"];
            this.offerSupplement = _data["offerSupplement"];
            this.calculationGross = _data["calculationGross"];
            this.termsheetCalculationGross = _data["termsheetCalculationGross"];
            this.turnOverTaxStatementRequested = _data["turnOverTaxStatementRequested"];
            this.useCoApplicantAccount = _data["useCoApplicantAccount"];
            if (Array.isArray(_data["offerDocumentIds"])) {
                this.offerDocumentIds = [] as any;
                for (let item of _data["offerDocumentIds"])
                    this.offerDocumentIds!.push(item);
            }
            if (Array.isArray(_data["termsheetDocumentIds"])) {
                this.termsheetDocumentIds = [] as any;
                for (let item of _data["termsheetDocumentIds"])
                    this.termsheetDocumentIds!.push(item);
            }
            if (Array.isArray(_data["contractDocumentIds"])) {
                this.contractDocumentIds = [] as any;
                for (let item of _data["contractDocumentIds"])
                    this.contractDocumentIds!.push(item);
            }
            if (Array.isArray(_data["miscellaneousDocumentIds"])) {
                this.miscellaneousDocumentIds = [] as any;
                for (let item of _data["miscellaneousDocumentIds"])
                    this.miscellaneousDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
            this.suppressEuriborAutoUpdate = _data["suppressEuriborAutoUpdate"];
        }
    }

    static fromJS(data: any): PrintFinancingCalculationDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintFinancingCalculationDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingCalculationId"] = this.financingCalculationId;
        data["selectedEuriborId"] = this.selectedEuriborId;
        data["termsheet"] = this.termsheet;
        data["leasingContractNotes"] = this.leasingContractNotes;
        data["offerSupplement"] = this.offerSupplement;
        data["calculationGross"] = this.calculationGross;
        data["termsheetCalculationGross"] = this.termsheetCalculationGross;
        data["turnOverTaxStatementRequested"] = this.turnOverTaxStatementRequested;
        data["useCoApplicantAccount"] = this.useCoApplicantAccount;
        if (Array.isArray(this.offerDocumentIds)) {
            data["offerDocumentIds"] = [];
            for (let item of this.offerDocumentIds)
                data["offerDocumentIds"].push(item);
        }
        if (Array.isArray(this.termsheetDocumentIds)) {
            data["termsheetDocumentIds"] = [];
            for (let item of this.termsheetDocumentIds)
                data["termsheetDocumentIds"].push(item);
        }
        if (Array.isArray(this.contractDocumentIds)) {
            data["contractDocumentIds"] = [];
            for (let item of this.contractDocumentIds)
                data["contractDocumentIds"].push(item);
        }
        if (Array.isArray(this.miscellaneousDocumentIds)) {
            data["miscellaneousDocumentIds"] = [];
            for (let item of this.miscellaneousDocumentIds)
                data["miscellaneousDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        data["suppressEuriborAutoUpdate"] = this.suppressEuriborAutoUpdate;
        return data;
    }
}

export interface IPrintFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId: number;
    /** Euribor Datum */
    selectedEuriborId: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross: boolean;
    turnOverTaxStatementRequested: boolean;
    useCoApplicantAccount: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
    suppressEuriborAutoUpdate: boolean;
}

export class PrintInsuranceDocumentsRequest implements IPrintInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId!: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired!: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];

    constructor(data?: IPrintInsuranceDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.insuranceDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceCalculationId = _data["insuranceCalculationId"];
            this.offerSupplement = _data["offerSupplement"];
            this.previousInsuranceInfoRequired = _data["previousInsuranceInfoRequired"];
            this.previousInsuranceCompanyName = _data["previousInsuranceCompanyName"];
            this.previousTerminateContract = _data["previousTerminateContract"];
            this.previousContractNumber = _data["previousContractNumber"];
            this.previousLicensePlate = _data["previousLicensePlate"];
            this.previousContractTypeId = _data["previousContractTypeId"];
            this.waiverOfBonus = _data["waiverOfBonus"];
            if (Array.isArray(_data["insuranceDocumentIds"])) {
                this.insuranceDocumentIds = [] as any;
                for (let item of _data["insuranceDocumentIds"])
                    this.insuranceDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PrintInsuranceDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PrintInsuranceDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceCalculationId"] = this.insuranceCalculationId;
        data["offerSupplement"] = this.offerSupplement;
        data["previousInsuranceInfoRequired"] = this.previousInsuranceInfoRequired;
        data["previousInsuranceCompanyName"] = this.previousInsuranceCompanyName;
        data["previousTerminateContract"] = this.previousTerminateContract;
        data["previousContractNumber"] = this.previousContractNumber;
        data["previousLicensePlate"] = this.previousLicensePlate;
        data["previousContractTypeId"] = this.previousContractTypeId;
        data["waiverOfBonus"] = this.waiverOfBonus;
        if (Array.isArray(this.insuranceDocumentIds)) {
            data["insuranceDocumentIds"] = [];
            for (let item of this.insuranceDocumentIds)
                data["insuranceDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        return data;
    }
}

export interface IPrintInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
}

export class PrintedDocumentView implements IPrintedDocumentView {
    id!: string;
    documentName!: string;
    createdAt!: Date;
    createdBy!: string;

    constructor(data?: IPrintedDocumentView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentName = _data["documentName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
        }
    }

    static fromJS(data: any): PrintedDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new PrintedDocumentView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentName"] = this.documentName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        return data;
    }
}

export interface IPrintedDocumentView {
    id: string;
    documentName: string;
    createdAt: Date;
    createdBy: string;
}

export class PrintedDocumentViewIReadOnlyListApiResult implements IPrintedDocumentViewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: PrintedDocumentView[];

    constructor(data?: IPrintedDocumentViewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PrintedDocumentView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrintedDocumentViewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new PrintedDocumentViewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrintedDocumentViewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: PrintedDocumentView[];
}

export class PrivateCustomerKsvResponse implements IPrivateCustomerKsvResponse {
    ksvId!: string;
    firstName!: string;
    lastName!: string;
    birthDate?: Date | undefined;
    street!: string;
    house!: string;
    zipCode!: string;
    city!: string;

    constructor(data?: IPrivateCustomerKsvResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ksvId = _data["ksvId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.house = _data["house"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): PrivateCustomerKsvResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateCustomerKsvResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ksvId"] = this.ksvId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["house"] = this.house;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IPrivateCustomerKsvResponse {
    ksvId: string;
    firstName: string;
    lastName: string;
    birthDate?: Date | undefined;
    street: string;
    house: string;
    zipCode: string;
    city: string;
}

export class PrivateCustomerKsvResponseIReadOnlyCollectionApiResult implements IPrivateCustomerKsvResponseIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: PrivateCustomerKsvResponse[];

    constructor(data?: IPrivateCustomerKsvResponseIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PrivateCustomerKsvResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrivateCustomerKsvResponseIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateCustomerKsvResponseIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrivateCustomerKsvResponseIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: PrivateCustomerKsvResponse[];
}

export class PrivateCustomerSnapshotData implements IPrivateCustomerSnapshotData {
    personalDetails!: PersonalSnapshotData;
    jobTitleId?: number | undefined;
    residenceTypeId?: number | undefined;
    assetTypeId?: number | undefined;
    otherAssetTypeId?: number | undefined;
    currentEmployerName?: string | undefined;
    currentEmployerAddress?: string | undefined;
    verifiableMonthlyIncome?: number | undefined;
    verifiableMonthlyAddIncome?: number | undefined;
    verifiableMonthlyAddIncomeType?: string | undefined;
    monthlyRentInclAddCharges?: number | undefined;
    monthlyLoanRepayment?: number | undefined;
    currentBankLoansAndOverdrafts?: number | undefined;
    maintenanceObligations?: number | undefined;
    currentHousehold?: number | undefined;
    otherAssets?: number | undefined;
    assetCity?: string | undefined;
    assetSize?: string | undefined;
    workPermitValidSince?: Date | undefined;
    workPermitValidTill?: Date | undefined;

    constructor(data?: IPrivateCustomerSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personalDetails = new PersonalSnapshotData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalDetails = _data["personalDetails"] ? PersonalSnapshotData.fromJS(_data["personalDetails"]) : new PersonalSnapshotData();
            this.jobTitleId = _data["jobTitleId"];
            this.residenceTypeId = _data["residenceTypeId"];
            this.assetTypeId = _data["assetTypeId"];
            this.otherAssetTypeId = _data["otherAssetTypeId"];
            this.currentEmployerName = _data["currentEmployerName"];
            this.currentEmployerAddress = _data["currentEmployerAddress"];
            this.verifiableMonthlyIncome = _data["verifiableMonthlyIncome"];
            this.verifiableMonthlyAddIncome = _data["verifiableMonthlyAddIncome"];
            this.verifiableMonthlyAddIncomeType = _data["verifiableMonthlyAddIncomeType"];
            this.monthlyRentInclAddCharges = _data["monthlyRentInclAddCharges"];
            this.monthlyLoanRepayment = _data["monthlyLoanRepayment"];
            this.currentBankLoansAndOverdrafts = _data["currentBankLoansAndOverdrafts"];
            this.maintenanceObligations = _data["maintenanceObligations"];
            this.currentHousehold = _data["currentHousehold"];
            this.otherAssets = _data["otherAssets"];
            this.assetCity = _data["assetCity"];
            this.assetSize = _data["assetSize"];
            this.workPermitValidSince = _data["workPermitValidSince"] ? new Date(_data["workPermitValidSince"].toString()) : <any>undefined;
            this.workPermitValidTill = _data["workPermitValidTill"] ? new Date(_data["workPermitValidTill"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PrivateCustomerSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateCustomerSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalDetails"] = this.personalDetails ? this.personalDetails.toJSON() : <any>undefined;
        data["jobTitleId"] = this.jobTitleId;
        data["residenceTypeId"] = this.residenceTypeId;
        data["assetTypeId"] = this.assetTypeId;
        data["otherAssetTypeId"] = this.otherAssetTypeId;
        data["currentEmployerName"] = this.currentEmployerName;
        data["currentEmployerAddress"] = this.currentEmployerAddress;
        data["verifiableMonthlyIncome"] = this.verifiableMonthlyIncome;
        data["verifiableMonthlyAddIncome"] = this.verifiableMonthlyAddIncome;
        data["verifiableMonthlyAddIncomeType"] = this.verifiableMonthlyAddIncomeType;
        data["monthlyRentInclAddCharges"] = this.monthlyRentInclAddCharges;
        data["monthlyLoanRepayment"] = this.monthlyLoanRepayment;
        data["currentBankLoansAndOverdrafts"] = this.currentBankLoansAndOverdrafts;
        data["maintenanceObligations"] = this.maintenanceObligations;
        data["currentHousehold"] = this.currentHousehold;
        data["otherAssets"] = this.otherAssets;
        data["assetCity"] = this.assetCity;
        data["assetSize"] = this.assetSize;
        data["workPermitValidSince"] = this.workPermitValidSince ? this.workPermitValidSince.toISOString() : <any>undefined;
        data["workPermitValidTill"] = this.workPermitValidTill ? this.workPermitValidTill.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPrivateCustomerSnapshotData {
    personalDetails: PersonalSnapshotData;
    jobTitleId?: number | undefined;
    residenceTypeId?: number | undefined;
    assetTypeId?: number | undefined;
    otherAssetTypeId?: number | undefined;
    currentEmployerName?: string | undefined;
    currentEmployerAddress?: string | undefined;
    verifiableMonthlyIncome?: number | undefined;
    verifiableMonthlyAddIncome?: number | undefined;
    verifiableMonthlyAddIncomeType?: string | undefined;
    monthlyRentInclAddCharges?: number | undefined;
    monthlyLoanRepayment?: number | undefined;
    currentBankLoansAndOverdrafts?: number | undefined;
    maintenanceObligations?: number | undefined;
    currentHousehold?: number | undefined;
    otherAssets?: number | undefined;
    assetCity?: string | undefined;
    assetSize?: string | undefined;
    workPermitValidSince?: Date | undefined;
    workPermitValidTill?: Date | undefined;
}

export class PrivateCustomerViewApiResult implements IPrivateCustomerViewApiResult {
    messages!: ApiMessages;
    data!: PrivateCustomerView;

    constructor(data?: IPrivateCustomerViewApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new PrivateCustomerView();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? PrivateCustomerView.fromJS(_data["data"]) : new PrivateCustomerView();
        }
    }

    static fromJS(data: any): PrivateCustomerViewApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new PrivateCustomerViewApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrivateCustomerViewApiResult {
    messages: ApiMessages;
    data: PrivateCustomerView;
}

export class ProblemDetailsApiResult implements IProblemDetailsApiResult {
    messages!: ApiMessages;
    data!: ProblemDetails;

    constructor(data?: IProblemDetailsApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ProblemDetails();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ProblemDetails.fromJS(_data["data"]) : new ProblemDetails();
        }
    }

    static fromJS(data: any): ProblemDetailsApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetailsApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProblemDetailsApiResult {
    messages: ApiMessages;
    data: ProblemDetails;
}

export class ProductIndustry implements IProductIndustry {
    productIndustryId?: string | undefined;
    designation?: string | undefined;

    constructor(data?: IProductIndustry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productIndustryId = _data["productIndustryId"];
            this.designation = _data["designation"];
        }
    }

    static fromJS(data: any): ProductIndustry {
        data = typeof data === 'object' ? data : {};
        let result = new ProductIndustry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productIndustryId"] = this.productIndustryId;
        data["designation"] = this.designation;
        return data;
    }
}

export interface IProductIndustry {
    productIndustryId?: string | undefined;
    designation?: string | undefined;
}

export class ProductUsage implements IProductUsage {
    productUsageId?: string | undefined;
    designation?: string | undefined;

    constructor(data?: IProductUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productUsageId = _data["productUsageId"];
            this.designation = _data["designation"];
        }
    }

    static fromJS(data: any): ProductUsage {
        data = typeof data === 'object' ? data : {};
        let result = new ProductUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productUsageId"] = this.productUsageId;
        data["designation"] = this.designation;
        return data;
    }
}

export interface IProductUsage {
    productUsageId?: string | undefined;
    designation?: string | undefined;
}

export enum PurchaseBy {
    Dealer = "Dealer",
    Lessee = "Lessee",
}

export class RecalculateTakeoverRequest implements IRecalculateTakeoverRequest {
    idempotencyKey!: string;

    constructor(data?: IRecalculateTakeoverRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idempotencyKey = _data["idempotencyKey"];
        }
    }

    static fromJS(data: any): RecalculateTakeoverRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecalculateTakeoverRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idempotencyKey"] = this.idempotencyKey;
        return data;
    }
}

export interface IRecalculateTakeoverRequest {
    idempotencyKey: string;
}

export class RemoveClassificationGroupRequest implements IRemoveClassificationGroupRequest {
    objectId!: string;
    objectType!: ClassificationType;

    constructor(data?: IRemoveClassificationGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.objectType = _data["objectType"];
        }
    }

    static fromJS(data: any): RemoveClassificationGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveClassificationGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["objectType"] = this.objectType;
        return data;
    }
}

export interface IRemoveClassificationGroupRequest {
    objectId: string;
    objectType: ClassificationType;
}

export class ReplaceMainCustomerRequest implements IReplaceMainCustomerRequest {
    sourceCustomerId!: number;
    targetCustomerIds!: number[];
    updateDealCustomer!: boolean;

    constructor(data?: IReplaceMainCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.targetCustomerIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceCustomerId = _data["sourceCustomerId"];
            if (Array.isArray(_data["targetCustomerIds"])) {
                this.targetCustomerIds = [] as any;
                for (let item of _data["targetCustomerIds"])
                    this.targetCustomerIds!.push(item);
            }
            this.updateDealCustomer = _data["updateDealCustomer"];
        }
    }

    static fromJS(data: any): ReplaceMainCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReplaceMainCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceCustomerId"] = this.sourceCustomerId;
        if (Array.isArray(this.targetCustomerIds)) {
            data["targetCustomerIds"] = [];
            for (let item of this.targetCustomerIds)
                data["targetCustomerIds"].push(item);
        }
        data["updateDealCustomer"] = this.updateDealCustomer;
        return data;
    }
}

export interface IReplaceMainCustomerRequest {
    sourceCustomerId: number;
    targetCustomerIds: number[];
    updateDealCustomer: boolean;
}

export class ReportEntry implements IReportEntry {
    contractId!: string;
    rediualValue?: number | undefined;
    rkv?: string | undefined;
    listPrice?: number | undefined;

    constructor(data?: IReportEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractId = _data["contractId"];
            this.rediualValue = _data["rediualValue"];
            this.rkv = _data["rkv"];
            this.listPrice = _data["listPrice"];
        }
    }

    static fromJS(data: any): ReportEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractId"] = this.contractId;
        data["rediualValue"] = this.rediualValue;
        data["rkv"] = this.rkv;
        data["listPrice"] = this.listPrice;
        return data;
    }
}

export interface IReportEntry {
    contractId: string;
    rediualValue?: number | undefined;
    rkv?: string | undefined;
    listPrice?: number | undefined;
}

export class ReportEntryApiResult implements IReportEntryApiResult {
    messages!: ApiMessages;
    data!: ReportEntry;

    constructor(data?: IReportEntryApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ReportEntry();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ReportEntry.fromJS(_data["data"]) : new ReportEntry();
        }
    }

    static fromJS(data: any): ReportEntryApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEntryApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReportEntryApiResult {
    messages: ApiMessages;
    data: ReportEntry;
}

export class RequiredDocumentView implements IRequiredDocumentView {
    id!: number;
    name!: string;

    constructor(data?: IRequiredDocumentView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RequiredDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDocumentView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRequiredDocumentView {
    id: number;
    name: string;
}

export class RequiredDocumentViewIReadOnlyListApiResult implements IRequiredDocumentViewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: RequiredDocumentView[];

    constructor(data?: IRequiredDocumentViewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(RequiredDocumentView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequiredDocumentViewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new RequiredDocumentViewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequiredDocumentViewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: RequiredDocumentView[];
}

export class ResidualValueSnapshotData implements IResidualValueSnapshotData {
    residualValuePercentage!: number;
    residualValueAbsolute!: number;
    consideredExtrasPercentage!: number;
    consideredExtrasAbsolute!: number;
    residualValueSubsidyFixum?: number | undefined;
    residualValueSubsidyPercentage?: number | undefined;

    constructor(data?: IResidualValueSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residualValuePercentage = _data["residualValuePercentage"];
            this.residualValueAbsolute = _data["residualValueAbsolute"];
            this.consideredExtrasPercentage = _data["consideredExtrasPercentage"];
            this.consideredExtrasAbsolute = _data["consideredExtrasAbsolute"];
            this.residualValueSubsidyFixum = _data["residualValueSubsidyFixum"];
            this.residualValueSubsidyPercentage = _data["residualValueSubsidyPercentage"];
        }
    }

    static fromJS(data: any): ResidualValueSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new ResidualValueSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residualValuePercentage"] = this.residualValuePercentage;
        data["residualValueAbsolute"] = this.residualValueAbsolute;
        data["consideredExtrasPercentage"] = this.consideredExtrasPercentage;
        data["consideredExtrasAbsolute"] = this.consideredExtrasAbsolute;
        data["residualValueSubsidyFixum"] = this.residualValueSubsidyFixum;
        data["residualValueSubsidyPercentage"] = this.residualValueSubsidyPercentage;
        return data;
    }
}

export interface IResidualValueSnapshotData {
    residualValuePercentage: number;
    residualValueAbsolute: number;
    consideredExtrasPercentage: number;
    consideredExtrasAbsolute: number;
    residualValueSubsidyFixum?: number | undefined;
    residualValueSubsidyPercentage?: number | undefined;
}

export enum ResultType {
    Undefined = "Undefined",
    Application = "Application",
    Deal = "Deal",
}

export class RkvConfigurationEntry implements IRkvConfigurationEntry {
    contact!: string;
    disableOverlayDissolveDetail!: boolean;

    constructor(data?: IRkvConfigurationEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contact = _data["contact"];
            this.disableOverlayDissolveDetail = _data["disableOverlayDissolveDetail"];
        }
    }

    static fromJS(data: any): RkvConfigurationEntry {
        data = typeof data === 'object' ? data : {};
        let result = new RkvConfigurationEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contact"] = this.contact;
        data["disableOverlayDissolveDetail"] = this.disableOverlayDissolveDetail;
        return data;
    }
}

export interface IRkvConfigurationEntry {
    contact: string;
    disableOverlayDissolveDetail: boolean;
}

export class RkvConfigurationEntryApiResult implements IRkvConfigurationEntryApiResult {
    messages!: ApiMessages;
    data!: RkvConfigurationEntry;

    constructor(data?: IRkvConfigurationEntryApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new RkvConfigurationEntry();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? RkvConfigurationEntry.fromJS(_data["data"]) : new RkvConfigurationEntry();
        }
    }

    static fromJS(data: any): RkvConfigurationEntryApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new RkvConfigurationEntryApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRkvConfigurationEntryApiResult {
    messages: ApiMessages;
    data: RkvConfigurationEntry;
}

export class RuleSetOverview implements IRuleSetOverview {
    id!: string;
    name!: string;
    state!: RuleSetState;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    matched!: boolean;
    error?: string | undefined;
    rules!: ConditionDebugRuleView[];

    constructor(data?: IRuleSetOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.state = _data["state"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>undefined;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>undefined;
            this.matched = _data["matched"];
            this.error = _data["error"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [] as any;
                for (let item of _data["rules"])
                    this.rules!.push(ConditionDebugRuleView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RuleSetOverview {
        data = typeof data === 'object' ? data : {};
        let result = new RuleSetOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["state"] = this.state;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>undefined;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : <any>undefined;
        data["matched"] = this.matched;
        data["error"] = this.error;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRuleSetOverview {
    id: string;
    name: string;
    state: RuleSetState;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    matched: boolean;
    error?: string | undefined;
    rules: ConditionDebugRuleView[];
}

export enum RuleSetState {
    Disabled = "Disabled",
    Active = "Active",
    Simulation = "Simulation",
}

export class SalesAidLimitViolationView implements ISalesAidLimitViolationView {
    limit?: number | undefined;
    subsidySum?: number | undefined;
    initialValue?: number | undefined;
    subsidyRecipient?: number | undefined;
    minimum?: number | undefined;
    minKsv?: number | undefined;
    maxKsv?: number | undefined;
    info!: string;

    constructor(data?: ISalesAidLimitViolationView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
            this.subsidySum = _data["subsidySum"];
            this.initialValue = _data["initialValue"];
            this.subsidyRecipient = _data["subsidyRecipient"];
            this.minimum = _data["minimum"];
            this.minKsv = _data["minKsv"];
            this.maxKsv = _data["maxKsv"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): SalesAidLimitViolationView {
        data = typeof data === 'object' ? data : {};
        let result = new SalesAidLimitViolationView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        data["subsidySum"] = this.subsidySum;
        data["initialValue"] = this.initialValue;
        data["subsidyRecipient"] = this.subsidyRecipient;
        data["minimum"] = this.minimum;
        data["minKsv"] = this.minKsv;
        data["maxKsv"] = this.maxKsv;
        data["info"] = this.info;
        return data;
    }
}

export interface ISalesAidLimitViolationView {
    limit?: number | undefined;
    subsidySum?: number | undefined;
    initialValue?: number | undefined;
    subsidyRecipient?: number | undefined;
    minimum?: number | undefined;
    minKsv?: number | undefined;
    maxKsv?: number | undefined;
    info: string;
}

export class SalesAidView implements ISalesAidView {
    id?: number | undefined;
    name!: string;
    description?: string | undefined;
    notice?: string | undefined;
    specialOfferId?: number | undefined;
    subsidies!: SubsidyView[];
    isEditable?: boolean | undefined;
    descriptionFileId?: string | undefined;
    isLocked!: boolean;
    isBundle!: boolean;

    constructor(data?: ISalesAidView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subsidies = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.notice = _data["notice"];
            this.specialOfferId = _data["specialOfferId"];
            if (Array.isArray(_data["subsidies"])) {
                this.subsidies = [] as any;
                for (let item of _data["subsidies"])
                    this.subsidies!.push(SubsidyView.fromJS(item));
            }
            this.isEditable = _data["isEditable"];
            this.descriptionFileId = _data["descriptionFileId"];
            this.isLocked = _data["isLocked"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): SalesAidView {
        data = typeof data === 'object' ? data : {};
        let result = new SalesAidView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["notice"] = this.notice;
        data["specialOfferId"] = this.specialOfferId;
        if (Array.isArray(this.subsidies)) {
            data["subsidies"] = [];
            for (let item of this.subsidies)
                data["subsidies"].push(item.toJSON());
        }
        data["isEditable"] = this.isEditable;
        data["descriptionFileId"] = this.descriptionFileId;
        data["isLocked"] = this.isLocked;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface ISalesAidView {
    id?: number | undefined;
    name: string;
    description?: string | undefined;
    notice?: string | undefined;
    specialOfferId?: number | undefined;
    subsidies: SubsidyView[];
    isEditable?: boolean | undefined;
    descriptionFileId?: string | undefined;
    isLocked: boolean;
    isBundle: boolean;
}

export class SalesAidViewApiResult implements ISalesAidViewApiResult {
    messages!: ApiMessages;
    data!: SalesAidView;

    constructor(data?: ISalesAidViewApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SalesAidView();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SalesAidView.fromJS(_data["data"]) : new SalesAidView();
        }
    }

    static fromJS(data: any): SalesAidViewApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SalesAidViewApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISalesAidViewApiResult {
    messages: ApiMessages;
    data: SalesAidView;
}

export class SaveCalculationRequest implements ISaveCalculationRequest {
    dealId!: number;
    calculationId?: number | undefined;
    overtakenCustomerId?: number | undefined;
    removeReconsiderationReference?: boolean | undefined;
    calculation!: DealCalculation;
    /** Additional deal Data that needs to be saved after calculating */
    additionalDealData!: AdditionalDealData;

    constructor(data?: ISaveCalculationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.calculation = new DealCalculation();
            this.additionalDealData = new AdditionalDealData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.overtakenCustomerId = _data["overtakenCustomerId"];
            this.removeReconsiderationReference = _data["removeReconsiderationReference"];
            this.calculation = _data["calculation"] ? DealCalculation.fromJS(_data["calculation"]) : new DealCalculation();
            this.additionalDealData = _data["additionalDealData"] ? AdditionalDealData.fromJS(_data["additionalDealData"]) : new AdditionalDealData();
        }
    }

    static fromJS(data: any): SaveCalculationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCalculationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["overtakenCustomerId"] = this.overtakenCustomerId;
        data["removeReconsiderationReference"] = this.removeReconsiderationReference;
        data["calculation"] = this.calculation ? this.calculation.toJSON() : <any>undefined;
        data["additionalDealData"] = this.additionalDealData ? this.additionalDealData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCalculationRequest {
    dealId: number;
    calculationId?: number | undefined;
    overtakenCustomerId?: number | undefined;
    removeReconsiderationReference?: boolean | undefined;
    calculation: DealCalculation;
    /** Additional deal Data that needs to be saved after calculating */
    additionalDealData: AdditionalDealData;
}

export class SaveCalculationResponse implements ISaveCalculationResponse {
    calculationId!: number;

    constructor(data?: ISaveCalculationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationId = _data["calculationId"];
        }
    }

    static fromJS(data: any): SaveCalculationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCalculationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationId"] = this.calculationId;
        return data;
    }
}

export interface ISaveCalculationResponse {
    calculationId: number;
}

export class SaveCalculationResponseApiResult implements ISaveCalculationResponseApiResult {
    messages!: ApiMessages;
    data!: SaveCalculationResponse;

    constructor(data?: ISaveCalculationResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SaveCalculationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SaveCalculationResponse.fromJS(_data["data"]) : new SaveCalculationResponse();
        }
    }

    static fromJS(data: any): SaveCalculationResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveCalculationResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveCalculationResponseApiResult {
    messages: ApiMessages;
    data: SaveCalculationResponse;
}

export class SaveDashboardConfigurationRequest implements ISaveDashboardConfigurationRequest {
    cmsId!: string;
    dealId!: number;
    displayAsGross!: boolean;
    rate!: number;
    purchaseBy?: PurchaseBy | undefined;

    constructor(data?: ISaveDashboardConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmsId = _data["cmsId"];
            this.dealId = _data["dealId"];
            this.displayAsGross = _data["displayAsGross"];
            this.rate = _data["rate"];
            this.purchaseBy = _data["purchaseBy"];
        }
    }

    static fromJS(data: any): SaveDashboardConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDashboardConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmsId"] = this.cmsId;
        data["dealId"] = this.dealId;
        data["displayAsGross"] = this.displayAsGross;
        data["rate"] = this.rate;
        data["purchaseBy"] = this.purchaseBy;
        return data;
    }
}

export interface ISaveDashboardConfigurationRequest {
    cmsId: string;
    dealId: number;
    displayAsGross: boolean;
    rate: number;
    purchaseBy?: PurchaseBy | undefined;
}

export class SaveDealRequest implements ISaveDealRequest {
    customer!: DealCustomer;
    coApplicants!: DealCustomer[];
    calculations!: DealCalculation[];
    /** Deal Parameters should be relevant for the Calculation */
    dealParameters!: DealParameters;
    /** Additional deal Data that needs to be saved after calculating */
    additionalDealData!: AdditionalDealData;

    constructor(data?: ISaveDealRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.customer = new DealCustomer();
            this.coApplicants = [];
            this.calculations = [];
            this.dealParameters = new DealParameters();
            this.additionalDealData = new AdditionalDealData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customer = _data["customer"] ? DealCustomer.fromJS(_data["customer"]) : new DealCustomer();
            if (Array.isArray(_data["coApplicants"])) {
                this.coApplicants = [] as any;
                for (let item of _data["coApplicants"])
                    this.coApplicants!.push(DealCustomer.fromJS(item));
            }
            if (Array.isArray(_data["calculations"])) {
                this.calculations = [] as any;
                for (let item of _data["calculations"])
                    this.calculations!.push(DealCalculation.fromJS(item));
            }
            this.dealParameters = _data["dealParameters"] ? DealParameters.fromJS(_data["dealParameters"]) : new DealParameters();
            this.additionalDealData = _data["additionalDealData"] ? AdditionalDealData.fromJS(_data["additionalDealData"]) : new AdditionalDealData();
        }
    }

    static fromJS(data: any): SaveDealRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDealRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        if (Array.isArray(this.coApplicants)) {
            data["coApplicants"] = [];
            for (let item of this.coApplicants)
                data["coApplicants"].push(item.toJSON());
        }
        if (Array.isArray(this.calculations)) {
            data["calculations"] = [];
            for (let item of this.calculations)
                data["calculations"].push(item.toJSON());
        }
        data["dealParameters"] = this.dealParameters ? this.dealParameters.toJSON() : <any>undefined;
        data["additionalDealData"] = this.additionalDealData ? this.additionalDealData.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveDealRequest {
    customer: DealCustomer;
    coApplicants: DealCustomer[];
    calculations: DealCalculation[];
    /** Deal Parameters should be relevant for the Calculation */
    dealParameters: DealParameters;
    /** Additional deal Data that needs to be saved after calculating */
    additionalDealData: AdditionalDealData;
}

export class SaveDealResponse implements ISaveDealResponse {
    dealId!: number;
    calculations!: { [key: string]: CalculationMapping; };

    constructor(data?: ISaveDealResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.calculations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            if (_data["calculations"]) {
                this.calculations = {} as any;
                for (let key in _data["calculations"]) {
                    if (_data["calculations"].hasOwnProperty(key))
                        (<any>this.calculations)![key] = _data["calculations"][key] ? CalculationMapping.fromJS(_data["calculations"][key]) : new CalculationMapping();
                }
            }
        }
    }

    static fromJS(data: any): SaveDealResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDealResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        if (this.calculations) {
            data["calculations"] = {};
            for (let key in this.calculations) {
                if (this.calculations.hasOwnProperty(key))
                    (<any>data["calculations"])[key] = this.calculations[key] ? this.calculations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface ISaveDealResponse {
    dealId: number;
    calculations: { [key: string]: CalculationMapping; };
}

export class SaveDealResponseApiResult implements ISaveDealResponseApiResult {
    messages!: ApiMessages;
    data!: SaveDealResponse;

    constructor(data?: ISaveDealResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SaveDealResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SaveDealResponse.fromJS(_data["data"]) : new SaveDealResponse();
        }
    }

    static fromJS(data: any): SaveDealResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDealResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveDealResponseApiResult {
    messages: ApiMessages;
    data: SaveDealResponse;
}

export class SaveDissolveValuesRequest implements ISaveDissolveValuesRequest {
    cmsId!: number;
    dissolveValues!: DissolveValueModel[];

    constructor(data?: ISaveDissolveValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dissolveValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cmsId = _data["cmsId"];
            if (Array.isArray(_data["dissolveValues"])) {
                this.dissolveValues = [] as any;
                for (let item of _data["dissolveValues"])
                    this.dissolveValues!.push(DissolveValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveDissolveValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDissolveValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cmsId"] = this.cmsId;
        if (Array.isArray(this.dissolveValues)) {
            data["dissolveValues"] = [];
            for (let item of this.dissolveValues)
                data["dissolveValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveDissolveValuesRequest {
    cmsId: number;
    dissolveValues: DissolveValueModel[];
}

export class SaveIdentityCheckFieldsBody implements ISaveIdentityCheckFieldsBody {
    dealId?: number | undefined;
    ksvId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    companyName?: string | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;

    constructor(data?: ISaveIdentityCheckFieldsBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.ksvId = _data["ksvId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.houseNumber = _data["houseNumber"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.companyName = _data["companyName"];
            this.uidNumber = _data["uidNumber"];
            this.commercialRegisterNumber = _data["commercialRegisterNumber"];
        }
    }

    static fromJS(data: any): SaveIdentityCheckFieldsBody {
        data = typeof data === 'object' ? data : {};
        let result = new SaveIdentityCheckFieldsBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["ksvId"] = this.ksvId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["houseNumber"] = this.houseNumber;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["companyName"] = this.companyName;
        data["uidNumber"] = this.uidNumber;
        data["commercialRegisterNumber"] = this.commercialRegisterNumber;
        return data;
    }
}

export interface ISaveIdentityCheckFieldsBody {
    dealId?: number | undefined;
    ksvId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    birthDate?: Date | undefined;
    street?: string | undefined;
    houseNumber?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    companyName?: string | undefined;
    uidNumber?: string | undefined;
    commercialRegisterNumber?: string | undefined;
}

export class SaveInsuranceRequest implements ISaveInsuranceRequest {
    dealId!: number;
    id?: number | undefined;
    bmLevel?: number | undefined;
    liability_BonusMalus_Internal_Id?: number | undefined;
    usageTypeId!: number;
    kw?: number | undefined;
    co2?: number | undefined;
    weight?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    applicantId!: number;
    additionalApplicantId?: number | undefined;
    paymentPeriodId!: number;
    paymentTypeId!: number;
    specialOfferId?: number | undefined;
    enableLiability!: boolean;
    liabilityInsuranceCompanyId!: number;
    liabilityInsuranceId?: number | undefined;
    enableLegalProtection!: boolean;
    enableAccident!: boolean;
    enableKasko!: boolean;
    kaskoInsuranceCompanyId?: number | undefined;
    kaskoInsuranceId?: number | undefined;
    kaskoAdditionalProductIds!: number[];
    inputTaxDeduction!: boolean;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    kaskoPremiumOverride?: number | undefined;
    liabilityPremiumOverride?: number | undefined;
    removeCommission?: boolean | undefined;
    curbWeight?: number | undefined;

    constructor(data?: ISaveInsuranceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kaskoAdditionalProductIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.id = _data["id"];
            this.bmLevel = _data["bmLevel"];
            this.liability_BonusMalus_Internal_Id = _data["liability_BonusMalus_Internal_Id"];
            this.usageTypeId = _data["usageTypeId"];
            this.kw = _data["kw"];
            this.co2 = _data["co2"];
            this.weight = _data["weight"];
            this.numberOfSeats = _data["numberOfSeats"];
            this.maxTotalWeight = _data["maxTotalWeight"];
            this.applicantId = _data["applicantId"];
            this.additionalApplicantId = _data["additionalApplicantId"];
            this.paymentPeriodId = _data["paymentPeriodId"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.specialOfferId = _data["specialOfferId"];
            this.enableLiability = _data["enableLiability"];
            this.liabilityInsuranceCompanyId = _data["liabilityInsuranceCompanyId"];
            this.liabilityInsuranceId = _data["liabilityInsuranceId"];
            this.enableLegalProtection = _data["enableLegalProtection"];
            this.enableAccident = _data["enableAccident"];
            this.enableKasko = _data["enableKasko"];
            this.kaskoInsuranceCompanyId = _data["kaskoInsuranceCompanyId"];
            this.kaskoInsuranceId = _data["kaskoInsuranceId"];
            if (Array.isArray(_data["kaskoAdditionalProductIds"])) {
                this.kaskoAdditionalProductIds = [] as any;
                for (let item of _data["kaskoAdditionalProductIds"])
                    this.kaskoAdditionalProductIds!.push(item);
            }
            this.inputTaxDeduction = _data["inputTaxDeduction"];
            this.liabilityPremiumDiscount = _data["liabilityPremiumDiscount"];
            this.kaskoPremiumDiscount = _data["kaskoPremiumDiscount"];
            this.kaskoPremiumOverride = _data["kaskoPremiumOverride"];
            this.liabilityPremiumOverride = _data["liabilityPremiumOverride"];
            this.removeCommission = _data["removeCommission"];
            this.curbWeight = _data["curbWeight"];
        }
    }

    static fromJS(data: any): SaveInsuranceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInsuranceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["id"] = this.id;
        data["bmLevel"] = this.bmLevel;
        data["liability_BonusMalus_Internal_Id"] = this.liability_BonusMalus_Internal_Id;
        data["usageTypeId"] = this.usageTypeId;
        data["kw"] = this.kw;
        data["co2"] = this.co2;
        data["weight"] = this.weight;
        data["numberOfSeats"] = this.numberOfSeats;
        data["maxTotalWeight"] = this.maxTotalWeight;
        data["applicantId"] = this.applicantId;
        data["additionalApplicantId"] = this.additionalApplicantId;
        data["paymentPeriodId"] = this.paymentPeriodId;
        data["paymentTypeId"] = this.paymentTypeId;
        data["specialOfferId"] = this.specialOfferId;
        data["enableLiability"] = this.enableLiability;
        data["liabilityInsuranceCompanyId"] = this.liabilityInsuranceCompanyId;
        data["liabilityInsuranceId"] = this.liabilityInsuranceId;
        data["enableLegalProtection"] = this.enableLegalProtection;
        data["enableAccident"] = this.enableAccident;
        data["enableKasko"] = this.enableKasko;
        data["kaskoInsuranceCompanyId"] = this.kaskoInsuranceCompanyId;
        data["kaskoInsuranceId"] = this.kaskoInsuranceId;
        if (Array.isArray(this.kaskoAdditionalProductIds)) {
            data["kaskoAdditionalProductIds"] = [];
            for (let item of this.kaskoAdditionalProductIds)
                data["kaskoAdditionalProductIds"].push(item);
        }
        data["inputTaxDeduction"] = this.inputTaxDeduction;
        data["liabilityPremiumDiscount"] = this.liabilityPremiumDiscount;
        data["kaskoPremiumDiscount"] = this.kaskoPremiumDiscount;
        data["kaskoPremiumOverride"] = this.kaskoPremiumOverride;
        data["liabilityPremiumOverride"] = this.liabilityPremiumOverride;
        data["removeCommission"] = this.removeCommission;
        data["curbWeight"] = this.curbWeight;
        return data;
    }
}

export interface ISaveInsuranceRequest {
    dealId: number;
    id?: number | undefined;
    bmLevel?: number | undefined;
    liability_BonusMalus_Internal_Id?: number | undefined;
    usageTypeId: number;
    kw?: number | undefined;
    co2?: number | undefined;
    weight?: number | undefined;
    numberOfSeats?: number | undefined;
    maxTotalWeight?: number | undefined;
    applicantId: number;
    additionalApplicantId?: number | undefined;
    paymentPeriodId: number;
    paymentTypeId: number;
    specialOfferId?: number | undefined;
    enableLiability: boolean;
    liabilityInsuranceCompanyId: number;
    liabilityInsuranceId?: number | undefined;
    enableLegalProtection: boolean;
    enableAccident: boolean;
    enableKasko: boolean;
    kaskoInsuranceCompanyId?: number | undefined;
    kaskoInsuranceId?: number | undefined;
    kaskoAdditionalProductIds: number[];
    inputTaxDeduction: boolean;
    liabilityPremiumDiscount?: number | undefined;
    kaskoPremiumDiscount?: number | undefined;
    kaskoPremiumOverride?: number | undefined;
    liabilityPremiumOverride?: number | undefined;
    removeCommission?: boolean | undefined;
    curbWeight?: number | undefined;
}

export class SaveInsuranceResponse implements ISaveInsuranceResponse {

    constructor(data?: ISaveInsuranceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SaveInsuranceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInsuranceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISaveInsuranceResponse {
}

export class SaveInsuranceResponseApiResult implements ISaveInsuranceResponseApiResult {
    messages!: ApiMessages;
    data!: SaveInsuranceResponse;

    constructor(data?: ISaveInsuranceResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SaveInsuranceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SaveInsuranceResponse.fromJS(_data["data"]) : new SaveInsuranceResponse();
        }
    }

    static fromJS(data: any): SaveInsuranceResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveInsuranceResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveInsuranceResponseApiResult {
    messages: ApiMessages;
    data: SaveInsuranceResponse;
}

export class SaveProposalRequest implements ISaveProposalRequest {
    cacheGuid?: string | undefined;
    dealId!: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId!: number;
    duration!: number;
    isServiceVariantsResetRequest!: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId!: number;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest!: boolean;
    preCheckServiceProductSelectionsFromApicon!: boolean;
    isPriceFormSpecialCaseMandatory!: boolean;
    isServiceVariantSaveRequest!: boolean;
    isBundle!: boolean;

    constructor(data?: ISaveProposalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheGuid = _data["cacheGuid"];
            this.dealId = _data["dealId"];
            this.calculationId = _data["calculationId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.serviceProductId = _data["serviceProductId"];
            this.mileageId = _data["mileageId"];
            this.duration = _data["duration"];
            this.isServiceVariantsResetRequest = _data["isServiceVariantsResetRequest"];
            this.serviceChargeNet = _data["serviceChargeNet"];
            this.configurationID = _data["configurationID"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.campaignId = _data["campaignId"];
            this.priceNet = _data["priceNet"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.fundingProductId = _data["fundingProductId"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.specialCaseRequestBundle = _data["specialCaseRequestBundle"] ? ApiconSpecialCaseRequestBundle.fromJS(_data["specialCaseRequestBundle"]) : <any>undefined;
            this.preCheckServiceProductSelectionsFromRequest = _data["preCheckServiceProductSelectionsFromRequest"];
            this.preCheckServiceProductSelectionsFromApicon = _data["preCheckServiceProductSelectionsFromApicon"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.isServiceVariantSaveRequest = _data["isServiceVariantSaveRequest"];
            this.isBundle = _data["isBundle"];
        }
    }

    static fromJS(data: any): SaveProposalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveProposalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheGuid"] = this.cacheGuid;
        data["dealId"] = this.dealId;
        data["calculationId"] = this.calculationId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["serviceProductId"] = this.serviceProductId;
        data["mileageId"] = this.mileageId;
        data["duration"] = this.duration;
        data["isServiceVariantsResetRequest"] = this.isServiceVariantsResetRequest;
        data["serviceChargeNet"] = this.serviceChargeNet;
        data["configurationID"] = this.configurationID;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["campaignId"] = this.campaignId;
        data["priceNet"] = this.priceNet;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["fundingProductId"] = this.fundingProductId;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["specialCaseRequestBundle"] = this.specialCaseRequestBundle ? this.specialCaseRequestBundle.toJSON() : <any>undefined;
        data["preCheckServiceProductSelectionsFromRequest"] = this.preCheckServiceProductSelectionsFromRequest;
        data["preCheckServiceProductSelectionsFromApicon"] = this.preCheckServiceProductSelectionsFromApicon;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["isServiceVariantSaveRequest"] = this.isServiceVariantSaveRequest;
        data["isBundle"] = this.isBundle;
        return data;
    }
}

export interface ISaveProposalRequest {
    cacheGuid?: string | undefined;
    dealId: number;
    calculationId?: number | undefined;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    serviceProductId?: string | undefined;
    mileageId: number;
    duration: number;
    isServiceVariantsResetRequest: boolean;
    serviceChargeNet?: number | undefined;
    configurationID?: string | undefined;
    productOptionIds?: string[] | undefined;
    productIndustryId?: string | undefined;
    productUsageId?: string | undefined;
    technicalOptionIds?: string[] | undefined;
    campaignId?: string | undefined;
    priceNet?: number | undefined;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    fundingProductId: number;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    specialCaseRequestBundle?: ApiconSpecialCaseRequestBundle | undefined;
    preCheckServiceProductSelectionsFromRequest: boolean;
    preCheckServiceProductSelectionsFromApicon: boolean;
    isPriceFormSpecialCaseMandatory: boolean;
    isServiceVariantSaveRequest: boolean;
    isBundle: boolean;
}

export class SaveServiceVariantRequest implements ISaveServiceVariantRequest {
    calculationId!: number;
    dealId!: number;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    cacheGuid?: string | undefined;
    mileageId!: number;
    serviceProductId!: string;
    productIndustryId!: string;
    productUsageId!: string;
    campaignId!: string;
    productOptionIds!: string[];
    technicalOptionIds!: string[];
    priceNet?: number | undefined;
    totalPrice?: number | undefined;
    priceFormState!: ApiconSpecialCasePriceFormState;
    uptimeInfos?: ApiconUptimeInfosForm | undefined;
    configurationID!: string;
    isPriceFormSpecialCaseMandatory!: boolean;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    duration!: number;

    constructor(data?: ISaveServiceVariantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.productOptionIds = [];
            this.technicalOptionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculationId = _data["calculationId"];
            this.dealId = _data["dealId"];
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
            this.cacheGuid = _data["cacheGuid"];
            this.mileageId = _data["mileageId"];
            this.serviceProductId = _data["serviceProductId"];
            this.productIndustryId = _data["productIndustryId"];
            this.productUsageId = _data["productUsageId"];
            this.campaignId = _data["campaignId"];
            if (Array.isArray(_data["productOptionIds"])) {
                this.productOptionIds = [] as any;
                for (let item of _data["productOptionIds"])
                    this.productOptionIds!.push(item);
            }
            if (Array.isArray(_data["technicalOptionIds"])) {
                this.technicalOptionIds = [] as any;
                for (let item of _data["technicalOptionIds"])
                    this.technicalOptionIds!.push(item);
            }
            this.priceNet = _data["priceNet"];
            this.totalPrice = _data["totalPrice"];
            this.priceFormState = _data["priceFormState"];
            this.uptimeInfos = _data["uptimeInfos"] ? ApiconUptimeInfosForm.fromJS(_data["uptimeInfos"]) : <any>undefined;
            this.configurationID = _data["configurationID"];
            this.isPriceFormSpecialCaseMandatory = _data["isPriceFormSpecialCaseMandatory"];
            this.baumuster = _data["baumuster"];
            this.nstCode = _data["nstCode"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): SaveServiceVariantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaveServiceVariantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculationId"] = this.calculationId;
        data["dealId"] = this.dealId;
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        data["cacheGuid"] = this.cacheGuid;
        data["mileageId"] = this.mileageId;
        data["serviceProductId"] = this.serviceProductId;
        data["productIndustryId"] = this.productIndustryId;
        data["productUsageId"] = this.productUsageId;
        data["campaignId"] = this.campaignId;
        if (Array.isArray(this.productOptionIds)) {
            data["productOptionIds"] = [];
            for (let item of this.productOptionIds)
                data["productOptionIds"].push(item);
        }
        if (Array.isArray(this.technicalOptionIds)) {
            data["technicalOptionIds"] = [];
            for (let item of this.technicalOptionIds)
                data["technicalOptionIds"].push(item);
        }
        data["priceNet"] = this.priceNet;
        data["totalPrice"] = this.totalPrice;
        data["priceFormState"] = this.priceFormState;
        data["uptimeInfos"] = this.uptimeInfos ? this.uptimeInfos.toJSON() : <any>undefined;
        data["configurationID"] = this.configurationID;
        data["isPriceFormSpecialCaseMandatory"] = this.isPriceFormSpecialCaseMandatory;
        data["baumuster"] = this.baumuster;
        data["nstCode"] = this.nstCode;
        data["duration"] = this.duration;
        return data;
    }
}

export interface ISaveServiceVariantRequest {
    calculationId: number;
    dealId: number;
    serviceVariantId?: number | undefined;
    variantNumber?: number | undefined;
    cacheGuid?: string | undefined;
    mileageId: number;
    serviceProductId: string;
    productIndustryId: string;
    productUsageId: string;
    campaignId: string;
    productOptionIds: string[];
    technicalOptionIds: string[];
    priceNet?: number | undefined;
    totalPrice?: number | undefined;
    priceFormState: ApiconSpecialCasePriceFormState;
    uptimeInfos?: ApiconUptimeInfosForm | undefined;
    configurationID: string;
    isPriceFormSpecialCaseMandatory: boolean;
    baumuster?: string | undefined;
    nstCode?: string | undefined;
    duration: number;
}

export class SaveServiceVariantResponse implements ISaveServiceVariantResponse {
    serviceVariantId!: number;
    variantNumber!: number;

    constructor(data?: ISaveServiceVariantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceVariantId = _data["serviceVariantId"];
            this.variantNumber = _data["variantNumber"];
        }
    }

    static fromJS(data: any): SaveServiceVariantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SaveServiceVariantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceVariantId"] = this.serviceVariantId;
        data["variantNumber"] = this.variantNumber;
        return data;
    }
}

export interface ISaveServiceVariantResponse {
    serviceVariantId: number;
    variantNumber: number;
}

export class SaveServiceVariantResponseApiResult implements ISaveServiceVariantResponseApiResult {
    messages!: ApiMessages;
    data!: SaveServiceVariantResponse;

    constructor(data?: ISaveServiceVariantResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SaveServiceVariantResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SaveServiceVariantResponse.fromJS(_data["data"]) : new SaveServiceVariantResponse();
        }
    }

    static fromJS(data: any): SaveServiceVariantResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SaveServiceVariantResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveServiceVariantResponseApiResult {
    messages: ApiMessages;
    data: SaveServiceVariantResponse;
}

export class SendFinancingCalculationDocumentsRequest implements ISendFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId!: number;
    /** Euribor Datum */
    selectedEuriborId!: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross!: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross!: boolean;
    turnOverTaxStatementRequested!: boolean;
    useCoApplicantAccount!: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds!: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds!: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds!: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];
    /** Betreff der Email */
    subject!: string;
    /** Text der Email */
    text!: string;
    /** Email wird auch in CC zum eingeloggten Verkäufer versendet */
    sendAlsoToSalesman!: boolean;
    suppressEuriborAutoUpdate!: boolean;

    constructor(data?: ISendFinancingCalculationDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.offerDocumentIds = [];
            this.termsheetDocumentIds = [];
            this.contractDocumentIds = [];
            this.miscellaneousDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financingCalculationId = _data["financingCalculationId"];
            this.selectedEuriborId = _data["selectedEuriborId"];
            this.termsheet = _data["termsheet"];
            this.leasingContractNotes = _data["leasingContractNotes"];
            this.offerSupplement = _data["offerSupplement"];
            this.calculationGross = _data["calculationGross"];
            this.termsheetCalculationGross = _data["termsheetCalculationGross"];
            this.turnOverTaxStatementRequested = _data["turnOverTaxStatementRequested"];
            this.useCoApplicantAccount = _data["useCoApplicantAccount"];
            if (Array.isArray(_data["offerDocumentIds"])) {
                this.offerDocumentIds = [] as any;
                for (let item of _data["offerDocumentIds"])
                    this.offerDocumentIds!.push(item);
            }
            if (Array.isArray(_data["termsheetDocumentIds"])) {
                this.termsheetDocumentIds = [] as any;
                for (let item of _data["termsheetDocumentIds"])
                    this.termsheetDocumentIds!.push(item);
            }
            if (Array.isArray(_data["contractDocumentIds"])) {
                this.contractDocumentIds = [] as any;
                for (let item of _data["contractDocumentIds"])
                    this.contractDocumentIds!.push(item);
            }
            if (Array.isArray(_data["miscellaneousDocumentIds"])) {
                this.miscellaneousDocumentIds = [] as any;
                for (let item of _data["miscellaneousDocumentIds"])
                    this.miscellaneousDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
            this.subject = _data["subject"];
            this.text = _data["text"];
            this.sendAlsoToSalesman = _data["sendAlsoToSalesman"];
            this.suppressEuriborAutoUpdate = _data["suppressEuriborAutoUpdate"];
        }
    }

    static fromJS(data: any): SendFinancingCalculationDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendFinancingCalculationDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingCalculationId"] = this.financingCalculationId;
        data["selectedEuriborId"] = this.selectedEuriborId;
        data["termsheet"] = this.termsheet;
        data["leasingContractNotes"] = this.leasingContractNotes;
        data["offerSupplement"] = this.offerSupplement;
        data["calculationGross"] = this.calculationGross;
        data["termsheetCalculationGross"] = this.termsheetCalculationGross;
        data["turnOverTaxStatementRequested"] = this.turnOverTaxStatementRequested;
        data["useCoApplicantAccount"] = this.useCoApplicantAccount;
        if (Array.isArray(this.offerDocumentIds)) {
            data["offerDocumentIds"] = [];
            for (let item of this.offerDocumentIds)
                data["offerDocumentIds"].push(item);
        }
        if (Array.isArray(this.termsheetDocumentIds)) {
            data["termsheetDocumentIds"] = [];
            for (let item of this.termsheetDocumentIds)
                data["termsheetDocumentIds"].push(item);
        }
        if (Array.isArray(this.contractDocumentIds)) {
            data["contractDocumentIds"] = [];
            for (let item of this.contractDocumentIds)
                data["contractDocumentIds"].push(item);
        }
        if (Array.isArray(this.miscellaneousDocumentIds)) {
            data["miscellaneousDocumentIds"] = [];
            for (let item of this.miscellaneousDocumentIds)
                data["miscellaneousDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        data["subject"] = this.subject;
        data["text"] = this.text;
        data["sendAlsoToSalesman"] = this.sendAlsoToSalesman;
        data["suppressEuriborAutoUpdate"] = this.suppressEuriborAutoUpdate;
        return data;
    }
}

export interface ISendFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId: number;
    /** Euribor Datum */
    selectedEuriborId: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross: boolean;
    turnOverTaxStatementRequested: boolean;
    useCoApplicantAccount: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
    /** Betreff der Email */
    subject: string;
    /** Text der Email */
    text: string;
    /** Email wird auch in CC zum eingeloggten Verkäufer versendet */
    sendAlsoToSalesman: boolean;
    suppressEuriborAutoUpdate: boolean;
}

export class SendInsuranceDocumentsRequest implements ISendInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId!: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired!: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];
    /** Betreff der Email */
    subject!: string;
    /** Text der Email */
    text!: string;
    /** Email wird auch in CC zum eingeloggten Verkäufer versendet */
    sendAlsoToSaltesman!: boolean;

    constructor(data?: ISendInsuranceDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.insuranceDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceCalculationId = _data["insuranceCalculationId"];
            this.offerSupplement = _data["offerSupplement"];
            this.previousInsuranceInfoRequired = _data["previousInsuranceInfoRequired"];
            this.previousInsuranceCompanyName = _data["previousInsuranceCompanyName"];
            this.previousTerminateContract = _data["previousTerminateContract"];
            this.previousContractNumber = _data["previousContractNumber"];
            this.previousLicensePlate = _data["previousLicensePlate"];
            this.previousContractTypeId = _data["previousContractTypeId"];
            this.waiverOfBonus = _data["waiverOfBonus"];
            if (Array.isArray(_data["insuranceDocumentIds"])) {
                this.insuranceDocumentIds = [] as any;
                for (let item of _data["insuranceDocumentIds"])
                    this.insuranceDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
            this.subject = _data["subject"];
            this.text = _data["text"];
            this.sendAlsoToSaltesman = _data["sendAlsoToSaltesman"];
        }
    }

    static fromJS(data: any): SendInsuranceDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendInsuranceDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceCalculationId"] = this.insuranceCalculationId;
        data["offerSupplement"] = this.offerSupplement;
        data["previousInsuranceInfoRequired"] = this.previousInsuranceInfoRequired;
        data["previousInsuranceCompanyName"] = this.previousInsuranceCompanyName;
        data["previousTerminateContract"] = this.previousTerminateContract;
        data["previousContractNumber"] = this.previousContractNumber;
        data["previousLicensePlate"] = this.previousLicensePlate;
        data["previousContractTypeId"] = this.previousContractTypeId;
        data["waiverOfBonus"] = this.waiverOfBonus;
        if (Array.isArray(this.insuranceDocumentIds)) {
            data["insuranceDocumentIds"] = [];
            for (let item of this.insuranceDocumentIds)
                data["insuranceDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        data["subject"] = this.subject;
        data["text"] = this.text;
        data["sendAlsoToSaltesman"] = this.sendAlsoToSaltesman;
        return data;
    }
}

export interface ISendInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
    /** Betreff der Email */
    subject: string;
    /** Text der Email */
    text: string;
    /** Email wird auch in CC zum eingeloggten Verkäufer versendet */
    sendAlsoToSaltesman: boolean;
}

export class SendPurchaseApplicationRequest implements ISendPurchaseApplicationRequest {
    contractNumber!: string;
    dealId!: number;
    date!: Date;
    purchasePrice!: number;
    noMboeCharge!: boolean;
    isPurchasesByLesee!: boolean;
    isFollowUp!: boolean;
    commissionNumber?: string | undefined;

    constructor(data?: ISendPurchaseApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractNumber = _data["contractNumber"];
            this.dealId = _data["dealId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.purchasePrice = _data["purchasePrice"];
            this.noMboeCharge = _data["noMboeCharge"];
            this.isPurchasesByLesee = _data["isPurchasesByLesee"];
            this.isFollowUp = _data["isFollowUp"];
            this.commissionNumber = _data["commissionNumber"];
        }
    }

    static fromJS(data: any): SendPurchaseApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendPurchaseApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractNumber"] = this.contractNumber;
        data["dealId"] = this.dealId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["purchasePrice"] = this.purchasePrice;
        data["noMboeCharge"] = this.noMboeCharge;
        data["isPurchasesByLesee"] = this.isPurchasesByLesee;
        data["isFollowUp"] = this.isFollowUp;
        data["commissionNumber"] = this.commissionNumber;
        return data;
    }
}

export interface ISendPurchaseApplicationRequest {
    contractNumber: string;
    dealId: number;
    date: Date;
    purchasePrice: number;
    noMboeCharge: boolean;
    isPurchasesByLesee: boolean;
    isFollowUp: boolean;
    commissionNumber?: string | undefined;
}

export class SendPurchaseApplicationResponse implements ISendPurchaseApplicationResponse {
    fileId!: string;

    constructor(data?: ISendPurchaseApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): SendPurchaseApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendPurchaseApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface ISendPurchaseApplicationResponse {
    fileId: string;
}

export class SendPurchaseApplicationResponseApiResult implements ISendPurchaseApplicationResponseApiResult {
    messages!: ApiMessages;
    data!: SendPurchaseApplicationResponse;

    constructor(data?: ISendPurchaseApplicationResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SendPurchaseApplicationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SendPurchaseApplicationResponse.fromJS(_data["data"]) : new SendPurchaseApplicationResponse();
        }
    }

    static fromJS(data: any): SendPurchaseApplicationResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendPurchaseApplicationResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendPurchaseApplicationResponseApiResult {
    messages: ApiMessages;
    data: SendPurchaseApplicationResponse;
}

export class SendToCreditCheckRequest implements ISendToCreditCheckRequest {
    financialCalculationId!: number;
    termsheet?: string | undefined;
    providerId!: number;
    selectedEuriborDateId!: number;
    handoverDealerId!: number;
    commissionDealerId?: number | undefined;

    constructor(data?: ISendToCreditCheckRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialCalculationId = _data["financialCalculationId"];
            this.termsheet = _data["termsheet"];
            this.providerId = _data["providerId"];
            this.selectedEuriborDateId = _data["selectedEuriborDateId"];
            this.handoverDealerId = _data["handoverDealerId"];
            this.commissionDealerId = _data["commissionDealerId"];
        }
    }

    static fromJS(data: any): SendToCreditCheckRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendToCreditCheckRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialCalculationId"] = this.financialCalculationId;
        data["termsheet"] = this.termsheet;
        data["providerId"] = this.providerId;
        data["selectedEuriborDateId"] = this.selectedEuriborDateId;
        data["handoverDealerId"] = this.handoverDealerId;
        data["commissionDealerId"] = this.commissionDealerId;
        return data;
    }
}

export interface ISendToCreditCheckRequest {
    financialCalculationId: number;
    termsheet?: string | undefined;
    providerId: number;
    selectedEuriborDateId: number;
    handoverDealerId: number;
    commissionDealerId?: number | undefined;
}

export class SendToCreditCheckResponse implements ISendToCreditCheckResponse {

    constructor(data?: ISendToCreditCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendToCreditCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendToCreditCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendToCreditCheckResponse {
}

export class SendToCreditCheckResponseApiResult implements ISendToCreditCheckResponseApiResult {
    messages!: ApiMessages;
    data!: SendToCreditCheckResponse;

    constructor(data?: ISendToCreditCheckResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SendToCreditCheckResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SendToCreditCheckResponse.fromJS(_data["data"]) : new SendToCreditCheckResponse();
        }
    }

    static fromJS(data: any): SendToCreditCheckResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendToCreditCheckResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendToCreditCheckResponseApiResult {
    messages: ApiMessages;
    data: SendToCreditCheckResponse;
}

export class SendTypeCertificateRequest implements ISendTypeCertificateRequest {
    dealId!: number;
    contractId!: number;
    recipient!: string;
    additionalInfo?: string | undefined;
    street!: string;
    postalCode!: string;
    city!: string;
    country!: string;
    reasonId!: number;

    constructor(data?: ISendTypeCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.contractId = _data["contractId"];
            this.recipient = _data["recipient"];
            this.additionalInfo = _data["additionalInfo"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.reasonId = _data["reasonId"];
        }
    }

    static fromJS(data: any): SendTypeCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendTypeCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["contractId"] = this.contractId;
        data["recipient"] = this.recipient;
        data["additionalInfo"] = this.additionalInfo;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["reasonId"] = this.reasonId;
        return data;
    }
}

export interface ISendTypeCertificateRequest {
    dealId: number;
    contractId: number;
    recipient: string;
    additionalInfo?: string | undefined;
    street: string;
    postalCode: string;
    city: string;
    country: string;
    reasonId: number;
}

export class SendTypeCertificateResponse implements ISendTypeCertificateResponse {

    constructor(data?: ISendTypeCertificateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SendTypeCertificateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendTypeCertificateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISendTypeCertificateResponse {
}

export class SendTypeCertificateResponseApiResult implements ISendTypeCertificateResponseApiResult {
    messages!: ApiMessages;
    data!: SendTypeCertificateResponse;

    constructor(data?: ISendTypeCertificateResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SendTypeCertificateResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SendTypeCertificateResponse.fromJS(_data["data"]) : new SendTypeCertificateResponse();
        }
    }

    static fromJS(data: any): SendTypeCertificateResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendTypeCertificateResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISendTypeCertificateResponseApiResult {
    messages: ApiMessages;
    data: SendTypeCertificateResponse;
}

export class ServiceConfigurationResponse implements IServiceConfigurationResponse {
    fuelServiceProductId?: number | undefined;

    constructor(data?: IServiceConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelServiceProductId = _data["fuelServiceProductId"];
        }
    }

    static fromJS(data: any): ServiceConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelServiceProductId"] = this.fuelServiceProductId;
        return data;
    }
}

export interface IServiceConfigurationResponse {
    fuelServiceProductId?: number | undefined;
}

export class ServiceOption implements IServiceOption {
    id?: string | undefined;
    text?: string | undefined;
    isSelected!: boolean;
    isReadOnly!: boolean;
    isUptimeOption!: boolean;
    requiredTechnicalOptionIds?: string[] | undefined;

    constructor(data?: IServiceOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.isSelected = _data["isSelected"];
            this.isReadOnly = _data["isReadOnly"];
            this.isUptimeOption = _data["isUptimeOption"];
            if (Array.isArray(_data["requiredTechnicalOptionIds"])) {
                this.requiredTechnicalOptionIds = [] as any;
                for (let item of _data["requiredTechnicalOptionIds"])
                    this.requiredTechnicalOptionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceOption {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["isSelected"] = this.isSelected;
        data["isReadOnly"] = this.isReadOnly;
        data["isUptimeOption"] = this.isUptimeOption;
        if (Array.isArray(this.requiredTechnicalOptionIds)) {
            data["requiredTechnicalOptionIds"] = [];
            for (let item of this.requiredTechnicalOptionIds)
                data["requiredTechnicalOptionIds"].push(item);
        }
        return data;
    }
}

export interface IServiceOption {
    id?: string | undefined;
    text?: string | undefined;
    isSelected: boolean;
    isReadOnly: boolean;
    isUptimeOption: boolean;
    requiredTechnicalOptionIds?: string[] | undefined;
}

export class ServiceProduct implements IServiceProduct {
    productId?: string | undefined;
    productDesignation?: string | undefined;

    constructor(data?: IServiceProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data["productId"];
            this.productDesignation = _data["productDesignation"];
        }
    }

    static fromJS(data: any): ServiceProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productId"] = this.productId;
        data["productDesignation"] = this.productDesignation;
        return data;
    }
}

export interface IServiceProduct {
    productId?: string | undefined;
    productDesignation?: string | undefined;
}

export class SetApprovalRequest implements ISetApprovalRequest {
    isAccepted!: boolean;

    constructor(data?: ISetApprovalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccepted = _data["isAccepted"];
        }
    }

    static fromJS(data: any): SetApprovalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetApprovalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccepted"] = this.isAccepted;
        return data;
    }
}

export interface ISetApprovalRequest {
    isAccepted: boolean;
}

export class SetPrimaryInsuranceRequest implements ISetPrimaryInsuranceRequest {
    dealId!: number;
    primaryId!: number;

    constructor(data?: ISetPrimaryInsuranceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.primaryId = _data["primaryId"];
        }
    }

    static fromJS(data: any): SetPrimaryInsuranceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetPrimaryInsuranceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["primaryId"] = this.primaryId;
        return data;
    }
}

export interface ISetPrimaryInsuranceRequest {
    dealId: number;
    primaryId: number;
}

export class SignFinancingCalculationDocumentsRequest implements ISignFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId!: number;
    /** Euribor Datum */
    selectedEuriborId!: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross!: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross!: boolean;
    turnOverTaxStatementRequested!: boolean;
    useCoApplicantAccount!: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds!: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds!: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds!: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];
    suppressEuriborAutoUpdate!: boolean;

    constructor(data?: ISignFinancingCalculationDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.offerDocumentIds = [];
            this.termsheetDocumentIds = [];
            this.contractDocumentIds = [];
            this.miscellaneousDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financingCalculationId = _data["financingCalculationId"];
            this.selectedEuriborId = _data["selectedEuriborId"];
            this.termsheet = _data["termsheet"];
            this.leasingContractNotes = _data["leasingContractNotes"];
            this.offerSupplement = _data["offerSupplement"];
            this.calculationGross = _data["calculationGross"];
            this.termsheetCalculationGross = _data["termsheetCalculationGross"];
            this.turnOverTaxStatementRequested = _data["turnOverTaxStatementRequested"];
            this.useCoApplicantAccount = _data["useCoApplicantAccount"];
            if (Array.isArray(_data["offerDocumentIds"])) {
                this.offerDocumentIds = [] as any;
                for (let item of _data["offerDocumentIds"])
                    this.offerDocumentIds!.push(item);
            }
            if (Array.isArray(_data["termsheetDocumentIds"])) {
                this.termsheetDocumentIds = [] as any;
                for (let item of _data["termsheetDocumentIds"])
                    this.termsheetDocumentIds!.push(item);
            }
            if (Array.isArray(_data["contractDocumentIds"])) {
                this.contractDocumentIds = [] as any;
                for (let item of _data["contractDocumentIds"])
                    this.contractDocumentIds!.push(item);
            }
            if (Array.isArray(_data["miscellaneousDocumentIds"])) {
                this.miscellaneousDocumentIds = [] as any;
                for (let item of _data["miscellaneousDocumentIds"])
                    this.miscellaneousDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
            this.suppressEuriborAutoUpdate = _data["suppressEuriborAutoUpdate"];
        }
    }

    static fromJS(data: any): SignFinancingCalculationDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignFinancingCalculationDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingCalculationId"] = this.financingCalculationId;
        data["selectedEuriborId"] = this.selectedEuriborId;
        data["termsheet"] = this.termsheet;
        data["leasingContractNotes"] = this.leasingContractNotes;
        data["offerSupplement"] = this.offerSupplement;
        data["calculationGross"] = this.calculationGross;
        data["termsheetCalculationGross"] = this.termsheetCalculationGross;
        data["turnOverTaxStatementRequested"] = this.turnOverTaxStatementRequested;
        data["useCoApplicantAccount"] = this.useCoApplicantAccount;
        if (Array.isArray(this.offerDocumentIds)) {
            data["offerDocumentIds"] = [];
            for (let item of this.offerDocumentIds)
                data["offerDocumentIds"].push(item);
        }
        if (Array.isArray(this.termsheetDocumentIds)) {
            data["termsheetDocumentIds"] = [];
            for (let item of this.termsheetDocumentIds)
                data["termsheetDocumentIds"].push(item);
        }
        if (Array.isArray(this.contractDocumentIds)) {
            data["contractDocumentIds"] = [];
            for (let item of this.contractDocumentIds)
                data["contractDocumentIds"].push(item);
        }
        if (Array.isArray(this.miscellaneousDocumentIds)) {
            data["miscellaneousDocumentIds"] = [];
            for (let item of this.miscellaneousDocumentIds)
                data["miscellaneousDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        data["suppressEuriborAutoUpdate"] = this.suppressEuriborAutoUpdate;
        return data;
    }
}

export interface ISignFinancingCalculationDocumentsRequest {
    /** FinancingCalculation Id */
    financingCalculationId: number;
    /** Euribor Datum */
    selectedEuriborId: number;
    /** Informationen für Bonitätsabteilung */
    termsheet?: string | undefined;
    /** Sonstige Bemerkungen zum Vertrag */
    leasingContractNotes?: string | undefined;
    /** Angebotszusatz Finanzierung */
    offerSupplement?: string | undefined;
    /** Angebot Brutto / Netto */
    calculationGross: boolean;
    /** Einreichblatt Brutto / Netto */
    termsheetCalculationGross: boolean;
    turnOverTaxStatementRequested: boolean;
    useCoApplicantAccount: boolean;
    /** Angebots-Dokumente */
    offerDocumentIds: number[];
    /** Einreichblatt-Dokumente */
    termsheetDocumentIds: number[];
    /** Vertrags-Dokumente */
    contractDocumentIds: number[];
    /** Sonstige-Dokumente */
    miscellaneousDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
    suppressEuriborAutoUpdate: boolean;
}

export class SignFinancingCalculationDocumentsResponse implements ISignFinancingCalculationDocumentsResponse {
    /** Dokument Name */
    documentName!: string;
    /** Dokument PIN */
    documentPin?: string | undefined;
    /** URL zum Signieren */
    signDocumentUrl!: string;

    constructor(data?: ISignFinancingCalculationDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.documentPin = _data["documentPin"];
            this.signDocumentUrl = _data["signDocumentUrl"];
        }
    }

    static fromJS(data: any): SignFinancingCalculationDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignFinancingCalculationDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["documentPin"] = this.documentPin;
        data["signDocumentUrl"] = this.signDocumentUrl;
        return data;
    }
}

export interface ISignFinancingCalculationDocumentsResponse {
    /** Dokument Name */
    documentName: string;
    /** Dokument PIN */
    documentPin?: string | undefined;
    /** URL zum Signieren */
    signDocumentUrl: string;
}

export class SignFinancingCalculationDocumentsResponseApiResult implements ISignFinancingCalculationDocumentsResponseApiResult {
    messages!: ApiMessages;
    data!: SignFinancingCalculationDocumentsResponse;

    constructor(data?: ISignFinancingCalculationDocumentsResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SignFinancingCalculationDocumentsResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SignFinancingCalculationDocumentsResponse.fromJS(_data["data"]) : new SignFinancingCalculationDocumentsResponse();
        }
    }

    static fromJS(data: any): SignFinancingCalculationDocumentsResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignFinancingCalculationDocumentsResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISignFinancingCalculationDocumentsResponseApiResult {
    messages: ApiMessages;
    data: SignFinancingCalculationDocumentsResponse;
}

export class SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult implements ISignFinancingCalculationDocumentsResponseIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: SignFinancingCalculationDocumentsResponse[];

    constructor(data?: ISignFinancingCalculationDocumentsResponseIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SignFinancingCalculationDocumentsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignFinancingCalculationDocumentsResponseIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignFinancingCalculationDocumentsResponseIReadOnlyListApiResult {
    messages: ApiMessages;
    data: SignFinancingCalculationDocumentsResponse[];
}

export class SignInsuranceDocumentsRequest implements ISignInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId!: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired!: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds!: number[];
    /** Kunden-Dokumente */
    customerDocumentIds!: string[];

    constructor(data?: ISignInsuranceDocumentsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.insuranceDocumentIds = [];
            this.customerDocumentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.insuranceCalculationId = _data["insuranceCalculationId"];
            this.offerSupplement = _data["offerSupplement"];
            this.previousInsuranceInfoRequired = _data["previousInsuranceInfoRequired"];
            this.previousInsuranceCompanyName = _data["previousInsuranceCompanyName"];
            this.previousTerminateContract = _data["previousTerminateContract"];
            this.previousContractNumber = _data["previousContractNumber"];
            this.previousLicensePlate = _data["previousLicensePlate"];
            this.previousContractTypeId = _data["previousContractTypeId"];
            this.waiverOfBonus = _data["waiverOfBonus"];
            if (Array.isArray(_data["insuranceDocumentIds"])) {
                this.insuranceDocumentIds = [] as any;
                for (let item of _data["insuranceDocumentIds"])
                    this.insuranceDocumentIds!.push(item);
            }
            if (Array.isArray(_data["customerDocumentIds"])) {
                this.customerDocumentIds = [] as any;
                for (let item of _data["customerDocumentIds"])
                    this.customerDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SignInsuranceDocumentsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignInsuranceDocumentsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["insuranceCalculationId"] = this.insuranceCalculationId;
        data["offerSupplement"] = this.offerSupplement;
        data["previousInsuranceInfoRequired"] = this.previousInsuranceInfoRequired;
        data["previousInsuranceCompanyName"] = this.previousInsuranceCompanyName;
        data["previousTerminateContract"] = this.previousTerminateContract;
        data["previousContractNumber"] = this.previousContractNumber;
        data["previousLicensePlate"] = this.previousLicensePlate;
        data["previousContractTypeId"] = this.previousContractTypeId;
        data["waiverOfBonus"] = this.waiverOfBonus;
        if (Array.isArray(this.insuranceDocumentIds)) {
            data["insuranceDocumentIds"] = [];
            for (let item of this.insuranceDocumentIds)
                data["insuranceDocumentIds"].push(item);
        }
        if (Array.isArray(this.customerDocumentIds)) {
            data["customerDocumentIds"] = [];
            for (let item of this.customerDocumentIds)
                data["customerDocumentIds"].push(item);
        }
        return data;
    }
}

export interface ISignInsuranceDocumentsRequest {
    /** InsuranceCalculation Id */
    insuranceCalculationId: number;
    /** Angebotszusatz Versicherung */
    offerSupplement?: string | undefined;
    previousInsuranceInfoRequired: boolean;
    /** Bisherige Versicherung */
    previousInsuranceCompanyName?: string | undefined;
    /** Bisherige Versicherung kündigen */
    previousTerminateContract?: boolean | undefined;
    /** Polizzennummer */
    previousContractNumber?: string | undefined;
    /** Kennzeichen Vorversicherung */
    previousLicensePlate?: string | undefined;
    /** Vertragsart */
    previousContractTypeId?: number | undefined;
    /** Bonusverzicht */
    waiverOfBonus?: boolean | undefined;
    /** Versicherungs-Dokumente */
    insuranceDocumentIds: number[];
    /** Kunden-Dokumente */
    customerDocumentIds: string[];
}

export class SignInsuranceDocumentsResponse implements ISignInsuranceDocumentsResponse {
    /** Dokument Name */
    documentName!: string;
    /** Dokument PIN */
    documentPin?: string | undefined;
    /** URL zum Signieren */
    signDocumentUrl!: string;

    constructor(data?: ISignInsuranceDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentName = _data["documentName"];
            this.documentPin = _data["documentPin"];
            this.signDocumentUrl = _data["signDocumentUrl"];
        }
    }

    static fromJS(data: any): SignInsuranceDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SignInsuranceDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentName"] = this.documentName;
        data["documentPin"] = this.documentPin;
        data["signDocumentUrl"] = this.signDocumentUrl;
        return data;
    }
}

export interface ISignInsuranceDocumentsResponse {
    /** Dokument Name */
    documentName: string;
    /** Dokument PIN */
    documentPin?: string | undefined;
    /** URL zum Signieren */
    signDocumentUrl: string;
}

export class SignInsuranceDocumentsResponseIReadOnlyListApiResult implements ISignInsuranceDocumentsResponseIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: SignInsuranceDocumentsResponse[];

    constructor(data?: ISignInsuranceDocumentsResponseIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SignInsuranceDocumentsResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignInsuranceDocumentsResponseIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignInsuranceDocumentsResponseIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignInsuranceDocumentsResponseIReadOnlyListApiResult {
    messages: ApiMessages;
    data: SignInsuranceDocumentsResponse[];
}

export class SignPurchaseApplicationRequest implements ISignPurchaseApplicationRequest {
    fileId!: string;
    dealId!: number;

    constructor(data?: ISignPurchaseApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.dealId = _data["dealId"];
        }
    }

    static fromJS(data: any): SignPurchaseApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SignPurchaseApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["dealId"] = this.dealId;
        return data;
    }
}

export interface ISignPurchaseApplicationRequest {
    fileId: string;
    dealId: number;
}

export class SignedDocumentOverview implements ISignedDocumentOverview {
    id!: number;
    name!: string;
    calculationNumber!: string;

    constructor(data?: ISignedDocumentOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.calculationNumber = _data["calculationNumber"];
        }
    }

    static fromJS(data: any): SignedDocumentOverview {
        data = typeof data === 'object' ? data : {};
        let result = new SignedDocumentOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["calculationNumber"] = this.calculationNumber;
        return data;
    }
}

export interface ISignedDocumentOverview {
    id: number;
    name: string;
    calculationNumber: string;
}

export class SignedDocumentOverviewIReadOnlyListApiResult implements ISignedDocumentOverviewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: SignedDocumentOverview[];

    constructor(data?: ISignedDocumentOverviewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SignedDocumentOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SignedDocumentOverviewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SignedDocumentOverviewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISignedDocumentOverviewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: SignedDocumentOverview[];
}

export class StringIReadOnlyCollectionApiResult implements IStringIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: string[];

    constructor(data?: IStringIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static fromJS(data: any): StringIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new StringIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        return data;
    }
}

export interface IStringIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: string[];
}

export class StringInt32DictionaryApiResult implements IStringInt32DictionaryApiResult {
    messages!: ApiMessages;
    data!: { [key: string]: number; };

    constructor(data?: IStringInt32DictionaryApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
        }
    }

    static fromJS(data: any): StringInt32DictionaryApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new StringInt32DictionaryApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        return data;
    }
}

export interface IStringInt32DictionaryApiResult {
    messages: ApiMessages;
    data: { [key: string]: number; };
}

export class SubmittedDealOverview implements ISubmittedDealOverview {
    id!: number;
    salesPersonName!: string;
    creationDate!: Date;
    customerName!: string;
    trademarkName!: string;
    modelName!: string;

    constructor(data?: ISubmittedDealOverview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salesPersonName = _data["salesPersonName"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.customerName = _data["customerName"];
            this.trademarkName = _data["trademarkName"];
            this.modelName = _data["modelName"];
        }
    }

    static fromJS(data: any): SubmittedDealOverview {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedDealOverview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesPersonName"] = this.salesPersonName;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["customerName"] = this.customerName;
        data["trademarkName"] = this.trademarkName;
        data["modelName"] = this.modelName;
        return data;
    }
}

export interface ISubmittedDealOverview {
    id: number;
    salesPersonName: string;
    creationDate: Date;
    customerName: string;
    trademarkName: string;
    modelName: string;
}

export class SubmittedDealOverviewIPagedList implements ISubmittedDealOverviewIPagedList {
    readonly total!: number;
    readonly index!: number;
    readonly size!: number;
    readonly items!: SubmittedDealOverview[];

    constructor(data?: ISubmittedDealOverviewIPagedList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).total = _data["total"];
            (<any>this).index = _data["index"];
            (<any>this).size = _data["size"];
            if (Array.isArray(_data["items"])) {
                (<any>this).items = [] as any;
                for (let item of _data["items"])
                    (<any>this).items!.push(SubmittedDealOverview.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubmittedDealOverviewIPagedList {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedDealOverviewIPagedList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["index"] = this.index;
        data["size"] = this.size;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmittedDealOverviewIPagedList {
    total: number;
    index: number;
    size: number;
    items: SubmittedDealOverview[];
}

export class SubmittedDealOverviewIPagedListApiResult implements ISubmittedDealOverviewIPagedListApiResult {
    messages!: ApiMessages;
    data!: SubmittedDealOverviewIPagedList;

    constructor(data?: ISubmittedDealOverviewIPagedListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new SubmittedDealOverviewIPagedList();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? SubmittedDealOverviewIPagedList.fromJS(_data["data"]) : new SubmittedDealOverviewIPagedList();
        }
    }

    static fromJS(data: any): SubmittedDealOverviewIPagedListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmittedDealOverviewIPagedListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmittedDealOverviewIPagedListApiResult {
    messages: ApiMessages;
    data: SubmittedDealOverviewIPagedList;
}

export enum SubsidyRecipientUnit {
    Percentage = "Percentage",
    Currency = "Currency",
    Month = "Month",
}

export class SubsidyRecipientView implements ISubsidyRecipientView {
    value!: number;
    name!: string;
    unit!: SubsidyRecipientUnit;
    isRound!: boolean;
    isFixValueAvailable!: boolean;
    isOnlyFixedValue!: boolean;

    constructor(data?: ISubsidyRecipientView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
            this.unit = _data["unit"];
            this.isRound = _data["isRound"];
            this.isFixValueAvailable = _data["isFixValueAvailable"];
            this.isOnlyFixedValue = _data["isOnlyFixedValue"];
        }
    }

    static fromJS(data: any): SubsidyRecipientView {
        data = typeof data === 'object' ? data : {};
        let result = new SubsidyRecipientView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        data["unit"] = this.unit;
        data["isRound"] = this.isRound;
        data["isFixValueAvailable"] = this.isFixValueAvailable;
        data["isOnlyFixedValue"] = this.isOnlyFixedValue;
        return data;
    }
}

export interface ISubsidyRecipientView {
    value: number;
    name: string;
    unit: SubsidyRecipientUnit;
    isRound: boolean;
    isFixValueAvailable: boolean;
    isOnlyFixedValue: boolean;
}

export class SubsidyRecipientViewIReadOnlyCollectionApiResult implements ISubsidyRecipientViewIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: SubsidyRecipientView[];

    constructor(data?: ISubsidyRecipientViewIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SubsidyRecipientView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubsidyRecipientViewIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubsidyRecipientViewIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubsidyRecipientViewIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: SubsidyRecipientView[];
}

export class SubsidyView implements ISubsidyView {
    subsidyGiverId!: number;
    subsidyRecipientId!: number;
    fixum?: number | undefined;
    percentage?: number | undefined;
    isFixValue!: boolean;
    isVisible?: boolean | undefined;

    constructor(data?: ISubsidyView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subsidyGiverId = _data["subsidyGiverId"];
            this.subsidyRecipientId = _data["subsidyRecipientId"];
            this.fixum = _data["fixum"];
            this.percentage = _data["percentage"];
            this.isFixValue = _data["isFixValue"];
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): SubsidyView {
        data = typeof data === 'object' ? data : {};
        let result = new SubsidyView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subsidyGiverId"] = this.subsidyGiverId;
        data["subsidyRecipientId"] = this.subsidyRecipientId;
        data["fixum"] = this.fixum;
        data["percentage"] = this.percentage;
        data["isFixValue"] = this.isFixValue;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface ISubsidyView {
    subsidyGiverId: number;
    subsidyRecipientId: number;
    fixum?: number | undefined;
    percentage?: number | undefined;
    isFixValue: boolean;
    isVisible?: boolean | undefined;
}

export class T implements IT {

    constructor(data?: IT) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): T {
        data = typeof data === 'object' ? data : {};
        let result = new T();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IT {
}

export class TakeoverConditionAdjustmentResponse implements ITakeoverConditionAdjustmentResponse {
    decision!: ConditionAdjustmentDecision;
    reason?: string | undefined;
    conditionAdjustmentId!: number;
    instanceId?: string | undefined;
    recalculationSkipped!: boolean;
    timedOut!: boolean;

    constructor(data?: ITakeoverConditionAdjustmentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.decision = _data["decision"];
            this.reason = _data["reason"];
            this.conditionAdjustmentId = _data["conditionAdjustmentId"];
            this.instanceId = _data["instanceId"];
            this.recalculationSkipped = _data["recalculationSkipped"];
            this.timedOut = _data["timedOut"];
        }
    }

    static fromJS(data: any): TakeoverConditionAdjustmentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverConditionAdjustmentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["decision"] = this.decision;
        data["reason"] = this.reason;
        data["conditionAdjustmentId"] = this.conditionAdjustmentId;
        data["instanceId"] = this.instanceId;
        data["recalculationSkipped"] = this.recalculationSkipped;
        data["timedOut"] = this.timedOut;
        return data;
    }
}

export interface ITakeoverConditionAdjustmentResponse {
    decision: ConditionAdjustmentDecision;
    reason?: string | undefined;
    conditionAdjustmentId: number;
    instanceId?: string | undefined;
    recalculationSkipped: boolean;
    timedOut: boolean;
}

export class TakeoverConditionAdjustmentResponseApiResult implements ITakeoverConditionAdjustmentResponseApiResult {
    messages!: ApiMessages;
    data!: TakeoverConditionAdjustmentResponse;

    constructor(data?: ITakeoverConditionAdjustmentResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new TakeoverConditionAdjustmentResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? TakeoverConditionAdjustmentResponse.fromJS(_data["data"]) : new TakeoverConditionAdjustmentResponse();
        }
    }

    static fromJS(data: any): TakeoverConditionAdjustmentResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverConditionAdjustmentResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITakeoverConditionAdjustmentResponseApiResult {
    messages: ApiMessages;
    data: TakeoverConditionAdjustmentResponse;
}

export class TakeoverDispatchDate implements ITakeoverDispatchDate {
    expectedDispatchDate?: Date | undefined;

    constructor(data?: ITakeoverDispatchDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expectedDispatchDate = _data["expectedDispatchDate"] ? new Date(_data["expectedDispatchDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TakeoverDispatchDate {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverDispatchDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expectedDispatchDate"] = this.expectedDispatchDate ? this.expectedDispatchDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITakeoverDispatchDate {
    expectedDispatchDate?: Date | undefined;
}

export class TakeoverDispatchDateApiResult implements ITakeoverDispatchDateApiResult {
    messages!: ApiMessages;
    data!: TakeoverDispatchDate;

    constructor(data?: ITakeoverDispatchDateApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new TakeoverDispatchDate();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? TakeoverDispatchDate.fromJS(_data["data"]) : new TakeoverDispatchDate();
        }
    }

    static fromJS(data: any): TakeoverDispatchDateApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverDispatchDateApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITakeoverDispatchDateApiResult {
    messages: ApiMessages;
    data: TakeoverDispatchDate;
}

export class TakeoverPosition implements ITakeoverPosition {
    position!: number;
    vin?: string | undefined;
    selected!: boolean;

    constructor(data?: ITakeoverPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.vin = _data["vin"];
            this.selected = _data["selected"];
        }
    }

    static fromJS(data: any): TakeoverPosition {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["vin"] = this.vin;
        data["selected"] = this.selected;
        return data;
    }
}

export interface ITakeoverPosition {
    position: number;
    vin?: string | undefined;
    selected: boolean;
}

export class TakeoverPositions implements ITakeoverPositions {
    positions!: TakeoverPosition[];
    expectedDispatchDate?: Date | undefined;

    constructor(data?: ITakeoverPositions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.positions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(TakeoverPosition.fromJS(item));
            }
            this.expectedDispatchDate = _data["expectedDispatchDate"] ? new Date(_data["expectedDispatchDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TakeoverPositions {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverPositions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        data["expectedDispatchDate"] = this.expectedDispatchDate ? this.expectedDispatchDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITakeoverPositions {
    positions: TakeoverPosition[];
    expectedDispatchDate?: Date | undefined;
}

export class TakeoverRecalculation implements ITakeoverRecalculation {
    euriborApplied!: number;
    euriborNew!: number;
    delta!: number;
    zinsNew!: number;
    interestRate!: number;
    effectiveCustomerRate!: number;
    borrowingInterestRate!: number;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    monthlyNetPayment?: number | undefined;
    monthlyGrossPayment?: number | undefined;
    totalLoad!: number;
    legalTransactionFee?: number | undefined;
    additionalMileageCharge?: number | undefined;

    constructor(data?: ITakeoverRecalculation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.euriborApplied = _data["euriborApplied"];
            this.euriborNew = _data["euriborNew"];
            this.delta = _data["delta"];
            this.zinsNew = _data["zinsNew"];
            this.interestRate = _data["interestRate"];
            this.effectiveCustomerRate = _data["effectiveCustomerRate"];
            this.borrowingInterestRate = _data["borrowingInterestRate"];
            this.regularInstalment = _data["regularInstalment"];
            this.regularInstalmentExact = _data["regularInstalmentExact"];
            this.monthlyNetPayment = _data["monthlyNetPayment"];
            this.monthlyGrossPayment = _data["monthlyGrossPayment"];
            this.totalLoad = _data["totalLoad"];
            this.legalTransactionFee = _data["legalTransactionFee"];
            this.additionalMileageCharge = _data["additionalMileageCharge"];
        }
    }

    static fromJS(data: any): TakeoverRecalculation {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverRecalculation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["euriborApplied"] = this.euriborApplied;
        data["euriborNew"] = this.euriborNew;
        data["delta"] = this.delta;
        data["zinsNew"] = this.zinsNew;
        data["interestRate"] = this.interestRate;
        data["effectiveCustomerRate"] = this.effectiveCustomerRate;
        data["borrowingInterestRate"] = this.borrowingInterestRate;
        data["regularInstalment"] = this.regularInstalment;
        data["regularInstalmentExact"] = this.regularInstalmentExact;
        data["monthlyNetPayment"] = this.monthlyNetPayment;
        data["monthlyGrossPayment"] = this.monthlyGrossPayment;
        data["totalLoad"] = this.totalLoad;
        data["legalTransactionFee"] = this.legalTransactionFee;
        data["additionalMileageCharge"] = this.additionalMileageCharge;
        return data;
    }
}

export interface ITakeoverRecalculation {
    euriborApplied: number;
    euriborNew: number;
    delta: number;
    zinsNew: number;
    interestRate: number;
    effectiveCustomerRate: number;
    borrowingInterestRate: number;
    regularInstalment?: number | undefined;
    regularInstalmentExact?: number | undefined;
    monthlyNetPayment?: number | undefined;
    monthlyGrossPayment?: number | undefined;
    totalLoad: number;
    legalTransactionFee?: number | undefined;
    additionalMileageCharge?: number | undefined;
}

export class TakeoverRecalculationApiResult implements ITakeoverRecalculationApiResult {
    messages!: ApiMessages;
    data!: TakeoverRecalculation;

    constructor(data?: ITakeoverRecalculationApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new TakeoverRecalculation();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? TakeoverRecalculation.fromJS(_data["data"]) : new TakeoverRecalculation();
        }
    }

    static fromJS(data: any): TakeoverRecalculationApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new TakeoverRecalculationApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITakeoverRecalculationApiResult {
    messages: ApiMessages;
    data: TakeoverRecalculation;
}

export class TouchpointSnapshotData implements ITouchpointSnapshotData {
    id!: number;
    touchpointName!: string;
    channelName!: string;
    financialCodeNeeded!: boolean;
    isVdz!: boolean;

    constructor(data?: ITouchpointSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.touchpointName = _data["touchpointName"];
            this.channelName = _data["channelName"];
            this.financialCodeNeeded = _data["financialCodeNeeded"];
            this.isVdz = _data["isVdz"];
        }
    }

    static fromJS(data: any): TouchpointSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new TouchpointSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["touchpointName"] = this.touchpointName;
        data["channelName"] = this.channelName;
        data["financialCodeNeeded"] = this.financialCodeNeeded;
        data["isVdz"] = this.isVdz;
        return data;
    }
}

export interface ITouchpointSnapshotData {
    id: number;
    touchpointName: string;
    channelName: string;
    financialCodeNeeded: boolean;
    isVdz: boolean;
}

export class TypeCertificateReason implements ITypeCertificateReason {
    id!: string;
    name!: string;

    constructor(data?: ITypeCertificateReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TypeCertificateReason {
        data = typeof data === 'object' ? data : {};
        let result = new TypeCertificateReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ITypeCertificateReason {
    id: string;
    name: string;
}

export class UnauthorizedResult implements IUnauthorizedResult {
    redirectLogout!: boolean;

    constructor(data?: IUnauthorizedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectLogout = _data["redirectLogout"];
        }
    }

    static fromJS(data: any): UnauthorizedResult {
        data = typeof data === 'object' ? data : {};
        let result = new UnauthorizedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectLogout"] = this.redirectLogout;
        return data;
    }
}

export interface IUnauthorizedResult {
    redirectLogout: boolean;
}

export class UpdateClassificationGroupRequest implements IUpdateClassificationGroupRequest {
    id!: string;
    name!: string;
    parentId?: string | undefined;

    constructor(data?: IUpdateClassificationGroupRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): UpdateClassificationGroupRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClassificationGroupRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IUpdateClassificationGroupRequest {
    id: string;
    name: string;
    parentId?: string | undefined;
}

export class UpdateDealCustomerWithMainCustomerResponse implements IUpdateDealCustomerWithMainCustomerResponse {
    readonly success!: boolean;

    constructor(data?: IUpdateDealCustomerWithMainCustomerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateDealCustomerWithMainCustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealCustomerWithMainCustomerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data;
    }
}

export interface IUpdateDealCustomerWithMainCustomerResponse {
    success: boolean;
}

export class UpdateDealCustomerWithMainCustomerResponseApiResult implements IUpdateDealCustomerWithMainCustomerResponseApiResult {
    messages!: ApiMessages;
    data!: UpdateDealCustomerWithMainCustomerResponse;

    constructor(data?: IUpdateDealCustomerWithMainCustomerResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new UpdateDealCustomerWithMainCustomerResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? UpdateDealCustomerWithMainCustomerResponse.fromJS(_data["data"]) : new UpdateDealCustomerWithMainCustomerResponse();
        }
    }

    static fromJS(data: any): UpdateDealCustomerWithMainCustomerResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDealCustomerWithMainCustomerResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateDealCustomerWithMainCustomerResponseApiResult {
    messages: ApiMessages;
    data: UpdateDealCustomerWithMainCustomerResponse;
}

export class UpdateFeatureClassificationRequest implements IUpdateFeatureClassificationRequest {
    classificationGroupId!: string;
    featureDefinitionId!: string;
    isOverrideable!: boolean;
    defaultValue!: string;
    sortOrder!: number;

    constructor(data?: IUpdateFeatureClassificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classificationGroupId = _data["classificationGroupId"];
            this.featureDefinitionId = _data["featureDefinitionId"];
            this.isOverrideable = _data["isOverrideable"];
            this.defaultValue = _data["defaultValue"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): UpdateFeatureClassificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeatureClassificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classificationGroupId"] = this.classificationGroupId;
        data["featureDefinitionId"] = this.featureDefinitionId;
        data["isOverrideable"] = this.isOverrideable;
        data["defaultValue"] = this.defaultValue;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IUpdateFeatureClassificationRequest {
    classificationGroupId: string;
    featureDefinitionId: string;
    isOverrideable: boolean;
    defaultValue: string;
    sortOrder: number;
}

export class UpdateFeatureDefinitionRequest implements IUpdateFeatureDefinitionRequest {
    id!: string;
    name!: string;
    featureType!: FeatureType;
    format!: string;

    constructor(data?: IUpdateFeatureDefinitionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.featureType = _data["featureType"];
            this.format = _data["format"];
        }
    }

    static fromJS(data: any): UpdateFeatureDefinitionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeatureDefinitionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["featureType"] = this.featureType;
        data["format"] = this.format;
        return data;
    }
}

export interface IUpdateFeatureDefinitionRequest {
    id: string;
    name: string;
    featureType: FeatureType;
    format: string;
}

export class UpdateFeatureValueRequest implements IUpdateFeatureValueRequest {
    domainId!: number;
    objectType!: ClassificationType;
    featureId!: string;
    value!: string;

    constructor(data?: IUpdateFeatureValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.domainId = _data["domainId"];
            this.objectType = _data["objectType"];
            this.featureId = _data["featureId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateFeatureValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFeatureValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["domainId"] = this.domainId;
        data["objectType"] = this.objectType;
        data["featureId"] = this.featureId;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateFeatureValueRequest {
    domainId: number;
    objectType: ClassificationType;
    featureId: string;
    value: string;
}

export class UpdateServiceContractRequest implements IUpdateServiceContractRequest {
    dealId!: number;
    variantNr!: number;
    vin?: string | undefined;
    registrationDate?: Date | undefined;
    licensePlate?: string | undefined;
    signatureDate?: Date | undefined;

    constructor(data?: IUpdateServiceContractRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dealId = _data["dealId"];
            this.variantNr = _data["variantNr"];
            this.vin = _data["vin"];
            this.registrationDate = _data["registrationDate"] ? new Date(_data["registrationDate"].toString()) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
            this.signatureDate = _data["signatureDate"] ? new Date(_data["signatureDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateServiceContractRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceContractRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dealId"] = this.dealId;
        data["variantNr"] = this.variantNr;
        data["vin"] = this.vin;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        data["signatureDate"] = this.signatureDate ? this.signatureDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateServiceContractRequest {
    dealId: number;
    variantNr: number;
    vin?: string | undefined;
    registrationDate?: Date | undefined;
    licensePlate?: string | undefined;
    signatureDate?: Date | undefined;
}

export class UploadDocumentResponse implements IUploadDocumentResponse {
    isValid!: boolean;
    invalidDocuments!: string[];
    isRequired!: boolean;

    constructor(data?: IUploadDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.invalidDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["invalidDocuments"])) {
                this.invalidDocuments = [] as any;
                for (let item of _data["invalidDocuments"])
                    this.invalidDocuments!.push(item);
            }
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): UploadDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.invalidDocuments)) {
            data["invalidDocuments"] = [];
            for (let item of this.invalidDocuments)
                data["invalidDocuments"].push(item);
        }
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IUploadDocumentResponse {
    isValid: boolean;
    invalidDocuments: string[];
    isRequired: boolean;
}

export class UploadDocumentResponseApiResult implements IUploadDocumentResponseApiResult {
    messages!: ApiMessages;
    data!: UploadDocumentResponse;

    constructor(data?: IUploadDocumentResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new UploadDocumentResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? UploadDocumentResponse.fromJS(_data["data"]) : new UploadDocumentResponse();
        }
    }

    static fromJS(data: any): UploadDocumentResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadDocumentResponseApiResult {
    messages: ApiMessages;
    data: UploadDocumentResponse;
}

export class UploadSupplierInvoiceResponse implements IUploadSupplierInvoiceResponse {
    fileId!: string;

    constructor(data?: IUploadSupplierInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): UploadSupplierInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSupplierInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        return data;
    }
}

export interface IUploadSupplierInvoiceResponse {
    fileId: string;
}

export class UploadSupplierInvoiceResponseApiResult implements IUploadSupplierInvoiceResponseApiResult {
    messages!: ApiMessages;
    data!: UploadSupplierInvoiceResponse;

    constructor(data?: IUploadSupplierInvoiceResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new UploadSupplierInvoiceResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? UploadSupplierInvoiceResponse.fromJS(_data["data"]) : new UploadSupplierInvoiceResponse();
        }
    }

    static fromJS(data: any): UploadSupplierInvoiceResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadSupplierInvoiceResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadSupplierInvoiceResponseApiResult {
    messages: ApiMessages;
    data: UploadSupplierInvoiceResponse;
}

export class UploadedDocumentView implements IUploadedDocumentView {
    fileId!: string;
    name!: string;
    documentName!: string;
    created!: Date;
    modified?: Date | undefined;
    contentType!: string;
    size!: number;
    isProcessed!: boolean;

    constructor(data?: IUploadedDocumentView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.documentName = _data["documentName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : <any>undefined;
            this.contentType = _data["contentType"];
            this.size = _data["size"];
            this.isProcessed = _data["isProcessed"];
        }
    }

    static fromJS(data: any): UploadedDocumentView {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedDocumentView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["documentName"] = this.documentName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["modified"] = this.modified ? this.modified.toISOString() : <any>undefined;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["isProcessed"] = this.isProcessed;
        return data;
    }
}

export interface IUploadedDocumentView {
    fileId: string;
    name: string;
    documentName: string;
    created: Date;
    modified?: Date | undefined;
    contentType: string;
    size: number;
    isProcessed: boolean;
}

export class UploadedDocumentViewIReadOnlyListApiResult implements IUploadedDocumentViewIReadOnlyListApiResult {
    messages!: ApiMessages;
    data!: UploadedDocumentView[];

    constructor(data?: IUploadedDocumentViewIReadOnlyListApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UploadedDocumentView.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadedDocumentViewIReadOnlyListApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedDocumentViewIReadOnlyListApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUploadedDocumentViewIReadOnlyListApiResult {
    messages: ApiMessages;
    data: UploadedDocumentView[];
}

export class ValidateVehicleAgeResponse implements IValidateVehicleAgeResponse {
    isValid!: boolean;

    constructor(data?: IValidateVehicleAgeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ValidateVehicleAgeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVehicleAgeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IValidateVehicleAgeResponse {
    isValid: boolean;
}

export class ValidateVehicleAgeResponseApiResult implements IValidateVehicleAgeResponseApiResult {
    messages!: ApiMessages;
    data!: ValidateVehicleAgeResponse;

    constructor(data?: IValidateVehicleAgeResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new ValidateVehicleAgeResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? ValidateVehicleAgeResponse.fromJS(_data["data"]) : new ValidateVehicleAgeResponse();
        }
    }

    static fromJS(data: any): ValidateVehicleAgeResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateVehicleAgeResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateVehicleAgeResponseApiResult {
    messages: ApiMessages;
    data: ValidateVehicleAgeResponse;
}

export class ValidationErrorResult extends ApiResult implements IValidationErrorResult {

    constructor(data?: IValidationErrorResult) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ValidationErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IValidationErrorResult extends IApiResult {
}

export class VehicleDetail implements IVehicleDetail {
    objectName?: string | undefined;
    numberPlate?: string | undefined;
    fin?: string | undefined;
    vehicleCondition!: number;
    objectPictureUrl?: string | undefined;
    modelId?: number | undefined;
    contractStartMileage?: number | undefined;
    excessUnderMileageRate?: number | undefined;

    constructor(data?: IVehicleDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectName = _data["objectName"];
            this.numberPlate = _data["numberPlate"];
            this.fin = _data["fin"];
            this.vehicleCondition = _data["vehicleCondition"];
            this.objectPictureUrl = _data["objectPictureUrl"];
            this.modelId = _data["modelId"];
            this.contractStartMileage = _data["contractStartMileage"];
            this.excessUnderMileageRate = _data["excessUnderMileageRate"];
        }
    }

    static fromJS(data: any): VehicleDetail {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectName"] = this.objectName;
        data["numberPlate"] = this.numberPlate;
        data["fin"] = this.fin;
        data["vehicleCondition"] = this.vehicleCondition;
        data["objectPictureUrl"] = this.objectPictureUrl;
        data["modelId"] = this.modelId;
        data["contractStartMileage"] = this.contractStartMileage;
        data["excessUnderMileageRate"] = this.excessUnderMileageRate;
        return data;
    }
}

export interface IVehicleDetail {
    objectName?: string | undefined;
    numberPlate?: string | undefined;
    fin?: string | undefined;
    vehicleCondition: number;
    objectPictureUrl?: string | undefined;
    modelId?: number | undefined;
    contractStartMileage?: number | undefined;
    excessUnderMileageRate?: number | undefined;
}

export class VinAssignment implements IVinAssignment {
    position!: number;
    vin?: string | undefined;
    vinDate?: Date | undefined;
    vinIssue?: string | undefined;
    vinStatus?: string | undefined;
    vinState?: VinState | undefined;
    commissionNumber?: string | undefined;

    constructor(data?: IVinAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.vin = _data["vin"];
            this.vinDate = _data["vinDate"] ? new Date(_data["vinDate"].toString()) : <any>undefined;
            this.vinIssue = _data["vinIssue"];
            this.vinStatus = _data["vinStatus"];
            this.vinState = _data["vinState"];
            this.commissionNumber = _data["commissionNumber"];
        }
    }

    static fromJS(data: any): VinAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new VinAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["vin"] = this.vin;
        data["vinDate"] = this.vinDate ? this.vinDate.toISOString() : <any>undefined;
        data["vinIssue"] = this.vinIssue;
        data["vinStatus"] = this.vinStatus;
        data["vinState"] = this.vinState;
        data["commissionNumber"] = this.commissionNumber;
        return data;
    }
}

export interface IVinAssignment {
    position: number;
    vin?: string | undefined;
    vinDate?: Date | undefined;
    vinIssue?: string | undefined;
    vinStatus?: string | undefined;
    vinState?: VinState | undefined;
    commissionNumber?: string | undefined;
}

export class VinAssignmentIReadOnlyCollectionApiResult implements IVinAssignmentIReadOnlyCollectionApiResult {
    messages!: ApiMessages;
    data!: VinAssignment[];

    constructor(data?: IVinAssignmentIReadOnlyCollectionApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(VinAssignment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VinAssignmentIReadOnlyCollectionApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new VinAssignmentIReadOnlyCollectionApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IVinAssignmentIReadOnlyCollectionApiResult {
    messages: ApiMessages;
    data: VinAssignment[];
}

export class VinAssignmentSnapshotData implements IVinAssignmentSnapshotData {
    position!: number;
    vin?: string | undefined;
    cmsId?: string | undefined;
    status!: string;
    expectedDispatchDate?: Date | undefined;

    constructor(data?: IVinAssignmentSnapshotData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.vin = _data["vin"];
            this.cmsId = _data["cmsId"];
            this.status = _data["status"];
            this.expectedDispatchDate = _data["expectedDispatchDate"] ? new Date(_data["expectedDispatchDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VinAssignmentSnapshotData {
        data = typeof data === 'object' ? data : {};
        let result = new VinAssignmentSnapshotData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["vin"] = this.vin;
        data["cmsId"] = this.cmsId;
        data["status"] = this.status;
        data["expectedDispatchDate"] = this.expectedDispatchDate ? this.expectedDispatchDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IVinAssignmentSnapshotData {
    position: number;
    vin?: string | undefined;
    cmsId?: string | undefined;
    status: string;
    expectedDispatchDate?: Date | undefined;
}

export enum VinAssignmentStatus {
    New = "New",
    Submitted = "Submitted",
    HandOverPrinting = "HandOverPrinting",
    HandOverDelivered = "HandOverDelivered",
    Canceled = "Canceled",
}

export class VinParameters implements IVinParameters {
    chassisNumber?: string | undefined;
    vinDate?: Date | undefined;
    vinIssue?: string | undefined;
    vinStatus?: string | undefined;
    vinState?: VinState | undefined;

    constructor(data?: IVinParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chassisNumber = _data["chassisNumber"];
            this.vinDate = _data["vinDate"] ? new Date(_data["vinDate"].toString()) : <any>undefined;
            this.vinIssue = _data["vinIssue"];
            this.vinStatus = _data["vinStatus"];
            this.vinState = _data["vinState"];
        }
    }

    static fromJS(data: any): VinParameters {
        data = typeof data === 'object' ? data : {};
        let result = new VinParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chassisNumber"] = this.chassisNumber;
        data["vinDate"] = this.vinDate ? this.vinDate.toISOString() : <any>undefined;
        data["vinIssue"] = this.vinIssue;
        data["vinStatus"] = this.vinStatus;
        data["vinState"] = this.vinState;
        return data;
    }
}

export interface IVinParameters {
    chassisNumber?: string | undefined;
    vinDate?: Date | undefined;
    vinIssue?: string | undefined;
    vinStatus?: string | undefined;
    vinState?: VinState | undefined;
}

export class VinParametersApiResult implements IVinParametersApiResult {
    messages!: ApiMessages;
    data!: VinParameters;

    constructor(data?: IVinParametersApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new VinParameters();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? VinParameters.fromJS(_data["data"]) : new VinParameters();
        }
    }

    static fromJS(data: any): VinParametersApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new VinParametersApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVinParametersApiResult {
    messages: ApiMessages;
    data: VinParameters;
}

export enum VinState {
    Invalid = "Invalid",
    Success = "Success",
    UpdateRequired = "UpdateRequired",
    Error = "Error",
}

export class VoteOnSalesAidLimitViolationRequest implements IVoteOnSalesAidLimitViolationRequest {
    financingCalculationId!: number;
    voting!: LimitViolationVoting;

    constructor(data?: IVoteOnSalesAidLimitViolationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financingCalculationId = _data["financingCalculationId"];
            this.voting = _data["voting"];
        }
    }

    static fromJS(data: any): VoteOnSalesAidLimitViolationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VoteOnSalesAidLimitViolationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financingCalculationId"] = this.financingCalculationId;
        data["voting"] = this.voting;
        return data;
    }
}

export interface IVoteOnSalesAidLimitViolationRequest {
    financingCalculationId: number;
    voting: LimitViolationVoting;
}

export class VoteOnSalesAidLimitViolationResponse implements IVoteOnSalesAidLimitViolationResponse {

    constructor(data?: IVoteOnSalesAidLimitViolationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): VoteOnSalesAidLimitViolationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoteOnSalesAidLimitViolationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IVoteOnSalesAidLimitViolationResponse {
}

export class VoteOnSalesAidLimitViolationResponseApiResult implements IVoteOnSalesAidLimitViolationResponseApiResult {
    messages!: ApiMessages;
    data!: VoteOnSalesAidLimitViolationResponse;

    constructor(data?: IVoteOnSalesAidLimitViolationResponseApiResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = new ApiMessages();
            this.data = new VoteOnSalesAidLimitViolationResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messages = _data["messages"] ? ApiMessages.fromJS(_data["messages"]) : new ApiMessages();
            this.data = _data["data"] ? VoteOnSalesAidLimitViolationResponse.fromJS(_data["data"]) : new VoteOnSalesAidLimitViolationResponse();
        }
    }

    static fromJS(data: any): VoteOnSalesAidLimitViolationResponseApiResult {
        data = typeof data === 'object' ? data : {};
        let result = new VoteOnSalesAidLimitViolationResponseApiResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messages"] = this.messages ? this.messages.toJSON() : <any>undefined;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }
}

export interface IVoteOnSalesAidLimitViolationResponseApiResult {
    messages: ApiMessages;
    data: VoteOnSalesAidLimitViolationResponse;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars